// @ts-nocheck
import { z } from 'zod'
import { AffectedRowsOutput, Aggregate, AggregateAnalyticsDashboard, AggregateAnalyticsDashboardChart, AggregateAnalyticsDashboardFiltersSource, AggregateDataSource, AggregateDataSourceCell, AggregateDataSourceVersion, AggregateDataSourceVersionOrigin, AggregateLookup, AggregateNote, AggregateProposalTemplate, AggregateSelect, AggregateSelectProposal, AggregateSelectValueType, AggregateTransform, AggregateUserProposalAccess, AggregateWhere, AggregationBucket, AnalyticsDashboard, AnalyticsDashboardChartsArgs, AnalyticsDashboardFiltersSourcesArgs, AnalyticsDashboardAvgAggregate, AnalyticsDashboardAvgOrderByAggregateInput, AnalyticsDashboardChart, AnalyticsDashboardChartAvgAggregate, AnalyticsDashboardChartAvgOrderByAggregateInput, AnalyticsDashboardChartCountAggregate, AnalyticsDashboardChartCountOrderByAggregateInput, AnalyticsDashboardChartCreateInput, AnalyticsDashboardChartCreateManyDashboardInput, AnalyticsDashboardChartCreateManyDashboardInputEnvelope, AnalyticsDashboardChartCreateManyInput, AnalyticsDashboardChartCreateNestedManyWithoutDashboardInput, AnalyticsDashboardChartCreateOrConnectWithoutDashboardInput, AnalyticsDashboardChartCreateWithoutDashboardInput, AnalyticsDashboardChartGroupBy, AnalyticsDashboardChartListRelationFilter, AnalyticsDashboardChartMaxAggregate, AnalyticsDashboardChartMaxOrderByAggregateInput, AnalyticsDashboardChartMinAggregate, AnalyticsDashboardChartMinOrderByAggregateInput, AnalyticsDashboardChartOrderByRelationAggregateInput, AnalyticsDashboardChartOrderByRelevanceFieldEnum, AnalyticsDashboardChartOrderByRelevanceInput, AnalyticsDashboardChartOrderByWithAggregationInput, AnalyticsDashboardChartOrderByWithRelationInput, AnalyticsDashboardChartScalarFieldEnum, AnalyticsDashboardChartScalarWhereInput, AnalyticsDashboardChartScalarWhereWithAggregatesInput, AnalyticsDashboardChartSumAggregate, AnalyticsDashboardChartSumOrderByAggregateInput, AnalyticsDashboardChartUpdateInput, AnalyticsDashboardChartUpdateManyMutationInput, AnalyticsDashboardChartUpdateManyWithWhereWithoutDashboardInput, AnalyticsDashboardChartUpdateManyWithoutDashboardNestedInput, AnalyticsDashboardChartUpdateWithWhereUniqueWithoutDashboardInput, AnalyticsDashboardChartUpdateWithoutDashboardInput, AnalyticsDashboardChartUpsertWithWhereUniqueWithoutDashboardInput, AnalyticsDashboardChartWhereInput, AnalyticsDashboardChartWhereUniqueInput, AnalyticsDashboardCount, AnalyticsDashboardCountChartsArgs, AnalyticsDashboardCountFiltersSourcesArgs, AnalyticsDashboardCountAggregate, AnalyticsDashboardCountOrderByAggregateInput, AnalyticsDashboardCreateInput, AnalyticsDashboardCreateManyInput, AnalyticsDashboardFiltersSource, AnalyticsDashboardFiltersSourceAvgAggregate, AnalyticsDashboardFiltersSourceAvgOrderByAggregateInput, AnalyticsDashboardFiltersSourceCountAggregate, AnalyticsDashboardFiltersSourceCountOrderByAggregateInput, AnalyticsDashboardFiltersSourceCreateInput, AnalyticsDashboardFiltersSourceCreateManyDashboardInput, AnalyticsDashboardFiltersSourceCreateManyDashboardInputEnvelope, AnalyticsDashboardFiltersSourceCreateManyInput, AnalyticsDashboardFiltersSourceCreateNestedManyWithoutDashboardInput, AnalyticsDashboardFiltersSourceCreateOrConnectWithoutDashboardInput, AnalyticsDashboardFiltersSourceCreateWithoutDashboardInput, AnalyticsDashboardFiltersSourceGroupBy, AnalyticsDashboardFiltersSourceListRelationFilter, AnalyticsDashboardFiltersSourceMaxAggregate, AnalyticsDashboardFiltersSourceMaxOrderByAggregateInput, AnalyticsDashboardFiltersSourceMinAggregate, AnalyticsDashboardFiltersSourceMinOrderByAggregateInput, AnalyticsDashboardFiltersSourceOrderByRelationAggregateInput, AnalyticsDashboardFiltersSourceOrderByRelevanceFieldEnum, AnalyticsDashboardFiltersSourceOrderByRelevanceInput, AnalyticsDashboardFiltersSourceOrderByWithAggregationInput, AnalyticsDashboardFiltersSourceOrderByWithRelationInput, AnalyticsDashboardFiltersSourceScalarFieldEnum, AnalyticsDashboardFiltersSourceScalarWhereInput, AnalyticsDashboardFiltersSourceScalarWhereWithAggregatesInput, AnalyticsDashboardFiltersSourceSumAggregate, AnalyticsDashboardFiltersSourceSumOrderByAggregateInput, AnalyticsDashboardFiltersSourceUpdateInput, AnalyticsDashboardFiltersSourceUpdateManyMutationInput, AnalyticsDashboardFiltersSourceUpdateManyWithWhereWithoutDashboardInput, AnalyticsDashboardFiltersSourceUpdateManyWithoutDashboardNestedInput, AnalyticsDashboardFiltersSourceUpdateWithWhereUniqueWithoutDashboardInput, AnalyticsDashboardFiltersSourceUpdateWithoutDashboardInput, AnalyticsDashboardFiltersSourceUpsertWithWhereUniqueWithoutDashboardInput, AnalyticsDashboardFiltersSourceWhereInput, AnalyticsDashboardFiltersSourceWhereUniqueInput, AnalyticsDashboardGroupBy, AnalyticsDashboardMaxAggregate, AnalyticsDashboardMaxOrderByAggregateInput, AnalyticsDashboardMinAggregate, AnalyticsDashboardMinOrderByAggregateInput, AnalyticsDashboardOrderByRelevanceFieldEnum, AnalyticsDashboardOrderByRelevanceInput, AnalyticsDashboardOrderByWithAggregationInput, AnalyticsDashboardOrderByWithRelationInput, AnalyticsDashboardScalarFieldEnum, AnalyticsDashboardScalarWhereWithAggregatesInput, AnalyticsDashboardSumAggregate, AnalyticsDashboardSumOrderByAggregateInput, AnalyticsDashboardUpdateInput, AnalyticsDashboardUpdateManyMutationInput, AnalyticsDashboardWhereInput, AnalyticsDashboardWhereUniqueInput, AnalyticsPageField, AppAnalyticsDashboardUpdateInput, AppAnalyticsDashboardWhereUniqueInput, BaseEventType, BaseEventTypeInput, BigIntNullableFilter, BoolFieldUpdateOperationsInput, BoolFilter, BoolNullableFilter, BoolNullableWithAggregatesFilter, BoolWithAggregatesFilter, CalendarInterval, Client, ClientFeature, ClientFeatureCreateInput, ClientInput, ClientMembers, ClientPermission, ClientPermissionCreateInput, CredentialRepresentation, DataSource, DataSourceVersionsArgs, DataSourceAvgAggregate, DataSourceAvgOrderByAggregateInput, DataSourceCell, DataSourceCellAvgAggregate, DataSourceCellAvgOrderByAggregateInput, DataSourceCellCountAggregate, DataSourceCellCountOrderByAggregateInput, DataSourceCellCreateInput, DataSourceCellCreateManyInput, DataSourceCellCreateManyLastVersionInput, DataSourceCellCreateManyLastVersionInputEnvelope, DataSourceCellCreateNestedManyWithoutLastVersionInput, DataSourceCellCreateOrConnectWithoutLastVersionInput, DataSourceCellCreateWithoutLastVersionInput, DataSourceCellGroupBy, DataSourceCellLastVersionIdColumnUuidRowUuidCompoundUniqueInput, DataSourceCellListRelationFilter, DataSourceCellMaxAggregate, DataSourceCellMaxOrderByAggregateInput, DataSourceCellMinAggregate, DataSourceCellMinOrderByAggregateInput, DataSourceCellOrderByRelationAggregateInput, DataSourceCellOrderByRelevanceFieldEnum, DataSourceCellOrderByRelevanceInput, DataSourceCellOrderByWithAggregationInput, DataSourceCellOrderByWithRelationInput, DataSourceCellScalarFieldEnum, DataSourceCellScalarWhereInput, DataSourceCellScalarWhereWithAggregatesInput, DataSourceCellSumAggregate, DataSourceCellSumOrderByAggregateInput, DataSourceCellUpdateInput, DataSourceCellUpdateManyMutationInput, DataSourceCellUpdateManyWithWhereWithoutLastVersionInput, DataSourceCellUpdateManyWithoutLastVersionNestedInput, DataSourceCellUpdateWithWhereUniqueWithoutLastVersionInput, DataSourceCellUpdateWithoutLastVersionInput, DataSourceCellUpsertWithWhereUniqueWithoutLastVersionInput, DataSourceCellWhereInput, DataSourceCellWhereUniqueInput, DataSourceCount, DataSourceCountVersionsArgs, DataSourceCountAggregate, DataSourceCountOrderByAggregateInput, DataSourceCreateInput, DataSourceCreateManyInput, DataSourceCreateNestedOneWithoutVersionsInput, DataSourceCreateOrConnectWithoutVersionsInput, DataSourceCreateWithoutVersionsInput, DataSourceDeleteImpact, DataSourceGroupBy, DataSourceMaxAggregate, DataSourceMaxOrderByAggregateInput, DataSourceMeta, DataSourceMinAggregate, DataSourceMinOrderByAggregateInput, DataSourceOrderByRelevanceFieldEnum, DataSourceOrderByRelevanceInput, DataSourceOrderByWithAggregationInput, DataSourceOrderByWithRelationInput, DataSourceSaveResolverCreateInput, DataSourceSaveResolverUpdateInput, DataSourceScalarFieldEnum, DataSourceScalarRelationFilter, DataSourceScalarWhereWithAggregatesInput, DataSourceSumAggregate, DataSourceSumOrderByAggregateInput, DataSourceType, DataSourceUpdateInput, DataSourceUpdateManyMutationInput, DataSourceUpdateOneRequiredWithoutVersionsNestedInput, DataSourceUpdateToOneWithWhereWithoutVersionsInput, DataSourceUpdateWithoutVersionsInput, DataSourceUpsertWithoutVersionsInput, DataSourceVersion, DataSourceVersionCellsArgs, DataSourceVersionAvgAggregate, DataSourceVersionAvgOrderByAggregateInput, DataSourceVersionCount, DataSourceVersionCountCellsArgs, DataSourceVersionCountProposalVersionsArgs, DataSourceVersionCountAggregate, DataSourceVersionCountOrderByAggregateInput, DataSourceVersionCreateInput, DataSourceVersionCreateManyDataSourceInput, DataSourceVersionCreateManyDataSourceInputEnvelope, DataSourceVersionCreateManyInput, DataSourceVersionCreateNestedManyWithoutDataSourceInput, DataSourceVersionCreateNestedOneWithoutCellsInput, DataSourceVersionCreateNestedOneWithoutOriginInput, DataSourceVersionCreateOrConnectWithoutCellsInput, DataSourceVersionCreateOrConnectWithoutDataSourceInput, DataSourceVersionCreateOrConnectWithoutOriginInput, DataSourceVersionCreateWithoutCellsInput, DataSourceVersionCreateWithoutDataSourceInput, DataSourceVersionCreateWithoutOriginInput, DataSourceVersionGroupBy, DataSourceVersionListRelationFilter, DataSourceVersionMaxAggregate, DataSourceVersionMaxOrderByAggregateInput, DataSourceVersionMeta, DataSourceVersionMinAggregate, DataSourceVersionMinOrderByAggregateInput, DataSourceVersionOrderByRelationAggregateInput, DataSourceVersionOrderByRelevanceFieldEnum, DataSourceVersionOrderByRelevanceInput, DataSourceVersionOrderByWithAggregationInput, DataSourceVersionOrderByWithRelationInput, DataSourceVersionOrigin, DataSourceVersionOriginAvgAggregate, DataSourceVersionOriginAvgOrderByAggregateInput, DataSourceVersionOriginCountAggregate, DataSourceVersionOriginCountOrderByAggregateInput, DataSourceVersionOriginCreateInput, DataSourceVersionOriginCreateManyInput, DataSourceVersionOriginGroupBy, DataSourceVersionOriginMaxAggregate, DataSourceVersionOriginMaxOrderByAggregateInput, DataSourceVersionOriginMinAggregate, DataSourceVersionOriginMinOrderByAggregateInput, DataSourceVersionOriginOrderByWithAggregationInput, DataSourceVersionOriginOrderByWithRelationInput, DataSourceVersionOriginScalarFieldEnum, DataSourceVersionOriginScalarWhereWithAggregatesInput, DataSourceVersionOriginSumAggregate, DataSourceVersionOriginSumOrderByAggregateInput, DataSourceVersionOriginUpdateInput, DataSourceVersionOriginUpdateManyMutationInput, DataSourceVersionOriginWhereInput, DataSourceVersionOriginWhereUniqueInput, DataSourceVersionScalarFieldEnum, DataSourceVersionScalarRelationFilter, DataSourceVersionScalarWhereInput, DataSourceVersionScalarWhereWithAggregatesInput, DataSourceVersionSumAggregate, DataSourceVersionSumOrderByAggregateInput, DataSourceVersionUpdateInput, DataSourceVersionUpdateManyMutationInput, DataSourceVersionUpdateManyWithWhereWithoutDataSourceInput, DataSourceVersionUpdateManyWithoutDataSourceNestedInput, DataSourceVersionUpdateOneRequiredWithoutCellsNestedInput, DataSourceVersionUpdateOneRequiredWithoutOriginNestedInput, DataSourceVersionUpdateToOneWithWhereWithoutCellsInput, DataSourceVersionUpdateToOneWithWhereWithoutOriginInput, DataSourceVersionUpdateWithWhereUniqueWithoutDataSourceInput, DataSourceVersionUpdateWithoutCellsInput, DataSourceVersionUpdateWithoutDataSourceInput, DataSourceVersionUpdateWithoutOriginInput, DataSourceVersionUpsertWithWhereUniqueWithoutDataSourceInput, DataSourceVersionUpsertWithoutCellsInput, DataSourceVersionUpsertWithoutOriginInput, DataSourceVersionWhereInput, DataSourceVersionWhereUniqueInput, DataSourceWhereInput, DataSourceWhereUniqueInput, DateMode, DateTimeFieldUpdateOperationsInput, DateTimeFilter, DateTimeNullableFilter, DateTimeNullableWithAggregatesFilter, DateTimeWithAggregatesFilter, DefaultInfo, EnumDataSourceTypeFieldUpdateOperationsInput, EnumDataSourceTypeFilter, EnumDataSourceTypeWithAggregatesFilter, EnumDateModeNullableFilter, EnumFiltersSourceTypeFieldUpdateOperationsInput, EnumFiltersSourceTypeFilter, EnumFiltersSourceTypeWithAggregatesFilter, EnumProposalTypeFieldUpdateOperationsInput, EnumProposalTypeFilter, EnumTemplateTypeFieldUpdateOperationsInput, EnumTemplateTypeFilter, EnumTemplateTypeWithAggregatesFilter, EventAggregationByInterval, Feature, Features, FederatedIdentityRepresentation, Field, FiltersSourceType, FloatNullableFilter, IdInt, InsightAuditChangeBreakdown, InsightAuditChangeItem, InsightAuditChangesPaginated, InsightAuditPageBreakdown, IntFieldUpdateOperationsInput, IntFilter, IntNullableFilter, IntNullableWithAggregatesFilter, IntWithAggregatesFilter, JsonFilter, JsonNullableFilter, JsonNullableWithAggregatesFilter, JsonWithAggregatesFilter, KeycloakClient, KeycloakClientAttributes, KeycloakClientAttributesInput, KeycloakClientInput, KeycloakGroup, KeycloakServerInfo, KeycloakThemes, KeycloakUser, KeycloakUserProtected, LogAuditEventInput, LogicalOperator, Lookup, LookupAvgAggregate, LookupAvgOrderByAggregateInput, LookupCountAggregate, LookupCountOrderByAggregateInput, LookupCreateInput, LookupCreateManyInput, LookupGroupBy, LookupMaxAggregate, LookupMaxOrderByAggregateInput, LookupMinAggregate, LookupMinOrderByAggregateInput, LookupOrderByRelevanceFieldEnum, LookupOrderByRelevanceInput, LookupOrderByWithAggregationInput, LookupOrderByWithRelationInput, LookupScalarFieldEnum, LookupScalarWhereWithAggregatesInput, LookupSumAggregate, LookupSumOrderByAggregateInput, LookupUpdateInput, LookupUpdateManyMutationInput, LookupWhereInput, LookupWhereUniqueInput, NavigationPositionResp, NestedBigIntNullableFilter, NestedBoolFilter, NestedBoolNullableFilter, NestedBoolNullableWithAggregatesFilter, NestedBoolWithAggregatesFilter, NestedDateTimeFilter, NestedDateTimeNullableFilter, NestedDateTimeNullableWithAggregatesFilter, NestedDateTimeWithAggregatesFilter, NestedEnumDataSourceTypeFilter, NestedEnumDataSourceTypeWithAggregatesFilter, NestedEnumDateModeNullableFilter, NestedEnumFiltersSourceTypeFilter, NestedEnumFiltersSourceTypeWithAggregatesFilter, NestedEnumProposalTypeFilter, NestedEnumTemplateTypeFilter, NestedEnumTemplateTypeWithAggregatesFilter, NestedFloatFilter, NestedFloatNullableFilter, NestedIntFilter, NestedIntNullableFilter, NestedIntNullableWithAggregatesFilter, NestedIntWithAggregatesFilter, NestedJsonFilter, NestedJsonNullableFilter, NestedStringFilter, NestedStringNullableFilter, NestedStringNullableWithAggregatesFilter, NestedStringWithAggregatesFilter, Note, NoteAvgAggregate, NoteAvgOrderByAggregateInput, NoteCountAggregate, NoteCountOrderByAggregateInput, NoteCreateInput, NoteCreateManyInput, NoteCreateManyProposalInput, NoteCreateManyProposalInputEnvelope, NoteCreateNestedManyWithoutProposalInput, NoteCreateOrConnectWithoutProposalInput, NoteCreateWithoutProposalInput, NoteGroupBy, NoteListRelationFilter, NoteMaxAggregate, NoteMaxOrderByAggregateInput, NoteMinAggregate, NoteMinOrderByAggregateInput, NoteOrderByRelationAggregateInput, NoteOrderByRelevanceFieldEnum, NoteOrderByRelevanceInput, NoteOrderByWithAggregationInput, NoteOrderByWithRelationInput, NoteScalarFieldEnum, NoteScalarWhereInput, NoteScalarWhereWithAggregatesInput, NoteSumAggregate, NoteSumOrderByAggregateInput, NoteUpdateInput, NoteUpdateManyMutationInput, NoteUpdateManyWithWhereWithoutProposalInput, NoteUpdateManyWithoutProposalNestedInput, NoteUpdateWithWhereUniqueWithoutProposalInput, NoteUpdateWithoutProposalInput, NoteUpsertWithWhereUniqueWithoutProposalInput, NoteWhereInput, NoteWhereUniqueInput, NullableBigIntFieldUpdateOperationsInput, NullableBoolFieldUpdateOperationsInput, NullableDateTimeFieldUpdateOperationsInput, NullableEnumDateModeFieldUpdateOperationsInput, NullableFloatFieldUpdateOperationsInput, NullableIntFieldUpdateOperationsInput, NullableStringFieldUpdateOperationsInput, NullsOrder, Proposal, ProposalNotesArgs, ProposalVersionsArgs, ProposalAnalyticsPage, ProposalCell, ProposalCellCreateManyLastVersionInput, ProposalCellCreateManyLastVersionInputEnvelope, ProposalCellCreateNestedManyWithoutLastVersionInput, ProposalCellCreateOrConnectWithoutLastVersionInput, ProposalCellCreateWithoutLastVersionInput, ProposalCellLastVersionIdColumnUuidRowUuidPageUuidArrayIndexCompoundUniqueInput, ProposalCellListRelationFilter, ProposalCellOrderByRelationAggregateInput, ProposalCellOrderByRelevanceFieldEnum, ProposalCellOrderByRelevanceInput, ProposalCellOrderByWithRelationInput, ProposalCellScalarFieldEnum, ProposalCellScalarWhereInput, ProposalCellUpdateManyMutationInput, ProposalCellUpdateManyWithWhereWithoutLastVersionInput, ProposalCellUpdateManyWithoutLastVersionNestedInput, ProposalCellUpdateWithWhereUniqueWithoutLastVersionInput, ProposalCellUpdateWithoutLastVersionInput, ProposalCellUpsertWithWhereUniqueWithoutLastVersionInput, ProposalCellWhereInput, ProposalCellWhereUniqueInput, ProposalCount, ProposalCountDataSourceVersionOriginArgs, ProposalCountNotesArgs, ProposalCountUserProposalAccessArgs, ProposalCountUserProposalPinsArgs, ProposalCountVersionsArgs, ProposalCreateInput, ProposalCreateManyTemplateVersionInput, ProposalCreateManyTemplateVersionInputEnvelope, ProposalCreateNestedManyWithoutTemplateVersionInput, ProposalCreateNestedOneWithoutDataSourceVersionOriginInput, ProposalCreateNestedOneWithoutNotesInput, ProposalCreateNestedOneWithoutUserProposalAccessInput, ProposalCreateNestedOneWithoutVersionsInput, ProposalCreateOrConnectWithoutDataSourceVersionOriginInput, ProposalCreateOrConnectWithoutNotesInput, ProposalCreateOrConnectWithoutTemplateVersionInput, ProposalCreateOrConnectWithoutUserProposalAccessInput, ProposalCreateOrConnectWithoutVersionsInput, ProposalCreateWithoutDataSourceVersionOriginInput, ProposalCreateWithoutNotesInput, ProposalCreateWithoutTemplateVersionInput, ProposalCreateWithoutUserProposalAccessInput, ProposalCreateWithoutVersionsInput, ProposalDownloadAuditEventInput, ProposalField, ProposalFieldCreateManyProposalVersionInput, ProposalFieldCreateManyProposalVersionInputEnvelope, ProposalFieldCreateNestedManyWithoutProposalVersionInput, ProposalFieldCreateOrConnectWithoutProposalVersionInput, ProposalFieldCreateWithoutProposalVersionInput, ProposalFieldListRelationFilter, ProposalFieldOrderByRelationAggregateInput, ProposalFieldOrderByRelevanceFieldEnum, ProposalFieldOrderByRelevanceInput, ProposalFieldOrderByWithRelationInput, ProposalFieldProposalVersionIdFieldIdCompoundUniqueInput, ProposalFieldScalarFieldEnum, ProposalFieldScalarWhereInput, ProposalFieldUpdateManyMutationInput, ProposalFieldUpdateManyWithWhereWithoutProposalVersionInput, ProposalFieldUpdateManyWithoutProposalVersionNestedInput, ProposalFieldUpdateWithWhereUniqueWithoutProposalVersionInput, ProposalFieldUpdateWithoutProposalVersionInput, ProposalFieldUpsertWithWhereUniqueWithoutProposalVersionInput, ProposalFieldWhereInput, ProposalFieldWhereUniqueInput, ProposalInteractionAuditEventInput, ProposalLastEditorCreateNestedOneWithoutProposalInput, ProposalLastEditorCreateOrConnectWithoutProposalInput, ProposalLastEditorCreateWithoutProposalInput, ProposalLastEditorNullableScalarRelationFilter, ProposalLastEditorOrderByRelevanceFieldEnum, ProposalLastEditorOrderByRelevanceInput, ProposalLastEditorOrderByWithRelationInput, ProposalLastEditorUpdateOneWithoutProposalNestedInput, ProposalLastEditorUpdateToOneWithWhereWithoutProposalInput, ProposalLastEditorUpdateWithoutProposalInput, ProposalLastEditorUpsertWithoutProposalInput, ProposalLastEditorWhereInput, ProposalLastEditorWhereUniqueInput, ProposalListItem, ProposalListItemField, ProposalListRelationFilter, ProposalMetric, ProposalMetricProposalVersionArgs, ProposalMetricCreateManyProposalVersionInput, ProposalMetricCreateManyProposalVersionInputEnvelope, ProposalMetricCreateNestedManyWithoutProposalVersionInput, ProposalMetricCreateOrConnectWithoutProposalVersionInput, ProposalMetricCreateWithoutProposalVersionInput, ProposalMetricListRelationFilter, ProposalMetricOrderByRelationAggregateInput, ProposalMetricOrderByRelevanceFieldEnum, ProposalMetricOrderByRelevanceInput, ProposalMetricOrderByWithRelationInput, ProposalMetricSaveInput, ProposalMetricScalarFieldEnum, ProposalMetricScalarWhereInput, ProposalMetricUpdateManyMutationInput, ProposalMetricUpdateManyWithWhereWithoutProposalVersionInput, ProposalMetricUpdateManyWithoutProposalVersionNestedInput, ProposalMetricUpdateWithWhereUniqueWithoutProposalVersionInput, ProposalMetricUpdateWithoutProposalVersionInput, ProposalMetricUpsertWithWhereUniqueWithoutProposalVersionInput, ProposalMetricWhereInput, ProposalMetricWhereUniqueInput, ProposalNavigationPositionType, ProposalOrderByRelationAggregateInput, ProposalOrderByRelevanceFieldEnum, ProposalOrderByRelevanceInput, ProposalOrderByWithRelationInput, ProposalPageDataSourceRows, ProposalPageRowIndex, ProposalPageRowIndexCreateManyVersionInput, ProposalPageRowIndexCreateManyVersionInputEnvelope, ProposalPageRowIndexCreateNestedManyWithoutVersionInput, ProposalPageRowIndexCreateOrConnectWithoutVersionInput, ProposalPageRowIndexCreateWithoutVersionInput, ProposalPageRowIndexListRelationFilter, ProposalPageRowIndexOrderByRelationAggregateInput, ProposalPageRowIndexOrderByRelevanceFieldEnum, ProposalPageRowIndexOrderByRelevanceInput, ProposalPageRowIndexOrderByWithRelationInput, ProposalPageRowIndexPageUuidVersionIdRowUuidCompoundUniqueInput, ProposalPageRowIndexScalarFieldEnum, ProposalPageRowIndexScalarWhereInput, ProposalPageRowIndexUpdateManyMutationInput, ProposalPageRowIndexUpdateManyWithWhereWithoutVersionInput, ProposalPageRowIndexUpdateManyWithoutVersionNestedInput, ProposalPageRowIndexUpdateWithWhereUniqueWithoutVersionInput, ProposalPageRowIndexUpdateWithoutVersionInput, ProposalPageRowIndexUpsertWithWhereUniqueWithoutVersionInput, ProposalPageRowIndexWhereInput, ProposalPageRowIndexWhereUniqueInput, ProposalRowSummaryResult, ProposalScalarFieldEnum, ProposalScalarRelationFilter, ProposalScalarWhereInput, ProposalTemplate, ProposalTemplateVersionsArgs, ProposalTemplateAvgAggregate, ProposalTemplateAvgOrderByAggregateInput, ProposalTemplateCount, ProposalTemplateCountVersionsArgs, ProposalTemplateCountAggregate, ProposalTemplateCountOrderByAggregateInput, ProposalTemplateCreateInput, ProposalTemplateCreateManyInput, ProposalTemplateCreateNestedOneWithoutVersionsInput, ProposalTemplateCreateOrConnectWithoutVersionsInput, ProposalTemplateCreateWithoutVersionsInput, ProposalTemplateGroupBy, ProposalTemplateMaxAggregate, ProposalTemplateMaxOrderByAggregateInput, ProposalTemplateMinAggregate, ProposalTemplateMinOrderByAggregateInput, ProposalTemplateOrderByRelevanceFieldEnum, ProposalTemplateOrderByRelevanceInput, ProposalTemplateOrderByWithAggregationInput, ProposalTemplateOrderByWithRelationInput, ProposalTemplateScalarFieldEnum, ProposalTemplateScalarRelationFilter, ProposalTemplateScalarWhereWithAggregatesInput, ProposalTemplateSumAggregate, ProposalTemplateSumOrderByAggregateInput, ProposalTemplateUpdateInput, ProposalTemplateUpdateManyMutationInput, ProposalTemplateUpdateOneRequiredWithoutVersionsNestedInput, ProposalTemplateUpdateToOneWithWhereWithoutVersionsInput, ProposalTemplateUpdateWithoutVersionsInput, ProposalTemplateUpsertWithoutVersionsInput, ProposalTemplateVersion, ProposalTemplateVersionProposalVersionArgs, ProposalTemplateVersionProposalsArgs, ProposalTemplateVersionCount, ProposalTemplateVersionCountProposalVersionArgs, ProposalTemplateVersionCountProposalsArgs, ProposalTemplateVersionCreateManyTemplateInput, ProposalTemplateVersionCreateManyTemplateInputEnvelope, ProposalTemplateVersionCreateNestedManyWithoutTemplateInput, ProposalTemplateVersionCreateNestedOneWithoutProposalVersionInput, ProposalTemplateVersionCreateNestedOneWithoutProposalsInput, ProposalTemplateVersionCreateOrConnectWithoutProposalVersionInput, ProposalTemplateVersionCreateOrConnectWithoutProposalsInput, ProposalTemplateVersionCreateOrConnectWithoutTemplateInput, ProposalTemplateVersionCreateWithoutProposalVersionInput, ProposalTemplateVersionCreateWithoutProposalsInput, ProposalTemplateVersionCreateWithoutTemplateInput, ProposalTemplateVersionListRelationFilter, ProposalTemplateVersionOrderByRelationAggregateInput, ProposalTemplateVersionOrderByRelevanceFieldEnum, ProposalTemplateVersionOrderByRelevanceInput, ProposalTemplateVersionOrderByWithRelationInput, ProposalTemplateVersionScalarFieldEnum, ProposalTemplateVersionScalarRelationFilter, ProposalTemplateVersionScalarWhereInput, ProposalTemplateVersionUpdateManyMutationInput, ProposalTemplateVersionUpdateManyWithWhereWithoutTemplateInput, ProposalTemplateVersionUpdateManyWithoutTemplateNestedInput, ProposalTemplateVersionUpdateOneRequiredWithoutProposalVersionNestedInput, ProposalTemplateVersionUpdateOneRequiredWithoutProposalsNestedInput, ProposalTemplateVersionUpdateToOneWithWhereWithoutProposalVersionInput, ProposalTemplateVersionUpdateToOneWithWhereWithoutProposalsInput, ProposalTemplateVersionUpdateWithWhereUniqueWithoutTemplateInput, ProposalTemplateVersionUpdateWithoutProposalVersionInput, ProposalTemplateVersionUpdateWithoutProposalsInput, ProposalTemplateVersionUpdateWithoutTemplateInput, ProposalTemplateVersionUpsertWithWhereUniqueWithoutTemplateInput, ProposalTemplateVersionUpsertWithoutProposalVersionInput, ProposalTemplateVersionUpsertWithoutProposalsInput, ProposalTemplateVersionWhereInput, ProposalTemplateVersionWhereUniqueInput, ProposalTemplateWhereInput, ProposalTemplateWhereUniqueInput, ProposalType, ProposalUpdateInput, ProposalUpdateManyMutationInput, ProposalUpdateManyWithWhereWithoutTemplateVersionInput, ProposalUpdateManyWithoutTemplateVersionNestedInput, ProposalUpdateOneRequiredWithoutDataSourceVersionOriginNestedInput, ProposalUpdateOneRequiredWithoutNotesNestedInput, ProposalUpdateOneRequiredWithoutUserProposalAccessNestedInput, ProposalUpdateOneRequiredWithoutVersionsNestedInput, ProposalUpdateToOneWithWhereWithoutDataSourceVersionOriginInput, ProposalUpdateToOneWithWhereWithoutNotesInput, ProposalUpdateToOneWithWhereWithoutUserProposalAccessInput, ProposalUpdateToOneWithWhereWithoutVersionsInput, ProposalUpdateWithWhereUniqueWithoutTemplateVersionInput, ProposalUpdateWithoutDataSourceVersionOriginInput, ProposalUpdateWithoutNotesInput, ProposalUpdateWithoutTemplateVersionInput, ProposalUpdateWithoutUserProposalAccessInput, ProposalUpdateWithoutVersionsInput, ProposalUpsertWithWhereUniqueWithoutTemplateVersionInput, ProposalUpsertWithoutDataSourceVersionOriginInput, ProposalUpsertWithoutNotesInput, ProposalUpsertWithoutUserProposalAccessInput, ProposalUpsertWithoutVersionsInput, ProposalVersion, ProposalVersionCellsArgs, ProposalVersionDataSourceVersionsArgs, ProposalVersionFieldsArgs, ProposalVersionMetricsArgs, ProposalVersionPageRowIndexArgs, ProposalVersionCount, ProposalVersionCountCellsArgs, ProposalVersionCountDataSourceVersionsArgs, ProposalVersionCountFieldsArgs, ProposalVersionCountMetricsArgs, ProposalVersionCountPageRowIndexArgs, ProposalVersionCreateInput, ProposalVersionCreateManyProposalInput, ProposalVersionCreateManyProposalInputEnvelope, ProposalVersionCreateManyTemplateVersionInput, ProposalVersionCreateManyTemplateVersionInputEnvelope, ProposalVersionCreateNestedManyWithoutProposalInput, ProposalVersionCreateNestedManyWithoutTemplateVersionInput, ProposalVersionCreateOrConnectWithoutProposalInput, ProposalVersionCreateOrConnectWithoutTemplateVersionInput, ProposalVersionCreateWithoutProposalInput, ProposalVersionCreateWithoutTemplateVersionInput, ProposalVersionDataCreateNestedOneWithoutProposalVersionInput, ProposalVersionDataCreateOrConnectWithoutProposalVersionInput, ProposalVersionDataCreateWithoutProposalVersionInput, ProposalVersionDataNullableScalarRelationFilter, ProposalVersionDataOrderByWithRelationInput, ProposalVersionDataSource, ProposalVersionDataSourceOrderByWithRelationInput, ProposalVersionDataSourceProposalVersionIdDataSourceVersionIdCompoundUniqueInput, ProposalVersionDataSourceScalarFieldEnum, ProposalVersionDataSourceWhereInput, ProposalVersionDataSourceWhereUniqueInput, ProposalVersionDataUpdateOneWithoutProposalVersionNestedInput, ProposalVersionDataUpdateToOneWithWhereWithoutProposalVersionInput, ProposalVersionDataUpdateWithoutProposalVersionInput, ProposalVersionDataUpsertWithoutProposalVersionInput, ProposalVersionDataWhereInput, ProposalVersionDataWhereUniqueInput, ProposalVersionListRelationFilter, ProposalVersionNullableScalarRelationFilter, ProposalVersionOrderByRelationAggregateInput, ProposalVersionOrderByRelevanceFieldEnum, ProposalVersionOrderByRelevanceInput, ProposalVersionOrderByWithRelationInput, ProposalVersionScalarFieldEnum, ProposalVersionScalarRelationFilter, ProposalVersionScalarWhereInput, ProposalVersionUpdateManyMutationInput, ProposalVersionUpdateManyWithWhereWithoutProposalInput, ProposalVersionUpdateManyWithWhereWithoutTemplateVersionInput, ProposalVersionUpdateManyWithoutProposalNestedInput, ProposalVersionUpdateManyWithoutTemplateVersionNestedInput, ProposalVersionUpdateWithWhereUniqueWithoutProposalInput, ProposalVersionUpdateWithWhereUniqueWithoutTemplateVersionInput, ProposalVersionUpdateWithoutProposalInput, ProposalVersionUpdateWithoutTemplateVersionInput, ProposalVersionUpsertWithWhereUniqueWithoutProposalInput, ProposalVersionUpsertWithWhereUniqueWithoutTemplateVersionInput, ProposalVersionWhereInput, ProposalVersionWhereUniqueInput, ProposalWhereInput, ProposalWhereUniqueInput, ProposalWithPageIds, ProposalsFilter, ProposalsFilterItem, ProposalsPaginated, ProposalsSortItem, PublicConfig, QueryMode, RequiredAction, Resp, Role, Scope, SortOrder, SortOrderInput, StringFieldUpdateOperationsInput, StringFilter, StringNullableFilter, StringNullableWithAggregatesFilter, StringWithAggregatesFilter, SyncUserActivityInput, TemplateCreateInput, TemplatePageType, TemplateType, TemplateUpdateInput, ThemeInfoRepresentation, UserActivityRow, UserConsentRepresentation, UserCreateInput, UserFacingError, UserFacingErrorCode, UserLoginAuditEventInput, UserLogoutAuditEventInput, UserProposalAccess, UserProposalAccessAvgAggregate, UserProposalAccessAvgOrderByAggregateInput, UserProposalAccessCountAggregate, UserProposalAccessCountOrderByAggregateInput, UserProposalAccessCreateInput, UserProposalAccessCreateManyInput, UserProposalAccessCreateManyProposalInput, UserProposalAccessCreateManyProposalInputEnvelope, UserProposalAccessCreateNestedManyWithoutProposalInput, UserProposalAccessCreateOrConnectWithoutProposalInput, UserProposalAccessCreateWithoutProposalInput, UserProposalAccessGroupBy, UserProposalAccessListRelationFilter, UserProposalAccessMaxAggregate, UserProposalAccessMaxOrderByAggregateInput, UserProposalAccessMinAggregate, UserProposalAccessMinOrderByAggregateInput, UserProposalAccessOrderByRelationAggregateInput, UserProposalAccessOrderByRelevanceFieldEnum, UserProposalAccessOrderByRelevanceInput, UserProposalAccessOrderByWithAggregationInput, UserProposalAccessOrderByWithRelationInput, UserProposalAccessScalarFieldEnum, UserProposalAccessScalarWhereInput, UserProposalAccessScalarWhereWithAggregatesInput, UserProposalAccessSumAggregate, UserProposalAccessSumOrderByAggregateInput, UserProposalAccessUpdateInput, UserProposalAccessUpdateManyMutationInput, UserProposalAccessUpdateManyWithWhereWithoutProposalInput, UserProposalAccessUpdateManyWithoutProposalNestedInput, UserProposalAccessUpdateWithWhereUniqueWithoutProposalInput, UserProposalAccessUpdateWithoutProposalInput, UserProposalAccessUpsertWithWhereUniqueWithoutProposalInput, UserProposalAccessUserEmailProposalIdCompoundUniqueInput, UserProposalAccessWhereInput, UserProposalAccessWhereUniqueInput, UserProposalPinCreateManyProposalInput, UserProposalPinCreateManyProposalInputEnvelope, UserProposalPinCreateNestedManyWithoutProposalInput, UserProposalPinCreateOrConnectWithoutProposalInput, UserProposalPinCreateWithoutProposalInput, UserProposalPinListRelationFilter, UserProposalPinOrderByRelationAggregateInput, UserProposalPinScalarWhereInput, UserProposalPinUpdateManyMutationInput, UserProposalPinUpdateManyWithWhereWithoutProposalInput, UserProposalPinUpdateManyWithoutProposalNestedInput, UserProposalPinUpdateWithWhereUniqueWithoutProposalInput, UserProposalPinUpdateWithoutProposalInput, UserProposalPinUpsertWithWhereUniqueWithoutProposalInput, UserProposalPinUserEmailProposalIdCompoundUniqueInput, UserProposalPinWhereInput, UserProposalPinWhereUniqueInput } from './apollo'

type Properties<T> = Required<{
  [K in keyof T]: z.ZodType<T[K], any, T[K]>;
}>;

type definedNonNullAny = {};

export const isDefinedNonNullAny = (v: any): v is definedNonNullAny => v !== undefined && v !== null;

export const definedNonNullAnySchema = z.any().refine((v) => isDefinedNonNullAny(v));

export const AggregateSelectProposalSchema = z.nativeEnum(AggregateSelectProposal);

export const AggregateSelectValueTypeSchema = z.nativeEnum(AggregateSelectValueType);

export const AggregateTransformSchema = z.nativeEnum(AggregateTransform);

export const AnalyticsDashboardChartOrderByRelevanceFieldEnumSchema = z.nativeEnum(AnalyticsDashboardChartOrderByRelevanceFieldEnum);

export const AnalyticsDashboardChartScalarFieldEnumSchema = z.nativeEnum(AnalyticsDashboardChartScalarFieldEnum);

export const AnalyticsDashboardFiltersSourceOrderByRelevanceFieldEnumSchema = z.nativeEnum(AnalyticsDashboardFiltersSourceOrderByRelevanceFieldEnum);

export const AnalyticsDashboardFiltersSourceScalarFieldEnumSchema = z.nativeEnum(AnalyticsDashboardFiltersSourceScalarFieldEnum);

export const AnalyticsDashboardOrderByRelevanceFieldEnumSchema = z.nativeEnum(AnalyticsDashboardOrderByRelevanceFieldEnum);

export const AnalyticsDashboardScalarFieldEnumSchema = z.nativeEnum(AnalyticsDashboardScalarFieldEnum);

export const CalendarIntervalSchema = z.nativeEnum(CalendarInterval);

export const DataSourceCellOrderByRelevanceFieldEnumSchema = z.nativeEnum(DataSourceCellOrderByRelevanceFieldEnum);

export const DataSourceCellScalarFieldEnumSchema = z.nativeEnum(DataSourceCellScalarFieldEnum);

export const DataSourceOrderByRelevanceFieldEnumSchema = z.nativeEnum(DataSourceOrderByRelevanceFieldEnum);

export const DataSourceScalarFieldEnumSchema = z.nativeEnum(DataSourceScalarFieldEnum);

export const DataSourceTypeSchema = z.nativeEnum(DataSourceType);

export const DataSourceVersionOrderByRelevanceFieldEnumSchema = z.nativeEnum(DataSourceVersionOrderByRelevanceFieldEnum);

export const DataSourceVersionOriginScalarFieldEnumSchema = z.nativeEnum(DataSourceVersionOriginScalarFieldEnum);

export const DataSourceVersionScalarFieldEnumSchema = z.nativeEnum(DataSourceVersionScalarFieldEnum);

export const DateModeSchema = z.nativeEnum(DateMode);

export const FeatureSchema = z.nativeEnum(Feature);

export const FiltersSourceTypeSchema = z.nativeEnum(FiltersSourceType);

export const LogicalOperatorSchema = z.nativeEnum(LogicalOperator);

export const LookupOrderByRelevanceFieldEnumSchema = z.nativeEnum(LookupOrderByRelevanceFieldEnum);

export const LookupScalarFieldEnumSchema = z.nativeEnum(LookupScalarFieldEnum);

export const NoteOrderByRelevanceFieldEnumSchema = z.nativeEnum(NoteOrderByRelevanceFieldEnum);

export const NoteScalarFieldEnumSchema = z.nativeEnum(NoteScalarFieldEnum);

export const NullsOrderSchema = z.nativeEnum(NullsOrder);

export const ProposalCellOrderByRelevanceFieldEnumSchema = z.nativeEnum(ProposalCellOrderByRelevanceFieldEnum);

export const ProposalCellScalarFieldEnumSchema = z.nativeEnum(ProposalCellScalarFieldEnum);

export const ProposalFieldOrderByRelevanceFieldEnumSchema = z.nativeEnum(ProposalFieldOrderByRelevanceFieldEnum);

export const ProposalFieldScalarFieldEnumSchema = z.nativeEnum(ProposalFieldScalarFieldEnum);

export const ProposalLastEditorOrderByRelevanceFieldEnumSchema = z.nativeEnum(ProposalLastEditorOrderByRelevanceFieldEnum);

export const ProposalMetricOrderByRelevanceFieldEnumSchema = z.nativeEnum(ProposalMetricOrderByRelevanceFieldEnum);

export const ProposalMetricScalarFieldEnumSchema = z.nativeEnum(ProposalMetricScalarFieldEnum);

export const ProposalNavigationPositionTypeSchema = z.nativeEnum(ProposalNavigationPositionType);

export const ProposalOrderByRelevanceFieldEnumSchema = z.nativeEnum(ProposalOrderByRelevanceFieldEnum);

export const ProposalPageRowIndexOrderByRelevanceFieldEnumSchema = z.nativeEnum(ProposalPageRowIndexOrderByRelevanceFieldEnum);

export const ProposalPageRowIndexScalarFieldEnumSchema = z.nativeEnum(ProposalPageRowIndexScalarFieldEnum);

export const ProposalScalarFieldEnumSchema = z.nativeEnum(ProposalScalarFieldEnum);

export const ProposalTemplateOrderByRelevanceFieldEnumSchema = z.nativeEnum(ProposalTemplateOrderByRelevanceFieldEnum);

export const ProposalTemplateScalarFieldEnumSchema = z.nativeEnum(ProposalTemplateScalarFieldEnum);

export const ProposalTemplateVersionOrderByRelevanceFieldEnumSchema = z.nativeEnum(ProposalTemplateVersionOrderByRelevanceFieldEnum);

export const ProposalTemplateVersionScalarFieldEnumSchema = z.nativeEnum(ProposalTemplateVersionScalarFieldEnum);

export const ProposalTypeSchema = z.nativeEnum(ProposalType);

export const ProposalVersionDataSourceScalarFieldEnumSchema = z.nativeEnum(ProposalVersionDataSourceScalarFieldEnum);

export const ProposalVersionOrderByRelevanceFieldEnumSchema = z.nativeEnum(ProposalVersionOrderByRelevanceFieldEnum);

export const ProposalVersionScalarFieldEnumSchema = z.nativeEnum(ProposalVersionScalarFieldEnum);

export const QueryModeSchema = z.nativeEnum(QueryMode);

export const RequiredActionSchema = z.nativeEnum(RequiredAction);

export const RoleSchema = z.nativeEnum(Role);

export const ScopeSchema = z.nativeEnum(Scope);

export const SortOrderSchema = z.nativeEnum(SortOrder);

export const TemplatePageTypeSchema = z.nativeEnum(TemplatePageType);

export const TemplateTypeSchema = z.nativeEnum(TemplateType);

export const UserFacingErrorCodeSchema = z.nativeEnum(UserFacingErrorCode);

export const UserProposalAccessOrderByRelevanceFieldEnumSchema = z.nativeEnum(UserProposalAccessOrderByRelevanceFieldEnum);

export const UserProposalAccessScalarFieldEnumSchema = z.nativeEnum(UserProposalAccessScalarFieldEnum);

export function AffectedRowsOutputSchema(): z.ZodObject<Properties<AffectedRowsOutput>> {
  return z.object({
    __typename: z.literal('AffectedRowsOutput').optional(),
    count: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function AggregateSchema(): z.ZodObject<Properties<Aggregate>> {
  return z.object({
    from: z.string().trim(),
    groupBy: z.array(z.string().trim()).nullish(),
    primaryColumnUUID: z.string().trim(),
    select: z.array(z.lazy(() => AggregateSelectSchema())).nullish(),
    where: z.array(z.lazy(() => AggregateWhereSchema())).nullish()
  })
}

export function AggregateAnalyticsDashboardSchema(): z.ZodObject<Properties<AggregateAnalyticsDashboard>> {
  return z.object({
    __typename: z.literal('AggregateAnalyticsDashboard').optional(),
    _avg: z.lazy(() => AnalyticsDashboardAvgAggregateSchema().nullish()),
    _count: z.lazy(() => AnalyticsDashboardCountAggregateSchema().nullish()),
    _max: z.lazy(() => AnalyticsDashboardMaxAggregateSchema().nullish()),
    _min: z.lazy(() => AnalyticsDashboardMinAggregateSchema().nullish()),
    _sum: z.lazy(() => AnalyticsDashboardSumAggregateSchema().nullish())
  })
}

export function AggregateAnalyticsDashboardChartSchema(): z.ZodObject<Properties<AggregateAnalyticsDashboardChart>> {
  return z.object({
    __typename: z.literal('AggregateAnalyticsDashboardChart').optional(),
    _avg: z.lazy(() => AnalyticsDashboardChartAvgAggregateSchema().nullish()),
    _count: z.lazy(() => AnalyticsDashboardChartCountAggregateSchema().nullish()),
    _max: z.lazy(() => AnalyticsDashboardChartMaxAggregateSchema().nullish()),
    _min: z.lazy(() => AnalyticsDashboardChartMinAggregateSchema().nullish()),
    _sum: z.lazy(() => AnalyticsDashboardChartSumAggregateSchema().nullish())
  })
}

export function AggregateAnalyticsDashboardFiltersSourceSchema(): z.ZodObject<Properties<AggregateAnalyticsDashboardFiltersSource>> {
  return z.object({
    __typename: z.literal('AggregateAnalyticsDashboardFiltersSource').optional(),
    _avg: z.lazy(() => AnalyticsDashboardFiltersSourceAvgAggregateSchema().nullish()),
    _count: z.lazy(() => AnalyticsDashboardFiltersSourceCountAggregateSchema().nullish()),
    _max: z.lazy(() => AnalyticsDashboardFiltersSourceMaxAggregateSchema().nullish()),
    _min: z.lazy(() => AnalyticsDashboardFiltersSourceMinAggregateSchema().nullish()),
    _sum: z.lazy(() => AnalyticsDashboardFiltersSourceSumAggregateSchema().nullish())
  })
}

export function AggregateDataSourceSchema(): z.ZodObject<Properties<AggregateDataSource>> {
  return z.object({
    __typename: z.literal('AggregateDataSource').optional(),
    _avg: z.lazy(() => DataSourceAvgAggregateSchema().nullish()),
    _count: z.lazy(() => DataSourceCountAggregateSchema().nullish()),
    _max: z.lazy(() => DataSourceMaxAggregateSchema().nullish()),
    _min: z.lazy(() => DataSourceMinAggregateSchema().nullish()),
    _sum: z.lazy(() => DataSourceSumAggregateSchema().nullish())
  })
}

export function AggregateDataSourceCellSchema(): z.ZodObject<Properties<AggregateDataSourceCell>> {
  return z.object({
    __typename: z.literal('AggregateDataSourceCell').optional(),
    _avg: z.lazy(() => DataSourceCellAvgAggregateSchema().nullish()),
    _count: z.lazy(() => DataSourceCellCountAggregateSchema().nullish()),
    _max: z.lazy(() => DataSourceCellMaxAggregateSchema().nullish()),
    _min: z.lazy(() => DataSourceCellMinAggregateSchema().nullish()),
    _sum: z.lazy(() => DataSourceCellSumAggregateSchema().nullish())
  })
}

export function AggregateDataSourceVersionSchema(): z.ZodObject<Properties<AggregateDataSourceVersion>> {
  return z.object({
    __typename: z.literal('AggregateDataSourceVersion').optional(),
    _avg: z.lazy(() => DataSourceVersionAvgAggregateSchema().nullish()),
    _count: z.lazy(() => DataSourceVersionCountAggregateSchema().nullish()),
    _max: z.lazy(() => DataSourceVersionMaxAggregateSchema().nullish()),
    _min: z.lazy(() => DataSourceVersionMinAggregateSchema().nullish()),
    _sum: z.lazy(() => DataSourceVersionSumAggregateSchema().nullish())
  })
}

export function AggregateDataSourceVersionOriginSchema(): z.ZodObject<Properties<AggregateDataSourceVersionOrigin>> {
  return z.object({
    __typename: z.literal('AggregateDataSourceVersionOrigin').optional(),
    _avg: z.lazy(() => DataSourceVersionOriginAvgAggregateSchema().nullish()),
    _count: z.lazy(() => DataSourceVersionOriginCountAggregateSchema().nullish()),
    _max: z.lazy(() => DataSourceVersionOriginMaxAggregateSchema().nullish()),
    _min: z.lazy(() => DataSourceVersionOriginMinAggregateSchema().nullish()),
    _sum: z.lazy(() => DataSourceVersionOriginSumAggregateSchema().nullish())
  })
}

export function AggregateLookupSchema(): z.ZodObject<Properties<AggregateLookup>> {
  return z.object({
    __typename: z.literal('AggregateLookup').optional(),
    _avg: z.lazy(() => LookupAvgAggregateSchema().nullish()),
    _count: z.lazy(() => LookupCountAggregateSchema().nullish()),
    _max: z.lazy(() => LookupMaxAggregateSchema().nullish()),
    _min: z.lazy(() => LookupMinAggregateSchema().nullish()),
    _sum: z.lazy(() => LookupSumAggregateSchema().nullish())
  })
}

export function AggregateNoteSchema(): z.ZodObject<Properties<AggregateNote>> {
  return z.object({
    __typename: z.literal('AggregateNote').optional(),
    _avg: z.lazy(() => NoteAvgAggregateSchema().nullish()),
    _count: z.lazy(() => NoteCountAggregateSchema().nullish()),
    _max: z.lazy(() => NoteMaxAggregateSchema().nullish()),
    _min: z.lazy(() => NoteMinAggregateSchema().nullish()),
    _sum: z.lazy(() => NoteSumAggregateSchema().nullish())
  })
}

export function AggregateProposalTemplateSchema(): z.ZodObject<Properties<AggregateProposalTemplate>> {
  return z.object({
    __typename: z.literal('AggregateProposalTemplate').optional(),
    _avg: z.lazy(() => ProposalTemplateAvgAggregateSchema().nullish()),
    _count: z.lazy(() => ProposalTemplateCountAggregateSchema().nullish()),
    _max: z.lazy(() => ProposalTemplateMaxAggregateSchema().nullish()),
    _min: z.lazy(() => ProposalTemplateMinAggregateSchema().nullish()),
    _sum: z.lazy(() => ProposalTemplateSumAggregateSchema().nullish())
  })
}

export function AggregateSelectSchema(): z.ZodObject<Properties<AggregateSelect>> {
  return z.object({
    aggregate: z.string().trim().nullish(),
    as: z.string().trim().nullish(),
    columnUUID: z.string().trim().nullish(),
    compareWith: z.string().trim().nullish(),
    distinct: z.boolean().nullish(),
    fieldUUID: z.string().trim().nullish(),
    proposal: AggregateSelectProposalSchema.nullish(),
    thresholds: z.array(z.number()).nullish(),
    transform: AggregateTransformSchema.nullish(),
    valueType: AggregateSelectValueTypeSchema.nullish()
  })
}

export function AggregateUserProposalAccessSchema(): z.ZodObject<Properties<AggregateUserProposalAccess>> {
  return z.object({
    __typename: z.literal('AggregateUserProposalAccess').optional(),
    _avg: z.lazy(() => UserProposalAccessAvgAggregateSchema().nullish()),
    _count: z.lazy(() => UserProposalAccessCountAggregateSchema().nullish()),
    _max: z.lazy(() => UserProposalAccessMaxAggregateSchema().nullish()),
    _min: z.lazy(() => UserProposalAccessMinAggregateSchema().nullish()),
    _sum: z.lazy(() => UserProposalAccessSumAggregateSchema().nullish())
  })
}

export function AggregateWhereSchema(): z.ZodObject<Properties<AggregateWhere>> {
  return z.object({
    columnUUID: z.string().trim().nullish(),
    gt: z.number().nullish(),
    id: z.string().trim().nullish(),
    in: z.array(z.union([z.number(), z.string(), z.boolean()]).nullable()).nullish(),
    lt: z.number().nullish()
  })
}

export function AggregationBucketSchema(): z.ZodObject<Properties<AggregationBucket>> {
  return z.object({
    __typename: z.literal('AggregationBucket').optional(),
    doc_count: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    key: z.number()
  })
}

export function AnalyticsDashboardSchema(): z.ZodObject<Properties<AnalyticsDashboard>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboard').optional(),
    _count: z.lazy(() => AnalyticsDashboardCountSchema().nullish()),
    charts: z.array(z.lazy(() => AnalyticsDashboardChartSchema())),
    content: z.string().trim(),
    filtersSources: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceSchema())),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    name: z.string().trim(),
    restricted: z.boolean()
  })
}

export function AnalyticsDashboardChartsArgsSchema(): z.ZodObject<Properties<AnalyticsDashboardChartsArgs>> {
  return z.object({
    cursor: z.lazy(() => AnalyticsDashboardChartWhereUniqueInputSchema().nullish()),
    distinct: z.array(AnalyticsDashboardChartScalarFieldEnumSchema).nullish(),
    orderBy: z.array(z.lazy(() => AnalyticsDashboardChartOrderByWithRelationInputSchema())).nullish(),
    skip: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    take: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    where: z.lazy(() => AnalyticsDashboardChartWhereInputSchema().nullish())
  })
}

export function AnalyticsDashboardFiltersSourcesArgsSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourcesArgs>> {
  return z.object({
    cursor: z.lazy(() => AnalyticsDashboardFiltersSourceWhereUniqueInputSchema().nullish()),
    distinct: z.array(AnalyticsDashboardFiltersSourceScalarFieldEnumSchema).nullish(),
    orderBy: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceOrderByWithRelationInputSchema())).nullish(),
    skip: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    take: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    where: z.lazy(() => AnalyticsDashboardFiltersSourceWhereInputSchema().nullish())
  })
}

export function AnalyticsDashboardAvgAggregateSchema(): z.ZodObject<Properties<AnalyticsDashboardAvgAggregate>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboardAvgAggregate').optional(),
    id: z.number().nullish()
  })
}

export function AnalyticsDashboardAvgOrderByAggregateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardAvgOrderByAggregateInput>> {
  return z.object({
    id: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardChartSchema(): z.ZodObject<Properties<AnalyticsDashboardChart>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboardChart').optional(),
    dashboardDefinition: z.string().trim(),
    id: z.string().trim(),
    name: z.string().trim(),
    pageId: z.string().trim(),
    showTable: z.boolean(),
    sqlQuery: z.string().trim(),
    tableColumns: z.record(z.string(), z.unknown()),
    templateId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function AnalyticsDashboardChartAvgAggregateSchema(): z.ZodObject<Properties<AnalyticsDashboardChartAvgAggregate>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboardChartAvgAggregate').optional(),
    dashboardId: z.number().nullish(),
    templateId: z.number().nullish()
  })
}

export function AnalyticsDashboardChartAvgOrderByAggregateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartAvgOrderByAggregateInput>> {
  return z.object({
    templateId: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardChartCountAggregateSchema(): z.ZodObject<Properties<AnalyticsDashboardChartCountAggregate>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboardChartCountAggregate').optional(),
    _all: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    dashboardDefinition: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    dashboardId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    name: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    pageId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    showTable: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    sqlQuery: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    tableColumns: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    templateId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function AnalyticsDashboardChartCountOrderByAggregateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartCountOrderByAggregateInput>> {
  return z.object({
    dashboardDefinition: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    pageId: SortOrderSchema.nullish(),
    showTable: SortOrderSchema.nullish(),
    sqlQuery: SortOrderSchema.nullish(),
    tableColumns: SortOrderSchema.nullish(),
    templateId: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardChartCreateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartCreateInput>> {
  return z.object({
    dashboardDefinition: z.string().trim().nullish(),
    id: z.string().trim().nullish(),
    name: z.string().trim(),
    pageId: z.string().trim(),
    showTable: z.boolean().nullish(),
    sqlQuery: z.string().trim().nullish(),
    tableColumns: z.record(z.string(), z.unknown()),
    templateId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function AnalyticsDashboardChartCreateManyDashboardInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartCreateManyDashboardInput>> {
  return z.object({
    dashboardDefinition: z.string().trim().nullish(),
    id: z.string().trim().nullish(),
    name: z.string().trim(),
    pageId: z.string().trim(),
    showTable: z.boolean().nullish(),
    sqlQuery: z.string().trim().nullish(),
    tableColumns: z.record(z.string(), z.unknown()),
    templateId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function AnalyticsDashboardChartCreateManyDashboardInputEnvelopeSchema(): z.ZodObject<Properties<AnalyticsDashboardChartCreateManyDashboardInputEnvelope>> {
  return z.object({
    data: z.array(z.lazy(() => AnalyticsDashboardChartCreateManyDashboardInputSchema())),
    skipDuplicates: z.boolean().nullish()
  })
}

export function AnalyticsDashboardChartCreateManyInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartCreateManyInput>> {
  return z.object({
    dashboardDefinition: z.string().trim().nullish(),
    id: z.string().trim().nullish(),
    name: z.string().trim(),
    pageId: z.string().trim(),
    showTable: z.boolean().nullish(),
    sqlQuery: z.string().trim().nullish(),
    tableColumns: z.record(z.string(), z.unknown()),
    templateId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function AnalyticsDashboardChartCreateNestedManyWithoutDashboardInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartCreateNestedManyWithoutDashboardInput>> {
  return z.object({
    connect: z.array(z.lazy(() => AnalyticsDashboardChartWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => AnalyticsDashboardChartCreateOrConnectWithoutDashboardInputSchema())).nullish(),
    create: z.array(z.lazy(() => AnalyticsDashboardChartCreateWithoutDashboardInputSchema())).nullish(),
    createMany: z.lazy(() => AnalyticsDashboardChartCreateManyDashboardInputEnvelopeSchema().nullish())
  })
}

export function AnalyticsDashboardChartCreateOrConnectWithoutDashboardInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartCreateOrConnectWithoutDashboardInput>> {
  return z.object({
    create: z.lazy(() => AnalyticsDashboardChartCreateWithoutDashboardInputSchema()),
    where: z.lazy(() => AnalyticsDashboardChartWhereUniqueInputSchema())
  })
}

export function AnalyticsDashboardChartCreateWithoutDashboardInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartCreateWithoutDashboardInput>> {
  return z.object({
    dashboardDefinition: z.string().trim().nullish(),
    id: z.string().trim().nullish(),
    name: z.string().trim(),
    pageId: z.string().trim(),
    showTable: z.boolean().nullish(),
    sqlQuery: z.string().trim().nullish(),
    tableColumns: z.record(z.string(), z.unknown()),
    templateId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function AnalyticsDashboardChartGroupBySchema(): z.ZodObject<Properties<AnalyticsDashboardChartGroupBy>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboardChartGroupBy').optional(),
    _avg: z.lazy(() => AnalyticsDashboardChartAvgAggregateSchema().nullish()),
    _count: z.lazy(() => AnalyticsDashboardChartCountAggregateSchema().nullish()),
    _max: z.lazy(() => AnalyticsDashboardChartMaxAggregateSchema().nullish()),
    _min: z.lazy(() => AnalyticsDashboardChartMinAggregateSchema().nullish()),
    _sum: z.lazy(() => AnalyticsDashboardChartSumAggregateSchema().nullish()),
    dashboardDefinition: z.string().trim(),
    dashboardId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    id: z.string().trim(),
    name: z.string().trim(),
    pageId: z.string().trim(),
    showTable: z.boolean(),
    sqlQuery: z.string().trim(),
    tableColumns: z.record(z.string(), z.unknown()),
    templateId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function AnalyticsDashboardChartListRelationFilterSchema(): z.ZodObject<Properties<AnalyticsDashboardChartListRelationFilter>> {
  return z.object({
    every: z.lazy(() => AnalyticsDashboardChartWhereInputSchema().nullish()),
    none: z.lazy(() => AnalyticsDashboardChartWhereInputSchema().nullish()),
    some: z.lazy(() => AnalyticsDashboardChartWhereInputSchema().nullish())
  })
}

export function AnalyticsDashboardChartMaxAggregateSchema(): z.ZodObject<Properties<AnalyticsDashboardChartMaxAggregate>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboardChartMaxAggregate').optional(),
    dashboardDefinition: z.string().trim().nullish(),
    dashboardId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    id: z.string().trim().nullish(),
    name: z.string().trim().nullish(),
    pageId: z.string().trim().nullish(),
    showTable: z.boolean().nullish(),
    sqlQuery: z.string().trim().nullish(),
    templateId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function AnalyticsDashboardChartMaxOrderByAggregateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartMaxOrderByAggregateInput>> {
  return z.object({
    dashboardDefinition: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    pageId: SortOrderSchema.nullish(),
    showTable: SortOrderSchema.nullish(),
    sqlQuery: SortOrderSchema.nullish(),
    templateId: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardChartMinAggregateSchema(): z.ZodObject<Properties<AnalyticsDashboardChartMinAggregate>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboardChartMinAggregate').optional(),
    dashboardDefinition: z.string().trim().nullish(),
    dashboardId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    id: z.string().trim().nullish(),
    name: z.string().trim().nullish(),
    pageId: z.string().trim().nullish(),
    showTable: z.boolean().nullish(),
    sqlQuery: z.string().trim().nullish(),
    templateId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function AnalyticsDashboardChartMinOrderByAggregateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartMinOrderByAggregateInput>> {
  return z.object({
    dashboardDefinition: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    pageId: SortOrderSchema.nullish(),
    showTable: SortOrderSchema.nullish(),
    sqlQuery: SortOrderSchema.nullish(),
    templateId: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardChartOrderByRelationAggregateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartOrderByRelationAggregateInput>> {
  return z.object({
    _count: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardChartOrderByRelevanceInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartOrderByRelevanceInput>> {
  return z.object({
    fields: z.array(AnalyticsDashboardChartOrderByRelevanceFieldEnumSchema),
    search: z.string().trim(),
    sort: SortOrderSchema
  })
}

export function AnalyticsDashboardChartOrderByWithAggregationInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartOrderByWithAggregationInput>> {
  return z.object({
    _avg: z.lazy(() => AnalyticsDashboardChartAvgOrderByAggregateInputSchema().nullish()),
    _count: z.lazy(() => AnalyticsDashboardChartCountOrderByAggregateInputSchema().nullish()),
    _max: z.lazy(() => AnalyticsDashboardChartMaxOrderByAggregateInputSchema().nullish()),
    _min: z.lazy(() => AnalyticsDashboardChartMinOrderByAggregateInputSchema().nullish()),
    _sum: z.lazy(() => AnalyticsDashboardChartSumOrderByAggregateInputSchema().nullish()),
    dashboardDefinition: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    pageId: SortOrderSchema.nullish(),
    showTable: SortOrderSchema.nullish(),
    sqlQuery: SortOrderSchema.nullish(),
    tableColumns: SortOrderSchema.nullish(),
    templateId: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardChartOrderByWithRelationInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartOrderByWithRelationInput>> {
  return z.object({
    _relevance: z.lazy(() => AnalyticsDashboardChartOrderByRelevanceInputSchema().nullish()),
    dashboardDefinition: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    pageId: SortOrderSchema.nullish(),
    showTable: SortOrderSchema.nullish(),
    sqlQuery: SortOrderSchema.nullish(),
    tableColumns: SortOrderSchema.nullish(),
    templateId: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardChartScalarWhereInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartScalarWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => AnalyticsDashboardChartScalarWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => AnalyticsDashboardChartScalarWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => AnalyticsDashboardChartScalarWhereInputSchema())).nullish(),
    dashboardDefinition: z.lazy(() => StringFilterSchema().nullish()),
    id: z.lazy(() => StringFilterSchema().nullish()),
    name: z.lazy(() => StringFilterSchema().nullish()),
    pageId: z.lazy(() => StringFilterSchema().nullish()),
    showTable: z.lazy(() => BoolFilterSchema().nullish()),
    sqlQuery: z.lazy(() => StringFilterSchema().nullish()),
    tableColumns: z.lazy(() => JsonFilterSchema().nullish()),
    templateId: z.lazy(() => IntFilterSchema().nullish())
  })
}

export function AnalyticsDashboardChartScalarWhereWithAggregatesInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartScalarWhereWithAggregatesInput>> {
  return z.object({
    AND: z.array(z.lazy(() => AnalyticsDashboardChartScalarWhereWithAggregatesInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => AnalyticsDashboardChartScalarWhereWithAggregatesInputSchema())).nullish(),
    OR: z.array(z.lazy(() => AnalyticsDashboardChartScalarWhereWithAggregatesInputSchema())).nullish(),
    dashboardDefinition: z.lazy(() => StringWithAggregatesFilterSchema().nullish()),
    id: z.lazy(() => StringWithAggregatesFilterSchema().nullish()),
    name: z.lazy(() => StringWithAggregatesFilterSchema().nullish()),
    pageId: z.lazy(() => StringWithAggregatesFilterSchema().nullish()),
    showTable: z.lazy(() => BoolWithAggregatesFilterSchema().nullish()),
    sqlQuery: z.lazy(() => StringWithAggregatesFilterSchema().nullish()),
    tableColumns: z.lazy(() => JsonWithAggregatesFilterSchema().nullish()),
    templateId: z.lazy(() => IntWithAggregatesFilterSchema().nullish())
  })
}

export function AnalyticsDashboardChartSumAggregateSchema(): z.ZodObject<Properties<AnalyticsDashboardChartSumAggregate>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboardChartSumAggregate').optional(),
    dashboardId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    templateId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function AnalyticsDashboardChartSumOrderByAggregateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartSumOrderByAggregateInput>> {
  return z.object({
    templateId: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardChartUpdateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartUpdateInput>> {
  return z.object({
    dashboardDefinition: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    id: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    name: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    pageId: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    showTable: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    sqlQuery: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    tableColumns: z.record(z.string(), z.unknown()).nullish(),
    templateId: z.lazy(() => IntFieldUpdateOperationsInputSchema().nullish())
  })
}

export function AnalyticsDashboardChartUpdateManyMutationInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartUpdateManyMutationInput>> {
  return z.object({
    dashboardDefinition: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    id: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    name: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    pageId: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    showTable: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    sqlQuery: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    tableColumns: z.record(z.string(), z.unknown()).nullish(),
    templateId: z.lazy(() => IntFieldUpdateOperationsInputSchema().nullish())
  })
}

export function AnalyticsDashboardChartUpdateManyWithWhereWithoutDashboardInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartUpdateManyWithWhereWithoutDashboardInput>> {
  return z.object({
    data: z.lazy(() => AnalyticsDashboardChartUpdateManyMutationInputSchema()),
    where: z.lazy(() => AnalyticsDashboardChartScalarWhereInputSchema())
  })
}

export function AnalyticsDashboardChartUpdateManyWithoutDashboardNestedInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartUpdateManyWithoutDashboardNestedInput>> {
  return z.object({
    connect: z.array(z.lazy(() => AnalyticsDashboardChartWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => AnalyticsDashboardChartCreateOrConnectWithoutDashboardInputSchema())).nullish(),
    create: z.array(z.lazy(() => AnalyticsDashboardChartCreateWithoutDashboardInputSchema())).nullish(),
    createMany: z.lazy(() => AnalyticsDashboardChartCreateManyDashboardInputEnvelopeSchema().nullish()),
    delete: z.array(z.lazy(() => AnalyticsDashboardChartWhereUniqueInputSchema())).nullish(),
    deleteMany: z.array(z.lazy(() => AnalyticsDashboardChartScalarWhereInputSchema())).nullish(),
    disconnect: z.array(z.lazy(() => AnalyticsDashboardChartWhereUniqueInputSchema())).nullish(),
    set: z.array(z.lazy(() => AnalyticsDashboardChartWhereUniqueInputSchema())).nullish(),
    update: z.array(z.lazy(() => AnalyticsDashboardChartUpdateWithWhereUniqueWithoutDashboardInputSchema())).nullish(),
    updateMany: z.array(z.lazy(() => AnalyticsDashboardChartUpdateManyWithWhereWithoutDashboardInputSchema())).nullish(),
    upsert: z.array(z.lazy(() => AnalyticsDashboardChartUpsertWithWhereUniqueWithoutDashboardInputSchema())).nullish()
  })
}

export function AnalyticsDashboardChartUpdateWithWhereUniqueWithoutDashboardInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartUpdateWithWhereUniqueWithoutDashboardInput>> {
  return z.object({
    data: z.lazy(() => AnalyticsDashboardChartUpdateWithoutDashboardInputSchema()),
    where: z.lazy(() => AnalyticsDashboardChartWhereUniqueInputSchema())
  })
}

export function AnalyticsDashboardChartUpdateWithoutDashboardInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartUpdateWithoutDashboardInput>> {
  return z.object({
    dashboardDefinition: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    id: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    name: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    pageId: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    showTable: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    sqlQuery: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    tableColumns: z.record(z.string(), z.unknown()).nullish(),
    templateId: z.lazy(() => IntFieldUpdateOperationsInputSchema().nullish())
  })
}

export function AnalyticsDashboardChartUpsertWithWhereUniqueWithoutDashboardInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartUpsertWithWhereUniqueWithoutDashboardInput>> {
  return z.object({
    create: z.lazy(() => AnalyticsDashboardChartCreateWithoutDashboardInputSchema()),
    update: z.lazy(() => AnalyticsDashboardChartUpdateWithoutDashboardInputSchema()),
    where: z.lazy(() => AnalyticsDashboardChartWhereUniqueInputSchema())
  })
}

export function AnalyticsDashboardChartWhereInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => AnalyticsDashboardChartWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => AnalyticsDashboardChartWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => AnalyticsDashboardChartWhereInputSchema())).nullish(),
    dashboardDefinition: z.lazy(() => StringFilterSchema().nullish()),
    id: z.lazy(() => StringFilterSchema().nullish()),
    name: z.lazy(() => StringFilterSchema().nullish()),
    pageId: z.lazy(() => StringFilterSchema().nullish()),
    showTable: z.lazy(() => BoolFilterSchema().nullish()),
    sqlQuery: z.lazy(() => StringFilterSchema().nullish()),
    tableColumns: z.lazy(() => JsonFilterSchema().nullish()),
    templateId: z.lazy(() => IntFilterSchema().nullish())
  })
}

export function AnalyticsDashboardChartWhereUniqueInputSchema(): z.ZodObject<Properties<AnalyticsDashboardChartWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => AnalyticsDashboardChartWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => AnalyticsDashboardChartWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => AnalyticsDashboardChartWhereInputSchema())).nullish(),
    dashboardDefinition: z.lazy(() => StringFilterSchema().nullish()),
    id: z.string().trim().nullish(),
    name: z.lazy(() => StringFilterSchema().nullish()),
    pageId: z.lazy(() => StringFilterSchema().nullish()),
    showTable: z.lazy(() => BoolFilterSchema().nullish()),
    sqlQuery: z.lazy(() => StringFilterSchema().nullish()),
    tableColumns: z.lazy(() => JsonFilterSchema().nullish()),
    templateId: z.lazy(() => IntFilterSchema().nullish())
  })
}

export function AnalyticsDashboardCountSchema(): z.ZodObject<Properties<AnalyticsDashboardCount>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboardCount').optional(),
    charts: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    filtersSources: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function AnalyticsDashboardCountChartsArgsSchema(): z.ZodObject<Properties<AnalyticsDashboardCountChartsArgs>> {
  return z.object({
    where: z.lazy(() => AnalyticsDashboardChartWhereInputSchema().nullish())
  })
}

export function AnalyticsDashboardCountFiltersSourcesArgsSchema(): z.ZodObject<Properties<AnalyticsDashboardCountFiltersSourcesArgs>> {
  return z.object({
    where: z.lazy(() => AnalyticsDashboardFiltersSourceWhereInputSchema().nullish())
  })
}

export function AnalyticsDashboardCountAggregateSchema(): z.ZodObject<Properties<AnalyticsDashboardCountAggregate>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboardCountAggregate').optional(),
    _all: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    content: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    name: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    restricted: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function AnalyticsDashboardCountOrderByAggregateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardCountOrderByAggregateInput>> {
  return z.object({
    content: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    restricted: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardCreateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardCreateInput>> {
  return z.object({
    charts: z.lazy(() => AnalyticsDashboardChartCreateNestedManyWithoutDashboardInputSchema().nullish()),
    content: z.string().trim(),
    filtersSources: z.lazy(() => AnalyticsDashboardFiltersSourceCreateNestedManyWithoutDashboardInputSchema().nullish()),
    name: z.string().trim(),
    restricted: z.boolean()
  })
}

export function AnalyticsDashboardCreateManyInputSchema(): z.ZodObject<Properties<AnalyticsDashboardCreateManyInput>> {
  return z.object({
    content: z.string().trim(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    name: z.string().trim(),
    restricted: z.boolean()
  })
}

export function AnalyticsDashboardFiltersSourceSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSource>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboardFiltersSource').optional(),
    addEmptyOption: z.boolean(),
    analyticsPage: z.lazy(() => ProposalAnalyticsPageSchema().nullish()),
    fieldId: z.string().trim().nullish(),
    filterKey: z.string().trim(),
    id: z.string().trim(),
    pageId: z.string().trim().nullish(),
    templateId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    type: FiltersSourceTypeSchema
  })
}

export function AnalyticsDashboardFiltersSourceAvgAggregateSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceAvgAggregate>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboardFiltersSourceAvgAggregate').optional(),
    dashboardId: z.number().nullish(),
    templateId: z.number().nullish()
  })
}

export function AnalyticsDashboardFiltersSourceAvgOrderByAggregateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceAvgOrderByAggregateInput>> {
  return z.object({
    templateId: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardFiltersSourceCountAggregateSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceCountAggregate>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboardFiltersSourceCountAggregate').optional(),
    _all: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    addEmptyOption: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    dashboardId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    fieldId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    filterKey: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    pageId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    templateId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    type: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function AnalyticsDashboardFiltersSourceCountOrderByAggregateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceCountOrderByAggregateInput>> {
  return z.object({
    addEmptyOption: SortOrderSchema.nullish(),
    fieldId: SortOrderSchema.nullish(),
    filterKey: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    pageId: SortOrderSchema.nullish(),
    templateId: SortOrderSchema.nullish(),
    type: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardFiltersSourceCreateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceCreateInput>> {
  return z.object({
    addEmptyOption: z.boolean().nullish(),
    fieldId: z.string().trim().nullish(),
    filterKey: z.string().trim(),
    id: z.string().trim().nullish(),
    pageId: z.string().trim().nullish(),
    templateId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    type: FiltersSourceTypeSchema
  })
}

export function AnalyticsDashboardFiltersSourceCreateManyDashboardInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceCreateManyDashboardInput>> {
  return z.object({
    addEmptyOption: z.boolean().nullish(),
    fieldId: z.string().trim().nullish(),
    filterKey: z.string().trim(),
    id: z.string().trim().nullish(),
    pageId: z.string().trim().nullish(),
    templateId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    type: FiltersSourceTypeSchema
  })
}

export function AnalyticsDashboardFiltersSourceCreateManyDashboardInputEnvelopeSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceCreateManyDashboardInputEnvelope>> {
  return z.object({
    data: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceCreateManyDashboardInputSchema())),
    skipDuplicates: z.boolean().nullish()
  })
}

export function AnalyticsDashboardFiltersSourceCreateManyInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceCreateManyInput>> {
  return z.object({
    addEmptyOption: z.boolean().nullish(),
    fieldId: z.string().trim().nullish(),
    filterKey: z.string().trim(),
    id: z.string().trim().nullish(),
    pageId: z.string().trim().nullish(),
    templateId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    type: FiltersSourceTypeSchema
  })
}

export function AnalyticsDashboardFiltersSourceCreateNestedManyWithoutDashboardInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceCreateNestedManyWithoutDashboardInput>> {
  return z.object({
    connect: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceCreateOrConnectWithoutDashboardInputSchema())).nullish(),
    create: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceCreateWithoutDashboardInputSchema())).nullish(),
    createMany: z.lazy(() => AnalyticsDashboardFiltersSourceCreateManyDashboardInputEnvelopeSchema().nullish())
  })
}

export function AnalyticsDashboardFiltersSourceCreateOrConnectWithoutDashboardInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceCreateOrConnectWithoutDashboardInput>> {
  return z.object({
    create: z.lazy(() => AnalyticsDashboardFiltersSourceCreateWithoutDashboardInputSchema()),
    where: z.lazy(() => AnalyticsDashboardFiltersSourceWhereUniqueInputSchema())
  })
}

export function AnalyticsDashboardFiltersSourceCreateWithoutDashboardInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceCreateWithoutDashboardInput>> {
  return z.object({
    addEmptyOption: z.boolean().nullish(),
    fieldId: z.string().trim().nullish(),
    filterKey: z.string().trim(),
    id: z.string().trim().nullish(),
    pageId: z.string().trim().nullish(),
    templateId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    type: FiltersSourceTypeSchema
  })
}

export function AnalyticsDashboardFiltersSourceGroupBySchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceGroupBy>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboardFiltersSourceGroupBy').optional(),
    _avg: z.lazy(() => AnalyticsDashboardFiltersSourceAvgAggregateSchema().nullish()),
    _count: z.lazy(() => AnalyticsDashboardFiltersSourceCountAggregateSchema().nullish()),
    _max: z.lazy(() => AnalyticsDashboardFiltersSourceMaxAggregateSchema().nullish()),
    _min: z.lazy(() => AnalyticsDashboardFiltersSourceMinAggregateSchema().nullish()),
    _sum: z.lazy(() => AnalyticsDashboardFiltersSourceSumAggregateSchema().nullish()),
    addEmptyOption: z.boolean(),
    dashboardId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    fieldId: z.string().trim().nullish(),
    filterKey: z.string().trim(),
    id: z.string().trim(),
    pageId: z.string().trim().nullish(),
    templateId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    type: FiltersSourceTypeSchema
  })
}

export function AnalyticsDashboardFiltersSourceListRelationFilterSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceListRelationFilter>> {
  return z.object({
    every: z.lazy(() => AnalyticsDashboardFiltersSourceWhereInputSchema().nullish()),
    none: z.lazy(() => AnalyticsDashboardFiltersSourceWhereInputSchema().nullish()),
    some: z.lazy(() => AnalyticsDashboardFiltersSourceWhereInputSchema().nullish())
  })
}

export function AnalyticsDashboardFiltersSourceMaxAggregateSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceMaxAggregate>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboardFiltersSourceMaxAggregate').optional(),
    addEmptyOption: z.boolean().nullish(),
    dashboardId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    fieldId: z.string().trim().nullish(),
    filterKey: z.string().trim().nullish(),
    id: z.string().trim().nullish(),
    pageId: z.string().trim().nullish(),
    templateId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    type: FiltersSourceTypeSchema.nullish()
  })
}

export function AnalyticsDashboardFiltersSourceMaxOrderByAggregateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceMaxOrderByAggregateInput>> {
  return z.object({
    addEmptyOption: SortOrderSchema.nullish(),
    fieldId: SortOrderSchema.nullish(),
    filterKey: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    pageId: SortOrderSchema.nullish(),
    templateId: SortOrderSchema.nullish(),
    type: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardFiltersSourceMinAggregateSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceMinAggregate>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboardFiltersSourceMinAggregate').optional(),
    addEmptyOption: z.boolean().nullish(),
    dashboardId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    fieldId: z.string().trim().nullish(),
    filterKey: z.string().trim().nullish(),
    id: z.string().trim().nullish(),
    pageId: z.string().trim().nullish(),
    templateId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    type: FiltersSourceTypeSchema.nullish()
  })
}

export function AnalyticsDashboardFiltersSourceMinOrderByAggregateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceMinOrderByAggregateInput>> {
  return z.object({
    addEmptyOption: SortOrderSchema.nullish(),
    fieldId: SortOrderSchema.nullish(),
    filterKey: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    pageId: SortOrderSchema.nullish(),
    templateId: SortOrderSchema.nullish(),
    type: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardFiltersSourceOrderByRelationAggregateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceOrderByRelationAggregateInput>> {
  return z.object({
    _count: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardFiltersSourceOrderByRelevanceInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceOrderByRelevanceInput>> {
  return z.object({
    fields: z.array(AnalyticsDashboardFiltersSourceOrderByRelevanceFieldEnumSchema),
    search: z.string().trim(),
    sort: SortOrderSchema
  })
}

export function AnalyticsDashboardFiltersSourceOrderByWithAggregationInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceOrderByWithAggregationInput>> {
  return z.object({
    _avg: z.lazy(() => AnalyticsDashboardFiltersSourceAvgOrderByAggregateInputSchema().nullish()),
    _count: z.lazy(() => AnalyticsDashboardFiltersSourceCountOrderByAggregateInputSchema().nullish()),
    _max: z.lazy(() => AnalyticsDashboardFiltersSourceMaxOrderByAggregateInputSchema().nullish()),
    _min: z.lazy(() => AnalyticsDashboardFiltersSourceMinOrderByAggregateInputSchema().nullish()),
    _sum: z.lazy(() => AnalyticsDashboardFiltersSourceSumOrderByAggregateInputSchema().nullish()),
    addEmptyOption: SortOrderSchema.nullish(),
    fieldId: z.lazy(() => SortOrderInputSchema().nullish()),
    filterKey: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    pageId: z.lazy(() => SortOrderInputSchema().nullish()),
    templateId: z.lazy(() => SortOrderInputSchema().nullish()),
    type: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardFiltersSourceOrderByWithRelationInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceOrderByWithRelationInput>> {
  return z.object({
    _relevance: z.lazy(() => AnalyticsDashboardFiltersSourceOrderByRelevanceInputSchema().nullish()),
    addEmptyOption: SortOrderSchema.nullish(),
    fieldId: z.lazy(() => SortOrderInputSchema().nullish()),
    filterKey: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    pageId: z.lazy(() => SortOrderInputSchema().nullish()),
    templateId: z.lazy(() => SortOrderInputSchema().nullish()),
    type: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardFiltersSourceScalarWhereInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceScalarWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceScalarWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceScalarWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceScalarWhereInputSchema())).nullish(),
    addEmptyOption: z.lazy(() => BoolFilterSchema().nullish()),
    fieldId: z.lazy(() => StringNullableFilterSchema().nullish()),
    filterKey: z.lazy(() => StringFilterSchema().nullish()),
    id: z.lazy(() => StringFilterSchema().nullish()),
    pageId: z.lazy(() => StringNullableFilterSchema().nullish()),
    templateId: z.lazy(() => IntNullableFilterSchema().nullish()),
    type: z.lazy(() => EnumFiltersSourceTypeFilterSchema().nullish())
  })
}

export function AnalyticsDashboardFiltersSourceScalarWhereWithAggregatesInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceScalarWhereWithAggregatesInput>> {
  return z.object({
    AND: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceScalarWhereWithAggregatesInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceScalarWhereWithAggregatesInputSchema())).nullish(),
    OR: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceScalarWhereWithAggregatesInputSchema())).nullish(),
    addEmptyOption: z.lazy(() => BoolWithAggregatesFilterSchema().nullish()),
    fieldId: z.lazy(() => StringNullableWithAggregatesFilterSchema().nullish()),
    filterKey: z.lazy(() => StringWithAggregatesFilterSchema().nullish()),
    id: z.lazy(() => StringWithAggregatesFilterSchema().nullish()),
    pageId: z.lazy(() => StringNullableWithAggregatesFilterSchema().nullish()),
    templateId: z.lazy(() => IntNullableWithAggregatesFilterSchema().nullish()),
    type: z.lazy(() => EnumFiltersSourceTypeWithAggregatesFilterSchema().nullish())
  })
}

export function AnalyticsDashboardFiltersSourceSumAggregateSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceSumAggregate>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboardFiltersSourceSumAggregate').optional(),
    dashboardId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    templateId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function AnalyticsDashboardFiltersSourceSumOrderByAggregateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceSumOrderByAggregateInput>> {
  return z.object({
    templateId: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardFiltersSourceUpdateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceUpdateInput>> {
  return z.object({
    addEmptyOption: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    fieldId: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish()),
    filterKey: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    id: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    pageId: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish()),
    templateId: z.lazy(() => NullableIntFieldUpdateOperationsInputSchema().nullish()),
    type: z.lazy(() => EnumFiltersSourceTypeFieldUpdateOperationsInputSchema().nullish())
  })
}

export function AnalyticsDashboardFiltersSourceUpdateManyMutationInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceUpdateManyMutationInput>> {
  return z.object({
    addEmptyOption: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    fieldId: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish()),
    filterKey: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    id: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    pageId: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish()),
    templateId: z.lazy(() => NullableIntFieldUpdateOperationsInputSchema().nullish()),
    type: z.lazy(() => EnumFiltersSourceTypeFieldUpdateOperationsInputSchema().nullish())
  })
}

export function AnalyticsDashboardFiltersSourceUpdateManyWithWhereWithoutDashboardInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceUpdateManyWithWhereWithoutDashboardInput>> {
  return z.object({
    data: z.lazy(() => AnalyticsDashboardFiltersSourceUpdateManyMutationInputSchema()),
    where: z.lazy(() => AnalyticsDashboardFiltersSourceScalarWhereInputSchema())
  })
}

export function AnalyticsDashboardFiltersSourceUpdateManyWithoutDashboardNestedInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceUpdateManyWithoutDashboardNestedInput>> {
  return z.object({
    connect: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceCreateOrConnectWithoutDashboardInputSchema())).nullish(),
    create: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceCreateWithoutDashboardInputSchema())).nullish(),
    createMany: z.lazy(() => AnalyticsDashboardFiltersSourceCreateManyDashboardInputEnvelopeSchema().nullish()),
    delete: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceWhereUniqueInputSchema())).nullish(),
    deleteMany: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceScalarWhereInputSchema())).nullish(),
    disconnect: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceWhereUniqueInputSchema())).nullish(),
    set: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceWhereUniqueInputSchema())).nullish(),
    update: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceUpdateWithWhereUniqueWithoutDashboardInputSchema())).nullish(),
    updateMany: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceUpdateManyWithWhereWithoutDashboardInputSchema())).nullish(),
    upsert: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceUpsertWithWhereUniqueWithoutDashboardInputSchema())).nullish()
  })
}

export function AnalyticsDashboardFiltersSourceUpdateWithWhereUniqueWithoutDashboardInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceUpdateWithWhereUniqueWithoutDashboardInput>> {
  return z.object({
    data: z.lazy(() => AnalyticsDashboardFiltersSourceUpdateWithoutDashboardInputSchema()),
    where: z.lazy(() => AnalyticsDashboardFiltersSourceWhereUniqueInputSchema())
  })
}

export function AnalyticsDashboardFiltersSourceUpdateWithoutDashboardInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceUpdateWithoutDashboardInput>> {
  return z.object({
    addEmptyOption: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    fieldId: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish()),
    filterKey: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    id: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    pageId: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish()),
    templateId: z.lazy(() => NullableIntFieldUpdateOperationsInputSchema().nullish()),
    type: z.lazy(() => EnumFiltersSourceTypeFieldUpdateOperationsInputSchema().nullish())
  })
}

export function AnalyticsDashboardFiltersSourceUpsertWithWhereUniqueWithoutDashboardInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceUpsertWithWhereUniqueWithoutDashboardInput>> {
  return z.object({
    create: z.lazy(() => AnalyticsDashboardFiltersSourceCreateWithoutDashboardInputSchema()),
    update: z.lazy(() => AnalyticsDashboardFiltersSourceUpdateWithoutDashboardInputSchema()),
    where: z.lazy(() => AnalyticsDashboardFiltersSourceWhereUniqueInputSchema())
  })
}

export function AnalyticsDashboardFiltersSourceWhereInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceWhereInputSchema())).nullish(),
    addEmptyOption: z.lazy(() => BoolFilterSchema().nullish()),
    fieldId: z.lazy(() => StringNullableFilterSchema().nullish()),
    filterKey: z.lazy(() => StringFilterSchema().nullish()),
    id: z.lazy(() => StringFilterSchema().nullish()),
    pageId: z.lazy(() => StringNullableFilterSchema().nullish()),
    templateId: z.lazy(() => IntNullableFilterSchema().nullish()),
    type: z.lazy(() => EnumFiltersSourceTypeFilterSchema().nullish())
  })
}

export function AnalyticsDashboardFiltersSourceWhereUniqueInputSchema(): z.ZodObject<Properties<AnalyticsDashboardFiltersSourceWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceWhereInputSchema())).nullish(),
    addEmptyOption: z.lazy(() => BoolFilterSchema().nullish()),
    fieldId: z.lazy(() => StringNullableFilterSchema().nullish()),
    filterKey: z.lazy(() => StringFilterSchema().nullish()),
    id: z.string().trim().nullish(),
    pageId: z.lazy(() => StringNullableFilterSchema().nullish()),
    templateId: z.lazy(() => IntNullableFilterSchema().nullish()),
    type: z.lazy(() => EnumFiltersSourceTypeFilterSchema().nullish())
  })
}

export function AnalyticsDashboardGroupBySchema(): z.ZodObject<Properties<AnalyticsDashboardGroupBy>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboardGroupBy').optional(),
    _avg: z.lazy(() => AnalyticsDashboardAvgAggregateSchema().nullish()),
    _count: z.lazy(() => AnalyticsDashboardCountAggregateSchema().nullish()),
    _max: z.lazy(() => AnalyticsDashboardMaxAggregateSchema().nullish()),
    _min: z.lazy(() => AnalyticsDashboardMinAggregateSchema().nullish()),
    _sum: z.lazy(() => AnalyticsDashboardSumAggregateSchema().nullish()),
    content: z.string().trim(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    name: z.string().trim(),
    restricted: z.boolean()
  })
}

export function AnalyticsDashboardMaxAggregateSchema(): z.ZodObject<Properties<AnalyticsDashboardMaxAggregate>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboardMaxAggregate').optional(),
    content: z.string().trim().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    name: z.string().trim().nullish(),
    restricted: z.boolean().nullish()
  })
}

export function AnalyticsDashboardMaxOrderByAggregateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardMaxOrderByAggregateInput>> {
  return z.object({
    content: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    restricted: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardMinAggregateSchema(): z.ZodObject<Properties<AnalyticsDashboardMinAggregate>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboardMinAggregate').optional(),
    content: z.string().trim().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    name: z.string().trim().nullish(),
    restricted: z.boolean().nullish()
  })
}

export function AnalyticsDashboardMinOrderByAggregateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardMinOrderByAggregateInput>> {
  return z.object({
    content: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    restricted: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardOrderByRelevanceInputSchema(): z.ZodObject<Properties<AnalyticsDashboardOrderByRelevanceInput>> {
  return z.object({
    fields: z.array(AnalyticsDashboardOrderByRelevanceFieldEnumSchema),
    search: z.string().trim(),
    sort: SortOrderSchema
  })
}

export function AnalyticsDashboardOrderByWithAggregationInputSchema(): z.ZodObject<Properties<AnalyticsDashboardOrderByWithAggregationInput>> {
  return z.object({
    _avg: z.lazy(() => AnalyticsDashboardAvgOrderByAggregateInputSchema().nullish()),
    _count: z.lazy(() => AnalyticsDashboardCountOrderByAggregateInputSchema().nullish()),
    _max: z.lazy(() => AnalyticsDashboardMaxOrderByAggregateInputSchema().nullish()),
    _min: z.lazy(() => AnalyticsDashboardMinOrderByAggregateInputSchema().nullish()),
    _sum: z.lazy(() => AnalyticsDashboardSumOrderByAggregateInputSchema().nullish()),
    content: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    restricted: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardOrderByWithRelationInputSchema(): z.ZodObject<Properties<AnalyticsDashboardOrderByWithRelationInput>> {
  return z.object({
    _relevance: z.lazy(() => AnalyticsDashboardOrderByRelevanceInputSchema().nullish()),
    charts: z.lazy(() => AnalyticsDashboardChartOrderByRelationAggregateInputSchema().nullish()),
    content: SortOrderSchema.nullish(),
    filtersSources: z.lazy(() => AnalyticsDashboardFiltersSourceOrderByRelationAggregateInputSchema().nullish()),
    id: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    restricted: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardScalarWhereWithAggregatesInputSchema(): z.ZodObject<Properties<AnalyticsDashboardScalarWhereWithAggregatesInput>> {
  return z.object({
    AND: z.array(z.lazy(() => AnalyticsDashboardScalarWhereWithAggregatesInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => AnalyticsDashboardScalarWhereWithAggregatesInputSchema())).nullish(),
    OR: z.array(z.lazy(() => AnalyticsDashboardScalarWhereWithAggregatesInputSchema())).nullish(),
    content: z.lazy(() => StringWithAggregatesFilterSchema().nullish()),
    id: z.lazy(() => IntWithAggregatesFilterSchema().nullish()),
    name: z.lazy(() => StringWithAggregatesFilterSchema().nullish()),
    restricted: z.lazy(() => BoolWithAggregatesFilterSchema().nullish())
  })
}

export function AnalyticsDashboardSumAggregateSchema(): z.ZodObject<Properties<AnalyticsDashboardSumAggregate>> {
  return z.object({
    __typename: z.literal('AnalyticsDashboardSumAggregate').optional(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function AnalyticsDashboardSumOrderByAggregateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardSumOrderByAggregateInput>> {
  return z.object({
    id: SortOrderSchema.nullish()
  })
}

export function AnalyticsDashboardUpdateInputSchema(): z.ZodObject<Properties<AnalyticsDashboardUpdateInput>> {
  return z.object({
    charts: z.lazy(() => AnalyticsDashboardChartUpdateManyWithoutDashboardNestedInputSchema().nullish()),
    content: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    filtersSources: z.lazy(() => AnalyticsDashboardFiltersSourceUpdateManyWithoutDashboardNestedInputSchema().nullish()),
    name: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    restricted: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish())
  })
}

export function AnalyticsDashboardUpdateManyMutationInputSchema(): z.ZodObject<Properties<AnalyticsDashboardUpdateManyMutationInput>> {
  return z.object({
    content: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    name: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    restricted: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish())
  })
}

export function AnalyticsDashboardWhereInputSchema(): z.ZodObject<Properties<AnalyticsDashboardWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => AnalyticsDashboardWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => AnalyticsDashboardWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => AnalyticsDashboardWhereInputSchema())).nullish(),
    charts: z.lazy(() => AnalyticsDashboardChartListRelationFilterSchema().nullish()),
    content: z.lazy(() => StringFilterSchema().nullish()),
    filtersSources: z.lazy(() => AnalyticsDashboardFiltersSourceListRelationFilterSchema().nullish()),
    id: z.lazy(() => IntFilterSchema().nullish()),
    name: z.lazy(() => StringFilterSchema().nullish()),
    restricted: z.lazy(() => BoolFilterSchema().nullish())
  })
}

export function AnalyticsDashboardWhereUniqueInputSchema(): z.ZodObject<Properties<AnalyticsDashboardWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => AnalyticsDashboardWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => AnalyticsDashboardWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => AnalyticsDashboardWhereInputSchema())).nullish(),
    charts: z.lazy(() => AnalyticsDashboardChartListRelationFilterSchema().nullish()),
    content: z.lazy(() => StringFilterSchema().nullish()),
    filtersSources: z.lazy(() => AnalyticsDashboardFiltersSourceListRelationFilterSchema().nullish()),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    name: z.lazy(() => StringFilterSchema().nullish()),
    restricted: z.lazy(() => BoolFilterSchema().nullish())
  })
}

export function AnalyticsPageFieldSchema(): z.ZodObject<Properties<AnalyticsPageField>> {
  return z.object({
    __typename: z.literal('AnalyticsPageField').optional(),
    fullName: z.string().trim(),
    id: z.string(),
    name: z.string().trim()
  })
}

export function AppAnalyticsDashboardUpdateInputSchema(): z.ZodObject<Properties<AppAnalyticsDashboardUpdateInput>> {
  return z.object({
    charts: z.array(z.lazy(() => AnalyticsDashboardChartCreateInputSchema())),
    content: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    filtersSources: z.array(z.lazy(() => AnalyticsDashboardFiltersSourceCreateInputSchema())),
    name: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    restricted: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish())
  })
}

export function AppAnalyticsDashboardWhereUniqueInputSchema(): z.ZodObject<Properties<AppAnalyticsDashboardWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => AnalyticsDashboardWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => AnalyticsDashboardWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => AnalyticsDashboardWhereInputSchema())).nullish(),
    charts: z.lazy(() => AnalyticsDashboardChartListRelationFilterSchema().nullish()),
    content: z.lazy(() => StringFilterSchema().nullish()),
    filtersSources: z.lazy(() => AnalyticsDashboardFiltersSourceListRelationFilterSchema().nullish()),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    name: z.lazy(() => StringFilterSchema().nullish()),
    restricted: z.lazy(() => BoolFilterSchema().nullish())
  })
}

export function BaseEventTypeSchema(): z.ZodObject<Properties<BaseEventType>> {
  return z.object({
    __typename: z.literal('BaseEventType').optional(),
    action: z.string().trim(),
    entity: z.string().trim()
  })
}

export function BaseEventTypeInputSchema(): z.ZodObject<Properties<BaseEventTypeInput>> {
  return z.object({
    action: z.string().trim(),
    entity: z.string().trim()
  })
}

export function BigIntNullableFilterSchema(): z.ZodObject<Properties<BigIntNullableFilter>> {
  return z.object({
    equals: definedNonNullAnySchema.nullish(),
    gt: definedNonNullAnySchema.nullish(),
    gte: definedNonNullAnySchema.nullish(),
    in: z.array(definedNonNullAnySchema).nullish(),
    lt: definedNonNullAnySchema.nullish(),
    lte: definedNonNullAnySchema.nullish(),
    not: z.lazy(() => NestedBigIntNullableFilterSchema().nullish()),
    notIn: z.array(definedNonNullAnySchema).nullish()
  })
}

export function BoolFieldUpdateOperationsInputSchema(): z.ZodObject<Properties<BoolFieldUpdateOperationsInput>> {
  return z.object({
    set: z.boolean().nullish()
  })
}

export function BoolFilterSchema(): z.ZodObject<Properties<BoolFilter>> {
  return z.object({
    equals: z.boolean().nullish(),
    not: z.lazy(() => NestedBoolFilterSchema().nullish())
  })
}

export function BoolNullableFilterSchema(): z.ZodObject<Properties<BoolNullableFilter>> {
  return z.object({
    equals: z.boolean().nullish(),
    not: z.lazy(() => NestedBoolNullableFilterSchema().nullish())
  })
}

export function BoolNullableWithAggregatesFilterSchema(): z.ZodObject<Properties<BoolNullableWithAggregatesFilter>> {
  return z.object({
    _count: z.lazy(() => NestedIntNullableFilterSchema().nullish()),
    _max: z.lazy(() => NestedBoolNullableFilterSchema().nullish()),
    _min: z.lazy(() => NestedBoolNullableFilterSchema().nullish()),
    equals: z.boolean().nullish(),
    not: z.lazy(() => NestedBoolNullableWithAggregatesFilterSchema().nullish())
  })
}

export function BoolWithAggregatesFilterSchema(): z.ZodObject<Properties<BoolWithAggregatesFilter>> {
  return z.object({
    _count: z.lazy(() => NestedIntFilterSchema().nullish()),
    _max: z.lazy(() => NestedBoolFilterSchema().nullish()),
    _min: z.lazy(() => NestedBoolFilterSchema().nullish()),
    equals: z.boolean().nullish(),
    not: z.lazy(() => NestedBoolWithAggregatesFilterSchema().nullish())
  })
}

export function ClientSchema(): z.ZodObject<Properties<Client>> {
  return z.object({
    __typename: z.literal('Client').optional(),
    applicationBaseUrl: z.string().trim(),
    applicationBrandColor: z.string().trim(),
    applicationLogoUrl: z.string().trim(),
    applicationTitle: z.string().trim(),
    bannerEnabled: z.boolean(),
    bannerHeader: z.string().trim(),
    bannerText: z.string().trim(),
    clientFeatures: z.array(z.lazy(() => ClientFeatureSchema())),
    clientPermissions: z.array(z.lazy(() => ClientPermissionSchema())),
    databaseName: z.string().trim().nullish(),
    enabled: z.boolean(),
    entityNamePlural: z.string().trim(),
    entityNameSingular: z.string().trim(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    insightPlaceholderPlural: z.string().trim(),
    insightPlaceholderSingular: z.string().trim(),
    keycloakFrontendClient: z.lazy(() => KeycloakClientSchema()),
    keycloakFrontendClientInternalId: z.string().trim(),
    keycloakGroup: z.lazy(() => KeycloakGroupSchema()),
    keycloakGroupId: z.string().trim(),
    keycloakGroupName: z.string().trim(),
    permissions: z.record(z.string(), z.unknown()),
    proposalNavigationPosition: ProposalNavigationPositionTypeSchema,
    settings: z.record(z.string(), z.unknown()),
    users: z.array(z.lazy(() => KeycloakUserSchema())),
    usersLimit: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function ClientFeatureSchema(): z.ZodObject<Properties<ClientFeature>> {
  return z.object({
    __typename: z.literal('ClientFeature').optional(),
    clientId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    name: FeatureSchema
  })
}

export function ClientFeatureCreateInputSchema(): z.ZodObject<Properties<ClientFeatureCreateInput>> {
  return z.object({
    name: FeatureSchema
  })
}

export function ClientInputSchema(): z.ZodObject<Properties<ClientInput>> {
  return z.object({
    applicationBaseUrl: z.string().trim(),
    applicationBrandColor: z.string().regex(/^#[0-9a-f]{6}$/i),
    applicationLogoUrl: z.string().trim(),
    applicationTitle: z.string().trim(),
    bannerEnabled: z.boolean().nullish(),
    bannerHeader: z.string().trim().nullish(),
    bannerText: z.string().trim().nullish(),
    clientFeatures: z.array(z.lazy(() => ClientFeatureCreateInputSchema())),
    clientPermissions: z.array(z.lazy(() => ClientPermissionCreateInputSchema())),
    entityNamePlural: z.string().trim().nullish(),
    entityNameSingular: z.string().trim().nullish(),
    insightPlaceholderPlural: z.string().trim().nullish(),
    insightPlaceholderSingular: z.string().trim().nullish(),
    keycloakGroupName: z.string().trim(),
    loginTheme: z.string().trim(),
    permissions: z.record(z.string(), z.unknown()).nullish(),
    proposalNavigationPosition: ProposalNavigationPositionTypeSchema.nullish(),
    settings: z.record(z.string(), z.unknown()).nullish(),
    usersLimit: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function ClientMembersSchema(): z.ZodObject<Properties<ClientMembers>> {
  return z.object({
    __typename: z.literal('ClientMembers').optional(),
    usersProtected: z.array(z.lazy(() => KeycloakUserProtectedSchema())).nullish()
  })
}

export function ClientPermissionSchema(): z.ZodObject<Properties<ClientPermission>> {
  return z.object({
    __typename: z.literal('ClientPermission').optional(),
    clientId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    role: z.string().trim(),
    scope: ScopeSchema
  })
}

export function ClientPermissionCreateInputSchema(): z.ZodObject<Properties<ClientPermissionCreateInput>> {
  return z.object({
    role: z.string().trim(),
    scope: ScopeSchema
  })
}

export function CredentialRepresentationSchema(): z.ZodObject<Properties<CredentialRepresentation>> {
  return z.object({
    __typename: z.literal('CredentialRepresentation').optional(),
    createdDate: z.number().nullish(),
    credentialData: z.string().trim().nullish(),
    id: z.string().trim().nullish(),
    priority: z.number().nullish(),
    secretData: z.string().trim().nullish(),
    temporary: z.boolean().nullish(),
    type: z.string().trim().nullish(),
    userLabel: z.string().trim().nullish(),
    value: z.string().trim().nullish()
  })
}

export function DataSourceSchema(): z.ZodObject<Properties<DataSource>> {
  return z.object({
    __typename: z.literal('DataSource').optional(),
    _count: z.lazy(() => DataSourceCountSchema().nullish()),
    createdAt: z.number(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    includeInFreshness: z.boolean(),
    isSharedWithAdmin: z.boolean().nullish(),
    lastVersion: z.lazy(() => DataSourceVersionSchema()),
    name: z.string().trim(),
    updatedAt: z.number(),
    versions: z.array(z.lazy(() => DataSourceVersionSchema()))
  })
}

export function DataSourceVersionsArgsSchema(): z.ZodObject<Properties<DataSourceVersionsArgs>> {
  return z.object({
    cursor: z.lazy(() => DataSourceVersionWhereUniqueInputSchema().nullish()),
    distinct: z.array(DataSourceVersionScalarFieldEnumSchema).nullish(),
    orderBy: z.array(z.lazy(() => DataSourceVersionOrderByWithRelationInputSchema())).nullish(),
    skip: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    take: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    where: z.lazy(() => DataSourceVersionWhereInputSchema().nullish())
  })
}

export function DataSourceAvgAggregateSchema(): z.ZodObject<Properties<DataSourceAvgAggregate>> {
  return z.object({
    __typename: z.literal('DataSourceAvgAggregate').optional(),
    id: z.number().nullish()
  })
}

export function DataSourceAvgOrderByAggregateInputSchema(): z.ZodObject<Properties<DataSourceAvgOrderByAggregateInput>> {
  return z.object({
    id: SortOrderSchema.nullish()
  })
}

export function DataSourceCellSchema(): z.ZodObject<Properties<DataSourceCell>> {
  return z.object({
    __typename: z.literal('DataSourceCell').optional(),
    columnUUID: z.string().trim(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    initVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    lastVersion: z.lazy(() => DataSourceVersionSchema()),
    lastVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    rowUUID: z.string().trim(),
    value: z.string().trim()
  })
}

export function DataSourceCellAvgAggregateSchema(): z.ZodObject<Properties<DataSourceCellAvgAggregate>> {
  return z.object({
    __typename: z.literal('DataSourceCellAvgAggregate').optional(),
    id: z.number().nullish(),
    initVersionId: z.number().nullish(),
    lastVersionId: z.number().nullish()
  })
}

export function DataSourceCellAvgOrderByAggregateInputSchema(): z.ZodObject<Properties<DataSourceCellAvgOrderByAggregateInput>> {
  return z.object({
    id: SortOrderSchema.nullish(),
    initVersionId: SortOrderSchema.nullish(),
    lastVersionId: SortOrderSchema.nullish()
  })
}

export function DataSourceCellCountAggregateSchema(): z.ZodObject<Properties<DataSourceCellCountAggregate>> {
  return z.object({
    __typename: z.literal('DataSourceCellCountAggregate').optional(),
    _all: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    columnUUID: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    initVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    lastVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    rowUUID: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    value: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function DataSourceCellCountOrderByAggregateInputSchema(): z.ZodObject<Properties<DataSourceCellCountOrderByAggregateInput>> {
  return z.object({
    columnUUID: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    initVersionId: SortOrderSchema.nullish(),
    lastVersionId: SortOrderSchema.nullish(),
    rowUUID: SortOrderSchema.nullish(),
    value: SortOrderSchema.nullish()
  })
}

export function DataSourceCellCreateInputSchema(): z.ZodObject<Properties<DataSourceCellCreateInput>> {
  return z.object({
    columnUUID: z.string().trim(),
    initVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    lastVersion: z.lazy(() => DataSourceVersionCreateNestedOneWithoutCellsInputSchema()),
    rowUUID: z.string().trim(),
    value: z.string().trim()
  })
}

export function DataSourceCellCreateManyInputSchema(): z.ZodObject<Properties<DataSourceCellCreateManyInput>> {
  return z.object({
    columnUUID: z.string().trim(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    initVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    lastVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    rowUUID: z.string().trim(),
    value: z.string().trim()
  })
}

export function DataSourceCellCreateManyLastVersionInputSchema(): z.ZodObject<Properties<DataSourceCellCreateManyLastVersionInput>> {
  return z.object({
    columnUUID: z.string().trim(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    initVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    rowUUID: z.string().trim(),
    value: z.string().trim()
  })
}

export function DataSourceCellCreateManyLastVersionInputEnvelopeSchema(): z.ZodObject<Properties<DataSourceCellCreateManyLastVersionInputEnvelope>> {
  return z.object({
    data: z.array(z.lazy(() => DataSourceCellCreateManyLastVersionInputSchema())),
    skipDuplicates: z.boolean().nullish()
  })
}

export function DataSourceCellCreateNestedManyWithoutLastVersionInputSchema(): z.ZodObject<Properties<DataSourceCellCreateNestedManyWithoutLastVersionInput>> {
  return z.object({
    connect: z.array(z.lazy(() => DataSourceCellWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => DataSourceCellCreateOrConnectWithoutLastVersionInputSchema())).nullish(),
    create: z.array(z.lazy(() => DataSourceCellCreateWithoutLastVersionInputSchema())).nullish(),
    createMany: z.lazy(() => DataSourceCellCreateManyLastVersionInputEnvelopeSchema().nullish())
  })
}

export function DataSourceCellCreateOrConnectWithoutLastVersionInputSchema(): z.ZodObject<Properties<DataSourceCellCreateOrConnectWithoutLastVersionInput>> {
  return z.object({
    create: z.lazy(() => DataSourceCellCreateWithoutLastVersionInputSchema()),
    where: z.lazy(() => DataSourceCellWhereUniqueInputSchema())
  })
}

export function DataSourceCellCreateWithoutLastVersionInputSchema(): z.ZodObject<Properties<DataSourceCellCreateWithoutLastVersionInput>> {
  return z.object({
    columnUUID: z.string().trim(),
    initVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    rowUUID: z.string().trim(),
    value: z.string().trim()
  })
}

export function DataSourceCellGroupBySchema(): z.ZodObject<Properties<DataSourceCellGroupBy>> {
  return z.object({
    __typename: z.literal('DataSourceCellGroupBy').optional(),
    _avg: z.lazy(() => DataSourceCellAvgAggregateSchema().nullish()),
    _count: z.lazy(() => DataSourceCellCountAggregateSchema().nullish()),
    _max: z.lazy(() => DataSourceCellMaxAggregateSchema().nullish()),
    _min: z.lazy(() => DataSourceCellMinAggregateSchema().nullish()),
    _sum: z.lazy(() => DataSourceCellSumAggregateSchema().nullish()),
    columnUUID: z.string().trim(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    initVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    lastVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    rowUUID: z.string().trim(),
    value: z.string().trim()
  })
}

export function DataSourceCellLastVersionIdColumnUuidRowUuidCompoundUniqueInputSchema(): z.ZodObject<Properties<DataSourceCellLastVersionIdColumnUuidRowUuidCompoundUniqueInput>> {
  return z.object({
    columnUUID: z.string().trim(),
    lastVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    rowUUID: z.string().trim()
  })
}

export function DataSourceCellListRelationFilterSchema(): z.ZodObject<Properties<DataSourceCellListRelationFilter>> {
  return z.object({
    every: z.lazy(() => DataSourceCellWhereInputSchema().nullish()),
    none: z.lazy(() => DataSourceCellWhereInputSchema().nullish()),
    some: z.lazy(() => DataSourceCellWhereInputSchema().nullish())
  })
}

export function DataSourceCellMaxAggregateSchema(): z.ZodObject<Properties<DataSourceCellMaxAggregate>> {
  return z.object({
    __typename: z.literal('DataSourceCellMaxAggregate').optional(),
    columnUUID: z.string().trim().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    initVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    lastVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    rowUUID: z.string().trim().nullish(),
    value: z.string().trim().nullish()
  })
}

export function DataSourceCellMaxOrderByAggregateInputSchema(): z.ZodObject<Properties<DataSourceCellMaxOrderByAggregateInput>> {
  return z.object({
    columnUUID: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    initVersionId: SortOrderSchema.nullish(),
    lastVersionId: SortOrderSchema.nullish(),
    rowUUID: SortOrderSchema.nullish(),
    value: SortOrderSchema.nullish()
  })
}

export function DataSourceCellMinAggregateSchema(): z.ZodObject<Properties<DataSourceCellMinAggregate>> {
  return z.object({
    __typename: z.literal('DataSourceCellMinAggregate').optional(),
    columnUUID: z.string().trim().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    initVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    lastVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    rowUUID: z.string().trim().nullish(),
    value: z.string().trim().nullish()
  })
}

export function DataSourceCellMinOrderByAggregateInputSchema(): z.ZodObject<Properties<DataSourceCellMinOrderByAggregateInput>> {
  return z.object({
    columnUUID: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    initVersionId: SortOrderSchema.nullish(),
    lastVersionId: SortOrderSchema.nullish(),
    rowUUID: SortOrderSchema.nullish(),
    value: SortOrderSchema.nullish()
  })
}

export function DataSourceCellOrderByRelationAggregateInputSchema(): z.ZodObject<Properties<DataSourceCellOrderByRelationAggregateInput>> {
  return z.object({
    _count: SortOrderSchema.nullish()
  })
}

export function DataSourceCellOrderByRelevanceInputSchema(): z.ZodObject<Properties<DataSourceCellOrderByRelevanceInput>> {
  return z.object({
    fields: z.array(DataSourceCellOrderByRelevanceFieldEnumSchema),
    search: z.string().trim(),
    sort: SortOrderSchema
  })
}

export function DataSourceCellOrderByWithAggregationInputSchema(): z.ZodObject<Properties<DataSourceCellOrderByWithAggregationInput>> {
  return z.object({
    _avg: z.lazy(() => DataSourceCellAvgOrderByAggregateInputSchema().nullish()),
    _count: z.lazy(() => DataSourceCellCountOrderByAggregateInputSchema().nullish()),
    _max: z.lazy(() => DataSourceCellMaxOrderByAggregateInputSchema().nullish()),
    _min: z.lazy(() => DataSourceCellMinOrderByAggregateInputSchema().nullish()),
    _sum: z.lazy(() => DataSourceCellSumOrderByAggregateInputSchema().nullish()),
    columnUUID: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    initVersionId: SortOrderSchema.nullish(),
    lastVersionId: SortOrderSchema.nullish(),
    rowUUID: SortOrderSchema.nullish(),
    value: SortOrderSchema.nullish()
  })
}

export function DataSourceCellOrderByWithRelationInputSchema(): z.ZodObject<Properties<DataSourceCellOrderByWithRelationInput>> {
  return z.object({
    _relevance: z.lazy(() => DataSourceCellOrderByRelevanceInputSchema().nullish()),
    columnUUID: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    initVersionId: SortOrderSchema.nullish(),
    lastVersion: z.lazy(() => DataSourceVersionOrderByWithRelationInputSchema().nullish()),
    lastVersionId: SortOrderSchema.nullish(),
    rowUUID: SortOrderSchema.nullish(),
    value: SortOrderSchema.nullish()
  })
}

export function DataSourceCellScalarWhereInputSchema(): z.ZodObject<Properties<DataSourceCellScalarWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => DataSourceCellScalarWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => DataSourceCellScalarWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => DataSourceCellScalarWhereInputSchema())).nullish(),
    columnUUID: z.lazy(() => StringFilterSchema().nullish()),
    id: z.lazy(() => IntFilterSchema().nullish()),
    initVersionId: z.lazy(() => IntFilterSchema().nullish()),
    lastVersionId: z.lazy(() => IntFilterSchema().nullish()),
    rowUUID: z.lazy(() => StringFilterSchema().nullish()),
    value: z.lazy(() => StringFilterSchema().nullish())
  })
}

export function DataSourceCellScalarWhereWithAggregatesInputSchema(): z.ZodObject<Properties<DataSourceCellScalarWhereWithAggregatesInput>> {
  return z.object({
    AND: z.array(z.lazy(() => DataSourceCellScalarWhereWithAggregatesInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => DataSourceCellScalarWhereWithAggregatesInputSchema())).nullish(),
    OR: z.array(z.lazy(() => DataSourceCellScalarWhereWithAggregatesInputSchema())).nullish(),
    columnUUID: z.lazy(() => StringWithAggregatesFilterSchema().nullish()),
    id: z.lazy(() => IntWithAggregatesFilterSchema().nullish()),
    initVersionId: z.lazy(() => IntWithAggregatesFilterSchema().nullish()),
    lastVersionId: z.lazy(() => IntWithAggregatesFilterSchema().nullish()),
    rowUUID: z.lazy(() => StringWithAggregatesFilterSchema().nullish()),
    value: z.lazy(() => StringWithAggregatesFilterSchema().nullish())
  })
}

export function DataSourceCellSumAggregateSchema(): z.ZodObject<Properties<DataSourceCellSumAggregate>> {
  return z.object({
    __typename: z.literal('DataSourceCellSumAggregate').optional(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    initVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    lastVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function DataSourceCellSumOrderByAggregateInputSchema(): z.ZodObject<Properties<DataSourceCellSumOrderByAggregateInput>> {
  return z.object({
    id: SortOrderSchema.nullish(),
    initVersionId: SortOrderSchema.nullish(),
    lastVersionId: SortOrderSchema.nullish()
  })
}

export function DataSourceCellUpdateInputSchema(): z.ZodObject<Properties<DataSourceCellUpdateInput>> {
  return z.object({
    columnUUID: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    initVersionId: z.lazy(() => IntFieldUpdateOperationsInputSchema().nullish()),
    lastVersion: z.lazy(() => DataSourceVersionUpdateOneRequiredWithoutCellsNestedInputSchema().nullish()),
    rowUUID: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    value: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish())
  })
}

export function DataSourceCellUpdateManyMutationInputSchema(): z.ZodObject<Properties<DataSourceCellUpdateManyMutationInput>> {
  return z.object({
    columnUUID: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    initVersionId: z.lazy(() => IntFieldUpdateOperationsInputSchema().nullish()),
    rowUUID: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    value: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish())
  })
}

export function DataSourceCellUpdateManyWithWhereWithoutLastVersionInputSchema(): z.ZodObject<Properties<DataSourceCellUpdateManyWithWhereWithoutLastVersionInput>> {
  return z.object({
    data: z.lazy(() => DataSourceCellUpdateManyMutationInputSchema()),
    where: z.lazy(() => DataSourceCellScalarWhereInputSchema())
  })
}

export function DataSourceCellUpdateManyWithoutLastVersionNestedInputSchema(): z.ZodObject<Properties<DataSourceCellUpdateManyWithoutLastVersionNestedInput>> {
  return z.object({
    connect: z.array(z.lazy(() => DataSourceCellWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => DataSourceCellCreateOrConnectWithoutLastVersionInputSchema())).nullish(),
    create: z.array(z.lazy(() => DataSourceCellCreateWithoutLastVersionInputSchema())).nullish(),
    createMany: z.lazy(() => DataSourceCellCreateManyLastVersionInputEnvelopeSchema().nullish()),
    delete: z.array(z.lazy(() => DataSourceCellWhereUniqueInputSchema())).nullish(),
    deleteMany: z.array(z.lazy(() => DataSourceCellScalarWhereInputSchema())).nullish(),
    disconnect: z.array(z.lazy(() => DataSourceCellWhereUniqueInputSchema())).nullish(),
    set: z.array(z.lazy(() => DataSourceCellWhereUniqueInputSchema())).nullish(),
    update: z.array(z.lazy(() => DataSourceCellUpdateWithWhereUniqueWithoutLastVersionInputSchema())).nullish(),
    updateMany: z.array(z.lazy(() => DataSourceCellUpdateManyWithWhereWithoutLastVersionInputSchema())).nullish(),
    upsert: z.array(z.lazy(() => DataSourceCellUpsertWithWhereUniqueWithoutLastVersionInputSchema())).nullish()
  })
}

export function DataSourceCellUpdateWithWhereUniqueWithoutLastVersionInputSchema(): z.ZodObject<Properties<DataSourceCellUpdateWithWhereUniqueWithoutLastVersionInput>> {
  return z.object({
    data: z.lazy(() => DataSourceCellUpdateWithoutLastVersionInputSchema()),
    where: z.lazy(() => DataSourceCellWhereUniqueInputSchema())
  })
}

export function DataSourceCellUpdateWithoutLastVersionInputSchema(): z.ZodObject<Properties<DataSourceCellUpdateWithoutLastVersionInput>> {
  return z.object({
    columnUUID: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    initVersionId: z.lazy(() => IntFieldUpdateOperationsInputSchema().nullish()),
    rowUUID: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    value: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish())
  })
}

export function DataSourceCellUpsertWithWhereUniqueWithoutLastVersionInputSchema(): z.ZodObject<Properties<DataSourceCellUpsertWithWhereUniqueWithoutLastVersionInput>> {
  return z.object({
    create: z.lazy(() => DataSourceCellCreateWithoutLastVersionInputSchema()),
    update: z.lazy(() => DataSourceCellUpdateWithoutLastVersionInputSchema()),
    where: z.lazy(() => DataSourceCellWhereUniqueInputSchema())
  })
}

export function DataSourceCellWhereInputSchema(): z.ZodObject<Properties<DataSourceCellWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => DataSourceCellWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => DataSourceCellWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => DataSourceCellWhereInputSchema())).nullish(),
    columnUUID: z.lazy(() => StringFilterSchema().nullish()),
    id: z.lazy(() => IntFilterSchema().nullish()),
    initVersionId: z.lazy(() => IntFilterSchema().nullish()),
    lastVersion: z.lazy(() => DataSourceVersionScalarRelationFilterSchema().nullish()),
    lastVersionId: z.lazy(() => IntFilterSchema().nullish()),
    rowUUID: z.lazy(() => StringFilterSchema().nullish()),
    value: z.lazy(() => StringFilterSchema().nullish())
  })
}

export function DataSourceCellWhereUniqueInputSchema(): z.ZodObject<Properties<DataSourceCellWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => DataSourceCellWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => DataSourceCellWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => DataSourceCellWhereInputSchema())).nullish(),
    columnUUID: z.lazy(() => StringFilterSchema().nullish()),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    initVersionId: z.lazy(() => IntFilterSchema().nullish()),
    lastVersion: z.lazy(() => DataSourceVersionScalarRelationFilterSchema().nullish()),
    lastVersionId: z.lazy(() => IntFilterSchema().nullish()),
    lastVersionId_columnUUID_rowUUID: z.lazy(() => DataSourceCellLastVersionIdColumnUuidRowUuidCompoundUniqueInputSchema().nullish()),
    rowUUID: z.lazy(() => StringFilterSchema().nullish()),
    value: z.lazy(() => StringFilterSchema().nullish())
  })
}

export function DataSourceCountSchema(): z.ZodObject<Properties<DataSourceCount>> {
  return z.object({
    __typename: z.literal('DataSourceCount').optional(),
    versions: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function DataSourceCountVersionsArgsSchema(): z.ZodObject<Properties<DataSourceCountVersionsArgs>> {
  return z.object({
    where: z.lazy(() => DataSourceVersionWhereInputSchema().nullish())
  })
}

export function DataSourceCountAggregateSchema(): z.ZodObject<Properties<DataSourceCountAggregate>> {
  return z.object({
    __typename: z.literal('DataSourceCountAggregate').optional(),
    _all: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    createdAt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    includeInFreshness: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    isSharedWithAdmin: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    name: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    updatedAt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function DataSourceCountOrderByAggregateInputSchema(): z.ZodObject<Properties<DataSourceCountOrderByAggregateInput>> {
  return z.object({
    createdAt: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    includeInFreshness: SortOrderSchema.nullish(),
    isSharedWithAdmin: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    updatedAt: SortOrderSchema.nullish()
  })
}

export function DataSourceCreateInputSchema(): z.ZodObject<Properties<DataSourceCreateInput>> {
  return z.object({
    createdAt: z.number().nullish(),
    includeInFreshness: z.boolean().nullish(),
    isSharedWithAdmin: z.boolean().nullish(),
    name: z.string().trim(),
    updatedAt: z.number().nullish(),
    versions: z.lazy(() => DataSourceVersionCreateNestedManyWithoutDataSourceInputSchema().nullish())
  })
}

export function DataSourceCreateManyInputSchema(): z.ZodObject<Properties<DataSourceCreateManyInput>> {
  return z.object({
    createdAt: z.number().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    includeInFreshness: z.boolean().nullish(),
    isSharedWithAdmin: z.boolean().nullish(),
    name: z.string().trim(),
    updatedAt: z.number().nullish()
  })
}

export function DataSourceCreateNestedOneWithoutVersionsInputSchema(): z.ZodObject<Properties<DataSourceCreateNestedOneWithoutVersionsInput>> {
  return z.object({
    connect: z.lazy(() => DataSourceWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => DataSourceCreateOrConnectWithoutVersionsInputSchema().nullish()),
    create: z.lazy(() => DataSourceCreateWithoutVersionsInputSchema().nullish())
  })
}

export function DataSourceCreateOrConnectWithoutVersionsInputSchema(): z.ZodObject<Properties<DataSourceCreateOrConnectWithoutVersionsInput>> {
  return z.object({
    create: z.lazy(() => DataSourceCreateWithoutVersionsInputSchema()),
    where: z.lazy(() => DataSourceWhereUniqueInputSchema())
  })
}

export function DataSourceCreateWithoutVersionsInputSchema(): z.ZodObject<Properties<DataSourceCreateWithoutVersionsInput>> {
  return z.object({
    createdAt: z.number().nullish(),
    includeInFreshness: z.boolean().nullish(),
    isSharedWithAdmin: z.boolean().nullish(),
    name: z.string().trim(),
    updatedAt: z.number().nullish()
  })
}

export function DataSourceDeleteImpactSchema(): z.ZodObject<Properties<DataSourceDeleteImpact>> {
  return z.object({
    __typename: z.literal('DataSourceDeleteImpact').optional(),
    insights: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    proposals: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function DataSourceGroupBySchema(): z.ZodObject<Properties<DataSourceGroupBy>> {
  return z.object({
    __typename: z.literal('DataSourceGroupBy').optional(),
    _avg: z.lazy(() => DataSourceAvgAggregateSchema().nullish()),
    _count: z.lazy(() => DataSourceCountAggregateSchema().nullish()),
    _max: z.lazy(() => DataSourceMaxAggregateSchema().nullish()),
    _min: z.lazy(() => DataSourceMinAggregateSchema().nullish()),
    _sum: z.lazy(() => DataSourceSumAggregateSchema().nullish()),
    createdAt: z.number(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    includeInFreshness: z.boolean(),
    isSharedWithAdmin: z.boolean().nullish(),
    name: z.string().trim(),
    updatedAt: z.number()
  })
}

export function DataSourceMaxAggregateSchema(): z.ZodObject<Properties<DataSourceMaxAggregate>> {
  return z.object({
    __typename: z.literal('DataSourceMaxAggregate').optional(),
    createdAt: z.number().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    includeInFreshness: z.boolean().nullish(),
    isSharedWithAdmin: z.boolean().nullish(),
    name: z.string().trim().nullish(),
    updatedAt: z.number().nullish()
  })
}

export function DataSourceMaxOrderByAggregateInputSchema(): z.ZodObject<Properties<DataSourceMaxOrderByAggregateInput>> {
  return z.object({
    createdAt: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    includeInFreshness: SortOrderSchema.nullish(),
    isSharedWithAdmin: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    updatedAt: SortOrderSchema.nullish()
  })
}

export function DataSourceMetaSchema(): z.ZodObject<Properties<DataSourceMeta>> {
  return z.object({
    __typename: z.literal('DataSourceMeta').optional(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    lastVersion: z.lazy(() => DataSourceVersionMetaSchema()),
    name: z.string().trim(),
    updatedAt: z.number()
  })
}

export function DataSourceMinAggregateSchema(): z.ZodObject<Properties<DataSourceMinAggregate>> {
  return z.object({
    __typename: z.literal('DataSourceMinAggregate').optional(),
    createdAt: z.number().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    includeInFreshness: z.boolean().nullish(),
    isSharedWithAdmin: z.boolean().nullish(),
    name: z.string().trim().nullish(),
    updatedAt: z.number().nullish()
  })
}

export function DataSourceMinOrderByAggregateInputSchema(): z.ZodObject<Properties<DataSourceMinOrderByAggregateInput>> {
  return z.object({
    createdAt: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    includeInFreshness: SortOrderSchema.nullish(),
    isSharedWithAdmin: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    updatedAt: SortOrderSchema.nullish()
  })
}

export function DataSourceOrderByRelevanceInputSchema(): z.ZodObject<Properties<DataSourceOrderByRelevanceInput>> {
  return z.object({
    fields: z.array(DataSourceOrderByRelevanceFieldEnumSchema),
    search: z.string().trim(),
    sort: SortOrderSchema
  })
}

export function DataSourceOrderByWithAggregationInputSchema(): z.ZodObject<Properties<DataSourceOrderByWithAggregationInput>> {
  return z.object({
    _avg: z.lazy(() => DataSourceAvgOrderByAggregateInputSchema().nullish()),
    _count: z.lazy(() => DataSourceCountOrderByAggregateInputSchema().nullish()),
    _max: z.lazy(() => DataSourceMaxOrderByAggregateInputSchema().nullish()),
    _min: z.lazy(() => DataSourceMinOrderByAggregateInputSchema().nullish()),
    _sum: z.lazy(() => DataSourceSumOrderByAggregateInputSchema().nullish()),
    createdAt: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    includeInFreshness: SortOrderSchema.nullish(),
    isSharedWithAdmin: z.lazy(() => SortOrderInputSchema().nullish()),
    name: SortOrderSchema.nullish(),
    updatedAt: SortOrderSchema.nullish()
  })
}

export function DataSourceOrderByWithRelationInputSchema(): z.ZodObject<Properties<DataSourceOrderByWithRelationInput>> {
  return z.object({
    _relevance: z.lazy(() => DataSourceOrderByRelevanceInputSchema().nullish()),
    createdAt: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    includeInFreshness: SortOrderSchema.nullish(),
    isSharedWithAdmin: z.lazy(() => SortOrderInputSchema().nullish()),
    name: SortOrderSchema.nullish(),
    updatedAt: SortOrderSchema.nullish(),
    versions: z.lazy(() => DataSourceVersionOrderByRelationAggregateInputSchema().nullish())
  })
}

export function DataSourceSaveResolverCreateInputSchema(): z.ZodObject<Properties<DataSourceSaveResolverCreateInput>> {
  return z.object({
    code: z.string().trim(),
    columns: z.record(z.string(), z.unknown()),
    hash: z.string().trim().nullish(),
    includeInFreshness: z.boolean().nullish(),
    isSharedWithAdmin: z.boolean().nullish(),
    mappingRules: z.record(z.string(), z.unknown()),
    name: z.string().trim().nullish(),
    type: DataSourceTypeSchema,
    usedAt: z.number().nullish(),
    validationRules: z.record(z.string(), z.unknown())
  })
}

export function DataSourceSaveResolverUpdateInputSchema(): z.ZodObject<Properties<DataSourceSaveResolverUpdateInput>> {
  return z.object({
    code: z.string().trim(),
    columns: z.record(z.string(), z.unknown()),
    hash: z.string().trim().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    includeInFreshness: z.boolean().nullish(),
    isSharedWithAdmin: z.boolean().nullish(),
    mappingRules: z.record(z.string(), z.unknown()),
    name: z.string().trim().nullish(),
    type: DataSourceTypeSchema,
    usedAt: z.number().nullish(),
    validationRules: z.record(z.string(), z.unknown())
  })
}

export function DataSourceScalarRelationFilterSchema(): z.ZodObject<Properties<DataSourceScalarRelationFilter>> {
  return z.object({
    is: z.lazy(() => DataSourceWhereInputSchema().nullish()),
    isNot: z.lazy(() => DataSourceWhereInputSchema().nullish())
  })
}

export function DataSourceScalarWhereWithAggregatesInputSchema(): z.ZodObject<Properties<DataSourceScalarWhereWithAggregatesInput>> {
  return z.object({
    AND: z.array(z.lazy(() => DataSourceScalarWhereWithAggregatesInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => DataSourceScalarWhereWithAggregatesInputSchema())).nullish(),
    OR: z.array(z.lazy(() => DataSourceScalarWhereWithAggregatesInputSchema())).nullish(),
    createdAt: z.lazy(() => DateTimeWithAggregatesFilterSchema().nullish()),
    id: z.lazy(() => IntWithAggregatesFilterSchema().nullish()),
    includeInFreshness: z.lazy(() => BoolWithAggregatesFilterSchema().nullish()),
    isSharedWithAdmin: z.lazy(() => BoolNullableWithAggregatesFilterSchema().nullish()),
    name: z.lazy(() => StringWithAggregatesFilterSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeWithAggregatesFilterSchema().nullish())
  })
}

export function DataSourceSumAggregateSchema(): z.ZodObject<Properties<DataSourceSumAggregate>> {
  return z.object({
    __typename: z.literal('DataSourceSumAggregate').optional(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function DataSourceSumOrderByAggregateInputSchema(): z.ZodObject<Properties<DataSourceSumOrderByAggregateInput>> {
  return z.object({
    id: SortOrderSchema.nullish()
  })
}

export function DataSourceUpdateInputSchema(): z.ZodObject<Properties<DataSourceUpdateInput>> {
  return z.object({
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    includeInFreshness: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    isSharedWithAdmin: z.lazy(() => NullableBoolFieldUpdateOperationsInputSchema().nullish()),
    name: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    versions: z.lazy(() => DataSourceVersionUpdateManyWithoutDataSourceNestedInputSchema().nullish())
  })
}

export function DataSourceUpdateManyMutationInputSchema(): z.ZodObject<Properties<DataSourceUpdateManyMutationInput>> {
  return z.object({
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    includeInFreshness: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    isSharedWithAdmin: z.lazy(() => NullableBoolFieldUpdateOperationsInputSchema().nullish()),
    name: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish())
  })
}

export function DataSourceUpdateOneRequiredWithoutVersionsNestedInputSchema(): z.ZodObject<Properties<DataSourceUpdateOneRequiredWithoutVersionsNestedInput>> {
  return z.object({
    connect: z.lazy(() => DataSourceWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => DataSourceCreateOrConnectWithoutVersionsInputSchema().nullish()),
    create: z.lazy(() => DataSourceCreateWithoutVersionsInputSchema().nullish()),
    update: z.lazy(() => DataSourceUpdateToOneWithWhereWithoutVersionsInputSchema().nullish()),
    upsert: z.lazy(() => DataSourceUpsertWithoutVersionsInputSchema().nullish())
  })
}

export function DataSourceUpdateToOneWithWhereWithoutVersionsInputSchema(): z.ZodObject<Properties<DataSourceUpdateToOneWithWhereWithoutVersionsInput>> {
  return z.object({
    data: z.lazy(() => DataSourceUpdateWithoutVersionsInputSchema()),
    where: z.lazy(() => DataSourceWhereInputSchema().nullish())
  })
}

export function DataSourceUpdateWithoutVersionsInputSchema(): z.ZodObject<Properties<DataSourceUpdateWithoutVersionsInput>> {
  return z.object({
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    includeInFreshness: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    isSharedWithAdmin: z.lazy(() => NullableBoolFieldUpdateOperationsInputSchema().nullish()),
    name: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish())
  })
}

export function DataSourceUpsertWithoutVersionsInputSchema(): z.ZodObject<Properties<DataSourceUpsertWithoutVersionsInput>> {
  return z.object({
    create: z.lazy(() => DataSourceCreateWithoutVersionsInputSchema()),
    update: z.lazy(() => DataSourceUpdateWithoutVersionsInputSchema()),
    where: z.lazy(() => DataSourceWhereInputSchema().nullish())
  })
}

export function DataSourceVersionSchema(): z.ZodObject<Properties<DataSourceVersion>> {
  return z.object({
    __typename: z.literal('DataSourceVersion').optional(),
    _count: z.lazy(() => DataSourceVersionCountSchema().nullish()),
    cells: z.array(z.lazy(() => DataSourceCellSchema())),
    code: z.string().trim(),
    columns: z.record(z.string(), z.unknown()),
    createdAt: z.number(),
    createdBy: z.string().trim(),
    data: z.record(z.string(), z.unknown()).nullish(),
    dataSource: z.lazy(() => DataSourceSchema()),
    dataSourceId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    hash: z.string().trim().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    mappingRules: z.record(z.string(), z.unknown()).nullish(),
    type: DataSourceTypeSchema,
    usedAt: z.number().nullish(),
    validationRules: z.record(z.string(), z.unknown()).nullish()
  })
}

export function DataSourceVersionCellsArgsSchema(): z.ZodObject<Properties<DataSourceVersionCellsArgs>> {
  return z.object({
    cursor: z.lazy(() => DataSourceCellWhereUniqueInputSchema().nullish()),
    distinct: z.array(DataSourceCellScalarFieldEnumSchema).nullish(),
    orderBy: z.array(z.lazy(() => DataSourceCellOrderByWithRelationInputSchema())).nullish(),
    skip: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    take: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    where: z.lazy(() => DataSourceCellWhereInputSchema().nullish())
  })
}

export function DataSourceVersionAvgAggregateSchema(): z.ZodObject<Properties<DataSourceVersionAvgAggregate>> {
  return z.object({
    __typename: z.literal('DataSourceVersionAvgAggregate').optional(),
    dataSourceId: z.number().nullish(),
    id: z.number().nullish()
  })
}

export function DataSourceVersionAvgOrderByAggregateInputSchema(): z.ZodObject<Properties<DataSourceVersionAvgOrderByAggregateInput>> {
  return z.object({
    dataSourceId: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish()
  })
}

export function DataSourceVersionCountSchema(): z.ZodObject<Properties<DataSourceVersionCount>> {
  return z.object({
    __typename: z.literal('DataSourceVersionCount').optional(),
    cells: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    proposalVersions: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function DataSourceVersionCountCellsArgsSchema(): z.ZodObject<Properties<DataSourceVersionCountCellsArgs>> {
  return z.object({
    where: z.lazy(() => DataSourceCellWhereInputSchema().nullish())
  })
}

export function DataSourceVersionCountProposalVersionsArgsSchema(): z.ZodObject<Properties<DataSourceVersionCountProposalVersionsArgs>> {
  return z.object({
    where: z.lazy(() => ProposalVersionDataSourceWhereInputSchema().nullish())
  })
}

export function DataSourceVersionCountAggregateSchema(): z.ZodObject<Properties<DataSourceVersionCountAggregate>> {
  return z.object({
    __typename: z.literal('DataSourceVersionCountAggregate').optional(),
    _all: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    code: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    columns: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    createdAt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    createdBy: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    dataSourceId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    hash: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    mappingRules: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    type: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    usedAt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    validationRules: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function DataSourceVersionCountOrderByAggregateInputSchema(): z.ZodObject<Properties<DataSourceVersionCountOrderByAggregateInput>> {
  return z.object({
    code: SortOrderSchema.nullish(),
    columns: SortOrderSchema.nullish(),
    createdAt: SortOrderSchema.nullish(),
    createdBy: SortOrderSchema.nullish(),
    dataSourceId: SortOrderSchema.nullish(),
    hash: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    mappingRules: SortOrderSchema.nullish(),
    type: SortOrderSchema.nullish(),
    usedAt: SortOrderSchema.nullish(),
    validationRules: SortOrderSchema.nullish()
  })
}

export function DataSourceVersionCreateInputSchema(): z.ZodObject<Properties<DataSourceVersionCreateInput>> {
  return z.object({
    cells: z.lazy(() => DataSourceCellCreateNestedManyWithoutLastVersionInputSchema().nullish()),
    code: z.string().trim(),
    columns: z.record(z.string(), z.unknown()),
    createdAt: z.number().nullish(),
    createdBy: z.string().trim().nullish(),
    dataSource: z.lazy(() => DataSourceCreateNestedOneWithoutVersionsInputSchema()),
    hash: z.string().trim().nullish(),
    mappingRules: z.record(z.string(), z.unknown()).nullish(),
    type: DataSourceTypeSchema,
    usedAt: z.number().nullish(),
    validationRules: z.record(z.string(), z.unknown()).nullish()
  })
}

export function DataSourceVersionCreateManyDataSourceInputSchema(): z.ZodObject<Properties<DataSourceVersionCreateManyDataSourceInput>> {
  return z.object({
    code: z.string().trim(),
    columns: z.record(z.string(), z.unknown()),
    createdAt: z.number().nullish(),
    createdBy: z.string().trim().nullish(),
    hash: z.string().trim().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    mappingRules: z.record(z.string(), z.unknown()).nullish(),
    type: DataSourceTypeSchema,
    usedAt: z.number().nullish(),
    validationRules: z.record(z.string(), z.unknown()).nullish()
  })
}

export function DataSourceVersionCreateManyDataSourceInputEnvelopeSchema(): z.ZodObject<Properties<DataSourceVersionCreateManyDataSourceInputEnvelope>> {
  return z.object({
    data: z.array(z.lazy(() => DataSourceVersionCreateManyDataSourceInputSchema())),
    skipDuplicates: z.boolean().nullish()
  })
}

export function DataSourceVersionCreateManyInputSchema(): z.ZodObject<Properties<DataSourceVersionCreateManyInput>> {
  return z.object({
    code: z.string().trim(),
    columns: z.record(z.string(), z.unknown()),
    createdAt: z.number().nullish(),
    createdBy: z.string().trim().nullish(),
    dataSourceId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    hash: z.string().trim().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    mappingRules: z.record(z.string(), z.unknown()).nullish(),
    type: DataSourceTypeSchema,
    usedAt: z.number().nullish(),
    validationRules: z.record(z.string(), z.unknown()).nullish()
  })
}

export function DataSourceVersionCreateNestedManyWithoutDataSourceInputSchema(): z.ZodObject<Properties<DataSourceVersionCreateNestedManyWithoutDataSourceInput>> {
  return z.object({
    connect: z.array(z.lazy(() => DataSourceVersionWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => DataSourceVersionCreateOrConnectWithoutDataSourceInputSchema())).nullish(),
    create: z.array(z.lazy(() => DataSourceVersionCreateWithoutDataSourceInputSchema())).nullish(),
    createMany: z.lazy(() => DataSourceVersionCreateManyDataSourceInputEnvelopeSchema().nullish())
  })
}

export function DataSourceVersionCreateNestedOneWithoutCellsInputSchema(): z.ZodObject<Properties<DataSourceVersionCreateNestedOneWithoutCellsInput>> {
  return z.object({
    connect: z.lazy(() => DataSourceVersionWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => DataSourceVersionCreateOrConnectWithoutCellsInputSchema().nullish()),
    create: z.lazy(() => DataSourceVersionCreateWithoutCellsInputSchema().nullish())
  })
}

export function DataSourceVersionCreateNestedOneWithoutOriginInputSchema(): z.ZodObject<Properties<DataSourceVersionCreateNestedOneWithoutOriginInput>> {
  return z.object({
    connect: z.lazy(() => DataSourceVersionWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => DataSourceVersionCreateOrConnectWithoutOriginInputSchema().nullish()),
    create: z.lazy(() => DataSourceVersionCreateWithoutOriginInputSchema().nullish())
  })
}

export function DataSourceVersionCreateOrConnectWithoutCellsInputSchema(): z.ZodObject<Properties<DataSourceVersionCreateOrConnectWithoutCellsInput>> {
  return z.object({
    create: z.lazy(() => DataSourceVersionCreateWithoutCellsInputSchema()),
    where: z.lazy(() => DataSourceVersionWhereUniqueInputSchema())
  })
}

export function DataSourceVersionCreateOrConnectWithoutDataSourceInputSchema(): z.ZodObject<Properties<DataSourceVersionCreateOrConnectWithoutDataSourceInput>> {
  return z.object({
    create: z.lazy(() => DataSourceVersionCreateWithoutDataSourceInputSchema()),
    where: z.lazy(() => DataSourceVersionWhereUniqueInputSchema())
  })
}

export function DataSourceVersionCreateOrConnectWithoutOriginInputSchema(): z.ZodObject<Properties<DataSourceVersionCreateOrConnectWithoutOriginInput>> {
  return z.object({
    create: z.lazy(() => DataSourceVersionCreateWithoutOriginInputSchema()),
    where: z.lazy(() => DataSourceVersionWhereUniqueInputSchema())
  })
}

export function DataSourceVersionCreateWithoutCellsInputSchema(): z.ZodObject<Properties<DataSourceVersionCreateWithoutCellsInput>> {
  return z.object({
    code: z.string().trim(),
    columns: z.record(z.string(), z.unknown()),
    createdAt: z.number().nullish(),
    createdBy: z.string().trim().nullish(),
    dataSource: z.lazy(() => DataSourceCreateNestedOneWithoutVersionsInputSchema()),
    hash: z.string().trim().nullish(),
    mappingRules: z.record(z.string(), z.unknown()).nullish(),
    type: DataSourceTypeSchema,
    usedAt: z.number().nullish(),
    validationRules: z.record(z.string(), z.unknown()).nullish()
  })
}

export function DataSourceVersionCreateWithoutDataSourceInputSchema(): z.ZodObject<Properties<DataSourceVersionCreateWithoutDataSourceInput>> {
  return z.object({
    cells: z.lazy(() => DataSourceCellCreateNestedManyWithoutLastVersionInputSchema().nullish()),
    code: z.string().trim(),
    columns: z.record(z.string(), z.unknown()),
    createdAt: z.number().nullish(),
    createdBy: z.string().trim().nullish(),
    hash: z.string().trim().nullish(),
    mappingRules: z.record(z.string(), z.unknown()).nullish(),
    type: DataSourceTypeSchema,
    usedAt: z.number().nullish(),
    validationRules: z.record(z.string(), z.unknown()).nullish()
  })
}

export function DataSourceVersionCreateWithoutOriginInputSchema(): z.ZodObject<Properties<DataSourceVersionCreateWithoutOriginInput>> {
  return z.object({
    cells: z.lazy(() => DataSourceCellCreateNestedManyWithoutLastVersionInputSchema().nullish()),
    code: z.string().trim(),
    columns: z.record(z.string(), z.unknown()),
    createdAt: z.number().nullish(),
    createdBy: z.string().trim().nullish(),
    dataSource: z.lazy(() => DataSourceCreateNestedOneWithoutVersionsInputSchema()),
    hash: z.string().trim().nullish(),
    mappingRules: z.record(z.string(), z.unknown()).nullish(),
    type: DataSourceTypeSchema,
    usedAt: z.number().nullish(),
    validationRules: z.record(z.string(), z.unknown()).nullish()
  })
}

export function DataSourceVersionGroupBySchema(): z.ZodObject<Properties<DataSourceVersionGroupBy>> {
  return z.object({
    __typename: z.literal('DataSourceVersionGroupBy').optional(),
    _avg: z.lazy(() => DataSourceVersionAvgAggregateSchema().nullish()),
    _count: z.lazy(() => DataSourceVersionCountAggregateSchema().nullish()),
    _max: z.lazy(() => DataSourceVersionMaxAggregateSchema().nullish()),
    _min: z.lazy(() => DataSourceVersionMinAggregateSchema().nullish()),
    _sum: z.lazy(() => DataSourceVersionSumAggregateSchema().nullish()),
    code: z.string().trim(),
    columns: z.record(z.string(), z.unknown()),
    createdAt: z.number(),
    createdBy: z.string().trim(),
    dataSourceId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    hash: z.string().trim().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    mappingRules: z.record(z.string(), z.unknown()).nullish(),
    type: DataSourceTypeSchema,
    usedAt: z.number().nullish(),
    validationRules: z.record(z.string(), z.unknown()).nullish()
  })
}

export function DataSourceVersionListRelationFilterSchema(): z.ZodObject<Properties<DataSourceVersionListRelationFilter>> {
  return z.object({
    every: z.lazy(() => DataSourceVersionWhereInputSchema().nullish()),
    none: z.lazy(() => DataSourceVersionWhereInputSchema().nullish()),
    some: z.lazy(() => DataSourceVersionWhereInputSchema().nullish())
  })
}

export function DataSourceVersionMaxAggregateSchema(): z.ZodObject<Properties<DataSourceVersionMaxAggregate>> {
  return z.object({
    __typename: z.literal('DataSourceVersionMaxAggregate').optional(),
    code: z.string().trim().nullish(),
    createdAt: z.number().nullish(),
    createdBy: z.string().trim().nullish(),
    dataSourceId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    hash: z.string().trim().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    type: DataSourceTypeSchema.nullish(),
    usedAt: z.number().nullish()
  })
}

export function DataSourceVersionMaxOrderByAggregateInputSchema(): z.ZodObject<Properties<DataSourceVersionMaxOrderByAggregateInput>> {
  return z.object({
    code: SortOrderSchema.nullish(),
    createdAt: SortOrderSchema.nullish(),
    createdBy: SortOrderSchema.nullish(),
    dataSourceId: SortOrderSchema.nullish(),
    hash: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    type: SortOrderSchema.nullish(),
    usedAt: SortOrderSchema.nullish()
  })
}

export function DataSourceVersionMetaSchema(): z.ZodObject<Properties<DataSourceVersionMeta>> {
  return z.object({
    __typename: z.literal('DataSourceVersionMeta').optional(),
    createdAt: z.number(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    usedAt: z.number().nullish()
  })
}

export function DataSourceVersionMinAggregateSchema(): z.ZodObject<Properties<DataSourceVersionMinAggregate>> {
  return z.object({
    __typename: z.literal('DataSourceVersionMinAggregate').optional(),
    code: z.string().trim().nullish(),
    createdAt: z.number().nullish(),
    createdBy: z.string().trim().nullish(),
    dataSourceId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    hash: z.string().trim().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    type: DataSourceTypeSchema.nullish(),
    usedAt: z.number().nullish()
  })
}

export function DataSourceVersionMinOrderByAggregateInputSchema(): z.ZodObject<Properties<DataSourceVersionMinOrderByAggregateInput>> {
  return z.object({
    code: SortOrderSchema.nullish(),
    createdAt: SortOrderSchema.nullish(),
    createdBy: SortOrderSchema.nullish(),
    dataSourceId: SortOrderSchema.nullish(),
    hash: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    type: SortOrderSchema.nullish(),
    usedAt: SortOrderSchema.nullish()
  })
}

export function DataSourceVersionOrderByRelationAggregateInputSchema(): z.ZodObject<Properties<DataSourceVersionOrderByRelationAggregateInput>> {
  return z.object({
    _count: SortOrderSchema.nullish()
  })
}

export function DataSourceVersionOrderByRelevanceInputSchema(): z.ZodObject<Properties<DataSourceVersionOrderByRelevanceInput>> {
  return z.object({
    fields: z.array(DataSourceVersionOrderByRelevanceFieldEnumSchema),
    search: z.string().trim(),
    sort: SortOrderSchema
  })
}

export function DataSourceVersionOrderByWithAggregationInputSchema(): z.ZodObject<Properties<DataSourceVersionOrderByWithAggregationInput>> {
  return z.object({
    _avg: z.lazy(() => DataSourceVersionAvgOrderByAggregateInputSchema().nullish()),
    _count: z.lazy(() => DataSourceVersionCountOrderByAggregateInputSchema().nullish()),
    _max: z.lazy(() => DataSourceVersionMaxOrderByAggregateInputSchema().nullish()),
    _min: z.lazy(() => DataSourceVersionMinOrderByAggregateInputSchema().nullish()),
    _sum: z.lazy(() => DataSourceVersionSumOrderByAggregateInputSchema().nullish()),
    code: SortOrderSchema.nullish(),
    columns: SortOrderSchema.nullish(),
    createdAt: SortOrderSchema.nullish(),
    createdBy: SortOrderSchema.nullish(),
    dataSourceId: SortOrderSchema.nullish(),
    hash: z.lazy(() => SortOrderInputSchema().nullish()),
    id: SortOrderSchema.nullish(),
    mappingRules: z.lazy(() => SortOrderInputSchema().nullish()),
    type: SortOrderSchema.nullish(),
    usedAt: z.lazy(() => SortOrderInputSchema().nullish()),
    validationRules: z.lazy(() => SortOrderInputSchema().nullish())
  })
}

export function DataSourceVersionOrderByWithRelationInputSchema(): z.ZodObject<Properties<DataSourceVersionOrderByWithRelationInput>> {
  return z.object({
    _relevance: z.lazy(() => DataSourceVersionOrderByRelevanceInputSchema().nullish()),
    cells: z.lazy(() => DataSourceCellOrderByRelationAggregateInputSchema().nullish()),
    code: SortOrderSchema.nullish(),
    columns: SortOrderSchema.nullish(),
    createdAt: SortOrderSchema.nullish(),
    createdBy: SortOrderSchema.nullish(),
    dataSource: z.lazy(() => DataSourceOrderByWithRelationInputSchema().nullish()),
    dataSourceId: SortOrderSchema.nullish(),
    hash: z.lazy(() => SortOrderInputSchema().nullish()),
    id: SortOrderSchema.nullish(),
    mappingRules: z.lazy(() => SortOrderInputSchema().nullish()),
    type: SortOrderSchema.nullish(),
    usedAt: z.lazy(() => SortOrderInputSchema().nullish()),
    validationRules: z.lazy(() => SortOrderInputSchema().nullish())
  })
}

export function DataSourceVersionOriginSchema(): z.ZodObject<Properties<DataSourceVersionOrigin>> {
  return z.object({
    __typename: z.literal('DataSourceVersionOrigin').optional(),
    createdAt: z.number(),
    proposal: z.lazy(() => ProposalSchema()),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    version: z.lazy(() => DataSourceVersionSchema()),
    versionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function DataSourceVersionOriginAvgAggregateSchema(): z.ZodObject<Properties<DataSourceVersionOriginAvgAggregate>> {
  return z.object({
    __typename: z.literal('DataSourceVersionOriginAvgAggregate').optional(),
    proposalId: z.number().nullish(),
    versionId: z.number().nullish()
  })
}

export function DataSourceVersionOriginAvgOrderByAggregateInputSchema(): z.ZodObject<Properties<DataSourceVersionOriginAvgOrderByAggregateInput>> {
  return z.object({
    proposalId: SortOrderSchema.nullish(),
    versionId: SortOrderSchema.nullish()
  })
}

export function DataSourceVersionOriginCountAggregateSchema(): z.ZodObject<Properties<DataSourceVersionOriginCountAggregate>> {
  return z.object({
    __typename: z.literal('DataSourceVersionOriginCountAggregate').optional(),
    _all: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    createdAt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    versionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function DataSourceVersionOriginCountOrderByAggregateInputSchema(): z.ZodObject<Properties<DataSourceVersionOriginCountOrderByAggregateInput>> {
  return z.object({
    createdAt: SortOrderSchema.nullish(),
    proposalId: SortOrderSchema.nullish(),
    versionId: SortOrderSchema.nullish()
  })
}

export function DataSourceVersionOriginCreateInputSchema(): z.ZodObject<Properties<DataSourceVersionOriginCreateInput>> {
  return z.object({
    createdAt: z.number().nullish(),
    proposal: z.lazy(() => ProposalCreateNestedOneWithoutDataSourceVersionOriginInputSchema()),
    version: z.lazy(() => DataSourceVersionCreateNestedOneWithoutOriginInputSchema())
  })
}

export function DataSourceVersionOriginCreateManyInputSchema(): z.ZodObject<Properties<DataSourceVersionOriginCreateManyInput>> {
  return z.object({
    createdAt: z.number().nullish(),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    versionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function DataSourceVersionOriginGroupBySchema(): z.ZodObject<Properties<DataSourceVersionOriginGroupBy>> {
  return z.object({
    __typename: z.literal('DataSourceVersionOriginGroupBy').optional(),
    _avg: z.lazy(() => DataSourceVersionOriginAvgAggregateSchema().nullish()),
    _count: z.lazy(() => DataSourceVersionOriginCountAggregateSchema().nullish()),
    _max: z.lazy(() => DataSourceVersionOriginMaxAggregateSchema().nullish()),
    _min: z.lazy(() => DataSourceVersionOriginMinAggregateSchema().nullish()),
    _sum: z.lazy(() => DataSourceVersionOriginSumAggregateSchema().nullish()),
    createdAt: z.number(),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    versionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function DataSourceVersionOriginMaxAggregateSchema(): z.ZodObject<Properties<DataSourceVersionOriginMaxAggregate>> {
  return z.object({
    __typename: z.literal('DataSourceVersionOriginMaxAggregate').optional(),
    createdAt: z.number().nullish(),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    versionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function DataSourceVersionOriginMaxOrderByAggregateInputSchema(): z.ZodObject<Properties<DataSourceVersionOriginMaxOrderByAggregateInput>> {
  return z.object({
    createdAt: SortOrderSchema.nullish(),
    proposalId: SortOrderSchema.nullish(),
    versionId: SortOrderSchema.nullish()
  })
}

export function DataSourceVersionOriginMinAggregateSchema(): z.ZodObject<Properties<DataSourceVersionOriginMinAggregate>> {
  return z.object({
    __typename: z.literal('DataSourceVersionOriginMinAggregate').optional(),
    createdAt: z.number().nullish(),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    versionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function DataSourceVersionOriginMinOrderByAggregateInputSchema(): z.ZodObject<Properties<DataSourceVersionOriginMinOrderByAggregateInput>> {
  return z.object({
    createdAt: SortOrderSchema.nullish(),
    proposalId: SortOrderSchema.nullish(),
    versionId: SortOrderSchema.nullish()
  })
}

export function DataSourceVersionOriginOrderByWithAggregationInputSchema(): z.ZodObject<Properties<DataSourceVersionOriginOrderByWithAggregationInput>> {
  return z.object({
    _avg: z.lazy(() => DataSourceVersionOriginAvgOrderByAggregateInputSchema().nullish()),
    _count: z.lazy(() => DataSourceVersionOriginCountOrderByAggregateInputSchema().nullish()),
    _max: z.lazy(() => DataSourceVersionOriginMaxOrderByAggregateInputSchema().nullish()),
    _min: z.lazy(() => DataSourceVersionOriginMinOrderByAggregateInputSchema().nullish()),
    _sum: z.lazy(() => DataSourceVersionOriginSumOrderByAggregateInputSchema().nullish()),
    createdAt: SortOrderSchema.nullish(),
    proposalId: SortOrderSchema.nullish(),
    versionId: SortOrderSchema.nullish()
  })
}

export function DataSourceVersionOriginOrderByWithRelationInputSchema(): z.ZodObject<Properties<DataSourceVersionOriginOrderByWithRelationInput>> {
  return z.object({
    createdAt: SortOrderSchema.nullish(),
    proposal: z.lazy(() => ProposalOrderByWithRelationInputSchema().nullish()),
    proposalId: SortOrderSchema.nullish(),
    version: z.lazy(() => DataSourceVersionOrderByWithRelationInputSchema().nullish()),
    versionId: SortOrderSchema.nullish()
  })
}

export function DataSourceVersionOriginScalarWhereWithAggregatesInputSchema(): z.ZodObject<Properties<DataSourceVersionOriginScalarWhereWithAggregatesInput>> {
  return z.object({
    AND: z.array(z.lazy(() => DataSourceVersionOriginScalarWhereWithAggregatesInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => DataSourceVersionOriginScalarWhereWithAggregatesInputSchema())).nullish(),
    OR: z.array(z.lazy(() => DataSourceVersionOriginScalarWhereWithAggregatesInputSchema())).nullish(),
    createdAt: z.lazy(() => DateTimeWithAggregatesFilterSchema().nullish()),
    proposalId: z.lazy(() => IntWithAggregatesFilterSchema().nullish()),
    versionId: z.lazy(() => IntWithAggregatesFilterSchema().nullish())
  })
}

export function DataSourceVersionOriginSumAggregateSchema(): z.ZodObject<Properties<DataSourceVersionOriginSumAggregate>> {
  return z.object({
    __typename: z.literal('DataSourceVersionOriginSumAggregate').optional(),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    versionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function DataSourceVersionOriginSumOrderByAggregateInputSchema(): z.ZodObject<Properties<DataSourceVersionOriginSumOrderByAggregateInput>> {
  return z.object({
    proposalId: SortOrderSchema.nullish(),
    versionId: SortOrderSchema.nullish()
  })
}

export function DataSourceVersionOriginUpdateInputSchema(): z.ZodObject<Properties<DataSourceVersionOriginUpdateInput>> {
  return z.object({
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    proposal: z.lazy(() => ProposalUpdateOneRequiredWithoutDataSourceVersionOriginNestedInputSchema().nullish()),
    version: z.lazy(() => DataSourceVersionUpdateOneRequiredWithoutOriginNestedInputSchema().nullish())
  })
}

export function DataSourceVersionOriginUpdateManyMutationInputSchema(): z.ZodObject<Properties<DataSourceVersionOriginUpdateManyMutationInput>> {
  return z.object({
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish())
  })
}

export function DataSourceVersionOriginWhereInputSchema(): z.ZodObject<Properties<DataSourceVersionOriginWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => DataSourceVersionOriginWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => DataSourceVersionOriginWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => DataSourceVersionOriginWhereInputSchema())).nullish(),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    proposal: z.lazy(() => ProposalScalarRelationFilterSchema().nullish()),
    proposalId: z.lazy(() => IntFilterSchema().nullish()),
    version: z.lazy(() => DataSourceVersionScalarRelationFilterSchema().nullish()),
    versionId: z.lazy(() => IntFilterSchema().nullish())
  })
}

export function DataSourceVersionOriginWhereUniqueInputSchema(): z.ZodObject<Properties<DataSourceVersionOriginWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => DataSourceVersionOriginWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => DataSourceVersionOriginWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => DataSourceVersionOriginWhereInputSchema())).nullish(),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    proposal: z.lazy(() => ProposalScalarRelationFilterSchema().nullish()),
    proposalId: z.lazy(() => IntFilterSchema().nullish()),
    version: z.lazy(() => DataSourceVersionScalarRelationFilterSchema().nullish()),
    versionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function DataSourceVersionScalarRelationFilterSchema(): z.ZodObject<Properties<DataSourceVersionScalarRelationFilter>> {
  return z.object({
    is: z.lazy(() => DataSourceVersionWhereInputSchema().nullish()),
    isNot: z.lazy(() => DataSourceVersionWhereInputSchema().nullish())
  })
}

export function DataSourceVersionScalarWhereInputSchema(): z.ZodObject<Properties<DataSourceVersionScalarWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => DataSourceVersionScalarWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => DataSourceVersionScalarWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => DataSourceVersionScalarWhereInputSchema())).nullish(),
    code: z.lazy(() => StringFilterSchema().nullish()),
    columns: z.lazy(() => JsonFilterSchema().nullish()),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    createdBy: z.lazy(() => StringFilterSchema().nullish()),
    dataSourceId: z.lazy(() => IntFilterSchema().nullish()),
    hash: z.lazy(() => StringNullableFilterSchema().nullish()),
    id: z.lazy(() => IntFilterSchema().nullish()),
    mappingRules: z.lazy(() => JsonNullableFilterSchema().nullish()),
    type: z.lazy(() => EnumDataSourceTypeFilterSchema().nullish()),
    usedAt: z.lazy(() => DateTimeNullableFilterSchema().nullish()),
    validationRules: z.lazy(() => JsonNullableFilterSchema().nullish())
  })
}

export function DataSourceVersionScalarWhereWithAggregatesInputSchema(): z.ZodObject<Properties<DataSourceVersionScalarWhereWithAggregatesInput>> {
  return z.object({
    AND: z.array(z.lazy(() => DataSourceVersionScalarWhereWithAggregatesInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => DataSourceVersionScalarWhereWithAggregatesInputSchema())).nullish(),
    OR: z.array(z.lazy(() => DataSourceVersionScalarWhereWithAggregatesInputSchema())).nullish(),
    code: z.lazy(() => StringWithAggregatesFilterSchema().nullish()),
    columns: z.lazy(() => JsonWithAggregatesFilterSchema().nullish()),
    createdAt: z.lazy(() => DateTimeWithAggregatesFilterSchema().nullish()),
    createdBy: z.lazy(() => StringWithAggregatesFilterSchema().nullish()),
    dataSourceId: z.lazy(() => IntWithAggregatesFilterSchema().nullish()),
    hash: z.lazy(() => StringNullableWithAggregatesFilterSchema().nullish()),
    id: z.lazy(() => IntWithAggregatesFilterSchema().nullish()),
    mappingRules: z.lazy(() => JsonNullableWithAggregatesFilterSchema().nullish()),
    type: z.lazy(() => EnumDataSourceTypeWithAggregatesFilterSchema().nullish()),
    usedAt: z.lazy(() => DateTimeNullableWithAggregatesFilterSchema().nullish()),
    validationRules: z.lazy(() => JsonNullableWithAggregatesFilterSchema().nullish())
  })
}

export function DataSourceVersionSumAggregateSchema(): z.ZodObject<Properties<DataSourceVersionSumAggregate>> {
  return z.object({
    __typename: z.literal('DataSourceVersionSumAggregate').optional(),
    dataSourceId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function DataSourceVersionSumOrderByAggregateInputSchema(): z.ZodObject<Properties<DataSourceVersionSumOrderByAggregateInput>> {
  return z.object({
    dataSourceId: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish()
  })
}

export function DataSourceVersionUpdateInputSchema(): z.ZodObject<Properties<DataSourceVersionUpdateInput>> {
  return z.object({
    cells: z.lazy(() => DataSourceCellUpdateManyWithoutLastVersionNestedInputSchema().nullish()),
    code: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    columns: z.record(z.string(), z.unknown()).nullish(),
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    createdBy: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    dataSource: z.lazy(() => DataSourceUpdateOneRequiredWithoutVersionsNestedInputSchema().nullish()),
    hash: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish()),
    mappingRules: z.record(z.string(), z.unknown()).nullish(),
    type: z.lazy(() => EnumDataSourceTypeFieldUpdateOperationsInputSchema().nullish()),
    usedAt: z.lazy(() => NullableDateTimeFieldUpdateOperationsInputSchema().nullish()),
    validationRules: z.record(z.string(), z.unknown()).nullish()
  })
}

export function DataSourceVersionUpdateManyMutationInputSchema(): z.ZodObject<Properties<DataSourceVersionUpdateManyMutationInput>> {
  return z.object({
    code: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    columns: z.record(z.string(), z.unknown()).nullish(),
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    createdBy: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    hash: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish()),
    mappingRules: z.record(z.string(), z.unknown()).nullish(),
    type: z.lazy(() => EnumDataSourceTypeFieldUpdateOperationsInputSchema().nullish()),
    usedAt: z.lazy(() => NullableDateTimeFieldUpdateOperationsInputSchema().nullish()),
    validationRules: z.record(z.string(), z.unknown()).nullish()
  })
}

export function DataSourceVersionUpdateManyWithWhereWithoutDataSourceInputSchema(): z.ZodObject<Properties<DataSourceVersionUpdateManyWithWhereWithoutDataSourceInput>> {
  return z.object({
    data: z.lazy(() => DataSourceVersionUpdateManyMutationInputSchema()),
    where: z.lazy(() => DataSourceVersionScalarWhereInputSchema())
  })
}

export function DataSourceVersionUpdateManyWithoutDataSourceNestedInputSchema(): z.ZodObject<Properties<DataSourceVersionUpdateManyWithoutDataSourceNestedInput>> {
  return z.object({
    connect: z.array(z.lazy(() => DataSourceVersionWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => DataSourceVersionCreateOrConnectWithoutDataSourceInputSchema())).nullish(),
    create: z.array(z.lazy(() => DataSourceVersionCreateWithoutDataSourceInputSchema())).nullish(),
    createMany: z.lazy(() => DataSourceVersionCreateManyDataSourceInputEnvelopeSchema().nullish()),
    delete: z.array(z.lazy(() => DataSourceVersionWhereUniqueInputSchema())).nullish(),
    deleteMany: z.array(z.lazy(() => DataSourceVersionScalarWhereInputSchema())).nullish(),
    disconnect: z.array(z.lazy(() => DataSourceVersionWhereUniqueInputSchema())).nullish(),
    set: z.array(z.lazy(() => DataSourceVersionWhereUniqueInputSchema())).nullish(),
    update: z.array(z.lazy(() => DataSourceVersionUpdateWithWhereUniqueWithoutDataSourceInputSchema())).nullish(),
    updateMany: z.array(z.lazy(() => DataSourceVersionUpdateManyWithWhereWithoutDataSourceInputSchema())).nullish(),
    upsert: z.array(z.lazy(() => DataSourceVersionUpsertWithWhereUniqueWithoutDataSourceInputSchema())).nullish()
  })
}

export function DataSourceVersionUpdateOneRequiredWithoutCellsNestedInputSchema(): z.ZodObject<Properties<DataSourceVersionUpdateOneRequiredWithoutCellsNestedInput>> {
  return z.object({
    connect: z.lazy(() => DataSourceVersionWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => DataSourceVersionCreateOrConnectWithoutCellsInputSchema().nullish()),
    create: z.lazy(() => DataSourceVersionCreateWithoutCellsInputSchema().nullish()),
    update: z.lazy(() => DataSourceVersionUpdateToOneWithWhereWithoutCellsInputSchema().nullish()),
    upsert: z.lazy(() => DataSourceVersionUpsertWithoutCellsInputSchema().nullish())
  })
}

export function DataSourceVersionUpdateOneRequiredWithoutOriginNestedInputSchema(): z.ZodObject<Properties<DataSourceVersionUpdateOneRequiredWithoutOriginNestedInput>> {
  return z.object({
    connect: z.lazy(() => DataSourceVersionWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => DataSourceVersionCreateOrConnectWithoutOriginInputSchema().nullish()),
    create: z.lazy(() => DataSourceVersionCreateWithoutOriginInputSchema().nullish()),
    update: z.lazy(() => DataSourceVersionUpdateToOneWithWhereWithoutOriginInputSchema().nullish()),
    upsert: z.lazy(() => DataSourceVersionUpsertWithoutOriginInputSchema().nullish())
  })
}

export function DataSourceVersionUpdateToOneWithWhereWithoutCellsInputSchema(): z.ZodObject<Properties<DataSourceVersionUpdateToOneWithWhereWithoutCellsInput>> {
  return z.object({
    data: z.lazy(() => DataSourceVersionUpdateWithoutCellsInputSchema()),
    where: z.lazy(() => DataSourceVersionWhereInputSchema().nullish())
  })
}

export function DataSourceVersionUpdateToOneWithWhereWithoutOriginInputSchema(): z.ZodObject<Properties<DataSourceVersionUpdateToOneWithWhereWithoutOriginInput>> {
  return z.object({
    data: z.lazy(() => DataSourceVersionUpdateWithoutOriginInputSchema()),
    where: z.lazy(() => DataSourceVersionWhereInputSchema().nullish())
  })
}

export function DataSourceVersionUpdateWithWhereUniqueWithoutDataSourceInputSchema(): z.ZodObject<Properties<DataSourceVersionUpdateWithWhereUniqueWithoutDataSourceInput>> {
  return z.object({
    data: z.lazy(() => DataSourceVersionUpdateWithoutDataSourceInputSchema()),
    where: z.lazy(() => DataSourceVersionWhereUniqueInputSchema())
  })
}

export function DataSourceVersionUpdateWithoutCellsInputSchema(): z.ZodObject<Properties<DataSourceVersionUpdateWithoutCellsInput>> {
  return z.object({
    code: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    columns: z.record(z.string(), z.unknown()).nullish(),
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    createdBy: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    dataSource: z.lazy(() => DataSourceUpdateOneRequiredWithoutVersionsNestedInputSchema().nullish()),
    hash: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish()),
    mappingRules: z.record(z.string(), z.unknown()).nullish(),
    type: z.lazy(() => EnumDataSourceTypeFieldUpdateOperationsInputSchema().nullish()),
    usedAt: z.lazy(() => NullableDateTimeFieldUpdateOperationsInputSchema().nullish()),
    validationRules: z.record(z.string(), z.unknown()).nullish()
  })
}

export function DataSourceVersionUpdateWithoutDataSourceInputSchema(): z.ZodObject<Properties<DataSourceVersionUpdateWithoutDataSourceInput>> {
  return z.object({
    cells: z.lazy(() => DataSourceCellUpdateManyWithoutLastVersionNestedInputSchema().nullish()),
    code: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    columns: z.record(z.string(), z.unknown()).nullish(),
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    createdBy: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    hash: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish()),
    mappingRules: z.record(z.string(), z.unknown()).nullish(),
    type: z.lazy(() => EnumDataSourceTypeFieldUpdateOperationsInputSchema().nullish()),
    usedAt: z.lazy(() => NullableDateTimeFieldUpdateOperationsInputSchema().nullish()),
    validationRules: z.record(z.string(), z.unknown()).nullish()
  })
}

export function DataSourceVersionUpdateWithoutOriginInputSchema(): z.ZodObject<Properties<DataSourceVersionUpdateWithoutOriginInput>> {
  return z.object({
    cells: z.lazy(() => DataSourceCellUpdateManyWithoutLastVersionNestedInputSchema().nullish()),
    code: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    columns: z.record(z.string(), z.unknown()).nullish(),
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    createdBy: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    dataSource: z.lazy(() => DataSourceUpdateOneRequiredWithoutVersionsNestedInputSchema().nullish()),
    hash: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish()),
    mappingRules: z.record(z.string(), z.unknown()).nullish(),
    type: z.lazy(() => EnumDataSourceTypeFieldUpdateOperationsInputSchema().nullish()),
    usedAt: z.lazy(() => NullableDateTimeFieldUpdateOperationsInputSchema().nullish()),
    validationRules: z.record(z.string(), z.unknown()).nullish()
  })
}

export function DataSourceVersionUpsertWithWhereUniqueWithoutDataSourceInputSchema(): z.ZodObject<Properties<DataSourceVersionUpsertWithWhereUniqueWithoutDataSourceInput>> {
  return z.object({
    create: z.lazy(() => DataSourceVersionCreateWithoutDataSourceInputSchema()),
    update: z.lazy(() => DataSourceVersionUpdateWithoutDataSourceInputSchema()),
    where: z.lazy(() => DataSourceVersionWhereUniqueInputSchema())
  })
}

export function DataSourceVersionUpsertWithoutCellsInputSchema(): z.ZodObject<Properties<DataSourceVersionUpsertWithoutCellsInput>> {
  return z.object({
    create: z.lazy(() => DataSourceVersionCreateWithoutCellsInputSchema()),
    update: z.lazy(() => DataSourceVersionUpdateWithoutCellsInputSchema()),
    where: z.lazy(() => DataSourceVersionWhereInputSchema().nullish())
  })
}

export function DataSourceVersionUpsertWithoutOriginInputSchema(): z.ZodObject<Properties<DataSourceVersionUpsertWithoutOriginInput>> {
  return z.object({
    create: z.lazy(() => DataSourceVersionCreateWithoutOriginInputSchema()),
    update: z.lazy(() => DataSourceVersionUpdateWithoutOriginInputSchema()),
    where: z.lazy(() => DataSourceVersionWhereInputSchema().nullish())
  })
}

export function DataSourceVersionWhereInputSchema(): z.ZodObject<Properties<DataSourceVersionWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => DataSourceVersionWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => DataSourceVersionWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => DataSourceVersionWhereInputSchema())).nullish(),
    cells: z.lazy(() => DataSourceCellListRelationFilterSchema().nullish()),
    code: z.lazy(() => StringFilterSchema().nullish()),
    columns: z.lazy(() => JsonFilterSchema().nullish()),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    createdBy: z.lazy(() => StringFilterSchema().nullish()),
    dataSource: z.lazy(() => DataSourceScalarRelationFilterSchema().nullish()),
    dataSourceId: z.lazy(() => IntFilterSchema().nullish()),
    hash: z.lazy(() => StringNullableFilterSchema().nullish()),
    id: z.lazy(() => IntFilterSchema().nullish()),
    mappingRules: z.lazy(() => JsonNullableFilterSchema().nullish()),
    type: z.lazy(() => EnumDataSourceTypeFilterSchema().nullish()),
    usedAt: z.lazy(() => DateTimeNullableFilterSchema().nullish()),
    validationRules: z.lazy(() => JsonNullableFilterSchema().nullish())
  })
}

export function DataSourceVersionWhereUniqueInputSchema(): z.ZodObject<Properties<DataSourceVersionWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => DataSourceVersionWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => DataSourceVersionWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => DataSourceVersionWhereInputSchema())).nullish(),
    cells: z.lazy(() => DataSourceCellListRelationFilterSchema().nullish()),
    code: z.lazy(() => StringFilterSchema().nullish()),
    columns: z.lazy(() => JsonFilterSchema().nullish()),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    createdBy: z.lazy(() => StringFilterSchema().nullish()),
    dataSource: z.lazy(() => DataSourceScalarRelationFilterSchema().nullish()),
    dataSourceId: z.lazy(() => IntFilterSchema().nullish()),
    hash: z.lazy(() => StringNullableFilterSchema().nullish()),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    mappingRules: z.lazy(() => JsonNullableFilterSchema().nullish()),
    type: z.lazy(() => EnumDataSourceTypeFilterSchema().nullish()),
    usedAt: z.lazy(() => DateTimeNullableFilterSchema().nullish()),
    validationRules: z.lazy(() => JsonNullableFilterSchema().nullish())
  })
}

export function DataSourceWhereInputSchema(): z.ZodObject<Properties<DataSourceWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => DataSourceWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => DataSourceWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => DataSourceWhereInputSchema())).nullish(),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    id: z.lazy(() => IntFilterSchema().nullish()),
    includeInFreshness: z.lazy(() => BoolFilterSchema().nullish()),
    isSharedWithAdmin: z.lazy(() => BoolNullableFilterSchema().nullish()),
    name: z.lazy(() => StringFilterSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    versions: z.lazy(() => DataSourceVersionListRelationFilterSchema().nullish())
  })
}

export function DataSourceWhereUniqueInputSchema(): z.ZodObject<Properties<DataSourceWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => DataSourceWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => DataSourceWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => DataSourceWhereInputSchema())).nullish(),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    includeInFreshness: z.lazy(() => BoolFilterSchema().nullish()),
    isSharedWithAdmin: z.lazy(() => BoolNullableFilterSchema().nullish()),
    name: z.string().trim().nullish(),
    updatedAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    versions: z.lazy(() => DataSourceVersionListRelationFilterSchema().nullish())
  })
}

export function DateTimeFieldUpdateOperationsInputSchema(): z.ZodObject<Properties<DateTimeFieldUpdateOperationsInput>> {
  return z.object({
    set: z.number().nullish()
  })
}

export function DateTimeFilterSchema(): z.ZodObject<Properties<DateTimeFilter>> {
  return z.object({
    equals: z.number().nullish(),
    gt: z.number().nullish(),
    gte: z.number().nullish(),
    in: z.array(z.number()).nullish(),
    lt: z.number().nullish(),
    lte: z.number().nullish(),
    not: z.lazy(() => NestedDateTimeFilterSchema().nullish()),
    notIn: z.array(z.number()).nullish()
  })
}

export function DateTimeNullableFilterSchema(): z.ZodObject<Properties<DateTimeNullableFilter>> {
  return z.object({
    equals: z.number().nullish(),
    gt: z.number().nullish(),
    gte: z.number().nullish(),
    in: z.array(z.number()).nullish(),
    lt: z.number().nullish(),
    lte: z.number().nullish(),
    not: z.lazy(() => NestedDateTimeNullableFilterSchema().nullish()),
    notIn: z.array(z.number()).nullish()
  })
}

export function DateTimeNullableWithAggregatesFilterSchema(): z.ZodObject<Properties<DateTimeNullableWithAggregatesFilter>> {
  return z.object({
    _count: z.lazy(() => NestedIntNullableFilterSchema().nullish()),
    _max: z.lazy(() => NestedDateTimeNullableFilterSchema().nullish()),
    _min: z.lazy(() => NestedDateTimeNullableFilterSchema().nullish()),
    equals: z.number().nullish(),
    gt: z.number().nullish(),
    gte: z.number().nullish(),
    in: z.array(z.number()).nullish(),
    lt: z.number().nullish(),
    lte: z.number().nullish(),
    not: z.lazy(() => NestedDateTimeNullableWithAggregatesFilterSchema().nullish()),
    notIn: z.array(z.number()).nullish()
  })
}

export function DateTimeWithAggregatesFilterSchema(): z.ZodObject<Properties<DateTimeWithAggregatesFilter>> {
  return z.object({
    _count: z.lazy(() => NestedIntFilterSchema().nullish()),
    _max: z.lazy(() => NestedDateTimeFilterSchema().nullish()),
    _min: z.lazy(() => NestedDateTimeFilterSchema().nullish()),
    equals: z.number().nullish(),
    gt: z.number().nullish(),
    gte: z.number().nullish(),
    in: z.array(z.number()).nullish(),
    lt: z.number().nullish(),
    lte: z.number().nullish(),
    not: z.lazy(() => NestedDateTimeWithAggregatesFilterSchema().nullish()),
    notIn: z.array(z.number()).nullish()
  })
}

export function DefaultInfoSchema(): z.ZodObject<Properties<DefaultInfo>> {
  return z.object({
    __typename: z.literal('DefaultInfo').optional(),
    defaultFrontendClient: z.lazy(() => KeycloakClientSchema()),
    default_app_url: z.string().trim(),
    keycloakServerInfo: z.lazy(() => KeycloakServerInfoSchema())
  })
}

export function EnumDataSourceTypeFieldUpdateOperationsInputSchema(): z.ZodObject<Properties<EnumDataSourceTypeFieldUpdateOperationsInput>> {
  return z.object({
    set: DataSourceTypeSchema.nullish()
  })
}

export function EnumDataSourceTypeFilterSchema(): z.ZodObject<Properties<EnumDataSourceTypeFilter>> {
  return z.object({
    equals: DataSourceTypeSchema.nullish(),
    in: z.array(DataSourceTypeSchema).nullish(),
    not: z.lazy(() => NestedEnumDataSourceTypeFilterSchema().nullish()),
    notIn: z.array(DataSourceTypeSchema).nullish()
  })
}

export function EnumDataSourceTypeWithAggregatesFilterSchema(): z.ZodObject<Properties<EnumDataSourceTypeWithAggregatesFilter>> {
  return z.object({
    _count: z.lazy(() => NestedIntFilterSchema().nullish()),
    _max: z.lazy(() => NestedEnumDataSourceTypeFilterSchema().nullish()),
    _min: z.lazy(() => NestedEnumDataSourceTypeFilterSchema().nullish()),
    equals: DataSourceTypeSchema.nullish(),
    in: z.array(DataSourceTypeSchema).nullish(),
    not: z.lazy(() => NestedEnumDataSourceTypeWithAggregatesFilterSchema().nullish()),
    notIn: z.array(DataSourceTypeSchema).nullish()
  })
}

export function EnumDateModeNullableFilterSchema(): z.ZodObject<Properties<EnumDateModeNullableFilter>> {
  return z.object({
    equals: DateModeSchema.nullish(),
    in: z.array(DateModeSchema).nullish(),
    not: z.lazy(() => NestedEnumDateModeNullableFilterSchema().nullish()),
    notIn: z.array(DateModeSchema).nullish()
  })
}

export function EnumFiltersSourceTypeFieldUpdateOperationsInputSchema(): z.ZodObject<Properties<EnumFiltersSourceTypeFieldUpdateOperationsInput>> {
  return z.object({
    set: FiltersSourceTypeSchema.nullish()
  })
}

export function EnumFiltersSourceTypeFilterSchema(): z.ZodObject<Properties<EnumFiltersSourceTypeFilter>> {
  return z.object({
    equals: FiltersSourceTypeSchema.nullish(),
    in: z.array(FiltersSourceTypeSchema).nullish(),
    not: z.lazy(() => NestedEnumFiltersSourceTypeFilterSchema().nullish()),
    notIn: z.array(FiltersSourceTypeSchema).nullish()
  })
}

export function EnumFiltersSourceTypeWithAggregatesFilterSchema(): z.ZodObject<Properties<EnumFiltersSourceTypeWithAggregatesFilter>> {
  return z.object({
    _count: z.lazy(() => NestedIntFilterSchema().nullish()),
    _max: z.lazy(() => NestedEnumFiltersSourceTypeFilterSchema().nullish()),
    _min: z.lazy(() => NestedEnumFiltersSourceTypeFilterSchema().nullish()),
    equals: FiltersSourceTypeSchema.nullish(),
    in: z.array(FiltersSourceTypeSchema).nullish(),
    not: z.lazy(() => NestedEnumFiltersSourceTypeWithAggregatesFilterSchema().nullish()),
    notIn: z.array(FiltersSourceTypeSchema).nullish()
  })
}

export function EnumProposalTypeFieldUpdateOperationsInputSchema(): z.ZodObject<Properties<EnumProposalTypeFieldUpdateOperationsInput>> {
  return z.object({
    set: ProposalTypeSchema.nullish()
  })
}

export function EnumProposalTypeFilterSchema(): z.ZodObject<Properties<EnumProposalTypeFilter>> {
  return z.object({
    equals: ProposalTypeSchema.nullish(),
    in: z.array(ProposalTypeSchema).nullish(),
    not: z.lazy(() => NestedEnumProposalTypeFilterSchema().nullish()),
    notIn: z.array(ProposalTypeSchema).nullish()
  })
}

export function EnumTemplateTypeFieldUpdateOperationsInputSchema(): z.ZodObject<Properties<EnumTemplateTypeFieldUpdateOperationsInput>> {
  return z.object({
    set: TemplateTypeSchema.nullish()
  })
}

export function EnumTemplateTypeFilterSchema(): z.ZodObject<Properties<EnumTemplateTypeFilter>> {
  return z.object({
    equals: TemplateTypeSchema.nullish(),
    in: z.array(TemplateTypeSchema).nullish(),
    not: z.lazy(() => NestedEnumTemplateTypeFilterSchema().nullish()),
    notIn: z.array(TemplateTypeSchema).nullish()
  })
}

export function EnumTemplateTypeWithAggregatesFilterSchema(): z.ZodObject<Properties<EnumTemplateTypeWithAggregatesFilter>> {
  return z.object({
    _count: z.lazy(() => NestedIntFilterSchema().nullish()),
    _max: z.lazy(() => NestedEnumTemplateTypeFilterSchema().nullish()),
    _min: z.lazy(() => NestedEnumTemplateTypeFilterSchema().nullish()),
    equals: TemplateTypeSchema.nullish(),
    in: z.array(TemplateTypeSchema).nullish(),
    not: z.lazy(() => NestedEnumTemplateTypeWithAggregatesFilterSchema().nullish()),
    notIn: z.array(TemplateTypeSchema).nullish()
  })
}

export function EventAggregationByIntervalSchema(): z.ZodObject<Properties<EventAggregationByInterval>> {
  return z.object({
    __typename: z.literal('EventAggregationByInterval').optional(),
    buckets: z.array(z.lazy(() => AggregationBucketSchema())),
    event: z.lazy(() => BaseEventTypeSchema())
  })
}

export function FeaturesSchema(): z.ZodObject<Properties<Features>> {
  return z.object({
    __typename: z.literal('Features').optional(),
    delete_clients: z.boolean(),
    dynamic_client_databases_management: z.boolean(),
    new_proposals_ui: z.boolean()
  })
}

export function FederatedIdentityRepresentationSchema(): z.ZodObject<Properties<FederatedIdentityRepresentation>> {
  return z.object({
    __typename: z.literal('FederatedIdentityRepresentation').optional(),
    identityProvider: z.string().trim(),
    userId: z.string().trim(),
    userName: z.string().trim()
  })
}

export function FieldSchema(): z.ZodObject<Properties<Field>> {
  return z.object({
    fieldUUID: z.string().trim(),
    in: z.array(z.union([z.number(), z.string(), z.boolean()]).nullable())
  })
}

export function FloatNullableFilterSchema(): z.ZodObject<Properties<FloatNullableFilter>> {
  return z.object({
    equals: z.number().nullish(),
    gt: z.number().nullish(),
    gte: z.number().nullish(),
    in: z.array(z.number()).nullish(),
    lt: z.number().nullish(),
    lte: z.number().nullish(),
    not: z.lazy(() => NestedFloatNullableFilterSchema().nullish()),
    notIn: z.array(z.number()).nullish()
  })
}

export function IdIntSchema(): z.ZodObject<Properties<IdInt>> {
  return z.object({
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function InsightAuditChangeBreakdownSchema(): z.ZodObject<Properties<InsightAuditChangeBreakdown>> {
  return z.object({
    __typename: z.literal('InsightAuditChangeBreakdown').optional(),
    columnsAffected: z.array(z.string().trim()),
    pageBreakdown: z.array(z.lazy(() => InsightAuditPageBreakdownSchema())),
    pagesAffected: z.array(z.string().trim()),
    rowsAffected: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    versionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function InsightAuditChangeItemSchema(): z.ZodObject<Properties<InsightAuditChangeItem>> {
  return z.object({
    __typename: z.literal('InsightAuditChangeItem').optional(),
    createdAt: z.number(),
    createdBy: z.string().trim(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    insightId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    insightName: z.string().trim(),
    sequentialNumber: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function InsightAuditChangesPaginatedSchema(): z.ZodObject<Properties<InsightAuditChangesPaginated>> {
  return z.object({
    __typename: z.literal('InsightAuditChangesPaginated').optional(),
    count: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    items: z.array(z.lazy(() => InsightAuditChangeItemSchema()))
  })
}

export function InsightAuditPageBreakdownSchema(): z.ZodObject<Properties<InsightAuditPageBreakdown>> {
  return z.object({
    __typename: z.literal('InsightAuditPageBreakdown').optional(),
    columnNames: z.array(z.string().trim()),
    pageName: z.string().trim(),
    pageUuid: z.string().trim(),
    rowsAffected: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function IntFieldUpdateOperationsInputSchema(): z.ZodObject<Properties<IntFieldUpdateOperationsInput>> {
  return z.object({
    decrement: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    divide: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    increment: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    multiply: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    set: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function IntFilterSchema(): z.ZodObject<Properties<IntFilter>> {
  return z.object({
    equals: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    gt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    gte: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    in: z.array(z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)).nullish(),
    lt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    lte: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    not: z.lazy(() => NestedIntFilterSchema().nullish()),
    notIn: z.array(z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)).nullish()
  })
}

export function IntNullableFilterSchema(): z.ZodObject<Properties<IntNullableFilter>> {
  return z.object({
    equals: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    gt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    gte: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    in: z.array(z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)).nullish(),
    lt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    lte: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    not: z.lazy(() => NestedIntNullableFilterSchema().nullish()),
    notIn: z.array(z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)).nullish()
  })
}

export function IntNullableWithAggregatesFilterSchema(): z.ZodObject<Properties<IntNullableWithAggregatesFilter>> {
  return z.object({
    _avg: z.lazy(() => NestedFloatNullableFilterSchema().nullish()),
    _count: z.lazy(() => NestedIntNullableFilterSchema().nullish()),
    _max: z.lazy(() => NestedIntNullableFilterSchema().nullish()),
    _min: z.lazy(() => NestedIntNullableFilterSchema().nullish()),
    _sum: z.lazy(() => NestedIntNullableFilterSchema().nullish()),
    equals: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    gt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    gte: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    in: z.array(z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)).nullish(),
    lt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    lte: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    not: z.lazy(() => NestedIntNullableWithAggregatesFilterSchema().nullish()),
    notIn: z.array(z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)).nullish()
  })
}

export function IntWithAggregatesFilterSchema(): z.ZodObject<Properties<IntWithAggregatesFilter>> {
  return z.object({
    _avg: z.lazy(() => NestedFloatFilterSchema().nullish()),
    _count: z.lazy(() => NestedIntFilterSchema().nullish()),
    _max: z.lazy(() => NestedIntFilterSchema().nullish()),
    _min: z.lazy(() => NestedIntFilterSchema().nullish()),
    _sum: z.lazy(() => NestedIntFilterSchema().nullish()),
    equals: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    gt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    gte: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    in: z.array(z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)).nullish(),
    lt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    lte: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    not: z.lazy(() => NestedIntWithAggregatesFilterSchema().nullish()),
    notIn: z.array(z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)).nullish()
  })
}

export function JsonFilterSchema(): z.ZodObject<Properties<JsonFilter>> {
  return z.object({
    array_contains: z.record(z.string(), z.unknown()).nullish(),
    array_ends_with: z.record(z.string(), z.unknown()).nullish(),
    array_starts_with: z.record(z.string(), z.unknown()).nullish(),
    equals: z.record(z.string(), z.unknown()).nullish(),
    gt: z.record(z.string(), z.unknown()).nullish(),
    gte: z.record(z.string(), z.unknown()).nullish(),
    lt: z.record(z.string(), z.unknown()).nullish(),
    lte: z.record(z.string(), z.unknown()).nullish(),
    mode: QueryModeSchema.nullish(),
    not: z.record(z.string(), z.unknown()).nullish(),
    path: z.string().trim().nullish(),
    string_contains: z.string().trim().nullish(),
    string_ends_with: z.string().trim().nullish(),
    string_starts_with: z.string().trim().nullish()
  })
}

export function JsonNullableFilterSchema(): z.ZodObject<Properties<JsonNullableFilter>> {
  return z.object({
    array_contains: z.record(z.string(), z.unknown()).nullish(),
    array_ends_with: z.record(z.string(), z.unknown()).nullish(),
    array_starts_with: z.record(z.string(), z.unknown()).nullish(),
    equals: z.record(z.string(), z.unknown()).nullish(),
    gt: z.record(z.string(), z.unknown()).nullish(),
    gte: z.record(z.string(), z.unknown()).nullish(),
    lt: z.record(z.string(), z.unknown()).nullish(),
    lte: z.record(z.string(), z.unknown()).nullish(),
    mode: QueryModeSchema.nullish(),
    not: z.record(z.string(), z.unknown()).nullish(),
    path: z.string().trim().nullish(),
    string_contains: z.string().trim().nullish(),
    string_ends_with: z.string().trim().nullish(),
    string_starts_with: z.string().trim().nullish()
  })
}

export function JsonNullableWithAggregatesFilterSchema(): z.ZodObject<Properties<JsonNullableWithAggregatesFilter>> {
  return z.object({
    _count: z.lazy(() => NestedIntNullableFilterSchema().nullish()),
    _max: z.lazy(() => NestedJsonNullableFilterSchema().nullish()),
    _min: z.lazy(() => NestedJsonNullableFilterSchema().nullish()),
    array_contains: z.record(z.string(), z.unknown()).nullish(),
    array_ends_with: z.record(z.string(), z.unknown()).nullish(),
    array_starts_with: z.record(z.string(), z.unknown()).nullish(),
    equals: z.record(z.string(), z.unknown()).nullish(),
    gt: z.record(z.string(), z.unknown()).nullish(),
    gte: z.record(z.string(), z.unknown()).nullish(),
    lt: z.record(z.string(), z.unknown()).nullish(),
    lte: z.record(z.string(), z.unknown()).nullish(),
    mode: QueryModeSchema.nullish(),
    not: z.record(z.string(), z.unknown()).nullish(),
    path: z.string().trim().nullish(),
    string_contains: z.string().trim().nullish(),
    string_ends_with: z.string().trim().nullish(),
    string_starts_with: z.string().trim().nullish()
  })
}

export function JsonWithAggregatesFilterSchema(): z.ZodObject<Properties<JsonWithAggregatesFilter>> {
  return z.object({
    _count: z.lazy(() => NestedIntFilterSchema().nullish()),
    _max: z.lazy(() => NestedJsonFilterSchema().nullish()),
    _min: z.lazy(() => NestedJsonFilterSchema().nullish()),
    array_contains: z.record(z.string(), z.unknown()).nullish(),
    array_ends_with: z.record(z.string(), z.unknown()).nullish(),
    array_starts_with: z.record(z.string(), z.unknown()).nullish(),
    equals: z.record(z.string(), z.unknown()).nullish(),
    gt: z.record(z.string(), z.unknown()).nullish(),
    gte: z.record(z.string(), z.unknown()).nullish(),
    lt: z.record(z.string(), z.unknown()).nullish(),
    lte: z.record(z.string(), z.unknown()).nullish(),
    mode: QueryModeSchema.nullish(),
    not: z.record(z.string(), z.unknown()).nullish(),
    path: z.string().trim().nullish(),
    string_contains: z.string().trim().nullish(),
    string_ends_with: z.string().trim().nullish(),
    string_starts_with: z.string().trim().nullish()
  })
}

export function KeycloakClientSchema(): z.ZodObject<Properties<KeycloakClient>> {
  return z.object({
    __typename: z.literal('KeycloakClient').optional(),
    attributes: z.lazy(() => KeycloakClientAttributesSchema().nullish()),
    id: z.string().trim()
  })
}

export function KeycloakClientAttributesSchema(): z.ZodObject<Properties<KeycloakClientAttributes>> {
  return z.object({
    __typename: z.literal('KeycloakClientAttributes').optional(),
    login_theme: z.string().trim().nullish()
  })
}

export function KeycloakClientAttributesInputSchema(): z.ZodObject<Properties<KeycloakClientAttributesInput>> {
  return z.object({
    login_theme: z.string().trim().nullish()
  })
}

export function KeycloakClientInputSchema(): z.ZodObject<Properties<KeycloakClientInput>> {
  return z.object({
    attributes: z.lazy(() => KeycloakClientAttributesInputSchema().nullish()),
    id: z.string().trim()
  })
}

export function KeycloakGroupSchema(): z.ZodObject<Properties<KeycloakGroup>> {
  return z.object({
    __typename: z.literal('KeycloakGroup').optional(),
    access: z.record(z.string(), z.unknown()).nullish(),
    attributes: z.record(z.string(), z.unknown()).nullish(),
    clientRoles: z.record(z.string(), z.unknown()).nullish(),
    id: z.string().trim().nullish(),
    name: z.string().trim().nullish(),
    path: z.string().trim().nullish(),
    realmRoles: z.array(z.string().trim()).nullish(),
    subGroups: z.array(z.lazy(() => KeycloakGroupSchema())).nullish()
  })
}

export function KeycloakServerInfoSchema(): z.ZodObject<Properties<KeycloakServerInfo>> {
  return z.object({
    __typename: z.literal('KeycloakServerInfo').optional(),
    themes: z.lazy(() => KeycloakThemesSchema().nullish())
  })
}

export function KeycloakThemesSchema(): z.ZodObject<Properties<KeycloakThemes>> {
  return z.object({
    __typename: z.literal('KeycloakThemes').optional(),
    account: z.array(z.lazy(() => ThemeInfoRepresentationSchema())).nullish(),
    admin: z.array(z.lazy(() => ThemeInfoRepresentationSchema())).nullish(),
    common: z.array(z.lazy(() => ThemeInfoRepresentationSchema())).nullish(),
    email: z.array(z.lazy(() => ThemeInfoRepresentationSchema())).nullish(),
    login: z.array(z.lazy(() => ThemeInfoRepresentationSchema())).nullish(),
    welcome: z.array(z.lazy(() => ThemeInfoRepresentationSchema())).nullish()
  })
}

export function KeycloakUserSchema(): z.ZodObject<Properties<KeycloakUser>> {
  return z.object({
    __typename: z.literal('KeycloakUser').optional(),
    clientConsents: z.array(z.lazy(() => UserConsentRepresentationSchema())).nullish(),
    createdTimestamp: z.number().nullish(),
    credentials: z.array(z.lazy(() => CredentialRepresentationSchema())).nullish(),
    disableableCredentialTypes: z.array(z.string().trim()).nullish(),
    email: z.string().trim().nullish(),
    emailVerified: z.boolean().nullish(),
    enabled: z.boolean().nullish(),
    federatedIdentities: z.array(z.lazy(() => FederatedIdentityRepresentationSchema())).nullish(),
    federationLink: z.string().trim().nullish(),
    firstName: z.string().trim().nullish(),
    groups: z.array(z.string().trim()).nullish(),
    id: z.string().trim(),
    lastLoginDate: z.number().nullish(),
    lastName: z.string().trim().nullish(),
    lastSentEmailDate: z.number().nullish(),
    notBefore: z.number().nullish(),
    origin: z.string().trim().nullish(),
    realm: z.string().trim().nullish(),
    realmRoles: z.array(z.string().trim()).nullish(),
    requiredActions: z.array(z.string().trim()).nullish(),
    role: RoleSchema.nullish(),
    self: z.string().trim().nullish(),
    serviceAccountClientId: z.string().trim().nullish(),
    subGroups: z.array(z.lazy(() => KeycloakGroupSchema())),
    totp: z.boolean().nullish(),
    username: z.string().trim().nullish()
  })
}

export function KeycloakUserProtectedSchema(): z.ZodObject<Properties<KeycloakUserProtected>> {
  return z.object({
    __typename: z.literal('KeycloakUserProtected').optional(),
    email: z.string().trim(),
    firstName: z.string().trim(),
    id: z.string().trim(),
    lastName: z.string().trim()
  })
}

export function LogAuditEventInputSchema(): z.ZodObject<Properties<LogAuditEventInput>> {
  return z.object({
    proposalDownload: z.lazy(() => ProposalDownloadAuditEventInputSchema().nullish()),
    proposalInteraction: z.lazy(() => ProposalInteractionAuditEventInputSchema().nullish()),
    userLogin: z.lazy(() => UserLoginAuditEventInputSchema().nullish()),
    userLogout: z.lazy(() => UserLogoutAuditEventInputSchema().nullish())
  })
}

export function LookupSchema(): z.ZodObject<Properties<Lookup>> {
  return z.object({
    __typename: z.literal('Lookup').optional(),
    createdAt: z.number(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    labelKey: z.string().trim(),
    name: z.string().trim(),
    options: z.record(z.string(), z.unknown()),
    updatedAt: z.number(),
    usedAt: z.number().nullish(),
    valueKey: z.string().trim()
  })
}

export function LookupAvgAggregateSchema(): z.ZodObject<Properties<LookupAvgAggregate>> {
  return z.object({
    __typename: z.literal('LookupAvgAggregate').optional(),
    id: z.number().nullish()
  })
}

export function LookupAvgOrderByAggregateInputSchema(): z.ZodObject<Properties<LookupAvgOrderByAggregateInput>> {
  return z.object({
    id: SortOrderSchema.nullish()
  })
}

export function LookupCountAggregateSchema(): z.ZodObject<Properties<LookupCountAggregate>> {
  return z.object({
    __typename: z.literal('LookupCountAggregate').optional(),
    _all: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    createdAt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    labelKey: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    name: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    options: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    updatedAt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    usedAt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    valueKey: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function LookupCountOrderByAggregateInputSchema(): z.ZodObject<Properties<LookupCountOrderByAggregateInput>> {
  return z.object({
    createdAt: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    labelKey: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    options: SortOrderSchema.nullish(),
    updatedAt: SortOrderSchema.nullish(),
    usedAt: SortOrderSchema.nullish(),
    valueKey: SortOrderSchema.nullish()
  })
}

export function LookupCreateInputSchema(): z.ZodObject<Properties<LookupCreateInput>> {
  return z.object({
    createdAt: z.number().nullish(),
    labelKey: z.string().trim(),
    name: z.string().trim(),
    options: z.record(z.string(), z.unknown()),
    updatedAt: z.number().nullish(),
    usedAt: z.number().nullish(),
    valueKey: z.string().trim()
  })
}

export function LookupCreateManyInputSchema(): z.ZodObject<Properties<LookupCreateManyInput>> {
  return z.object({
    createdAt: z.number().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    labelKey: z.string().trim(),
    name: z.string().trim(),
    options: z.record(z.string(), z.unknown()),
    updatedAt: z.number().nullish(),
    usedAt: z.number().nullish(),
    valueKey: z.string().trim()
  })
}

export function LookupGroupBySchema(): z.ZodObject<Properties<LookupGroupBy>> {
  return z.object({
    __typename: z.literal('LookupGroupBy').optional(),
    _avg: z.lazy(() => LookupAvgAggregateSchema().nullish()),
    _count: z.lazy(() => LookupCountAggregateSchema().nullish()),
    _max: z.lazy(() => LookupMaxAggregateSchema().nullish()),
    _min: z.lazy(() => LookupMinAggregateSchema().nullish()),
    _sum: z.lazy(() => LookupSumAggregateSchema().nullish()),
    createdAt: z.number(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    labelKey: z.string().trim(),
    name: z.string().trim(),
    options: z.record(z.string(), z.unknown()),
    updatedAt: z.number(),
    usedAt: z.number().nullish(),
    valueKey: z.string().trim()
  })
}

export function LookupMaxAggregateSchema(): z.ZodObject<Properties<LookupMaxAggregate>> {
  return z.object({
    __typename: z.literal('LookupMaxAggregate').optional(),
    createdAt: z.number().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    labelKey: z.string().trim().nullish(),
    name: z.string().trim().nullish(),
    updatedAt: z.number().nullish(),
    usedAt: z.number().nullish(),
    valueKey: z.string().trim().nullish()
  })
}

export function LookupMaxOrderByAggregateInputSchema(): z.ZodObject<Properties<LookupMaxOrderByAggregateInput>> {
  return z.object({
    createdAt: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    labelKey: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    updatedAt: SortOrderSchema.nullish(),
    usedAt: SortOrderSchema.nullish(),
    valueKey: SortOrderSchema.nullish()
  })
}

export function LookupMinAggregateSchema(): z.ZodObject<Properties<LookupMinAggregate>> {
  return z.object({
    __typename: z.literal('LookupMinAggregate').optional(),
    createdAt: z.number().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    labelKey: z.string().trim().nullish(),
    name: z.string().trim().nullish(),
    updatedAt: z.number().nullish(),
    usedAt: z.number().nullish(),
    valueKey: z.string().trim().nullish()
  })
}

export function LookupMinOrderByAggregateInputSchema(): z.ZodObject<Properties<LookupMinOrderByAggregateInput>> {
  return z.object({
    createdAt: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    labelKey: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    updatedAt: SortOrderSchema.nullish(),
    usedAt: SortOrderSchema.nullish(),
    valueKey: SortOrderSchema.nullish()
  })
}

export function LookupOrderByRelevanceInputSchema(): z.ZodObject<Properties<LookupOrderByRelevanceInput>> {
  return z.object({
    fields: z.array(LookupOrderByRelevanceFieldEnumSchema),
    search: z.string().trim(),
    sort: SortOrderSchema
  })
}

export function LookupOrderByWithAggregationInputSchema(): z.ZodObject<Properties<LookupOrderByWithAggregationInput>> {
  return z.object({
    _avg: z.lazy(() => LookupAvgOrderByAggregateInputSchema().nullish()),
    _count: z.lazy(() => LookupCountOrderByAggregateInputSchema().nullish()),
    _max: z.lazy(() => LookupMaxOrderByAggregateInputSchema().nullish()),
    _min: z.lazy(() => LookupMinOrderByAggregateInputSchema().nullish()),
    _sum: z.lazy(() => LookupSumOrderByAggregateInputSchema().nullish()),
    createdAt: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    labelKey: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    options: SortOrderSchema.nullish(),
    updatedAt: SortOrderSchema.nullish(),
    usedAt: z.lazy(() => SortOrderInputSchema().nullish()),
    valueKey: SortOrderSchema.nullish()
  })
}

export function LookupOrderByWithRelationInputSchema(): z.ZodObject<Properties<LookupOrderByWithRelationInput>> {
  return z.object({
    _relevance: z.lazy(() => LookupOrderByRelevanceInputSchema().nullish()),
    createdAt: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    labelKey: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    options: SortOrderSchema.nullish(),
    updatedAt: SortOrderSchema.nullish(),
    usedAt: z.lazy(() => SortOrderInputSchema().nullish()),
    valueKey: SortOrderSchema.nullish()
  })
}

export function LookupScalarWhereWithAggregatesInputSchema(): z.ZodObject<Properties<LookupScalarWhereWithAggregatesInput>> {
  return z.object({
    AND: z.array(z.lazy(() => LookupScalarWhereWithAggregatesInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => LookupScalarWhereWithAggregatesInputSchema())).nullish(),
    OR: z.array(z.lazy(() => LookupScalarWhereWithAggregatesInputSchema())).nullish(),
    createdAt: z.lazy(() => DateTimeWithAggregatesFilterSchema().nullish()),
    id: z.lazy(() => IntWithAggregatesFilterSchema().nullish()),
    labelKey: z.lazy(() => StringWithAggregatesFilterSchema().nullish()),
    name: z.lazy(() => StringWithAggregatesFilterSchema().nullish()),
    options: z.lazy(() => JsonWithAggregatesFilterSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeWithAggregatesFilterSchema().nullish()),
    usedAt: z.lazy(() => DateTimeNullableWithAggregatesFilterSchema().nullish()),
    valueKey: z.lazy(() => StringWithAggregatesFilterSchema().nullish())
  })
}

export function LookupSumAggregateSchema(): z.ZodObject<Properties<LookupSumAggregate>> {
  return z.object({
    __typename: z.literal('LookupSumAggregate').optional(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function LookupSumOrderByAggregateInputSchema(): z.ZodObject<Properties<LookupSumOrderByAggregateInput>> {
  return z.object({
    id: SortOrderSchema.nullish()
  })
}

export function LookupUpdateInputSchema(): z.ZodObject<Properties<LookupUpdateInput>> {
  return z.object({
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    labelKey: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    name: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    options: z.record(z.string(), z.unknown()).nullish(),
    updatedAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    usedAt: z.lazy(() => NullableDateTimeFieldUpdateOperationsInputSchema().nullish()),
    valueKey: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish())
  })
}

export function LookupUpdateManyMutationInputSchema(): z.ZodObject<Properties<LookupUpdateManyMutationInput>> {
  return z.object({
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    labelKey: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    name: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    options: z.record(z.string(), z.unknown()).nullish(),
    updatedAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    usedAt: z.lazy(() => NullableDateTimeFieldUpdateOperationsInputSchema().nullish()),
    valueKey: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish())
  })
}

export function LookupWhereInputSchema(): z.ZodObject<Properties<LookupWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => LookupWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => LookupWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => LookupWhereInputSchema())).nullish(),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    id: z.lazy(() => IntFilterSchema().nullish()),
    labelKey: z.lazy(() => StringFilterSchema().nullish()),
    name: z.lazy(() => StringFilterSchema().nullish()),
    options: z.lazy(() => JsonFilterSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    usedAt: z.lazy(() => DateTimeNullableFilterSchema().nullish()),
    valueKey: z.lazy(() => StringFilterSchema().nullish())
  })
}

export function LookupWhereUniqueInputSchema(): z.ZodObject<Properties<LookupWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => LookupWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => LookupWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => LookupWhereInputSchema())).nullish(),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    labelKey: z.lazy(() => StringFilterSchema().nullish()),
    name: z.string().trim().nullish(),
    options: z.lazy(() => JsonFilterSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    usedAt: z.lazy(() => DateTimeNullableFilterSchema().nullish()),
    valueKey: z.lazy(() => StringFilterSchema().nullish())
  })
}

export function NavigationPositionRespSchema(): z.ZodObject<Properties<NavigationPositionResp>> {
  return z.object({
    __typename: z.literal('NavigationPositionResp').optional(),
    data: z.string().trim()
  })
}

export function NestedBigIntNullableFilterSchema(): z.ZodObject<Properties<NestedBigIntNullableFilter>> {
  return z.object({
    equals: definedNonNullAnySchema.nullish(),
    gt: definedNonNullAnySchema.nullish(),
    gte: definedNonNullAnySchema.nullish(),
    in: z.array(definedNonNullAnySchema).nullish(),
    lt: definedNonNullAnySchema.nullish(),
    lte: definedNonNullAnySchema.nullish(),
    not: z.lazy(() => NestedBigIntNullableFilterSchema().nullish()),
    notIn: z.array(definedNonNullAnySchema).nullish()
  })
}

export function NestedBoolFilterSchema(): z.ZodObject<Properties<NestedBoolFilter>> {
  return z.object({
    equals: z.boolean().nullish(),
    not: z.lazy(() => NestedBoolFilterSchema().nullish())
  })
}

export function NestedBoolNullableFilterSchema(): z.ZodObject<Properties<NestedBoolNullableFilter>> {
  return z.object({
    equals: z.boolean().nullish(),
    not: z.lazy(() => NestedBoolNullableFilterSchema().nullish())
  })
}

export function NestedBoolNullableWithAggregatesFilterSchema(): z.ZodObject<Properties<NestedBoolNullableWithAggregatesFilter>> {
  return z.object({
    _count: z.lazy(() => NestedIntNullableFilterSchema().nullish()),
    _max: z.lazy(() => NestedBoolNullableFilterSchema().nullish()),
    _min: z.lazy(() => NestedBoolNullableFilterSchema().nullish()),
    equals: z.boolean().nullish(),
    not: z.lazy(() => NestedBoolNullableWithAggregatesFilterSchema().nullish())
  })
}

export function NestedBoolWithAggregatesFilterSchema(): z.ZodObject<Properties<NestedBoolWithAggregatesFilter>> {
  return z.object({
    _count: z.lazy(() => NestedIntFilterSchema().nullish()),
    _max: z.lazy(() => NestedBoolFilterSchema().nullish()),
    _min: z.lazy(() => NestedBoolFilterSchema().nullish()),
    equals: z.boolean().nullish(),
    not: z.lazy(() => NestedBoolWithAggregatesFilterSchema().nullish())
  })
}

export function NestedDateTimeFilterSchema(): z.ZodObject<Properties<NestedDateTimeFilter>> {
  return z.object({
    equals: z.number().nullish(),
    gt: z.number().nullish(),
    gte: z.number().nullish(),
    in: z.array(z.number()).nullish(),
    lt: z.number().nullish(),
    lte: z.number().nullish(),
    not: z.lazy(() => NestedDateTimeFilterSchema().nullish()),
    notIn: z.array(z.number()).nullish()
  })
}

export function NestedDateTimeNullableFilterSchema(): z.ZodObject<Properties<NestedDateTimeNullableFilter>> {
  return z.object({
    equals: z.number().nullish(),
    gt: z.number().nullish(),
    gte: z.number().nullish(),
    in: z.array(z.number()).nullish(),
    lt: z.number().nullish(),
    lte: z.number().nullish(),
    not: z.lazy(() => NestedDateTimeNullableFilterSchema().nullish()),
    notIn: z.array(z.number()).nullish()
  })
}

export function NestedDateTimeNullableWithAggregatesFilterSchema(): z.ZodObject<Properties<NestedDateTimeNullableWithAggregatesFilter>> {
  return z.object({
    _count: z.lazy(() => NestedIntNullableFilterSchema().nullish()),
    _max: z.lazy(() => NestedDateTimeNullableFilterSchema().nullish()),
    _min: z.lazy(() => NestedDateTimeNullableFilterSchema().nullish()),
    equals: z.number().nullish(),
    gt: z.number().nullish(),
    gte: z.number().nullish(),
    in: z.array(z.number()).nullish(),
    lt: z.number().nullish(),
    lte: z.number().nullish(),
    not: z.lazy(() => NestedDateTimeNullableWithAggregatesFilterSchema().nullish()),
    notIn: z.array(z.number()).nullish()
  })
}

export function NestedDateTimeWithAggregatesFilterSchema(): z.ZodObject<Properties<NestedDateTimeWithAggregatesFilter>> {
  return z.object({
    _count: z.lazy(() => NestedIntFilterSchema().nullish()),
    _max: z.lazy(() => NestedDateTimeFilterSchema().nullish()),
    _min: z.lazy(() => NestedDateTimeFilterSchema().nullish()),
    equals: z.number().nullish(),
    gt: z.number().nullish(),
    gte: z.number().nullish(),
    in: z.array(z.number()).nullish(),
    lt: z.number().nullish(),
    lte: z.number().nullish(),
    not: z.lazy(() => NestedDateTimeWithAggregatesFilterSchema().nullish()),
    notIn: z.array(z.number()).nullish()
  })
}

export function NestedEnumDataSourceTypeFilterSchema(): z.ZodObject<Properties<NestedEnumDataSourceTypeFilter>> {
  return z.object({
    equals: DataSourceTypeSchema.nullish(),
    in: z.array(DataSourceTypeSchema).nullish(),
    not: z.lazy(() => NestedEnumDataSourceTypeFilterSchema().nullish()),
    notIn: z.array(DataSourceTypeSchema).nullish()
  })
}

export function NestedEnumDataSourceTypeWithAggregatesFilterSchema(): z.ZodObject<Properties<NestedEnumDataSourceTypeWithAggregatesFilter>> {
  return z.object({
    _count: z.lazy(() => NestedIntFilterSchema().nullish()),
    _max: z.lazy(() => NestedEnumDataSourceTypeFilterSchema().nullish()),
    _min: z.lazy(() => NestedEnumDataSourceTypeFilterSchema().nullish()),
    equals: DataSourceTypeSchema.nullish(),
    in: z.array(DataSourceTypeSchema).nullish(),
    not: z.lazy(() => NestedEnumDataSourceTypeWithAggregatesFilterSchema().nullish()),
    notIn: z.array(DataSourceTypeSchema).nullish()
  })
}

export function NestedEnumDateModeNullableFilterSchema(): z.ZodObject<Properties<NestedEnumDateModeNullableFilter>> {
  return z.object({
    equals: DateModeSchema.nullish(),
    in: z.array(DateModeSchema).nullish(),
    not: z.lazy(() => NestedEnumDateModeNullableFilterSchema().nullish()),
    notIn: z.array(DateModeSchema).nullish()
  })
}

export function NestedEnumFiltersSourceTypeFilterSchema(): z.ZodObject<Properties<NestedEnumFiltersSourceTypeFilter>> {
  return z.object({
    equals: FiltersSourceTypeSchema.nullish(),
    in: z.array(FiltersSourceTypeSchema).nullish(),
    not: z.lazy(() => NestedEnumFiltersSourceTypeFilterSchema().nullish()),
    notIn: z.array(FiltersSourceTypeSchema).nullish()
  })
}

export function NestedEnumFiltersSourceTypeWithAggregatesFilterSchema(): z.ZodObject<Properties<NestedEnumFiltersSourceTypeWithAggregatesFilter>> {
  return z.object({
    _count: z.lazy(() => NestedIntFilterSchema().nullish()),
    _max: z.lazy(() => NestedEnumFiltersSourceTypeFilterSchema().nullish()),
    _min: z.lazy(() => NestedEnumFiltersSourceTypeFilterSchema().nullish()),
    equals: FiltersSourceTypeSchema.nullish(),
    in: z.array(FiltersSourceTypeSchema).nullish(),
    not: z.lazy(() => NestedEnumFiltersSourceTypeWithAggregatesFilterSchema().nullish()),
    notIn: z.array(FiltersSourceTypeSchema).nullish()
  })
}

export function NestedEnumProposalTypeFilterSchema(): z.ZodObject<Properties<NestedEnumProposalTypeFilter>> {
  return z.object({
    equals: ProposalTypeSchema.nullish(),
    in: z.array(ProposalTypeSchema).nullish(),
    not: z.lazy(() => NestedEnumProposalTypeFilterSchema().nullish()),
    notIn: z.array(ProposalTypeSchema).nullish()
  })
}

export function NestedEnumTemplateTypeFilterSchema(): z.ZodObject<Properties<NestedEnumTemplateTypeFilter>> {
  return z.object({
    equals: TemplateTypeSchema.nullish(),
    in: z.array(TemplateTypeSchema).nullish(),
    not: z.lazy(() => NestedEnumTemplateTypeFilterSchema().nullish()),
    notIn: z.array(TemplateTypeSchema).nullish()
  })
}

export function NestedEnumTemplateTypeWithAggregatesFilterSchema(): z.ZodObject<Properties<NestedEnumTemplateTypeWithAggregatesFilter>> {
  return z.object({
    _count: z.lazy(() => NestedIntFilterSchema().nullish()),
    _max: z.lazy(() => NestedEnumTemplateTypeFilterSchema().nullish()),
    _min: z.lazy(() => NestedEnumTemplateTypeFilterSchema().nullish()),
    equals: TemplateTypeSchema.nullish(),
    in: z.array(TemplateTypeSchema).nullish(),
    not: z.lazy(() => NestedEnumTemplateTypeWithAggregatesFilterSchema().nullish()),
    notIn: z.array(TemplateTypeSchema).nullish()
  })
}

export function NestedFloatFilterSchema(): z.ZodObject<Properties<NestedFloatFilter>> {
  return z.object({
    equals: z.number().nullish(),
    gt: z.number().nullish(),
    gte: z.number().nullish(),
    in: z.array(z.number()).nullish(),
    lt: z.number().nullish(),
    lte: z.number().nullish(),
    not: z.lazy(() => NestedFloatFilterSchema().nullish()),
    notIn: z.array(z.number()).nullish()
  })
}

export function NestedFloatNullableFilterSchema(): z.ZodObject<Properties<NestedFloatNullableFilter>> {
  return z.object({
    equals: z.number().nullish(),
    gt: z.number().nullish(),
    gte: z.number().nullish(),
    in: z.array(z.number()).nullish(),
    lt: z.number().nullish(),
    lte: z.number().nullish(),
    not: z.lazy(() => NestedFloatNullableFilterSchema().nullish()),
    notIn: z.array(z.number()).nullish()
  })
}

export function NestedIntFilterSchema(): z.ZodObject<Properties<NestedIntFilter>> {
  return z.object({
    equals: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    gt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    gte: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    in: z.array(z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)).nullish(),
    lt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    lte: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    not: z.lazy(() => NestedIntFilterSchema().nullish()),
    notIn: z.array(z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)).nullish()
  })
}

export function NestedIntNullableFilterSchema(): z.ZodObject<Properties<NestedIntNullableFilter>> {
  return z.object({
    equals: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    gt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    gte: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    in: z.array(z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)).nullish(),
    lt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    lte: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    not: z.lazy(() => NestedIntNullableFilterSchema().nullish()),
    notIn: z.array(z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)).nullish()
  })
}

export function NestedIntNullableWithAggregatesFilterSchema(): z.ZodObject<Properties<NestedIntNullableWithAggregatesFilter>> {
  return z.object({
    _avg: z.lazy(() => NestedFloatNullableFilterSchema().nullish()),
    _count: z.lazy(() => NestedIntNullableFilterSchema().nullish()),
    _max: z.lazy(() => NestedIntNullableFilterSchema().nullish()),
    _min: z.lazy(() => NestedIntNullableFilterSchema().nullish()),
    _sum: z.lazy(() => NestedIntNullableFilterSchema().nullish()),
    equals: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    gt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    gte: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    in: z.array(z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)).nullish(),
    lt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    lte: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    not: z.lazy(() => NestedIntNullableWithAggregatesFilterSchema().nullish()),
    notIn: z.array(z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)).nullish()
  })
}

export function NestedIntWithAggregatesFilterSchema(): z.ZodObject<Properties<NestedIntWithAggregatesFilter>> {
  return z.object({
    _avg: z.lazy(() => NestedFloatFilterSchema().nullish()),
    _count: z.lazy(() => NestedIntFilterSchema().nullish()),
    _max: z.lazy(() => NestedIntFilterSchema().nullish()),
    _min: z.lazy(() => NestedIntFilterSchema().nullish()),
    _sum: z.lazy(() => NestedIntFilterSchema().nullish()),
    equals: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    gt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    gte: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    in: z.array(z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)).nullish(),
    lt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    lte: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    not: z.lazy(() => NestedIntWithAggregatesFilterSchema().nullish()),
    notIn: z.array(z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)).nullish()
  })
}

export function NestedJsonFilterSchema(): z.ZodObject<Properties<NestedJsonFilter>> {
  return z.object({
    array_contains: z.record(z.string(), z.unknown()).nullish(),
    array_ends_with: z.record(z.string(), z.unknown()).nullish(),
    array_starts_with: z.record(z.string(), z.unknown()).nullish(),
    equals: z.record(z.string(), z.unknown()).nullish(),
    gt: z.record(z.string(), z.unknown()).nullish(),
    gte: z.record(z.string(), z.unknown()).nullish(),
    lt: z.record(z.string(), z.unknown()).nullish(),
    lte: z.record(z.string(), z.unknown()).nullish(),
    mode: QueryModeSchema.nullish(),
    not: z.record(z.string(), z.unknown()).nullish(),
    path: z.string().trim().nullish(),
    string_contains: z.string().trim().nullish(),
    string_ends_with: z.string().trim().nullish(),
    string_starts_with: z.string().trim().nullish()
  })
}

export function NestedJsonNullableFilterSchema(): z.ZodObject<Properties<NestedJsonNullableFilter>> {
  return z.object({
    array_contains: z.record(z.string(), z.unknown()).nullish(),
    array_ends_with: z.record(z.string(), z.unknown()).nullish(),
    array_starts_with: z.record(z.string(), z.unknown()).nullish(),
    equals: z.record(z.string(), z.unknown()).nullish(),
    gt: z.record(z.string(), z.unknown()).nullish(),
    gte: z.record(z.string(), z.unknown()).nullish(),
    lt: z.record(z.string(), z.unknown()).nullish(),
    lte: z.record(z.string(), z.unknown()).nullish(),
    mode: QueryModeSchema.nullish(),
    not: z.record(z.string(), z.unknown()).nullish(),
    path: z.string().trim().nullish(),
    string_contains: z.string().trim().nullish(),
    string_ends_with: z.string().trim().nullish(),
    string_starts_with: z.string().trim().nullish()
  })
}

export function NestedStringFilterSchema(): z.ZodObject<Properties<NestedStringFilter>> {
  return z.object({
    contains: z.string().trim().nullish(),
    endsWith: z.string().trim().nullish(),
    equals: z.string().trim().nullish(),
    gt: z.string().trim().nullish(),
    gte: z.string().trim().nullish(),
    in: z.array(z.string().trim()).nullish(),
    lt: z.string().trim().nullish(),
    lte: z.string().trim().nullish(),
    not: z.lazy(() => NestedStringFilterSchema().nullish()),
    notIn: z.array(z.string().trim()).nullish(),
    search: z.string().trim().nullish(),
    startsWith: z.string().trim().nullish()
  })
}

export function NestedStringNullableFilterSchema(): z.ZodObject<Properties<NestedStringNullableFilter>> {
  return z.object({
    contains: z.string().trim().nullish(),
    endsWith: z.string().trim().nullish(),
    equals: z.string().trim().nullish(),
    gt: z.string().trim().nullish(),
    gte: z.string().trim().nullish(),
    in: z.array(z.string().trim()).nullish(),
    lt: z.string().trim().nullish(),
    lte: z.string().trim().nullish(),
    not: z.lazy(() => NestedStringNullableFilterSchema().nullish()),
    notIn: z.array(z.string().trim()).nullish(),
    search: z.string().trim().nullish(),
    startsWith: z.string().trim().nullish()
  })
}

export function NestedStringNullableWithAggregatesFilterSchema(): z.ZodObject<Properties<NestedStringNullableWithAggregatesFilter>> {
  return z.object({
    _count: z.lazy(() => NestedIntNullableFilterSchema().nullish()),
    _max: z.lazy(() => NestedStringNullableFilterSchema().nullish()),
    _min: z.lazy(() => NestedStringNullableFilterSchema().nullish()),
    contains: z.string().trim().nullish(),
    endsWith: z.string().trim().nullish(),
    equals: z.string().trim().nullish(),
    gt: z.string().trim().nullish(),
    gte: z.string().trim().nullish(),
    in: z.array(z.string().trim()).nullish(),
    lt: z.string().trim().nullish(),
    lte: z.string().trim().nullish(),
    not: z.lazy(() => NestedStringNullableWithAggregatesFilterSchema().nullish()),
    notIn: z.array(z.string().trim()).nullish(),
    search: z.string().trim().nullish(),
    startsWith: z.string().trim().nullish()
  })
}

export function NestedStringWithAggregatesFilterSchema(): z.ZodObject<Properties<NestedStringWithAggregatesFilter>> {
  return z.object({
    _count: z.lazy(() => NestedIntFilterSchema().nullish()),
    _max: z.lazy(() => NestedStringFilterSchema().nullish()),
    _min: z.lazy(() => NestedStringFilterSchema().nullish()),
    contains: z.string().trim().nullish(),
    endsWith: z.string().trim().nullish(),
    equals: z.string().trim().nullish(),
    gt: z.string().trim().nullish(),
    gte: z.string().trim().nullish(),
    in: z.array(z.string().trim()).nullish(),
    lt: z.string().trim().nullish(),
    lte: z.string().trim().nullish(),
    not: z.lazy(() => NestedStringWithAggregatesFilterSchema().nullish()),
    notIn: z.array(z.string().trim()).nullish(),
    search: z.string().trim().nullish(),
    startsWith: z.string().trim().nullish()
  })
}

export function NoteSchema(): z.ZodObject<Properties<Note>> {
  return z.object({
    __typename: z.literal('Note').optional(),
    content: z.string().trim(),
    createdAt: z.number(),
    createdBy: z.string().trim(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    pageId: z.string().trim(),
    proposal: z.lazy(() => ProposalSchema()),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function NoteAvgAggregateSchema(): z.ZodObject<Properties<NoteAvgAggregate>> {
  return z.object({
    __typename: z.literal('NoteAvgAggregate').optional(),
    id: z.number().nullish(),
    proposalId: z.number().nullish()
  })
}

export function NoteAvgOrderByAggregateInputSchema(): z.ZodObject<Properties<NoteAvgOrderByAggregateInput>> {
  return z.object({
    id: SortOrderSchema.nullish(),
    proposalId: SortOrderSchema.nullish()
  })
}

export function NoteCountAggregateSchema(): z.ZodObject<Properties<NoteCountAggregate>> {
  return z.object({
    __typename: z.literal('NoteCountAggregate').optional(),
    _all: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    content: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    createdAt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    createdBy: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    pageId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function NoteCountOrderByAggregateInputSchema(): z.ZodObject<Properties<NoteCountOrderByAggregateInput>> {
  return z.object({
    content: SortOrderSchema.nullish(),
    createdAt: SortOrderSchema.nullish(),
    createdBy: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    pageId: SortOrderSchema.nullish(),
    proposalId: SortOrderSchema.nullish()
  })
}

export function NoteCreateInputSchema(): z.ZodObject<Properties<NoteCreateInput>> {
  return z.object({
    content: z.string().trim().nullish(),
    createdAt: z.number().nullish(),
    createdBy: z.string().trim(),
    pageId: z.string().trim(),
    proposal: z.lazy(() => ProposalCreateNestedOneWithoutNotesInputSchema())
  })
}

export function NoteCreateManyInputSchema(): z.ZodObject<Properties<NoteCreateManyInput>> {
  return z.object({
    content: z.string().trim().nullish(),
    createdAt: z.number().nullish(),
    createdBy: z.string().trim(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    pageId: z.string().trim(),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function NoteCreateManyProposalInputSchema(): z.ZodObject<Properties<NoteCreateManyProposalInput>> {
  return z.object({
    content: z.string().trim().nullish(),
    createdAt: z.number().nullish(),
    createdBy: z.string().trim(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    pageId: z.string().trim()
  })
}

export function NoteCreateManyProposalInputEnvelopeSchema(): z.ZodObject<Properties<NoteCreateManyProposalInputEnvelope>> {
  return z.object({
    data: z.array(z.lazy(() => NoteCreateManyProposalInputSchema())),
    skipDuplicates: z.boolean().nullish()
  })
}

export function NoteCreateNestedManyWithoutProposalInputSchema(): z.ZodObject<Properties<NoteCreateNestedManyWithoutProposalInput>> {
  return z.object({
    connect: z.array(z.lazy(() => NoteWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => NoteCreateOrConnectWithoutProposalInputSchema())).nullish(),
    create: z.array(z.lazy(() => NoteCreateWithoutProposalInputSchema())).nullish(),
    createMany: z.lazy(() => NoteCreateManyProposalInputEnvelopeSchema().nullish())
  })
}

export function NoteCreateOrConnectWithoutProposalInputSchema(): z.ZodObject<Properties<NoteCreateOrConnectWithoutProposalInput>> {
  return z.object({
    create: z.lazy(() => NoteCreateWithoutProposalInputSchema()),
    where: z.lazy(() => NoteWhereUniqueInputSchema())
  })
}

export function NoteCreateWithoutProposalInputSchema(): z.ZodObject<Properties<NoteCreateWithoutProposalInput>> {
  return z.object({
    content: z.string().trim().nullish(),
    createdAt: z.number().nullish(),
    createdBy: z.string().trim(),
    pageId: z.string().trim()
  })
}

export function NoteGroupBySchema(): z.ZodObject<Properties<NoteGroupBy>> {
  return z.object({
    __typename: z.literal('NoteGroupBy').optional(),
    _avg: z.lazy(() => NoteAvgAggregateSchema().nullish()),
    _count: z.lazy(() => NoteCountAggregateSchema().nullish()),
    _max: z.lazy(() => NoteMaxAggregateSchema().nullish()),
    _min: z.lazy(() => NoteMinAggregateSchema().nullish()),
    _sum: z.lazy(() => NoteSumAggregateSchema().nullish()),
    content: z.string().trim(),
    createdAt: z.number(),
    createdBy: z.string().trim(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    pageId: z.string().trim(),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function NoteListRelationFilterSchema(): z.ZodObject<Properties<NoteListRelationFilter>> {
  return z.object({
    every: z.lazy(() => NoteWhereInputSchema().nullish()),
    none: z.lazy(() => NoteWhereInputSchema().nullish()),
    some: z.lazy(() => NoteWhereInputSchema().nullish())
  })
}

export function NoteMaxAggregateSchema(): z.ZodObject<Properties<NoteMaxAggregate>> {
  return z.object({
    __typename: z.literal('NoteMaxAggregate').optional(),
    content: z.string().trim().nullish(),
    createdAt: z.number().nullish(),
    createdBy: z.string().trim().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    pageId: z.string().trim().nullish(),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function NoteMaxOrderByAggregateInputSchema(): z.ZodObject<Properties<NoteMaxOrderByAggregateInput>> {
  return z.object({
    content: SortOrderSchema.nullish(),
    createdAt: SortOrderSchema.nullish(),
    createdBy: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    pageId: SortOrderSchema.nullish(),
    proposalId: SortOrderSchema.nullish()
  })
}

export function NoteMinAggregateSchema(): z.ZodObject<Properties<NoteMinAggregate>> {
  return z.object({
    __typename: z.literal('NoteMinAggregate').optional(),
    content: z.string().trim().nullish(),
    createdAt: z.number().nullish(),
    createdBy: z.string().trim().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    pageId: z.string().trim().nullish(),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function NoteMinOrderByAggregateInputSchema(): z.ZodObject<Properties<NoteMinOrderByAggregateInput>> {
  return z.object({
    content: SortOrderSchema.nullish(),
    createdAt: SortOrderSchema.nullish(),
    createdBy: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    pageId: SortOrderSchema.nullish(),
    proposalId: SortOrderSchema.nullish()
  })
}

export function NoteOrderByRelationAggregateInputSchema(): z.ZodObject<Properties<NoteOrderByRelationAggregateInput>> {
  return z.object({
    _count: SortOrderSchema.nullish()
  })
}

export function NoteOrderByRelevanceInputSchema(): z.ZodObject<Properties<NoteOrderByRelevanceInput>> {
  return z.object({
    fields: z.array(NoteOrderByRelevanceFieldEnumSchema),
    search: z.string().trim(),
    sort: SortOrderSchema
  })
}

export function NoteOrderByWithAggregationInputSchema(): z.ZodObject<Properties<NoteOrderByWithAggregationInput>> {
  return z.object({
    _avg: z.lazy(() => NoteAvgOrderByAggregateInputSchema().nullish()),
    _count: z.lazy(() => NoteCountOrderByAggregateInputSchema().nullish()),
    _max: z.lazy(() => NoteMaxOrderByAggregateInputSchema().nullish()),
    _min: z.lazy(() => NoteMinOrderByAggregateInputSchema().nullish()),
    _sum: z.lazy(() => NoteSumOrderByAggregateInputSchema().nullish()),
    content: SortOrderSchema.nullish(),
    createdAt: SortOrderSchema.nullish(),
    createdBy: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    pageId: SortOrderSchema.nullish(),
    proposalId: SortOrderSchema.nullish()
  })
}

export function NoteOrderByWithRelationInputSchema(): z.ZodObject<Properties<NoteOrderByWithRelationInput>> {
  return z.object({
    _relevance: z.lazy(() => NoteOrderByRelevanceInputSchema().nullish()),
    content: SortOrderSchema.nullish(),
    createdAt: SortOrderSchema.nullish(),
    createdBy: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    pageId: SortOrderSchema.nullish(),
    proposal: z.lazy(() => ProposalOrderByWithRelationInputSchema().nullish()),
    proposalId: SortOrderSchema.nullish()
  })
}

export function NoteScalarWhereInputSchema(): z.ZodObject<Properties<NoteScalarWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => NoteScalarWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => NoteScalarWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => NoteScalarWhereInputSchema())).nullish(),
    content: z.lazy(() => StringFilterSchema().nullish()),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    createdBy: z.lazy(() => StringFilterSchema().nullish()),
    id: z.lazy(() => IntFilterSchema().nullish()),
    pageId: z.lazy(() => StringFilterSchema().nullish()),
    proposalId: z.lazy(() => IntFilterSchema().nullish())
  })
}

export function NoteScalarWhereWithAggregatesInputSchema(): z.ZodObject<Properties<NoteScalarWhereWithAggregatesInput>> {
  return z.object({
    AND: z.array(z.lazy(() => NoteScalarWhereWithAggregatesInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => NoteScalarWhereWithAggregatesInputSchema())).nullish(),
    OR: z.array(z.lazy(() => NoteScalarWhereWithAggregatesInputSchema())).nullish(),
    content: z.lazy(() => StringWithAggregatesFilterSchema().nullish()),
    createdAt: z.lazy(() => DateTimeWithAggregatesFilterSchema().nullish()),
    createdBy: z.lazy(() => StringWithAggregatesFilterSchema().nullish()),
    id: z.lazy(() => IntWithAggregatesFilterSchema().nullish()),
    pageId: z.lazy(() => StringWithAggregatesFilterSchema().nullish()),
    proposalId: z.lazy(() => IntWithAggregatesFilterSchema().nullish())
  })
}

export function NoteSumAggregateSchema(): z.ZodObject<Properties<NoteSumAggregate>> {
  return z.object({
    __typename: z.literal('NoteSumAggregate').optional(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function NoteSumOrderByAggregateInputSchema(): z.ZodObject<Properties<NoteSumOrderByAggregateInput>> {
  return z.object({
    id: SortOrderSchema.nullish(),
    proposalId: SortOrderSchema.nullish()
  })
}

export function NoteUpdateInputSchema(): z.ZodObject<Properties<NoteUpdateInput>> {
  return z.object({
    content: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    createdBy: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    pageId: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    proposal: z.lazy(() => ProposalUpdateOneRequiredWithoutNotesNestedInputSchema().nullish())
  })
}

export function NoteUpdateManyMutationInputSchema(): z.ZodObject<Properties<NoteUpdateManyMutationInput>> {
  return z.object({
    content: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    createdBy: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    pageId: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish())
  })
}

export function NoteUpdateManyWithWhereWithoutProposalInputSchema(): z.ZodObject<Properties<NoteUpdateManyWithWhereWithoutProposalInput>> {
  return z.object({
    data: z.lazy(() => NoteUpdateManyMutationInputSchema()),
    where: z.lazy(() => NoteScalarWhereInputSchema())
  })
}

export function NoteUpdateManyWithoutProposalNestedInputSchema(): z.ZodObject<Properties<NoteUpdateManyWithoutProposalNestedInput>> {
  return z.object({
    connect: z.array(z.lazy(() => NoteWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => NoteCreateOrConnectWithoutProposalInputSchema())).nullish(),
    create: z.array(z.lazy(() => NoteCreateWithoutProposalInputSchema())).nullish(),
    createMany: z.lazy(() => NoteCreateManyProposalInputEnvelopeSchema().nullish()),
    delete: z.array(z.lazy(() => NoteWhereUniqueInputSchema())).nullish(),
    deleteMany: z.array(z.lazy(() => NoteScalarWhereInputSchema())).nullish(),
    disconnect: z.array(z.lazy(() => NoteWhereUniqueInputSchema())).nullish(),
    set: z.array(z.lazy(() => NoteWhereUniqueInputSchema())).nullish(),
    update: z.array(z.lazy(() => NoteUpdateWithWhereUniqueWithoutProposalInputSchema())).nullish(),
    updateMany: z.array(z.lazy(() => NoteUpdateManyWithWhereWithoutProposalInputSchema())).nullish(),
    upsert: z.array(z.lazy(() => NoteUpsertWithWhereUniqueWithoutProposalInputSchema())).nullish()
  })
}

export function NoteUpdateWithWhereUniqueWithoutProposalInputSchema(): z.ZodObject<Properties<NoteUpdateWithWhereUniqueWithoutProposalInput>> {
  return z.object({
    data: z.lazy(() => NoteUpdateWithoutProposalInputSchema()),
    where: z.lazy(() => NoteWhereUniqueInputSchema())
  })
}

export function NoteUpdateWithoutProposalInputSchema(): z.ZodObject<Properties<NoteUpdateWithoutProposalInput>> {
  return z.object({
    content: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    createdBy: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    pageId: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish())
  })
}

export function NoteUpsertWithWhereUniqueWithoutProposalInputSchema(): z.ZodObject<Properties<NoteUpsertWithWhereUniqueWithoutProposalInput>> {
  return z.object({
    create: z.lazy(() => NoteCreateWithoutProposalInputSchema()),
    update: z.lazy(() => NoteUpdateWithoutProposalInputSchema()),
    where: z.lazy(() => NoteWhereUniqueInputSchema())
  })
}

export function NoteWhereInputSchema(): z.ZodObject<Properties<NoteWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => NoteWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => NoteWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => NoteWhereInputSchema())).nullish(),
    content: z.lazy(() => StringFilterSchema().nullish()),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    createdBy: z.lazy(() => StringFilterSchema().nullish()),
    id: z.lazy(() => IntFilterSchema().nullish()),
    pageId: z.lazy(() => StringFilterSchema().nullish()),
    proposal: z.lazy(() => ProposalScalarRelationFilterSchema().nullish()),
    proposalId: z.lazy(() => IntFilterSchema().nullish())
  })
}

export function NoteWhereUniqueInputSchema(): z.ZodObject<Properties<NoteWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => NoteWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => NoteWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => NoteWhereInputSchema())).nullish(),
    content: z.lazy(() => StringFilterSchema().nullish()),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    createdBy: z.lazy(() => StringFilterSchema().nullish()),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    pageId: z.lazy(() => StringFilterSchema().nullish()),
    proposal: z.lazy(() => ProposalScalarRelationFilterSchema().nullish()),
    proposalId: z.lazy(() => IntFilterSchema().nullish())
  })
}

export function NullableBigIntFieldUpdateOperationsInputSchema(): z.ZodObject<Properties<NullableBigIntFieldUpdateOperationsInput>> {
  return z.object({
    decrement: definedNonNullAnySchema.nullish(),
    divide: definedNonNullAnySchema.nullish(),
    increment: definedNonNullAnySchema.nullish(),
    multiply: definedNonNullAnySchema.nullish(),
    set: definedNonNullAnySchema.nullish()
  })
}

export function NullableBoolFieldUpdateOperationsInputSchema(): z.ZodObject<Properties<NullableBoolFieldUpdateOperationsInput>> {
  return z.object({
    set: z.boolean().nullish()
  })
}

export function NullableDateTimeFieldUpdateOperationsInputSchema(): z.ZodObject<Properties<NullableDateTimeFieldUpdateOperationsInput>> {
  return z.object({
    set: z.number().nullish()
  })
}

export function NullableEnumDateModeFieldUpdateOperationsInputSchema(): z.ZodObject<Properties<NullableEnumDateModeFieldUpdateOperationsInput>> {
  return z.object({
    set: DateModeSchema.nullish()
  })
}

export function NullableFloatFieldUpdateOperationsInputSchema(): z.ZodObject<Properties<NullableFloatFieldUpdateOperationsInput>> {
  return z.object({
    decrement: z.number().nullish(),
    divide: z.number().nullish(),
    increment: z.number().nullish(),
    multiply: z.number().nullish(),
    set: z.number().nullish()
  })
}

export function NullableIntFieldUpdateOperationsInputSchema(): z.ZodObject<Properties<NullableIntFieldUpdateOperationsInput>> {
  return z.object({
    decrement: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    divide: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    increment: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    multiply: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    set: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function NullableStringFieldUpdateOperationsInputSchema(): z.ZodObject<Properties<NullableStringFieldUpdateOperationsInput>> {
  return z.object({
    set: z.string().trim().nullish()
  })
}

export function ProposalSchema(): z.ZodObject<Properties<Proposal>> {
  return z.object({
    __typename: z.literal('Proposal').optional(),
    _count: z.lazy(() => ProposalCountSchema().nullish()),
    createdAt: z.number(),
    createdBy: z.string().trim(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    isFinalized: z.boolean(),
    lastVersion: z.lazy(() => ProposalVersionSchema()),
    name: z.string().trim(),
    notes: z.array(z.lazy(() => NoteSchema())),
    templateName: z.string().trim().nullish(),
    templateVersion: z.lazy(() => ProposalTemplateVersionSchema()),
    templateVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    totalCellCount: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    totalCellDataBytes: definedNonNullAnySchema.nullish(),
    totalStorageMB: z.number().nullish(),
    type: ProposalTypeSchema,
    versions: z.array(z.lazy(() => ProposalVersionSchema()))
  })
}

export function ProposalNotesArgsSchema(): z.ZodObject<Properties<ProposalNotesArgs>> {
  return z.object({
    cursor: z.lazy(() => NoteWhereUniqueInputSchema().nullish()),
    distinct: z.array(NoteScalarFieldEnumSchema).nullish(),
    orderBy: z.array(z.lazy(() => NoteOrderByWithRelationInputSchema())).nullish(),
    skip: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    take: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    where: z.lazy(() => NoteWhereInputSchema().nullish())
  })
}

export function ProposalVersionsArgsSchema(): z.ZodObject<Properties<ProposalVersionsArgs>> {
  return z.object({
    cursor: z.lazy(() => ProposalVersionWhereUniqueInputSchema().nullish()),
    distinct: z.array(ProposalVersionScalarFieldEnumSchema).nullish(),
    orderBy: z.array(z.lazy(() => ProposalVersionOrderByWithRelationInputSchema())).nullish(),
    skip: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    take: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    where: z.lazy(() => ProposalVersionWhereInputSchema().nullish())
  })
}

export function ProposalAnalyticsPageSchema(): z.ZodObject<Properties<ProposalAnalyticsPage>> {
  return z.object({
    __typename: z.literal('ProposalAnalyticsPage').optional(),
    fields: z.array(z.lazy(() => AnalyticsPageFieldSchema())),
    id: z.string(),
    name: z.string().trim(),
    primaryColumnUUID: z.string().trim().nullish(),
    type: TemplatePageTypeSchema
  })
}

export function ProposalCellSchema(): z.ZodObject<Properties<ProposalCell>> {
  return z.object({
    __typename: z.literal('ProposalCell').optional(),
    arrayIndex: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    booleanValue: z.boolean().nullish(),
    columnUUID: z.string().trim(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    initVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    isEnteredValue: z.boolean(),
    lastVersion: z.lazy(() => ProposalVersionSchema()),
    lastVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    numericValue: z.number().nullish(),
    pageUUID: z.string().trim(),
    rawValue: z.record(z.string(), z.unknown()).nullish(),
    rowUUID: z.string().trim(),
    stringValue: z.string().trim().nullish()
  })
}

export function ProposalCellCreateManyLastVersionInputSchema(): z.ZodObject<Properties<ProposalCellCreateManyLastVersionInput>> {
  return z.object({
    arrayIndex: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    booleanValue: z.boolean().nullish(),
    columnUUID: z.string().trim(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    initVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    isEnteredValue: z.boolean(),
    numericValue: z.number().nullish(),
    pageUUID: z.string().trim(),
    rawValue: z.record(z.string(), z.unknown()).nullish(),
    rowUUID: z.string().trim(),
    stringValue: z.string().trim().nullish()
  })
}

export function ProposalCellCreateManyLastVersionInputEnvelopeSchema(): z.ZodObject<Properties<ProposalCellCreateManyLastVersionInputEnvelope>> {
  return z.object({
    data: z.array(z.lazy(() => ProposalCellCreateManyLastVersionInputSchema())),
    skipDuplicates: z.boolean().nullish()
  })
}

export function ProposalCellCreateNestedManyWithoutLastVersionInputSchema(): z.ZodObject<Properties<ProposalCellCreateNestedManyWithoutLastVersionInput>> {
  return z.object({
    connect: z.array(z.lazy(() => ProposalCellWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => ProposalCellCreateOrConnectWithoutLastVersionInputSchema())).nullish(),
    create: z.array(z.lazy(() => ProposalCellCreateWithoutLastVersionInputSchema())).nullish(),
    createMany: z.lazy(() => ProposalCellCreateManyLastVersionInputEnvelopeSchema().nullish())
  })
}

export function ProposalCellCreateOrConnectWithoutLastVersionInputSchema(): z.ZodObject<Properties<ProposalCellCreateOrConnectWithoutLastVersionInput>> {
  return z.object({
    create: z.lazy(() => ProposalCellCreateWithoutLastVersionInputSchema()),
    where: z.lazy(() => ProposalCellWhereUniqueInputSchema())
  })
}

export function ProposalCellCreateWithoutLastVersionInputSchema(): z.ZodObject<Properties<ProposalCellCreateWithoutLastVersionInput>> {
  return z.object({
    arrayIndex: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    booleanValue: z.boolean().nullish(),
    columnUUID: z.string().trim(),
    initVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    isEnteredValue: z.boolean(),
    numericValue: z.number().nullish(),
    pageUUID: z.string().trim(),
    rawValue: z.record(z.string(), z.unknown()).nullish(),
    rowUUID: z.string().trim(),
    stringValue: z.string().trim().nullish()
  })
}

export function ProposalCellLastVersionIdColumnUuidRowUuidPageUuidArrayIndexCompoundUniqueInputSchema(): z.ZodObject<Properties<ProposalCellLastVersionIdColumnUuidRowUuidPageUuidArrayIndexCompoundUniqueInput>> {
  return z.object({
    arrayIndex: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    columnUUID: z.string().trim(),
    lastVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    pageUUID: z.string().trim(),
    rowUUID: z.string().trim()
  })
}

export function ProposalCellListRelationFilterSchema(): z.ZodObject<Properties<ProposalCellListRelationFilter>> {
  return z.object({
    every: z.lazy(() => ProposalCellWhereInputSchema().nullish()),
    none: z.lazy(() => ProposalCellWhereInputSchema().nullish()),
    some: z.lazy(() => ProposalCellWhereInputSchema().nullish())
  })
}

export function ProposalCellOrderByRelationAggregateInputSchema(): z.ZodObject<Properties<ProposalCellOrderByRelationAggregateInput>> {
  return z.object({
    _count: SortOrderSchema.nullish()
  })
}

export function ProposalCellOrderByRelevanceInputSchema(): z.ZodObject<Properties<ProposalCellOrderByRelevanceInput>> {
  return z.object({
    fields: z.array(ProposalCellOrderByRelevanceFieldEnumSchema),
    search: z.string().trim(),
    sort: SortOrderSchema
  })
}

export function ProposalCellOrderByWithRelationInputSchema(): z.ZodObject<Properties<ProposalCellOrderByWithRelationInput>> {
  return z.object({
    _relevance: z.lazy(() => ProposalCellOrderByRelevanceInputSchema().nullish()),
    arrayIndex: SortOrderSchema.nullish(),
    booleanValue: z.lazy(() => SortOrderInputSchema().nullish()),
    columnUUID: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    initVersionId: SortOrderSchema.nullish(),
    isEnteredValue: SortOrderSchema.nullish(),
    lastVersion: z.lazy(() => ProposalVersionOrderByWithRelationInputSchema().nullish()),
    lastVersionId: SortOrderSchema.nullish(),
    numericValue: z.lazy(() => SortOrderInputSchema().nullish()),
    pageUUID: SortOrderSchema.nullish(),
    rawValue: z.lazy(() => SortOrderInputSchema().nullish()),
    rowUUID: SortOrderSchema.nullish(),
    stringValue: z.lazy(() => SortOrderInputSchema().nullish())
  })
}

export function ProposalCellScalarWhereInputSchema(): z.ZodObject<Properties<ProposalCellScalarWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalCellScalarWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalCellScalarWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalCellScalarWhereInputSchema())).nullish(),
    arrayIndex: z.lazy(() => IntFilterSchema().nullish()),
    booleanValue: z.lazy(() => BoolNullableFilterSchema().nullish()),
    columnUUID: z.lazy(() => StringFilterSchema().nullish()),
    id: z.lazy(() => IntFilterSchema().nullish()),
    initVersionId: z.lazy(() => IntFilterSchema().nullish()),
    isEnteredValue: z.lazy(() => BoolFilterSchema().nullish()),
    lastVersionId: z.lazy(() => IntFilterSchema().nullish()),
    numericValue: z.lazy(() => FloatNullableFilterSchema().nullish()),
    pageUUID: z.lazy(() => StringFilterSchema().nullish()),
    rawValue: z.lazy(() => JsonNullableFilterSchema().nullish()),
    rowUUID: z.lazy(() => StringFilterSchema().nullish()),
    stringValue: z.lazy(() => StringNullableFilterSchema().nullish())
  })
}

export function ProposalCellUpdateManyMutationInputSchema(): z.ZodObject<Properties<ProposalCellUpdateManyMutationInput>> {
  return z.object({
    arrayIndex: z.lazy(() => IntFieldUpdateOperationsInputSchema().nullish()),
    booleanValue: z.lazy(() => NullableBoolFieldUpdateOperationsInputSchema().nullish()),
    columnUUID: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    initVersionId: z.lazy(() => IntFieldUpdateOperationsInputSchema().nullish()),
    isEnteredValue: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    numericValue: z.lazy(() => NullableFloatFieldUpdateOperationsInputSchema().nullish()),
    pageUUID: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    rawValue: z.record(z.string(), z.unknown()).nullish(),
    rowUUID: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    stringValue: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish())
  })
}

export function ProposalCellUpdateManyWithWhereWithoutLastVersionInputSchema(): z.ZodObject<Properties<ProposalCellUpdateManyWithWhereWithoutLastVersionInput>> {
  return z.object({
    data: z.lazy(() => ProposalCellUpdateManyMutationInputSchema()),
    where: z.lazy(() => ProposalCellScalarWhereInputSchema())
  })
}

export function ProposalCellUpdateManyWithoutLastVersionNestedInputSchema(): z.ZodObject<Properties<ProposalCellUpdateManyWithoutLastVersionNestedInput>> {
  return z.object({
    connect: z.array(z.lazy(() => ProposalCellWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => ProposalCellCreateOrConnectWithoutLastVersionInputSchema())).nullish(),
    create: z.array(z.lazy(() => ProposalCellCreateWithoutLastVersionInputSchema())).nullish(),
    createMany: z.lazy(() => ProposalCellCreateManyLastVersionInputEnvelopeSchema().nullish()),
    delete: z.array(z.lazy(() => ProposalCellWhereUniqueInputSchema())).nullish(),
    deleteMany: z.array(z.lazy(() => ProposalCellScalarWhereInputSchema())).nullish(),
    disconnect: z.array(z.lazy(() => ProposalCellWhereUniqueInputSchema())).nullish(),
    set: z.array(z.lazy(() => ProposalCellWhereUniqueInputSchema())).nullish(),
    update: z.array(z.lazy(() => ProposalCellUpdateWithWhereUniqueWithoutLastVersionInputSchema())).nullish(),
    updateMany: z.array(z.lazy(() => ProposalCellUpdateManyWithWhereWithoutLastVersionInputSchema())).nullish(),
    upsert: z.array(z.lazy(() => ProposalCellUpsertWithWhereUniqueWithoutLastVersionInputSchema())).nullish()
  })
}

export function ProposalCellUpdateWithWhereUniqueWithoutLastVersionInputSchema(): z.ZodObject<Properties<ProposalCellUpdateWithWhereUniqueWithoutLastVersionInput>> {
  return z.object({
    data: z.lazy(() => ProposalCellUpdateWithoutLastVersionInputSchema()),
    where: z.lazy(() => ProposalCellWhereUniqueInputSchema())
  })
}

export function ProposalCellUpdateWithoutLastVersionInputSchema(): z.ZodObject<Properties<ProposalCellUpdateWithoutLastVersionInput>> {
  return z.object({
    arrayIndex: z.lazy(() => IntFieldUpdateOperationsInputSchema().nullish()),
    booleanValue: z.lazy(() => NullableBoolFieldUpdateOperationsInputSchema().nullish()),
    columnUUID: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    initVersionId: z.lazy(() => IntFieldUpdateOperationsInputSchema().nullish()),
    isEnteredValue: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    numericValue: z.lazy(() => NullableFloatFieldUpdateOperationsInputSchema().nullish()),
    pageUUID: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    rawValue: z.record(z.string(), z.unknown()).nullish(),
    rowUUID: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    stringValue: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish())
  })
}

export function ProposalCellUpsertWithWhereUniqueWithoutLastVersionInputSchema(): z.ZodObject<Properties<ProposalCellUpsertWithWhereUniqueWithoutLastVersionInput>> {
  return z.object({
    create: z.lazy(() => ProposalCellCreateWithoutLastVersionInputSchema()),
    update: z.lazy(() => ProposalCellUpdateWithoutLastVersionInputSchema()),
    where: z.lazy(() => ProposalCellWhereUniqueInputSchema())
  })
}

export function ProposalCellWhereInputSchema(): z.ZodObject<Properties<ProposalCellWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalCellWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalCellWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalCellWhereInputSchema())).nullish(),
    arrayIndex: z.lazy(() => IntFilterSchema().nullish()),
    booleanValue: z.lazy(() => BoolNullableFilterSchema().nullish()),
    columnUUID: z.lazy(() => StringFilterSchema().nullish()),
    id: z.lazy(() => IntFilterSchema().nullish()),
    initVersionId: z.lazy(() => IntFilterSchema().nullish()),
    isEnteredValue: z.lazy(() => BoolFilterSchema().nullish()),
    lastVersion: z.lazy(() => ProposalVersionScalarRelationFilterSchema().nullish()),
    lastVersionId: z.lazy(() => IntFilterSchema().nullish()),
    numericValue: z.lazy(() => FloatNullableFilterSchema().nullish()),
    pageUUID: z.lazy(() => StringFilterSchema().nullish()),
    rawValue: z.lazy(() => JsonNullableFilterSchema().nullish()),
    rowUUID: z.lazy(() => StringFilterSchema().nullish()),
    stringValue: z.lazy(() => StringNullableFilterSchema().nullish())
  })
}

export function ProposalCellWhereUniqueInputSchema(): z.ZodObject<Properties<ProposalCellWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalCellWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalCellWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalCellWhereInputSchema())).nullish(),
    arrayIndex: z.lazy(() => IntFilterSchema().nullish()),
    booleanValue: z.lazy(() => BoolNullableFilterSchema().nullish()),
    columnUUID: z.lazy(() => StringFilterSchema().nullish()),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    initVersionId: z.lazy(() => IntFilterSchema().nullish()),
    isEnteredValue: z.lazy(() => BoolFilterSchema().nullish()),
    lastVersion: z.lazy(() => ProposalVersionScalarRelationFilterSchema().nullish()),
    lastVersionId: z.lazy(() => IntFilterSchema().nullish()),
    lastVersionId_columnUUID_rowUUID_pageUUID_arrayIndex: z.lazy(() => ProposalCellLastVersionIdColumnUuidRowUuidPageUuidArrayIndexCompoundUniqueInputSchema().nullish()),
    numericValue: z.lazy(() => FloatNullableFilterSchema().nullish()),
    pageUUID: z.lazy(() => StringFilterSchema().nullish()),
    rawValue: z.lazy(() => JsonNullableFilterSchema().nullish()),
    rowUUID: z.lazy(() => StringFilterSchema().nullish()),
    stringValue: z.lazy(() => StringNullableFilterSchema().nullish())
  })
}

export function ProposalCountSchema(): z.ZodObject<Properties<ProposalCount>> {
  return z.object({
    __typename: z.literal('ProposalCount').optional(),
    dataSourceVersionOrigin: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    notes: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    userProposalAccess: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    userProposalPins: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    versions: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function ProposalCountDataSourceVersionOriginArgsSchema(): z.ZodObject<Properties<ProposalCountDataSourceVersionOriginArgs>> {
  return z.object({
    where: z.lazy(() => DataSourceVersionOriginWhereInputSchema().nullish())
  })
}

export function ProposalCountNotesArgsSchema(): z.ZodObject<Properties<ProposalCountNotesArgs>> {
  return z.object({
    where: z.lazy(() => NoteWhereInputSchema().nullish())
  })
}

export function ProposalCountUserProposalAccessArgsSchema(): z.ZodObject<Properties<ProposalCountUserProposalAccessArgs>> {
  return z.object({
    where: z.lazy(() => UserProposalAccessWhereInputSchema().nullish())
  })
}

export function ProposalCountUserProposalPinsArgsSchema(): z.ZodObject<Properties<ProposalCountUserProposalPinsArgs>> {
  return z.object({
    where: z.lazy(() => UserProposalPinWhereInputSchema().nullish())
  })
}

export function ProposalCountVersionsArgsSchema(): z.ZodObject<Properties<ProposalCountVersionsArgs>> {
  return z.object({
    where: z.lazy(() => ProposalVersionWhereInputSchema().nullish())
  })
}

export function ProposalCreateInputSchema(): z.ZodObject<Properties<ProposalCreateInput>> {
  return z.object({
    name: z.string().trim(),
    templateId: z.number().nullish(),
    type: z.string().trim().nullish(),
    version: z.lazy(() => ProposalVersionCreateInputSchema())
  })
}

export function ProposalCreateManyTemplateVersionInputSchema(): z.ZodObject<Properties<ProposalCreateManyTemplateVersionInput>> {
  return z.object({
    createdAt: z.number().nullish(),
    createdBy: z.string().trim(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    isFinalized: z.boolean().nullish(),
    name: z.string().trim(),
    totalCellCount: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    totalCellDataBytes: definedNonNullAnySchema.nullish(),
    type: ProposalTypeSchema.nullish()
  })
}

export function ProposalCreateManyTemplateVersionInputEnvelopeSchema(): z.ZodObject<Properties<ProposalCreateManyTemplateVersionInputEnvelope>> {
  return z.object({
    data: z.array(z.lazy(() => ProposalCreateManyTemplateVersionInputSchema())),
    skipDuplicates: z.boolean().nullish()
  })
}

export function ProposalCreateNestedManyWithoutTemplateVersionInputSchema(): z.ZodObject<Properties<ProposalCreateNestedManyWithoutTemplateVersionInput>> {
  return z.object({
    connect: z.array(z.lazy(() => ProposalWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => ProposalCreateOrConnectWithoutTemplateVersionInputSchema())).nullish(),
    create: z.array(z.lazy(() => ProposalCreateWithoutTemplateVersionInputSchema())).nullish(),
    createMany: z.lazy(() => ProposalCreateManyTemplateVersionInputEnvelopeSchema().nullish())
  })
}

export function ProposalCreateNestedOneWithoutDataSourceVersionOriginInputSchema(): z.ZodObject<Properties<ProposalCreateNestedOneWithoutDataSourceVersionOriginInput>> {
  return z.object({
    connect: z.lazy(() => ProposalWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => ProposalCreateOrConnectWithoutDataSourceVersionOriginInputSchema().nullish()),
    create: z.lazy(() => ProposalCreateWithoutDataSourceVersionOriginInputSchema().nullish())
  })
}

export function ProposalCreateNestedOneWithoutNotesInputSchema(): z.ZodObject<Properties<ProposalCreateNestedOneWithoutNotesInput>> {
  return z.object({
    connect: z.lazy(() => ProposalWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => ProposalCreateOrConnectWithoutNotesInputSchema().nullish()),
    create: z.lazy(() => ProposalCreateWithoutNotesInputSchema().nullish())
  })
}

export function ProposalCreateNestedOneWithoutUserProposalAccessInputSchema(): z.ZodObject<Properties<ProposalCreateNestedOneWithoutUserProposalAccessInput>> {
  return z.object({
    connect: z.lazy(() => ProposalWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => ProposalCreateOrConnectWithoutUserProposalAccessInputSchema().nullish()),
    create: z.lazy(() => ProposalCreateWithoutUserProposalAccessInputSchema().nullish())
  })
}

export function ProposalCreateNestedOneWithoutVersionsInputSchema(): z.ZodObject<Properties<ProposalCreateNestedOneWithoutVersionsInput>> {
  return z.object({
    connect: z.lazy(() => ProposalWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => ProposalCreateOrConnectWithoutVersionsInputSchema().nullish()),
    create: z.lazy(() => ProposalCreateWithoutVersionsInputSchema().nullish())
  })
}

export function ProposalCreateOrConnectWithoutDataSourceVersionOriginInputSchema(): z.ZodObject<Properties<ProposalCreateOrConnectWithoutDataSourceVersionOriginInput>> {
  return z.object({
    create: z.lazy(() => ProposalCreateWithoutDataSourceVersionOriginInputSchema()),
    where: z.lazy(() => ProposalWhereUniqueInputSchema())
  })
}

export function ProposalCreateOrConnectWithoutNotesInputSchema(): z.ZodObject<Properties<ProposalCreateOrConnectWithoutNotesInput>> {
  return z.object({
    create: z.lazy(() => ProposalCreateWithoutNotesInputSchema()),
    where: z.lazy(() => ProposalWhereUniqueInputSchema())
  })
}

export function ProposalCreateOrConnectWithoutTemplateVersionInputSchema(): z.ZodObject<Properties<ProposalCreateOrConnectWithoutTemplateVersionInput>> {
  return z.object({
    create: z.lazy(() => ProposalCreateWithoutTemplateVersionInputSchema()),
    where: z.lazy(() => ProposalWhereUniqueInputSchema())
  })
}

export function ProposalCreateOrConnectWithoutUserProposalAccessInputSchema(): z.ZodObject<Properties<ProposalCreateOrConnectWithoutUserProposalAccessInput>> {
  return z.object({
    create: z.lazy(() => ProposalCreateWithoutUserProposalAccessInputSchema()),
    where: z.lazy(() => ProposalWhereUniqueInputSchema())
  })
}

export function ProposalCreateOrConnectWithoutVersionsInputSchema(): z.ZodObject<Properties<ProposalCreateOrConnectWithoutVersionsInput>> {
  return z.object({
    create: z.lazy(() => ProposalCreateWithoutVersionsInputSchema()),
    where: z.lazy(() => ProposalWhereUniqueInputSchema())
  })
}

export function ProposalCreateWithoutDataSourceVersionOriginInputSchema(): z.ZodObject<Properties<ProposalCreateWithoutDataSourceVersionOriginInput>> {
  return z.object({
    createdAt: z.number().nullish(),
    createdBy: z.string().trim(),
    isFinalized: z.boolean().nullish(),
    lastEditor: z.lazy(() => ProposalLastEditorCreateNestedOneWithoutProposalInputSchema().nullish()),
    name: z.string().trim(),
    notes: z.lazy(() => NoteCreateNestedManyWithoutProposalInputSchema().nullish()),
    templateVersion: z.lazy(() => ProposalTemplateVersionCreateNestedOneWithoutProposalsInputSchema()),
    totalCellCount: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    totalCellDataBytes: definedNonNullAnySchema.nullish(),
    type: ProposalTypeSchema.nullish(),
    userProposalAccess: z.lazy(() => UserProposalAccessCreateNestedManyWithoutProposalInputSchema().nullish()),
    userProposalPins: z.lazy(() => UserProposalPinCreateNestedManyWithoutProposalInputSchema().nullish()),
    versions: z.lazy(() => ProposalVersionCreateNestedManyWithoutProposalInputSchema().nullish())
  })
}

export function ProposalCreateWithoutNotesInputSchema(): z.ZodObject<Properties<ProposalCreateWithoutNotesInput>> {
  return z.object({
    createdAt: z.number().nullish(),
    createdBy: z.string().trim(),
    isFinalized: z.boolean().nullish(),
    lastEditor: z.lazy(() => ProposalLastEditorCreateNestedOneWithoutProposalInputSchema().nullish()),
    name: z.string().trim(),
    templateVersion: z.lazy(() => ProposalTemplateVersionCreateNestedOneWithoutProposalsInputSchema()),
    totalCellCount: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    totalCellDataBytes: definedNonNullAnySchema.nullish(),
    type: ProposalTypeSchema.nullish(),
    userProposalAccess: z.lazy(() => UserProposalAccessCreateNestedManyWithoutProposalInputSchema().nullish()),
    userProposalPins: z.lazy(() => UserProposalPinCreateNestedManyWithoutProposalInputSchema().nullish()),
    versions: z.lazy(() => ProposalVersionCreateNestedManyWithoutProposalInputSchema().nullish())
  })
}

export function ProposalCreateWithoutTemplateVersionInputSchema(): z.ZodObject<Properties<ProposalCreateWithoutTemplateVersionInput>> {
  return z.object({
    createdAt: z.number().nullish(),
    createdBy: z.string().trim(),
    isFinalized: z.boolean().nullish(),
    lastEditor: z.lazy(() => ProposalLastEditorCreateNestedOneWithoutProposalInputSchema().nullish()),
    name: z.string().trim(),
    notes: z.lazy(() => NoteCreateNestedManyWithoutProposalInputSchema().nullish()),
    totalCellCount: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    totalCellDataBytes: definedNonNullAnySchema.nullish(),
    type: ProposalTypeSchema.nullish(),
    userProposalAccess: z.lazy(() => UserProposalAccessCreateNestedManyWithoutProposalInputSchema().nullish()),
    userProposalPins: z.lazy(() => UserProposalPinCreateNestedManyWithoutProposalInputSchema().nullish()),
    versions: z.lazy(() => ProposalVersionCreateNestedManyWithoutProposalInputSchema().nullish())
  })
}

export function ProposalCreateWithoutUserProposalAccessInputSchema(): z.ZodObject<Properties<ProposalCreateWithoutUserProposalAccessInput>> {
  return z.object({
    createdAt: z.number().nullish(),
    createdBy: z.string().trim(),
    isFinalized: z.boolean().nullish(),
    lastEditor: z.lazy(() => ProposalLastEditorCreateNestedOneWithoutProposalInputSchema().nullish()),
    name: z.string().trim(),
    notes: z.lazy(() => NoteCreateNestedManyWithoutProposalInputSchema().nullish()),
    templateVersion: z.lazy(() => ProposalTemplateVersionCreateNestedOneWithoutProposalsInputSchema()),
    totalCellCount: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    totalCellDataBytes: definedNonNullAnySchema.nullish(),
    type: ProposalTypeSchema.nullish(),
    userProposalPins: z.lazy(() => UserProposalPinCreateNestedManyWithoutProposalInputSchema().nullish()),
    versions: z.lazy(() => ProposalVersionCreateNestedManyWithoutProposalInputSchema().nullish())
  })
}

export function ProposalCreateWithoutVersionsInputSchema(): z.ZodObject<Properties<ProposalCreateWithoutVersionsInput>> {
  return z.object({
    createdAt: z.number().nullish(),
    createdBy: z.string().trim(),
    isFinalized: z.boolean().nullish(),
    lastEditor: z.lazy(() => ProposalLastEditorCreateNestedOneWithoutProposalInputSchema().nullish()),
    name: z.string().trim(),
    notes: z.lazy(() => NoteCreateNestedManyWithoutProposalInputSchema().nullish()),
    templateVersion: z.lazy(() => ProposalTemplateVersionCreateNestedOneWithoutProposalsInputSchema()),
    totalCellCount: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    totalCellDataBytes: definedNonNullAnySchema.nullish(),
    type: ProposalTypeSchema.nullish(),
    userProposalAccess: z.lazy(() => UserProposalAccessCreateNestedManyWithoutProposalInputSchema().nullish()),
    userProposalPins: z.lazy(() => UserProposalPinCreateNestedManyWithoutProposalInputSchema().nullish())
  })
}

export function ProposalDownloadAuditEventInputSchema(): z.ZodObject<Properties<ProposalDownloadAuditEventInput>> {
  return z.object({
    proposal: z.lazy(() => ProposalWithPageIdsSchema())
  })
}

export function ProposalFieldSchema(): z.ZodObject<Properties<ProposalField>> {
  return z.object({
    __typename: z.literal('ProposalField').optional(),
    createdAt: z.number(),
    dateMode: DateModeSchema.nullish(),
    fieldId: z.string().trim(),
    fieldName: z.string().trim(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    proposalVersion: z.lazy(() => ProposalVersionSchema()),
    proposalVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    type: z.string().trim().nullish(),
    value: z.record(z.string(), z.unknown())
  })
}

export function ProposalFieldCreateManyProposalVersionInputSchema(): z.ZodObject<Properties<ProposalFieldCreateManyProposalVersionInput>> {
  return z.object({
    createdAt: z.number().nullish(),
    dateMode: DateModeSchema.nullish(),
    fieldId: z.string().trim(),
    fieldName: z.string().trim(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    type: z.string().trim().nullish(),
    value: z.record(z.string(), z.unknown())
  })
}

export function ProposalFieldCreateManyProposalVersionInputEnvelopeSchema(): z.ZodObject<Properties<ProposalFieldCreateManyProposalVersionInputEnvelope>> {
  return z.object({
    data: z.array(z.lazy(() => ProposalFieldCreateManyProposalVersionInputSchema())),
    skipDuplicates: z.boolean().nullish()
  })
}

export function ProposalFieldCreateNestedManyWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalFieldCreateNestedManyWithoutProposalVersionInput>> {
  return z.object({
    connect: z.array(z.lazy(() => ProposalFieldWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => ProposalFieldCreateOrConnectWithoutProposalVersionInputSchema())).nullish(),
    create: z.array(z.lazy(() => ProposalFieldCreateWithoutProposalVersionInputSchema())).nullish(),
    createMany: z.lazy(() => ProposalFieldCreateManyProposalVersionInputEnvelopeSchema().nullish())
  })
}

export function ProposalFieldCreateOrConnectWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalFieldCreateOrConnectWithoutProposalVersionInput>> {
  return z.object({
    create: z.lazy(() => ProposalFieldCreateWithoutProposalVersionInputSchema()),
    where: z.lazy(() => ProposalFieldWhereUniqueInputSchema())
  })
}

export function ProposalFieldCreateWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalFieldCreateWithoutProposalVersionInput>> {
  return z.object({
    createdAt: z.number().nullish(),
    dateMode: DateModeSchema.nullish(),
    fieldId: z.string().trim(),
    fieldName: z.string().trim(),
    type: z.string().trim().nullish(),
    value: z.record(z.string(), z.unknown())
  })
}

export function ProposalFieldListRelationFilterSchema(): z.ZodObject<Properties<ProposalFieldListRelationFilter>> {
  return z.object({
    every: z.lazy(() => ProposalFieldWhereInputSchema().nullish()),
    none: z.lazy(() => ProposalFieldWhereInputSchema().nullish()),
    some: z.lazy(() => ProposalFieldWhereInputSchema().nullish())
  })
}

export function ProposalFieldOrderByRelationAggregateInputSchema(): z.ZodObject<Properties<ProposalFieldOrderByRelationAggregateInput>> {
  return z.object({
    _count: SortOrderSchema.nullish()
  })
}

export function ProposalFieldOrderByRelevanceInputSchema(): z.ZodObject<Properties<ProposalFieldOrderByRelevanceInput>> {
  return z.object({
    fields: z.array(ProposalFieldOrderByRelevanceFieldEnumSchema),
    search: z.string().trim(),
    sort: SortOrderSchema
  })
}

export function ProposalFieldOrderByWithRelationInputSchema(): z.ZodObject<Properties<ProposalFieldOrderByWithRelationInput>> {
  return z.object({
    _relevance: z.lazy(() => ProposalFieldOrderByRelevanceInputSchema().nullish()),
    createdAt: SortOrderSchema.nullish(),
    dateMode: z.lazy(() => SortOrderInputSchema().nullish()),
    fieldId: SortOrderSchema.nullish(),
    fieldName: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    proposalVersion: z.lazy(() => ProposalVersionOrderByWithRelationInputSchema().nullish()),
    proposalVersionId: SortOrderSchema.nullish(),
    type: z.lazy(() => SortOrderInputSchema().nullish()),
    value: SortOrderSchema.nullish()
  })
}

export function ProposalFieldProposalVersionIdFieldIdCompoundUniqueInputSchema(): z.ZodObject<Properties<ProposalFieldProposalVersionIdFieldIdCompoundUniqueInput>> {
  return z.object({
    fieldId: z.string().trim(),
    proposalVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function ProposalFieldScalarWhereInputSchema(): z.ZodObject<Properties<ProposalFieldScalarWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalFieldScalarWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalFieldScalarWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalFieldScalarWhereInputSchema())).nullish(),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    dateMode: z.lazy(() => EnumDateModeNullableFilterSchema().nullish()),
    fieldId: z.lazy(() => StringFilterSchema().nullish()),
    fieldName: z.lazy(() => StringFilterSchema().nullish()),
    id: z.lazy(() => IntFilterSchema().nullish()),
    proposalVersionId: z.lazy(() => IntFilterSchema().nullish()),
    type: z.lazy(() => StringNullableFilterSchema().nullish()),
    value: z.lazy(() => JsonFilterSchema().nullish())
  })
}

export function ProposalFieldUpdateManyMutationInputSchema(): z.ZodObject<Properties<ProposalFieldUpdateManyMutationInput>> {
  return z.object({
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    dateMode: z.lazy(() => NullableEnumDateModeFieldUpdateOperationsInputSchema().nullish()),
    fieldId: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    fieldName: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    type: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish()),
    value: z.record(z.string(), z.unknown()).nullish()
  })
}

export function ProposalFieldUpdateManyWithWhereWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalFieldUpdateManyWithWhereWithoutProposalVersionInput>> {
  return z.object({
    data: z.lazy(() => ProposalFieldUpdateManyMutationInputSchema()),
    where: z.lazy(() => ProposalFieldScalarWhereInputSchema())
  })
}

export function ProposalFieldUpdateManyWithoutProposalVersionNestedInputSchema(): z.ZodObject<Properties<ProposalFieldUpdateManyWithoutProposalVersionNestedInput>> {
  return z.object({
    connect: z.array(z.lazy(() => ProposalFieldWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => ProposalFieldCreateOrConnectWithoutProposalVersionInputSchema())).nullish(),
    create: z.array(z.lazy(() => ProposalFieldCreateWithoutProposalVersionInputSchema())).nullish(),
    createMany: z.lazy(() => ProposalFieldCreateManyProposalVersionInputEnvelopeSchema().nullish()),
    delete: z.array(z.lazy(() => ProposalFieldWhereUniqueInputSchema())).nullish(),
    deleteMany: z.array(z.lazy(() => ProposalFieldScalarWhereInputSchema())).nullish(),
    disconnect: z.array(z.lazy(() => ProposalFieldWhereUniqueInputSchema())).nullish(),
    set: z.array(z.lazy(() => ProposalFieldWhereUniqueInputSchema())).nullish(),
    update: z.array(z.lazy(() => ProposalFieldUpdateWithWhereUniqueWithoutProposalVersionInputSchema())).nullish(),
    updateMany: z.array(z.lazy(() => ProposalFieldUpdateManyWithWhereWithoutProposalVersionInputSchema())).nullish(),
    upsert: z.array(z.lazy(() => ProposalFieldUpsertWithWhereUniqueWithoutProposalVersionInputSchema())).nullish()
  })
}

export function ProposalFieldUpdateWithWhereUniqueWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalFieldUpdateWithWhereUniqueWithoutProposalVersionInput>> {
  return z.object({
    data: z.lazy(() => ProposalFieldUpdateWithoutProposalVersionInputSchema()),
    where: z.lazy(() => ProposalFieldWhereUniqueInputSchema())
  })
}

export function ProposalFieldUpdateWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalFieldUpdateWithoutProposalVersionInput>> {
  return z.object({
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    dateMode: z.lazy(() => NullableEnumDateModeFieldUpdateOperationsInputSchema().nullish()),
    fieldId: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    fieldName: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    type: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish()),
    value: z.record(z.string(), z.unknown()).nullish()
  })
}

export function ProposalFieldUpsertWithWhereUniqueWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalFieldUpsertWithWhereUniqueWithoutProposalVersionInput>> {
  return z.object({
    create: z.lazy(() => ProposalFieldCreateWithoutProposalVersionInputSchema()),
    update: z.lazy(() => ProposalFieldUpdateWithoutProposalVersionInputSchema()),
    where: z.lazy(() => ProposalFieldWhereUniqueInputSchema())
  })
}

export function ProposalFieldWhereInputSchema(): z.ZodObject<Properties<ProposalFieldWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalFieldWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalFieldWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalFieldWhereInputSchema())).nullish(),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    dateMode: z.lazy(() => EnumDateModeNullableFilterSchema().nullish()),
    fieldId: z.lazy(() => StringFilterSchema().nullish()),
    fieldName: z.lazy(() => StringFilterSchema().nullish()),
    id: z.lazy(() => IntFilterSchema().nullish()),
    proposalVersion: z.lazy(() => ProposalVersionScalarRelationFilterSchema().nullish()),
    proposalVersionId: z.lazy(() => IntFilterSchema().nullish()),
    type: z.lazy(() => StringNullableFilterSchema().nullish()),
    value: z.lazy(() => JsonFilterSchema().nullish())
  })
}

export function ProposalFieldWhereUniqueInputSchema(): z.ZodObject<Properties<ProposalFieldWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalFieldWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalFieldWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalFieldWhereInputSchema())).nullish(),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    dateMode: z.lazy(() => EnumDateModeNullableFilterSchema().nullish()),
    fieldId: z.lazy(() => StringFilterSchema().nullish()),
    fieldName: z.lazy(() => StringFilterSchema().nullish()),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    proposalVersion: z.lazy(() => ProposalVersionScalarRelationFilterSchema().nullish()),
    proposalVersionId: z.lazy(() => IntFilterSchema().nullish()),
    proposalVersionId_fieldId: z.lazy(() => ProposalFieldProposalVersionIdFieldIdCompoundUniqueInputSchema().nullish()),
    type: z.lazy(() => StringNullableFilterSchema().nullish()),
    value: z.lazy(() => JsonFilterSchema().nullish())
  })
}

export function ProposalInteractionAuditEventInputSchema(): z.ZodObject<Properties<ProposalInteractionAuditEventInput>> {
  return z.object({
    durationSeconds: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    proposal: z.lazy(() => ProposalWithPageIdsSchema())
  })
}

export function ProposalLastEditorCreateNestedOneWithoutProposalInputSchema(): z.ZodObject<Properties<ProposalLastEditorCreateNestedOneWithoutProposalInput>> {
  return z.object({
    connect: z.lazy(() => ProposalLastEditorWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => ProposalLastEditorCreateOrConnectWithoutProposalInputSchema().nullish()),
    create: z.lazy(() => ProposalLastEditorCreateWithoutProposalInputSchema().nullish())
  })
}

export function ProposalLastEditorCreateOrConnectWithoutProposalInputSchema(): z.ZodObject<Properties<ProposalLastEditorCreateOrConnectWithoutProposalInput>> {
  return z.object({
    create: z.lazy(() => ProposalLastEditorCreateWithoutProposalInputSchema()),
    where: z.lazy(() => ProposalLastEditorWhereUniqueInputSchema())
  })
}

export function ProposalLastEditorCreateWithoutProposalInputSchema(): z.ZodObject<Properties<ProposalLastEditorCreateWithoutProposalInput>> {
  return z.object({
    email: z.string().trim(),
    lastCheckedInAt: z.number().nullish()
  })
}

export function ProposalLastEditorNullableScalarRelationFilterSchema(): z.ZodObject<Properties<ProposalLastEditorNullableScalarRelationFilter>> {
  return z.object({
    is: z.lazy(() => ProposalLastEditorWhereInputSchema().nullish()),
    isNot: z.lazy(() => ProposalLastEditorWhereInputSchema().nullish())
  })
}

export function ProposalLastEditorOrderByRelevanceInputSchema(): z.ZodObject<Properties<ProposalLastEditorOrderByRelevanceInput>> {
  return z.object({
    fields: z.array(ProposalLastEditorOrderByRelevanceFieldEnumSchema),
    search: z.string().trim(),
    sort: SortOrderSchema
  })
}

export function ProposalLastEditorOrderByWithRelationInputSchema(): z.ZodObject<Properties<ProposalLastEditorOrderByWithRelationInput>> {
  return z.object({
    _relevance: z.lazy(() => ProposalLastEditorOrderByRelevanceInputSchema().nullish()),
    email: SortOrderSchema.nullish(),
    lastCheckedInAt: SortOrderSchema.nullish(),
    proposal: z.lazy(() => ProposalOrderByWithRelationInputSchema().nullish()),
    proposalId: SortOrderSchema.nullish()
  })
}

export function ProposalLastEditorUpdateOneWithoutProposalNestedInputSchema(): z.ZodObject<Properties<ProposalLastEditorUpdateOneWithoutProposalNestedInput>> {
  return z.object({
    connect: z.lazy(() => ProposalLastEditorWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => ProposalLastEditorCreateOrConnectWithoutProposalInputSchema().nullish()),
    create: z.lazy(() => ProposalLastEditorCreateWithoutProposalInputSchema().nullish()),
    delete: z.lazy(() => ProposalLastEditorWhereInputSchema().nullish()),
    disconnect: z.lazy(() => ProposalLastEditorWhereInputSchema().nullish()),
    update: z.lazy(() => ProposalLastEditorUpdateToOneWithWhereWithoutProposalInputSchema().nullish()),
    upsert: z.lazy(() => ProposalLastEditorUpsertWithoutProposalInputSchema().nullish())
  })
}

export function ProposalLastEditorUpdateToOneWithWhereWithoutProposalInputSchema(): z.ZodObject<Properties<ProposalLastEditorUpdateToOneWithWhereWithoutProposalInput>> {
  return z.object({
    data: z.lazy(() => ProposalLastEditorUpdateWithoutProposalInputSchema()),
    where: z.lazy(() => ProposalLastEditorWhereInputSchema().nullish())
  })
}

export function ProposalLastEditorUpdateWithoutProposalInputSchema(): z.ZodObject<Properties<ProposalLastEditorUpdateWithoutProposalInput>> {
  return z.object({
    email: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    lastCheckedInAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish())
  })
}

export function ProposalLastEditorUpsertWithoutProposalInputSchema(): z.ZodObject<Properties<ProposalLastEditorUpsertWithoutProposalInput>> {
  return z.object({
    create: z.lazy(() => ProposalLastEditorCreateWithoutProposalInputSchema()),
    update: z.lazy(() => ProposalLastEditorUpdateWithoutProposalInputSchema()),
    where: z.lazy(() => ProposalLastEditorWhereInputSchema().nullish())
  })
}

export function ProposalLastEditorWhereInputSchema(): z.ZodObject<Properties<ProposalLastEditorWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalLastEditorWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalLastEditorWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalLastEditorWhereInputSchema())).nullish(),
    email: z.lazy(() => StringFilterSchema().nullish()),
    lastCheckedInAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    proposal: z.lazy(() => ProposalScalarRelationFilterSchema().nullish()),
    proposalId: z.lazy(() => IntFilterSchema().nullish())
  })
}

export function ProposalLastEditorWhereUniqueInputSchema(): z.ZodObject<Properties<ProposalLastEditorWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalLastEditorWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalLastEditorWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalLastEditorWhereInputSchema())).nullish(),
    email: z.lazy(() => StringFilterSchema().nullish()),
    lastCheckedInAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    proposal: z.lazy(() => ProposalScalarRelationFilterSchema().nullish()),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function ProposalListItemSchema(): z.ZodObject<Properties<ProposalListItem>> {
  return z.object({
    __typename: z.literal('ProposalListItem').optional(),
    createdAt: z.number(),
    createdBy: z.string().trim(),
    dataSourceUsedAt: z.number().nullish(),
    fields: z.array(z.lazy(() => ProposalListItemFieldSchema())),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    isFinalized: z.boolean(),
    isPinned: z.boolean(),
    lastVersionCreatedBy: z.string().trim(),
    latestVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    name: z.string().trim(),
    templateName: z.string().trim(),
    updatedAt: z.number()
  })
}

export function ProposalListItemFieldSchema(): z.ZodObject<Properties<ProposalListItemField>> {
  return z.object({
    __typename: z.literal('ProposalListItemField').optional(),
    dateMode: DateModeSchema.nullish(),
    fieldId: z.string().trim(),
    name: z.string().trim(),
    type: z.string().trim(),
    value: z.string().trim().nullish()
  })
}

export function ProposalListRelationFilterSchema(): z.ZodObject<Properties<ProposalListRelationFilter>> {
  return z.object({
    every: z.lazy(() => ProposalWhereInputSchema().nullish()),
    none: z.lazy(() => ProposalWhereInputSchema().nullish()),
    some: z.lazy(() => ProposalWhereInputSchema().nullish())
  })
}

export function ProposalMetricSchema(): z.ZodObject<Properties<ProposalMetric>> {
  return z.object({
    __typename: z.literal('ProposalMetric').optional(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    metricId: z.string().trim(),
    metricName: z.string().trim(),
    proposalVersion: z.lazy(() => ProposalVersionSchema().nullish()),
    proposalVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    updatedAt: z.number(),
    value: z.record(z.string(), z.unknown())
  })
}

export function ProposalMetricProposalVersionArgsSchema(): z.ZodObject<Properties<ProposalMetricProposalVersionArgs>> {
  return z.object({
    where: z.lazy(() => ProposalVersionWhereInputSchema().nullish())
  })
}

export function ProposalMetricCreateManyProposalVersionInputSchema(): z.ZodObject<Properties<ProposalMetricCreateManyProposalVersionInput>> {
  return z.object({
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    metricId: z.string().trim(),
    metricName: z.string().trim(),
    updatedAt: z.number().nullish(),
    value: z.record(z.string(), z.unknown())
  })
}

export function ProposalMetricCreateManyProposalVersionInputEnvelopeSchema(): z.ZodObject<Properties<ProposalMetricCreateManyProposalVersionInputEnvelope>> {
  return z.object({
    data: z.array(z.lazy(() => ProposalMetricCreateManyProposalVersionInputSchema())),
    skipDuplicates: z.boolean().nullish()
  })
}

export function ProposalMetricCreateNestedManyWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalMetricCreateNestedManyWithoutProposalVersionInput>> {
  return z.object({
    connect: z.array(z.lazy(() => ProposalMetricWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => ProposalMetricCreateOrConnectWithoutProposalVersionInputSchema())).nullish(),
    create: z.array(z.lazy(() => ProposalMetricCreateWithoutProposalVersionInputSchema())).nullish(),
    createMany: z.lazy(() => ProposalMetricCreateManyProposalVersionInputEnvelopeSchema().nullish())
  })
}

export function ProposalMetricCreateOrConnectWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalMetricCreateOrConnectWithoutProposalVersionInput>> {
  return z.object({
    create: z.lazy(() => ProposalMetricCreateWithoutProposalVersionInputSchema()),
    where: z.lazy(() => ProposalMetricWhereUniqueInputSchema())
  })
}

export function ProposalMetricCreateWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalMetricCreateWithoutProposalVersionInput>> {
  return z.object({
    metricId: z.string().trim(),
    metricName: z.string().trim(),
    updatedAt: z.number().nullish(),
    value: z.record(z.string(), z.unknown())
  })
}

export function ProposalMetricListRelationFilterSchema(): z.ZodObject<Properties<ProposalMetricListRelationFilter>> {
  return z.object({
    every: z.lazy(() => ProposalMetricWhereInputSchema().nullish()),
    none: z.lazy(() => ProposalMetricWhereInputSchema().nullish()),
    some: z.lazy(() => ProposalMetricWhereInputSchema().nullish())
  })
}

export function ProposalMetricOrderByRelationAggregateInputSchema(): z.ZodObject<Properties<ProposalMetricOrderByRelationAggregateInput>> {
  return z.object({
    _count: SortOrderSchema.nullish()
  })
}

export function ProposalMetricOrderByRelevanceInputSchema(): z.ZodObject<Properties<ProposalMetricOrderByRelevanceInput>> {
  return z.object({
    fields: z.array(ProposalMetricOrderByRelevanceFieldEnumSchema),
    search: z.string().trim(),
    sort: SortOrderSchema
  })
}

export function ProposalMetricOrderByWithRelationInputSchema(): z.ZodObject<Properties<ProposalMetricOrderByWithRelationInput>> {
  return z.object({
    _relevance: z.lazy(() => ProposalMetricOrderByRelevanceInputSchema().nullish()),
    id: SortOrderSchema.nullish(),
    metricId: SortOrderSchema.nullish(),
    metricName: SortOrderSchema.nullish(),
    proposalVersion: z.lazy(() => ProposalVersionOrderByWithRelationInputSchema().nullish()),
    proposalVersionId: z.lazy(() => SortOrderInputSchema().nullish()),
    updatedAt: SortOrderSchema.nullish(),
    value: SortOrderSchema.nullish()
  })
}

export function ProposalMetricSaveInputSchema(): z.ZodObject<Properties<ProposalMetricSaveInput>> {
  return z.object({
    collectForEveryVersion: z.boolean(),
    metricId: z.string().trim(),
    metricName: z.string().trim(),
    value: z.record(z.string(), z.unknown())
  })
}

export function ProposalMetricScalarWhereInputSchema(): z.ZodObject<Properties<ProposalMetricScalarWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalMetricScalarWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalMetricScalarWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalMetricScalarWhereInputSchema())).nullish(),
    id: z.lazy(() => IntFilterSchema().nullish()),
    metricId: z.lazy(() => StringFilterSchema().nullish()),
    metricName: z.lazy(() => StringFilterSchema().nullish()),
    proposalVersionId: z.lazy(() => IntNullableFilterSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    value: z.lazy(() => JsonFilterSchema().nullish())
  })
}

export function ProposalMetricUpdateManyMutationInputSchema(): z.ZodObject<Properties<ProposalMetricUpdateManyMutationInput>> {
  return z.object({
    metricId: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    metricName: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    value: z.record(z.string(), z.unknown()).nullish()
  })
}

export function ProposalMetricUpdateManyWithWhereWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalMetricUpdateManyWithWhereWithoutProposalVersionInput>> {
  return z.object({
    data: z.lazy(() => ProposalMetricUpdateManyMutationInputSchema()),
    where: z.lazy(() => ProposalMetricScalarWhereInputSchema())
  })
}

export function ProposalMetricUpdateManyWithoutProposalVersionNestedInputSchema(): z.ZodObject<Properties<ProposalMetricUpdateManyWithoutProposalVersionNestedInput>> {
  return z.object({
    connect: z.array(z.lazy(() => ProposalMetricWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => ProposalMetricCreateOrConnectWithoutProposalVersionInputSchema())).nullish(),
    create: z.array(z.lazy(() => ProposalMetricCreateWithoutProposalVersionInputSchema())).nullish(),
    createMany: z.lazy(() => ProposalMetricCreateManyProposalVersionInputEnvelopeSchema().nullish()),
    delete: z.array(z.lazy(() => ProposalMetricWhereUniqueInputSchema())).nullish(),
    deleteMany: z.array(z.lazy(() => ProposalMetricScalarWhereInputSchema())).nullish(),
    disconnect: z.array(z.lazy(() => ProposalMetricWhereUniqueInputSchema())).nullish(),
    set: z.array(z.lazy(() => ProposalMetricWhereUniqueInputSchema())).nullish(),
    update: z.array(z.lazy(() => ProposalMetricUpdateWithWhereUniqueWithoutProposalVersionInputSchema())).nullish(),
    updateMany: z.array(z.lazy(() => ProposalMetricUpdateManyWithWhereWithoutProposalVersionInputSchema())).nullish(),
    upsert: z.array(z.lazy(() => ProposalMetricUpsertWithWhereUniqueWithoutProposalVersionInputSchema())).nullish()
  })
}

export function ProposalMetricUpdateWithWhereUniqueWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalMetricUpdateWithWhereUniqueWithoutProposalVersionInput>> {
  return z.object({
    data: z.lazy(() => ProposalMetricUpdateWithoutProposalVersionInputSchema()),
    where: z.lazy(() => ProposalMetricWhereUniqueInputSchema())
  })
}

export function ProposalMetricUpdateWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalMetricUpdateWithoutProposalVersionInput>> {
  return z.object({
    metricId: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    metricName: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    value: z.record(z.string(), z.unknown()).nullish()
  })
}

export function ProposalMetricUpsertWithWhereUniqueWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalMetricUpsertWithWhereUniqueWithoutProposalVersionInput>> {
  return z.object({
    create: z.lazy(() => ProposalMetricCreateWithoutProposalVersionInputSchema()),
    update: z.lazy(() => ProposalMetricUpdateWithoutProposalVersionInputSchema()),
    where: z.lazy(() => ProposalMetricWhereUniqueInputSchema())
  })
}

export function ProposalMetricWhereInputSchema(): z.ZodObject<Properties<ProposalMetricWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalMetricWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalMetricWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalMetricWhereInputSchema())).nullish(),
    id: z.lazy(() => IntFilterSchema().nullish()),
    metricId: z.lazy(() => StringFilterSchema().nullish()),
    metricName: z.lazy(() => StringFilterSchema().nullish()),
    proposalVersion: z.lazy(() => ProposalVersionNullableScalarRelationFilterSchema().nullish()),
    proposalVersionId: z.lazy(() => IntNullableFilterSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    value: z.lazy(() => JsonFilterSchema().nullish())
  })
}

export function ProposalMetricWhereUniqueInputSchema(): z.ZodObject<Properties<ProposalMetricWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalMetricWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalMetricWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalMetricWhereInputSchema())).nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    metricId: z.lazy(() => StringFilterSchema().nullish()),
    metricName: z.lazy(() => StringFilterSchema().nullish()),
    proposalVersion: z.lazy(() => ProposalVersionNullableScalarRelationFilterSchema().nullish()),
    proposalVersionId: z.lazy(() => IntNullableFilterSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    value: z.lazy(() => JsonFilterSchema().nullish())
  })
}

export function ProposalOrderByRelationAggregateInputSchema(): z.ZodObject<Properties<ProposalOrderByRelationAggregateInput>> {
  return z.object({
    _count: SortOrderSchema.nullish()
  })
}

export function ProposalOrderByRelevanceInputSchema(): z.ZodObject<Properties<ProposalOrderByRelevanceInput>> {
  return z.object({
    fields: z.array(ProposalOrderByRelevanceFieldEnumSchema),
    search: z.string().trim(),
    sort: SortOrderSchema
  })
}

export function ProposalOrderByWithRelationInputSchema(): z.ZodObject<Properties<ProposalOrderByWithRelationInput>> {
  return z.object({
    _relevance: z.lazy(() => ProposalOrderByRelevanceInputSchema().nullish()),
    createdAt: SortOrderSchema.nullish(),
    createdBy: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    isFinalized: SortOrderSchema.nullish(),
    lastEditor: z.lazy(() => ProposalLastEditorOrderByWithRelationInputSchema().nullish()),
    name: SortOrderSchema.nullish(),
    notes: z.lazy(() => NoteOrderByRelationAggregateInputSchema().nullish()),
    templateVersion: z.lazy(() => ProposalTemplateVersionOrderByWithRelationInputSchema().nullish()),
    templateVersionId: SortOrderSchema.nullish(),
    totalCellCount: z.lazy(() => SortOrderInputSchema().nullish()),
    totalCellDataBytes: z.lazy(() => SortOrderInputSchema().nullish()),
    type: SortOrderSchema.nullish(),
    userProposalAccess: z.lazy(() => UserProposalAccessOrderByRelationAggregateInputSchema().nullish()),
    userProposalPins: z.lazy(() => UserProposalPinOrderByRelationAggregateInputSchema().nullish()),
    versions: z.lazy(() => ProposalVersionOrderByRelationAggregateInputSchema().nullish())
  })
}

export function ProposalPageDataSourceRowsSchema(): z.ZodObject<Properties<ProposalPageDataSourceRows>> {
  return z.object({
    __typename: z.literal('ProposalPageDataSourceRows').optional(),
    columns: z.array(z.string().trim()),
    rows: z.record(z.string(), z.unknown())
  })
}

export function ProposalPageRowIndexSchema(): z.ZodObject<Properties<ProposalPageRowIndex>> {
  return z.object({
    __typename: z.literal('ProposalPageRowIndex').optional(),
    pageUUID: z.string().trim(),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    rowUUID: z.string().trim(),
    version: z.lazy(() => ProposalVersionSchema()),
    versionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function ProposalPageRowIndexCreateManyVersionInputSchema(): z.ZodObject<Properties<ProposalPageRowIndexCreateManyVersionInput>> {
  return z.object({
    pageUUID: z.string().trim(),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    rowUUID: z.string().trim()
  })
}

export function ProposalPageRowIndexCreateManyVersionInputEnvelopeSchema(): z.ZodObject<Properties<ProposalPageRowIndexCreateManyVersionInputEnvelope>> {
  return z.object({
    data: z.array(z.lazy(() => ProposalPageRowIndexCreateManyVersionInputSchema())),
    skipDuplicates: z.boolean().nullish()
  })
}

export function ProposalPageRowIndexCreateNestedManyWithoutVersionInputSchema(): z.ZodObject<Properties<ProposalPageRowIndexCreateNestedManyWithoutVersionInput>> {
  return z.object({
    connect: z.array(z.lazy(() => ProposalPageRowIndexWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => ProposalPageRowIndexCreateOrConnectWithoutVersionInputSchema())).nullish(),
    create: z.array(z.lazy(() => ProposalPageRowIndexCreateWithoutVersionInputSchema())).nullish(),
    createMany: z.lazy(() => ProposalPageRowIndexCreateManyVersionInputEnvelopeSchema().nullish())
  })
}

export function ProposalPageRowIndexCreateOrConnectWithoutVersionInputSchema(): z.ZodObject<Properties<ProposalPageRowIndexCreateOrConnectWithoutVersionInput>> {
  return z.object({
    create: z.lazy(() => ProposalPageRowIndexCreateWithoutVersionInputSchema()),
    where: z.lazy(() => ProposalPageRowIndexWhereUniqueInputSchema())
  })
}

export function ProposalPageRowIndexCreateWithoutVersionInputSchema(): z.ZodObject<Properties<ProposalPageRowIndexCreateWithoutVersionInput>> {
  return z.object({
    pageUUID: z.string().trim(),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    rowUUID: z.string().trim()
  })
}

export function ProposalPageRowIndexListRelationFilterSchema(): z.ZodObject<Properties<ProposalPageRowIndexListRelationFilter>> {
  return z.object({
    every: z.lazy(() => ProposalPageRowIndexWhereInputSchema().nullish()),
    none: z.lazy(() => ProposalPageRowIndexWhereInputSchema().nullish()),
    some: z.lazy(() => ProposalPageRowIndexWhereInputSchema().nullish())
  })
}

export function ProposalPageRowIndexOrderByRelationAggregateInputSchema(): z.ZodObject<Properties<ProposalPageRowIndexOrderByRelationAggregateInput>> {
  return z.object({
    _count: SortOrderSchema.nullish()
  })
}

export function ProposalPageRowIndexOrderByRelevanceInputSchema(): z.ZodObject<Properties<ProposalPageRowIndexOrderByRelevanceInput>> {
  return z.object({
    fields: z.array(ProposalPageRowIndexOrderByRelevanceFieldEnumSchema),
    search: z.string().trim(),
    sort: SortOrderSchema
  })
}

export function ProposalPageRowIndexOrderByWithRelationInputSchema(): z.ZodObject<Properties<ProposalPageRowIndexOrderByWithRelationInput>> {
  return z.object({
    _relevance: z.lazy(() => ProposalPageRowIndexOrderByRelevanceInputSchema().nullish()),
    pageUUID: SortOrderSchema.nullish(),
    proposalId: SortOrderSchema.nullish(),
    rowUUID: SortOrderSchema.nullish(),
    version: z.lazy(() => ProposalVersionOrderByWithRelationInputSchema().nullish()),
    versionId: SortOrderSchema.nullish()
  })
}

export function ProposalPageRowIndexPageUuidVersionIdRowUuidCompoundUniqueInputSchema(): z.ZodObject<Properties<ProposalPageRowIndexPageUuidVersionIdRowUuidCompoundUniqueInput>> {
  return z.object({
    pageUUID: z.string().trim(),
    rowUUID: z.string().trim(),
    versionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function ProposalPageRowIndexScalarWhereInputSchema(): z.ZodObject<Properties<ProposalPageRowIndexScalarWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalPageRowIndexScalarWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalPageRowIndexScalarWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalPageRowIndexScalarWhereInputSchema())).nullish(),
    pageUUID: z.lazy(() => StringFilterSchema().nullish()),
    proposalId: z.lazy(() => IntFilterSchema().nullish()),
    rowUUID: z.lazy(() => StringFilterSchema().nullish()),
    versionId: z.lazy(() => IntFilterSchema().nullish())
  })
}

export function ProposalPageRowIndexUpdateManyMutationInputSchema(): z.ZodObject<Properties<ProposalPageRowIndexUpdateManyMutationInput>> {
  return z.object({
    pageUUID: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    proposalId: z.lazy(() => IntFieldUpdateOperationsInputSchema().nullish()),
    rowUUID: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish())
  })
}

export function ProposalPageRowIndexUpdateManyWithWhereWithoutVersionInputSchema(): z.ZodObject<Properties<ProposalPageRowIndexUpdateManyWithWhereWithoutVersionInput>> {
  return z.object({
    data: z.lazy(() => ProposalPageRowIndexUpdateManyMutationInputSchema()),
    where: z.lazy(() => ProposalPageRowIndexScalarWhereInputSchema())
  })
}

export function ProposalPageRowIndexUpdateManyWithoutVersionNestedInputSchema(): z.ZodObject<Properties<ProposalPageRowIndexUpdateManyWithoutVersionNestedInput>> {
  return z.object({
    connect: z.array(z.lazy(() => ProposalPageRowIndexWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => ProposalPageRowIndexCreateOrConnectWithoutVersionInputSchema())).nullish(),
    create: z.array(z.lazy(() => ProposalPageRowIndexCreateWithoutVersionInputSchema())).nullish(),
    createMany: z.lazy(() => ProposalPageRowIndexCreateManyVersionInputEnvelopeSchema().nullish()),
    delete: z.array(z.lazy(() => ProposalPageRowIndexWhereUniqueInputSchema())).nullish(),
    deleteMany: z.array(z.lazy(() => ProposalPageRowIndexScalarWhereInputSchema())).nullish(),
    disconnect: z.array(z.lazy(() => ProposalPageRowIndexWhereUniqueInputSchema())).nullish(),
    set: z.array(z.lazy(() => ProposalPageRowIndexWhereUniqueInputSchema())).nullish(),
    update: z.array(z.lazy(() => ProposalPageRowIndexUpdateWithWhereUniqueWithoutVersionInputSchema())).nullish(),
    updateMany: z.array(z.lazy(() => ProposalPageRowIndexUpdateManyWithWhereWithoutVersionInputSchema())).nullish(),
    upsert: z.array(z.lazy(() => ProposalPageRowIndexUpsertWithWhereUniqueWithoutVersionInputSchema())).nullish()
  })
}

export function ProposalPageRowIndexUpdateWithWhereUniqueWithoutVersionInputSchema(): z.ZodObject<Properties<ProposalPageRowIndexUpdateWithWhereUniqueWithoutVersionInput>> {
  return z.object({
    data: z.lazy(() => ProposalPageRowIndexUpdateWithoutVersionInputSchema()),
    where: z.lazy(() => ProposalPageRowIndexWhereUniqueInputSchema())
  })
}

export function ProposalPageRowIndexUpdateWithoutVersionInputSchema(): z.ZodObject<Properties<ProposalPageRowIndexUpdateWithoutVersionInput>> {
  return z.object({
    pageUUID: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    proposalId: z.lazy(() => IntFieldUpdateOperationsInputSchema().nullish()),
    rowUUID: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish())
  })
}

export function ProposalPageRowIndexUpsertWithWhereUniqueWithoutVersionInputSchema(): z.ZodObject<Properties<ProposalPageRowIndexUpsertWithWhereUniqueWithoutVersionInput>> {
  return z.object({
    create: z.lazy(() => ProposalPageRowIndexCreateWithoutVersionInputSchema()),
    update: z.lazy(() => ProposalPageRowIndexUpdateWithoutVersionInputSchema()),
    where: z.lazy(() => ProposalPageRowIndexWhereUniqueInputSchema())
  })
}

export function ProposalPageRowIndexWhereInputSchema(): z.ZodObject<Properties<ProposalPageRowIndexWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalPageRowIndexWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalPageRowIndexWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalPageRowIndexWhereInputSchema())).nullish(),
    pageUUID: z.lazy(() => StringFilterSchema().nullish()),
    proposalId: z.lazy(() => IntFilterSchema().nullish()),
    rowUUID: z.lazy(() => StringFilterSchema().nullish()),
    version: z.lazy(() => ProposalVersionScalarRelationFilterSchema().nullish()),
    versionId: z.lazy(() => IntFilterSchema().nullish())
  })
}

export function ProposalPageRowIndexWhereUniqueInputSchema(): z.ZodObject<Properties<ProposalPageRowIndexWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalPageRowIndexWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalPageRowIndexWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalPageRowIndexWhereInputSchema())).nullish(),
    pageUUID: z.lazy(() => StringFilterSchema().nullish()),
    pageUUID_versionId_rowUUID: z.lazy(() => ProposalPageRowIndexPageUuidVersionIdRowUuidCompoundUniqueInputSchema().nullish()),
    proposalId: z.lazy(() => IntFilterSchema().nullish()),
    rowUUID: z.lazy(() => StringFilterSchema().nullish()),
    version: z.lazy(() => ProposalVersionScalarRelationFilterSchema().nullish()),
    versionId: z.lazy(() => IntFilterSchema().nullish())
  })
}

export function ProposalRowSummaryResultSchema(): z.ZodObject<Properties<ProposalRowSummaryResult>> {
  return z.object({
    __typename: z.literal('ProposalRowSummaryResult').optional(),
    column_uuid: z.string().trim(),
    last_updated_at: z.number()
  })
}

export function ProposalScalarRelationFilterSchema(): z.ZodObject<Properties<ProposalScalarRelationFilter>> {
  return z.object({
    is: z.lazy(() => ProposalWhereInputSchema().nullish()),
    isNot: z.lazy(() => ProposalWhereInputSchema().nullish())
  })
}

export function ProposalScalarWhereInputSchema(): z.ZodObject<Properties<ProposalScalarWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalScalarWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalScalarWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalScalarWhereInputSchema())).nullish(),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    createdBy: z.lazy(() => StringFilterSchema().nullish()),
    id: z.lazy(() => IntFilterSchema().nullish()),
    isFinalized: z.lazy(() => BoolFilterSchema().nullish()),
    name: z.lazy(() => StringFilterSchema().nullish()),
    templateVersionId: z.lazy(() => IntFilterSchema().nullish()),
    totalCellCount: z.lazy(() => IntNullableFilterSchema().nullish()),
    totalCellDataBytes: z.lazy(() => BigIntNullableFilterSchema().nullish()),
    type: z.lazy(() => EnumProposalTypeFilterSchema().nullish())
  })
}

export function ProposalTemplateSchema(): z.ZodObject<Properties<ProposalTemplate>> {
  return z.object({
    __typename: z.literal('ProposalTemplate').optional(),
    _count: z.lazy(() => ProposalTemplateCountSchema().nullish()),
    createdAt: z.number(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    isDefault: z.boolean(),
    isPublished: z.boolean(),
    lastVersion: z.lazy(() => ProposalTemplateVersionSchema()),
    name: z.string().trim(),
    type: TemplateTypeSchema,
    updatedAt: z.number(),
    versions: z.array(z.lazy(() => ProposalTemplateVersionSchema()))
  })
}

export function ProposalTemplateVersionsArgsSchema(): z.ZodObject<Properties<ProposalTemplateVersionsArgs>> {
  return z.object({
    cursor: z.lazy(() => ProposalTemplateVersionWhereUniqueInputSchema().nullish()),
    distinct: z.array(ProposalTemplateVersionScalarFieldEnumSchema).nullish(),
    orderBy: z.array(z.lazy(() => ProposalTemplateVersionOrderByWithRelationInputSchema())).nullish(),
    skip: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    take: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    where: z.lazy(() => ProposalTemplateVersionWhereInputSchema().nullish())
  })
}

export function ProposalTemplateAvgAggregateSchema(): z.ZodObject<Properties<ProposalTemplateAvgAggregate>> {
  return z.object({
    __typename: z.literal('ProposalTemplateAvgAggregate').optional(),
    id: z.number().nullish()
  })
}

export function ProposalTemplateAvgOrderByAggregateInputSchema(): z.ZodObject<Properties<ProposalTemplateAvgOrderByAggregateInput>> {
  return z.object({
    id: SortOrderSchema.nullish()
  })
}

export function ProposalTemplateCountSchema(): z.ZodObject<Properties<ProposalTemplateCount>> {
  return z.object({
    __typename: z.literal('ProposalTemplateCount').optional(),
    versions: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function ProposalTemplateCountVersionsArgsSchema(): z.ZodObject<Properties<ProposalTemplateCountVersionsArgs>> {
  return z.object({
    where: z.lazy(() => ProposalTemplateVersionWhereInputSchema().nullish())
  })
}

export function ProposalTemplateCountAggregateSchema(): z.ZodObject<Properties<ProposalTemplateCountAggregate>> {
  return z.object({
    __typename: z.literal('ProposalTemplateCountAggregate').optional(),
    _all: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    createdAt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    isDefault: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    isPublished: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    name: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    type: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    updatedAt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function ProposalTemplateCountOrderByAggregateInputSchema(): z.ZodObject<Properties<ProposalTemplateCountOrderByAggregateInput>> {
  return z.object({
    createdAt: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    isDefault: SortOrderSchema.nullish(),
    isPublished: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    type: SortOrderSchema.nullish(),
    updatedAt: SortOrderSchema.nullish()
  })
}

export function ProposalTemplateCreateInputSchema(): z.ZodObject<Properties<ProposalTemplateCreateInput>> {
  return z.object({
    createdAt: z.number().nullish(),
    isDefault: z.boolean().nullish(),
    isPublished: z.boolean().nullish(),
    name: z.string().trim(),
    type: TemplateTypeSchema.nullish(),
    updatedAt: z.number().nullish(),
    versions: z.lazy(() => ProposalTemplateVersionCreateNestedManyWithoutTemplateInputSchema().nullish())
  })
}

export function ProposalTemplateCreateManyInputSchema(): z.ZodObject<Properties<ProposalTemplateCreateManyInput>> {
  return z.object({
    createdAt: z.number().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    isDefault: z.boolean().nullish(),
    isPublished: z.boolean().nullish(),
    name: z.string().trim(),
    type: TemplateTypeSchema.nullish(),
    updatedAt: z.number().nullish()
  })
}

export function ProposalTemplateCreateNestedOneWithoutVersionsInputSchema(): z.ZodObject<Properties<ProposalTemplateCreateNestedOneWithoutVersionsInput>> {
  return z.object({
    connect: z.lazy(() => ProposalTemplateWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => ProposalTemplateCreateOrConnectWithoutVersionsInputSchema().nullish()),
    create: z.lazy(() => ProposalTemplateCreateWithoutVersionsInputSchema().nullish())
  })
}

export function ProposalTemplateCreateOrConnectWithoutVersionsInputSchema(): z.ZodObject<Properties<ProposalTemplateCreateOrConnectWithoutVersionsInput>> {
  return z.object({
    create: z.lazy(() => ProposalTemplateCreateWithoutVersionsInputSchema()),
    where: z.lazy(() => ProposalTemplateWhereUniqueInputSchema())
  })
}

export function ProposalTemplateCreateWithoutVersionsInputSchema(): z.ZodObject<Properties<ProposalTemplateCreateWithoutVersionsInput>> {
  return z.object({
    createdAt: z.number().nullish(),
    isDefault: z.boolean().nullish(),
    isPublished: z.boolean().nullish(),
    name: z.string().trim(),
    type: TemplateTypeSchema.nullish(),
    updatedAt: z.number().nullish()
  })
}

export function ProposalTemplateGroupBySchema(): z.ZodObject<Properties<ProposalTemplateGroupBy>> {
  return z.object({
    __typename: z.literal('ProposalTemplateGroupBy').optional(),
    _avg: z.lazy(() => ProposalTemplateAvgAggregateSchema().nullish()),
    _count: z.lazy(() => ProposalTemplateCountAggregateSchema().nullish()),
    _max: z.lazy(() => ProposalTemplateMaxAggregateSchema().nullish()),
    _min: z.lazy(() => ProposalTemplateMinAggregateSchema().nullish()),
    _sum: z.lazy(() => ProposalTemplateSumAggregateSchema().nullish()),
    createdAt: z.number(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    isDefault: z.boolean(),
    isPublished: z.boolean(),
    name: z.string().trim(),
    type: TemplateTypeSchema,
    updatedAt: z.number()
  })
}

export function ProposalTemplateMaxAggregateSchema(): z.ZodObject<Properties<ProposalTemplateMaxAggregate>> {
  return z.object({
    __typename: z.literal('ProposalTemplateMaxAggregate').optional(),
    createdAt: z.number().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    isDefault: z.boolean().nullish(),
    isPublished: z.boolean().nullish(),
    name: z.string().trim().nullish(),
    type: TemplateTypeSchema.nullish(),
    updatedAt: z.number().nullish()
  })
}

export function ProposalTemplateMaxOrderByAggregateInputSchema(): z.ZodObject<Properties<ProposalTemplateMaxOrderByAggregateInput>> {
  return z.object({
    createdAt: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    isDefault: SortOrderSchema.nullish(),
    isPublished: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    type: SortOrderSchema.nullish(),
    updatedAt: SortOrderSchema.nullish()
  })
}

export function ProposalTemplateMinAggregateSchema(): z.ZodObject<Properties<ProposalTemplateMinAggregate>> {
  return z.object({
    __typename: z.literal('ProposalTemplateMinAggregate').optional(),
    createdAt: z.number().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    isDefault: z.boolean().nullish(),
    isPublished: z.boolean().nullish(),
    name: z.string().trim().nullish(),
    type: TemplateTypeSchema.nullish(),
    updatedAt: z.number().nullish()
  })
}

export function ProposalTemplateMinOrderByAggregateInputSchema(): z.ZodObject<Properties<ProposalTemplateMinOrderByAggregateInput>> {
  return z.object({
    createdAt: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    isDefault: SortOrderSchema.nullish(),
    isPublished: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    type: SortOrderSchema.nullish(),
    updatedAt: SortOrderSchema.nullish()
  })
}

export function ProposalTemplateOrderByRelevanceInputSchema(): z.ZodObject<Properties<ProposalTemplateOrderByRelevanceInput>> {
  return z.object({
    fields: z.array(ProposalTemplateOrderByRelevanceFieldEnumSchema),
    search: z.string().trim(),
    sort: SortOrderSchema
  })
}

export function ProposalTemplateOrderByWithAggregationInputSchema(): z.ZodObject<Properties<ProposalTemplateOrderByWithAggregationInput>> {
  return z.object({
    _avg: z.lazy(() => ProposalTemplateAvgOrderByAggregateInputSchema().nullish()),
    _count: z.lazy(() => ProposalTemplateCountOrderByAggregateInputSchema().nullish()),
    _max: z.lazy(() => ProposalTemplateMaxOrderByAggregateInputSchema().nullish()),
    _min: z.lazy(() => ProposalTemplateMinOrderByAggregateInputSchema().nullish()),
    _sum: z.lazy(() => ProposalTemplateSumOrderByAggregateInputSchema().nullish()),
    createdAt: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    isDefault: SortOrderSchema.nullish(),
    isPublished: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    type: SortOrderSchema.nullish(),
    updatedAt: SortOrderSchema.nullish()
  })
}

export function ProposalTemplateOrderByWithRelationInputSchema(): z.ZodObject<Properties<ProposalTemplateOrderByWithRelationInput>> {
  return z.object({
    _relevance: z.lazy(() => ProposalTemplateOrderByRelevanceInputSchema().nullish()),
    createdAt: SortOrderSchema.nullish(),
    id: SortOrderSchema.nullish(),
    isDefault: SortOrderSchema.nullish(),
    isPublished: SortOrderSchema.nullish(),
    name: SortOrderSchema.nullish(),
    type: SortOrderSchema.nullish(),
    updatedAt: SortOrderSchema.nullish(),
    versions: z.lazy(() => ProposalTemplateVersionOrderByRelationAggregateInputSchema().nullish())
  })
}

export function ProposalTemplateScalarRelationFilterSchema(): z.ZodObject<Properties<ProposalTemplateScalarRelationFilter>> {
  return z.object({
    is: z.lazy(() => ProposalTemplateWhereInputSchema().nullish()),
    isNot: z.lazy(() => ProposalTemplateWhereInputSchema().nullish())
  })
}

export function ProposalTemplateScalarWhereWithAggregatesInputSchema(): z.ZodObject<Properties<ProposalTemplateScalarWhereWithAggregatesInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalTemplateScalarWhereWithAggregatesInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalTemplateScalarWhereWithAggregatesInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalTemplateScalarWhereWithAggregatesInputSchema())).nullish(),
    createdAt: z.lazy(() => DateTimeWithAggregatesFilterSchema().nullish()),
    id: z.lazy(() => IntWithAggregatesFilterSchema().nullish()),
    isDefault: z.lazy(() => BoolWithAggregatesFilterSchema().nullish()),
    isPublished: z.lazy(() => BoolWithAggregatesFilterSchema().nullish()),
    name: z.lazy(() => StringWithAggregatesFilterSchema().nullish()),
    type: z.lazy(() => EnumTemplateTypeWithAggregatesFilterSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeWithAggregatesFilterSchema().nullish())
  })
}

export function ProposalTemplateSumAggregateSchema(): z.ZodObject<Properties<ProposalTemplateSumAggregate>> {
  return z.object({
    __typename: z.literal('ProposalTemplateSumAggregate').optional(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function ProposalTemplateSumOrderByAggregateInputSchema(): z.ZodObject<Properties<ProposalTemplateSumOrderByAggregateInput>> {
  return z.object({
    id: SortOrderSchema.nullish()
  })
}

export function ProposalTemplateUpdateInputSchema(): z.ZodObject<Properties<ProposalTemplateUpdateInput>> {
  return z.object({
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    isDefault: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    isPublished: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    name: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    type: z.lazy(() => EnumTemplateTypeFieldUpdateOperationsInputSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    versions: z.lazy(() => ProposalTemplateVersionUpdateManyWithoutTemplateNestedInputSchema().nullish())
  })
}

export function ProposalTemplateUpdateManyMutationInputSchema(): z.ZodObject<Properties<ProposalTemplateUpdateManyMutationInput>> {
  return z.object({
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    isDefault: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    isPublished: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    name: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    type: z.lazy(() => EnumTemplateTypeFieldUpdateOperationsInputSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish())
  })
}

export function ProposalTemplateUpdateOneRequiredWithoutVersionsNestedInputSchema(): z.ZodObject<Properties<ProposalTemplateUpdateOneRequiredWithoutVersionsNestedInput>> {
  return z.object({
    connect: z.lazy(() => ProposalTemplateWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => ProposalTemplateCreateOrConnectWithoutVersionsInputSchema().nullish()),
    create: z.lazy(() => ProposalTemplateCreateWithoutVersionsInputSchema().nullish()),
    update: z.lazy(() => ProposalTemplateUpdateToOneWithWhereWithoutVersionsInputSchema().nullish()),
    upsert: z.lazy(() => ProposalTemplateUpsertWithoutVersionsInputSchema().nullish())
  })
}

export function ProposalTemplateUpdateToOneWithWhereWithoutVersionsInputSchema(): z.ZodObject<Properties<ProposalTemplateUpdateToOneWithWhereWithoutVersionsInput>> {
  return z.object({
    data: z.lazy(() => ProposalTemplateUpdateWithoutVersionsInputSchema()),
    where: z.lazy(() => ProposalTemplateWhereInputSchema().nullish())
  })
}

export function ProposalTemplateUpdateWithoutVersionsInputSchema(): z.ZodObject<Properties<ProposalTemplateUpdateWithoutVersionsInput>> {
  return z.object({
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    isDefault: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    isPublished: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    name: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    type: z.lazy(() => EnumTemplateTypeFieldUpdateOperationsInputSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish())
  })
}

export function ProposalTemplateUpsertWithoutVersionsInputSchema(): z.ZodObject<Properties<ProposalTemplateUpsertWithoutVersionsInput>> {
  return z.object({
    create: z.lazy(() => ProposalTemplateCreateWithoutVersionsInputSchema()),
    update: z.lazy(() => ProposalTemplateUpdateWithoutVersionsInputSchema()),
    where: z.lazy(() => ProposalTemplateWhereInputSchema().nullish())
  })
}

export function ProposalTemplateVersionSchema(): z.ZodObject<Properties<ProposalTemplateVersion>> {
  return z.object({
    __typename: z.literal('ProposalTemplateVersion').optional(),
    ProposalVersion: z.array(z.lazy(() => ProposalVersionSchema())),
    _count: z.lazy(() => ProposalTemplateVersionCountSchema().nullish()),
    analyticsPages: z.array(z.lazy(() => ProposalAnalyticsPageSchema())),
    createdAt: z.number(),
    createdBy: z.string().trim().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    metrics: z.record(z.string(), z.unknown()),
    pages: z.record(z.string(), z.unknown()),
    proposals: z.array(z.lazy(() => ProposalSchema())),
    settings: z.record(z.string(), z.unknown()),
    template: z.lazy(() => ProposalTemplateSchema()),
    templateId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function ProposalTemplateVersionProposalVersionArgsSchema(): z.ZodObject<Properties<ProposalTemplateVersionProposalVersionArgs>> {
  return z.object({
    cursor: z.lazy(() => ProposalVersionWhereUniqueInputSchema().nullish()),
    distinct: z.array(ProposalVersionScalarFieldEnumSchema).nullish(),
    orderBy: z.array(z.lazy(() => ProposalVersionOrderByWithRelationInputSchema())).nullish(),
    skip: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    take: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    where: z.lazy(() => ProposalVersionWhereInputSchema().nullish())
  })
}

export function ProposalTemplateVersionProposalsArgsSchema(): z.ZodObject<Properties<ProposalTemplateVersionProposalsArgs>> {
  return z.object({
    cursor: z.lazy(() => ProposalWhereUniqueInputSchema().nullish()),
    distinct: z.array(ProposalScalarFieldEnumSchema).nullish(),
    orderBy: z.array(z.lazy(() => ProposalOrderByWithRelationInputSchema())).nullish(),
    skip: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    take: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    where: z.lazy(() => ProposalWhereInputSchema().nullish())
  })
}

export function ProposalTemplateVersionCountSchema(): z.ZodObject<Properties<ProposalTemplateVersionCount>> {
  return z.object({
    __typename: z.literal('ProposalTemplateVersionCount').optional(),
    ProposalVersion: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    proposals: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function ProposalTemplateVersionCountProposalVersionArgsSchema(): z.ZodObject<Properties<ProposalTemplateVersionCountProposalVersionArgs>> {
  return z.object({
    where: z.lazy(() => ProposalVersionWhereInputSchema().nullish())
  })
}

export function ProposalTemplateVersionCountProposalsArgsSchema(): z.ZodObject<Properties<ProposalTemplateVersionCountProposalsArgs>> {
  return z.object({
    where: z.lazy(() => ProposalWhereInputSchema().nullish())
  })
}

export function ProposalTemplateVersionCreateManyTemplateInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionCreateManyTemplateInput>> {
  return z.object({
    createdAt: z.number().nullish(),
    createdBy: z.string().trim().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    metrics: z.record(z.string(), z.unknown()).nullish(),
    pages: z.record(z.string(), z.unknown()),
    settings: z.record(z.string(), z.unknown()).nullish()
  })
}

export function ProposalTemplateVersionCreateManyTemplateInputEnvelopeSchema(): z.ZodObject<Properties<ProposalTemplateVersionCreateManyTemplateInputEnvelope>> {
  return z.object({
    data: z.array(z.lazy(() => ProposalTemplateVersionCreateManyTemplateInputSchema())),
    skipDuplicates: z.boolean().nullish()
  })
}

export function ProposalTemplateVersionCreateNestedManyWithoutTemplateInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionCreateNestedManyWithoutTemplateInput>> {
  return z.object({
    connect: z.array(z.lazy(() => ProposalTemplateVersionWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => ProposalTemplateVersionCreateOrConnectWithoutTemplateInputSchema())).nullish(),
    create: z.array(z.lazy(() => ProposalTemplateVersionCreateWithoutTemplateInputSchema())).nullish(),
    createMany: z.lazy(() => ProposalTemplateVersionCreateManyTemplateInputEnvelopeSchema().nullish())
  })
}

export function ProposalTemplateVersionCreateNestedOneWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionCreateNestedOneWithoutProposalVersionInput>> {
  return z.object({
    connect: z.lazy(() => ProposalTemplateVersionWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => ProposalTemplateVersionCreateOrConnectWithoutProposalVersionInputSchema().nullish()),
    create: z.lazy(() => ProposalTemplateVersionCreateWithoutProposalVersionInputSchema().nullish())
  })
}

export function ProposalTemplateVersionCreateNestedOneWithoutProposalsInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionCreateNestedOneWithoutProposalsInput>> {
  return z.object({
    connect: z.lazy(() => ProposalTemplateVersionWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => ProposalTemplateVersionCreateOrConnectWithoutProposalsInputSchema().nullish()),
    create: z.lazy(() => ProposalTemplateVersionCreateWithoutProposalsInputSchema().nullish())
  })
}

export function ProposalTemplateVersionCreateOrConnectWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionCreateOrConnectWithoutProposalVersionInput>> {
  return z.object({
    create: z.lazy(() => ProposalTemplateVersionCreateWithoutProposalVersionInputSchema()),
    where: z.lazy(() => ProposalTemplateVersionWhereUniqueInputSchema())
  })
}

export function ProposalTemplateVersionCreateOrConnectWithoutProposalsInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionCreateOrConnectWithoutProposalsInput>> {
  return z.object({
    create: z.lazy(() => ProposalTemplateVersionCreateWithoutProposalsInputSchema()),
    where: z.lazy(() => ProposalTemplateVersionWhereUniqueInputSchema())
  })
}

export function ProposalTemplateVersionCreateOrConnectWithoutTemplateInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionCreateOrConnectWithoutTemplateInput>> {
  return z.object({
    create: z.lazy(() => ProposalTemplateVersionCreateWithoutTemplateInputSchema()),
    where: z.lazy(() => ProposalTemplateVersionWhereUniqueInputSchema())
  })
}

export function ProposalTemplateVersionCreateWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionCreateWithoutProposalVersionInput>> {
  return z.object({
    createdAt: z.number().nullish(),
    createdBy: z.string().trim().nullish(),
    metrics: z.record(z.string(), z.unknown()).nullish(),
    pages: z.record(z.string(), z.unknown()),
    proposals: z.lazy(() => ProposalCreateNestedManyWithoutTemplateVersionInputSchema().nullish()),
    settings: z.record(z.string(), z.unknown()).nullish(),
    template: z.lazy(() => ProposalTemplateCreateNestedOneWithoutVersionsInputSchema())
  })
}

export function ProposalTemplateVersionCreateWithoutProposalsInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionCreateWithoutProposalsInput>> {
  return z.object({
    ProposalVersion: z.lazy(() => ProposalVersionCreateNestedManyWithoutTemplateVersionInputSchema().nullish()),
    createdAt: z.number().nullish(),
    createdBy: z.string().trim().nullish(),
    metrics: z.record(z.string(), z.unknown()).nullish(),
    pages: z.record(z.string(), z.unknown()),
    settings: z.record(z.string(), z.unknown()).nullish(),
    template: z.lazy(() => ProposalTemplateCreateNestedOneWithoutVersionsInputSchema())
  })
}

export function ProposalTemplateVersionCreateWithoutTemplateInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionCreateWithoutTemplateInput>> {
  return z.object({
    ProposalVersion: z.lazy(() => ProposalVersionCreateNestedManyWithoutTemplateVersionInputSchema().nullish()),
    createdAt: z.number().nullish(),
    createdBy: z.string().trim().nullish(),
    metrics: z.record(z.string(), z.unknown()).nullish(),
    pages: z.record(z.string(), z.unknown()),
    proposals: z.lazy(() => ProposalCreateNestedManyWithoutTemplateVersionInputSchema().nullish()),
    settings: z.record(z.string(), z.unknown()).nullish()
  })
}

export function ProposalTemplateVersionListRelationFilterSchema(): z.ZodObject<Properties<ProposalTemplateVersionListRelationFilter>> {
  return z.object({
    every: z.lazy(() => ProposalTemplateVersionWhereInputSchema().nullish()),
    none: z.lazy(() => ProposalTemplateVersionWhereInputSchema().nullish()),
    some: z.lazy(() => ProposalTemplateVersionWhereInputSchema().nullish())
  })
}

export function ProposalTemplateVersionOrderByRelationAggregateInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionOrderByRelationAggregateInput>> {
  return z.object({
    _count: SortOrderSchema.nullish()
  })
}

export function ProposalTemplateVersionOrderByRelevanceInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionOrderByRelevanceInput>> {
  return z.object({
    fields: z.array(ProposalTemplateVersionOrderByRelevanceFieldEnumSchema),
    search: z.string().trim(),
    sort: SortOrderSchema
  })
}

export function ProposalTemplateVersionOrderByWithRelationInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionOrderByWithRelationInput>> {
  return z.object({
    ProposalVersion: z.lazy(() => ProposalVersionOrderByRelationAggregateInputSchema().nullish()),
    _relevance: z.lazy(() => ProposalTemplateVersionOrderByRelevanceInputSchema().nullish()),
    createdAt: SortOrderSchema.nullish(),
    createdBy: z.lazy(() => SortOrderInputSchema().nullish()),
    id: SortOrderSchema.nullish(),
    metrics: SortOrderSchema.nullish(),
    pages: SortOrderSchema.nullish(),
    proposals: z.lazy(() => ProposalOrderByRelationAggregateInputSchema().nullish()),
    settings: SortOrderSchema.nullish(),
    template: z.lazy(() => ProposalTemplateOrderByWithRelationInputSchema().nullish()),
    templateId: SortOrderSchema.nullish()
  })
}

export function ProposalTemplateVersionScalarRelationFilterSchema(): z.ZodObject<Properties<ProposalTemplateVersionScalarRelationFilter>> {
  return z.object({
    is: z.lazy(() => ProposalTemplateVersionWhereInputSchema().nullish()),
    isNot: z.lazy(() => ProposalTemplateVersionWhereInputSchema().nullish())
  })
}

export function ProposalTemplateVersionScalarWhereInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionScalarWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalTemplateVersionScalarWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalTemplateVersionScalarWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalTemplateVersionScalarWhereInputSchema())).nullish(),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    createdBy: z.lazy(() => StringNullableFilterSchema().nullish()),
    id: z.lazy(() => IntFilterSchema().nullish()),
    metrics: z.lazy(() => JsonFilterSchema().nullish()),
    pages: z.lazy(() => JsonFilterSchema().nullish()),
    settings: z.lazy(() => JsonFilterSchema().nullish()),
    templateId: z.lazy(() => IntFilterSchema().nullish())
  })
}

export function ProposalTemplateVersionUpdateManyMutationInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionUpdateManyMutationInput>> {
  return z.object({
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    createdBy: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish()),
    metrics: z.record(z.string(), z.unknown()).nullish(),
    pages: z.record(z.string(), z.unknown()).nullish(),
    settings: z.record(z.string(), z.unknown()).nullish()
  })
}

export function ProposalTemplateVersionUpdateManyWithWhereWithoutTemplateInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionUpdateManyWithWhereWithoutTemplateInput>> {
  return z.object({
    data: z.lazy(() => ProposalTemplateVersionUpdateManyMutationInputSchema()),
    where: z.lazy(() => ProposalTemplateVersionScalarWhereInputSchema())
  })
}

export function ProposalTemplateVersionUpdateManyWithoutTemplateNestedInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionUpdateManyWithoutTemplateNestedInput>> {
  return z.object({
    connect: z.array(z.lazy(() => ProposalTemplateVersionWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => ProposalTemplateVersionCreateOrConnectWithoutTemplateInputSchema())).nullish(),
    create: z.array(z.lazy(() => ProposalTemplateVersionCreateWithoutTemplateInputSchema())).nullish(),
    createMany: z.lazy(() => ProposalTemplateVersionCreateManyTemplateInputEnvelopeSchema().nullish()),
    delete: z.array(z.lazy(() => ProposalTemplateVersionWhereUniqueInputSchema())).nullish(),
    deleteMany: z.array(z.lazy(() => ProposalTemplateVersionScalarWhereInputSchema())).nullish(),
    disconnect: z.array(z.lazy(() => ProposalTemplateVersionWhereUniqueInputSchema())).nullish(),
    set: z.array(z.lazy(() => ProposalTemplateVersionWhereUniqueInputSchema())).nullish(),
    update: z.array(z.lazy(() => ProposalTemplateVersionUpdateWithWhereUniqueWithoutTemplateInputSchema())).nullish(),
    updateMany: z.array(z.lazy(() => ProposalTemplateVersionUpdateManyWithWhereWithoutTemplateInputSchema())).nullish(),
    upsert: z.array(z.lazy(() => ProposalTemplateVersionUpsertWithWhereUniqueWithoutTemplateInputSchema())).nullish()
  })
}

export function ProposalTemplateVersionUpdateOneRequiredWithoutProposalVersionNestedInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionUpdateOneRequiredWithoutProposalVersionNestedInput>> {
  return z.object({
    connect: z.lazy(() => ProposalTemplateVersionWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => ProposalTemplateVersionCreateOrConnectWithoutProposalVersionInputSchema().nullish()),
    create: z.lazy(() => ProposalTemplateVersionCreateWithoutProposalVersionInputSchema().nullish()),
    update: z.lazy(() => ProposalTemplateVersionUpdateToOneWithWhereWithoutProposalVersionInputSchema().nullish()),
    upsert: z.lazy(() => ProposalTemplateVersionUpsertWithoutProposalVersionInputSchema().nullish())
  })
}

export function ProposalTemplateVersionUpdateOneRequiredWithoutProposalsNestedInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionUpdateOneRequiredWithoutProposalsNestedInput>> {
  return z.object({
    connect: z.lazy(() => ProposalTemplateVersionWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => ProposalTemplateVersionCreateOrConnectWithoutProposalsInputSchema().nullish()),
    create: z.lazy(() => ProposalTemplateVersionCreateWithoutProposalsInputSchema().nullish()),
    update: z.lazy(() => ProposalTemplateVersionUpdateToOneWithWhereWithoutProposalsInputSchema().nullish()),
    upsert: z.lazy(() => ProposalTemplateVersionUpsertWithoutProposalsInputSchema().nullish())
  })
}

export function ProposalTemplateVersionUpdateToOneWithWhereWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionUpdateToOneWithWhereWithoutProposalVersionInput>> {
  return z.object({
    data: z.lazy(() => ProposalTemplateVersionUpdateWithoutProposalVersionInputSchema()),
    where: z.lazy(() => ProposalTemplateVersionWhereInputSchema().nullish())
  })
}

export function ProposalTemplateVersionUpdateToOneWithWhereWithoutProposalsInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionUpdateToOneWithWhereWithoutProposalsInput>> {
  return z.object({
    data: z.lazy(() => ProposalTemplateVersionUpdateWithoutProposalsInputSchema()),
    where: z.lazy(() => ProposalTemplateVersionWhereInputSchema().nullish())
  })
}

export function ProposalTemplateVersionUpdateWithWhereUniqueWithoutTemplateInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionUpdateWithWhereUniqueWithoutTemplateInput>> {
  return z.object({
    data: z.lazy(() => ProposalTemplateVersionUpdateWithoutTemplateInputSchema()),
    where: z.lazy(() => ProposalTemplateVersionWhereUniqueInputSchema())
  })
}

export function ProposalTemplateVersionUpdateWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionUpdateWithoutProposalVersionInput>> {
  return z.object({
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    createdBy: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish()),
    metrics: z.record(z.string(), z.unknown()).nullish(),
    pages: z.record(z.string(), z.unknown()).nullish(),
    proposals: z.lazy(() => ProposalUpdateManyWithoutTemplateVersionNestedInputSchema().nullish()),
    settings: z.record(z.string(), z.unknown()).nullish(),
    template: z.lazy(() => ProposalTemplateUpdateOneRequiredWithoutVersionsNestedInputSchema().nullish())
  })
}

export function ProposalTemplateVersionUpdateWithoutProposalsInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionUpdateWithoutProposalsInput>> {
  return z.object({
    ProposalVersion: z.lazy(() => ProposalVersionUpdateManyWithoutTemplateVersionNestedInputSchema().nullish()),
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    createdBy: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish()),
    metrics: z.record(z.string(), z.unknown()).nullish(),
    pages: z.record(z.string(), z.unknown()).nullish(),
    settings: z.record(z.string(), z.unknown()).nullish(),
    template: z.lazy(() => ProposalTemplateUpdateOneRequiredWithoutVersionsNestedInputSchema().nullish())
  })
}

export function ProposalTemplateVersionUpdateWithoutTemplateInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionUpdateWithoutTemplateInput>> {
  return z.object({
    ProposalVersion: z.lazy(() => ProposalVersionUpdateManyWithoutTemplateVersionNestedInputSchema().nullish()),
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    createdBy: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish()),
    metrics: z.record(z.string(), z.unknown()).nullish(),
    pages: z.record(z.string(), z.unknown()).nullish(),
    proposals: z.lazy(() => ProposalUpdateManyWithoutTemplateVersionNestedInputSchema().nullish()),
    settings: z.record(z.string(), z.unknown()).nullish()
  })
}

export function ProposalTemplateVersionUpsertWithWhereUniqueWithoutTemplateInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionUpsertWithWhereUniqueWithoutTemplateInput>> {
  return z.object({
    create: z.lazy(() => ProposalTemplateVersionCreateWithoutTemplateInputSchema()),
    update: z.lazy(() => ProposalTemplateVersionUpdateWithoutTemplateInputSchema()),
    where: z.lazy(() => ProposalTemplateVersionWhereUniqueInputSchema())
  })
}

export function ProposalTemplateVersionUpsertWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionUpsertWithoutProposalVersionInput>> {
  return z.object({
    create: z.lazy(() => ProposalTemplateVersionCreateWithoutProposalVersionInputSchema()),
    update: z.lazy(() => ProposalTemplateVersionUpdateWithoutProposalVersionInputSchema()),
    where: z.lazy(() => ProposalTemplateVersionWhereInputSchema().nullish())
  })
}

export function ProposalTemplateVersionUpsertWithoutProposalsInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionUpsertWithoutProposalsInput>> {
  return z.object({
    create: z.lazy(() => ProposalTemplateVersionCreateWithoutProposalsInputSchema()),
    update: z.lazy(() => ProposalTemplateVersionUpdateWithoutProposalsInputSchema()),
    where: z.lazy(() => ProposalTemplateVersionWhereInputSchema().nullish())
  })
}

export function ProposalTemplateVersionWhereInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalTemplateVersionWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalTemplateVersionWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalTemplateVersionWhereInputSchema())).nullish(),
    ProposalVersion: z.lazy(() => ProposalVersionListRelationFilterSchema().nullish()),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    createdBy: z.lazy(() => StringNullableFilterSchema().nullish()),
    id: z.lazy(() => IntFilterSchema().nullish()),
    metrics: z.lazy(() => JsonFilterSchema().nullish()),
    pages: z.lazy(() => JsonFilterSchema().nullish()),
    proposals: z.lazy(() => ProposalListRelationFilterSchema().nullish()),
    settings: z.lazy(() => JsonFilterSchema().nullish()),
    template: z.lazy(() => ProposalTemplateScalarRelationFilterSchema().nullish()),
    templateId: z.lazy(() => IntFilterSchema().nullish())
  })
}

export function ProposalTemplateVersionWhereUniqueInputSchema(): z.ZodObject<Properties<ProposalTemplateVersionWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalTemplateVersionWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalTemplateVersionWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalTemplateVersionWhereInputSchema())).nullish(),
    ProposalVersion: z.lazy(() => ProposalVersionListRelationFilterSchema().nullish()),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    createdBy: z.lazy(() => StringNullableFilterSchema().nullish()),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    metrics: z.lazy(() => JsonFilterSchema().nullish()),
    pages: z.lazy(() => JsonFilterSchema().nullish()),
    proposals: z.lazy(() => ProposalListRelationFilterSchema().nullish()),
    settings: z.lazy(() => JsonFilterSchema().nullish()),
    template: z.lazy(() => ProposalTemplateScalarRelationFilterSchema().nullish()),
    templateId: z.lazy(() => IntFilterSchema().nullish())
  })
}

export function ProposalTemplateWhereInputSchema(): z.ZodObject<Properties<ProposalTemplateWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalTemplateWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalTemplateWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalTemplateWhereInputSchema())).nullish(),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    id: z.lazy(() => IntFilterSchema().nullish()),
    isDefault: z.lazy(() => BoolFilterSchema().nullish()),
    isPublished: z.lazy(() => BoolFilterSchema().nullish()),
    name: z.lazy(() => StringFilterSchema().nullish()),
    type: z.lazy(() => EnumTemplateTypeFilterSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    versions: z.lazy(() => ProposalTemplateVersionListRelationFilterSchema().nullish())
  })
}

export function ProposalTemplateWhereUniqueInputSchema(): z.ZodObject<Properties<ProposalTemplateWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalTemplateWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalTemplateWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalTemplateWhereInputSchema())).nullish(),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    isDefault: z.lazy(() => BoolFilterSchema().nullish()),
    isPublished: z.lazy(() => BoolFilterSchema().nullish()),
    name: z.string().trim().nullish(),
    type: z.lazy(() => EnumTemplateTypeFilterSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    versions: z.lazy(() => ProposalTemplateVersionListRelationFilterSchema().nullish())
  })
}

export function ProposalUpdateInputSchema(): z.ZodObject<Properties<ProposalUpdateInput>> {
  return z.object({
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    isFinalized: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    lastEditor: z.lazy(() => ProposalLastEditorUpdateOneWithoutProposalNestedInputSchema().nullish()),
    name: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    notes: z.lazy(() => NoteUpdateManyWithoutProposalNestedInputSchema().nullish()),
    userProposalAccess: z.lazy(() => UserProposalAccessUpdateManyWithoutProposalNestedInputSchema().nullish()),
    version: z.lazy(() => ProposalVersionCreateInputSchema().nullish())
  })
}

export function ProposalUpdateManyMutationInputSchema(): z.ZodObject<Properties<ProposalUpdateManyMutationInput>> {
  return z.object({
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    createdBy: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    isFinalized: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    name: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    totalCellCount: z.lazy(() => NullableIntFieldUpdateOperationsInputSchema().nullish()),
    totalCellDataBytes: z.lazy(() => NullableBigIntFieldUpdateOperationsInputSchema().nullish()),
    type: z.lazy(() => EnumProposalTypeFieldUpdateOperationsInputSchema().nullish())
  })
}

export function ProposalUpdateManyWithWhereWithoutTemplateVersionInputSchema(): z.ZodObject<Properties<ProposalUpdateManyWithWhereWithoutTemplateVersionInput>> {
  return z.object({
    data: z.lazy(() => ProposalUpdateManyMutationInputSchema()),
    where: z.lazy(() => ProposalScalarWhereInputSchema())
  })
}

export function ProposalUpdateManyWithoutTemplateVersionNestedInputSchema(): z.ZodObject<Properties<ProposalUpdateManyWithoutTemplateVersionNestedInput>> {
  return z.object({
    connect: z.array(z.lazy(() => ProposalWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => ProposalCreateOrConnectWithoutTemplateVersionInputSchema())).nullish(),
    create: z.array(z.lazy(() => ProposalCreateWithoutTemplateVersionInputSchema())).nullish(),
    createMany: z.lazy(() => ProposalCreateManyTemplateVersionInputEnvelopeSchema().nullish()),
    delete: z.array(z.lazy(() => ProposalWhereUniqueInputSchema())).nullish(),
    deleteMany: z.array(z.lazy(() => ProposalScalarWhereInputSchema())).nullish(),
    disconnect: z.array(z.lazy(() => ProposalWhereUniqueInputSchema())).nullish(),
    set: z.array(z.lazy(() => ProposalWhereUniqueInputSchema())).nullish(),
    update: z.array(z.lazy(() => ProposalUpdateWithWhereUniqueWithoutTemplateVersionInputSchema())).nullish(),
    updateMany: z.array(z.lazy(() => ProposalUpdateManyWithWhereWithoutTemplateVersionInputSchema())).nullish(),
    upsert: z.array(z.lazy(() => ProposalUpsertWithWhereUniqueWithoutTemplateVersionInputSchema())).nullish()
  })
}

export function ProposalUpdateOneRequiredWithoutDataSourceVersionOriginNestedInputSchema(): z.ZodObject<Properties<ProposalUpdateOneRequiredWithoutDataSourceVersionOriginNestedInput>> {
  return z.object({
    connect: z.lazy(() => ProposalWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => ProposalCreateOrConnectWithoutDataSourceVersionOriginInputSchema().nullish()),
    create: z.lazy(() => ProposalCreateWithoutDataSourceVersionOriginInputSchema().nullish()),
    update: z.lazy(() => ProposalUpdateToOneWithWhereWithoutDataSourceVersionOriginInputSchema().nullish()),
    upsert: z.lazy(() => ProposalUpsertWithoutDataSourceVersionOriginInputSchema().nullish())
  })
}

export function ProposalUpdateOneRequiredWithoutNotesNestedInputSchema(): z.ZodObject<Properties<ProposalUpdateOneRequiredWithoutNotesNestedInput>> {
  return z.object({
    connect: z.lazy(() => ProposalWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => ProposalCreateOrConnectWithoutNotesInputSchema().nullish()),
    create: z.lazy(() => ProposalCreateWithoutNotesInputSchema().nullish()),
    update: z.lazy(() => ProposalUpdateToOneWithWhereWithoutNotesInputSchema().nullish()),
    upsert: z.lazy(() => ProposalUpsertWithoutNotesInputSchema().nullish())
  })
}

export function ProposalUpdateOneRequiredWithoutUserProposalAccessNestedInputSchema(): z.ZodObject<Properties<ProposalUpdateOneRequiredWithoutUserProposalAccessNestedInput>> {
  return z.object({
    connect: z.lazy(() => ProposalWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => ProposalCreateOrConnectWithoutUserProposalAccessInputSchema().nullish()),
    create: z.lazy(() => ProposalCreateWithoutUserProposalAccessInputSchema().nullish()),
    update: z.lazy(() => ProposalUpdateToOneWithWhereWithoutUserProposalAccessInputSchema().nullish()),
    upsert: z.lazy(() => ProposalUpsertWithoutUserProposalAccessInputSchema().nullish())
  })
}

export function ProposalUpdateOneRequiredWithoutVersionsNestedInputSchema(): z.ZodObject<Properties<ProposalUpdateOneRequiredWithoutVersionsNestedInput>> {
  return z.object({
    connect: z.lazy(() => ProposalWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => ProposalCreateOrConnectWithoutVersionsInputSchema().nullish()),
    create: z.lazy(() => ProposalCreateWithoutVersionsInputSchema().nullish()),
    update: z.lazy(() => ProposalUpdateToOneWithWhereWithoutVersionsInputSchema().nullish()),
    upsert: z.lazy(() => ProposalUpsertWithoutVersionsInputSchema().nullish())
  })
}

export function ProposalUpdateToOneWithWhereWithoutDataSourceVersionOriginInputSchema(): z.ZodObject<Properties<ProposalUpdateToOneWithWhereWithoutDataSourceVersionOriginInput>> {
  return z.object({
    data: z.lazy(() => ProposalUpdateWithoutDataSourceVersionOriginInputSchema()),
    where: z.lazy(() => ProposalWhereInputSchema().nullish())
  })
}

export function ProposalUpdateToOneWithWhereWithoutNotesInputSchema(): z.ZodObject<Properties<ProposalUpdateToOneWithWhereWithoutNotesInput>> {
  return z.object({
    data: z.lazy(() => ProposalUpdateWithoutNotesInputSchema()),
    where: z.lazy(() => ProposalWhereInputSchema().nullish())
  })
}

export function ProposalUpdateToOneWithWhereWithoutUserProposalAccessInputSchema(): z.ZodObject<Properties<ProposalUpdateToOneWithWhereWithoutUserProposalAccessInput>> {
  return z.object({
    data: z.lazy(() => ProposalUpdateWithoutUserProposalAccessInputSchema()),
    where: z.lazy(() => ProposalWhereInputSchema().nullish())
  })
}

export function ProposalUpdateToOneWithWhereWithoutVersionsInputSchema(): z.ZodObject<Properties<ProposalUpdateToOneWithWhereWithoutVersionsInput>> {
  return z.object({
    data: z.lazy(() => ProposalUpdateWithoutVersionsInputSchema()),
    where: z.lazy(() => ProposalWhereInputSchema().nullish())
  })
}

export function ProposalUpdateWithWhereUniqueWithoutTemplateVersionInputSchema(): z.ZodObject<Properties<ProposalUpdateWithWhereUniqueWithoutTemplateVersionInput>> {
  return z.object({
    data: z.lazy(() => ProposalUpdateWithoutTemplateVersionInputSchema()),
    where: z.lazy(() => ProposalWhereUniqueInputSchema())
  })
}

export function ProposalUpdateWithoutDataSourceVersionOriginInputSchema(): z.ZodObject<Properties<ProposalUpdateWithoutDataSourceVersionOriginInput>> {
  return z.object({
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    createdBy: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    isFinalized: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    lastEditor: z.lazy(() => ProposalLastEditorUpdateOneWithoutProposalNestedInputSchema().nullish()),
    name: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    notes: z.lazy(() => NoteUpdateManyWithoutProposalNestedInputSchema().nullish()),
    templateVersion: z.lazy(() => ProposalTemplateVersionUpdateOneRequiredWithoutProposalsNestedInputSchema().nullish()),
    totalCellCount: z.lazy(() => NullableIntFieldUpdateOperationsInputSchema().nullish()),
    totalCellDataBytes: z.lazy(() => NullableBigIntFieldUpdateOperationsInputSchema().nullish()),
    type: z.lazy(() => EnumProposalTypeFieldUpdateOperationsInputSchema().nullish()),
    userProposalAccess: z.lazy(() => UserProposalAccessUpdateManyWithoutProposalNestedInputSchema().nullish()),
    userProposalPins: z.lazy(() => UserProposalPinUpdateManyWithoutProposalNestedInputSchema().nullish()),
    versions: z.lazy(() => ProposalVersionUpdateManyWithoutProposalNestedInputSchema().nullish())
  })
}

export function ProposalUpdateWithoutNotesInputSchema(): z.ZodObject<Properties<ProposalUpdateWithoutNotesInput>> {
  return z.object({
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    createdBy: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    isFinalized: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    lastEditor: z.lazy(() => ProposalLastEditorUpdateOneWithoutProposalNestedInputSchema().nullish()),
    name: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    templateVersion: z.lazy(() => ProposalTemplateVersionUpdateOneRequiredWithoutProposalsNestedInputSchema().nullish()),
    totalCellCount: z.lazy(() => NullableIntFieldUpdateOperationsInputSchema().nullish()),
    totalCellDataBytes: z.lazy(() => NullableBigIntFieldUpdateOperationsInputSchema().nullish()),
    type: z.lazy(() => EnumProposalTypeFieldUpdateOperationsInputSchema().nullish()),
    userProposalAccess: z.lazy(() => UserProposalAccessUpdateManyWithoutProposalNestedInputSchema().nullish()),
    userProposalPins: z.lazy(() => UserProposalPinUpdateManyWithoutProposalNestedInputSchema().nullish()),
    versions: z.lazy(() => ProposalVersionUpdateManyWithoutProposalNestedInputSchema().nullish())
  })
}

export function ProposalUpdateWithoutTemplateVersionInputSchema(): z.ZodObject<Properties<ProposalUpdateWithoutTemplateVersionInput>> {
  return z.object({
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    createdBy: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    isFinalized: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    lastEditor: z.lazy(() => ProposalLastEditorUpdateOneWithoutProposalNestedInputSchema().nullish()),
    name: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    notes: z.lazy(() => NoteUpdateManyWithoutProposalNestedInputSchema().nullish()),
    totalCellCount: z.lazy(() => NullableIntFieldUpdateOperationsInputSchema().nullish()),
    totalCellDataBytes: z.lazy(() => NullableBigIntFieldUpdateOperationsInputSchema().nullish()),
    type: z.lazy(() => EnumProposalTypeFieldUpdateOperationsInputSchema().nullish()),
    userProposalAccess: z.lazy(() => UserProposalAccessUpdateManyWithoutProposalNestedInputSchema().nullish()),
    userProposalPins: z.lazy(() => UserProposalPinUpdateManyWithoutProposalNestedInputSchema().nullish()),
    versions: z.lazy(() => ProposalVersionUpdateManyWithoutProposalNestedInputSchema().nullish())
  })
}

export function ProposalUpdateWithoutUserProposalAccessInputSchema(): z.ZodObject<Properties<ProposalUpdateWithoutUserProposalAccessInput>> {
  return z.object({
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    createdBy: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    isFinalized: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    lastEditor: z.lazy(() => ProposalLastEditorUpdateOneWithoutProposalNestedInputSchema().nullish()),
    name: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    notes: z.lazy(() => NoteUpdateManyWithoutProposalNestedInputSchema().nullish()),
    templateVersion: z.lazy(() => ProposalTemplateVersionUpdateOneRequiredWithoutProposalsNestedInputSchema().nullish()),
    totalCellCount: z.lazy(() => NullableIntFieldUpdateOperationsInputSchema().nullish()),
    totalCellDataBytes: z.lazy(() => NullableBigIntFieldUpdateOperationsInputSchema().nullish()),
    type: z.lazy(() => EnumProposalTypeFieldUpdateOperationsInputSchema().nullish()),
    userProposalPins: z.lazy(() => UserProposalPinUpdateManyWithoutProposalNestedInputSchema().nullish()),
    versions: z.lazy(() => ProposalVersionUpdateManyWithoutProposalNestedInputSchema().nullish())
  })
}

export function ProposalUpdateWithoutVersionsInputSchema(): z.ZodObject<Properties<ProposalUpdateWithoutVersionsInput>> {
  return z.object({
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    createdBy: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    isFinalized: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    lastEditor: z.lazy(() => ProposalLastEditorUpdateOneWithoutProposalNestedInputSchema().nullish()),
    name: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    notes: z.lazy(() => NoteUpdateManyWithoutProposalNestedInputSchema().nullish()),
    templateVersion: z.lazy(() => ProposalTemplateVersionUpdateOneRequiredWithoutProposalsNestedInputSchema().nullish()),
    totalCellCount: z.lazy(() => NullableIntFieldUpdateOperationsInputSchema().nullish()),
    totalCellDataBytes: z.lazy(() => NullableBigIntFieldUpdateOperationsInputSchema().nullish()),
    type: z.lazy(() => EnumProposalTypeFieldUpdateOperationsInputSchema().nullish()),
    userProposalAccess: z.lazy(() => UserProposalAccessUpdateManyWithoutProposalNestedInputSchema().nullish()),
    userProposalPins: z.lazy(() => UserProposalPinUpdateManyWithoutProposalNestedInputSchema().nullish())
  })
}

export function ProposalUpsertWithWhereUniqueWithoutTemplateVersionInputSchema(): z.ZodObject<Properties<ProposalUpsertWithWhereUniqueWithoutTemplateVersionInput>> {
  return z.object({
    create: z.lazy(() => ProposalCreateWithoutTemplateVersionInputSchema()),
    update: z.lazy(() => ProposalUpdateWithoutTemplateVersionInputSchema()),
    where: z.lazy(() => ProposalWhereUniqueInputSchema())
  })
}

export function ProposalUpsertWithoutDataSourceVersionOriginInputSchema(): z.ZodObject<Properties<ProposalUpsertWithoutDataSourceVersionOriginInput>> {
  return z.object({
    create: z.lazy(() => ProposalCreateWithoutDataSourceVersionOriginInputSchema()),
    update: z.lazy(() => ProposalUpdateWithoutDataSourceVersionOriginInputSchema()),
    where: z.lazy(() => ProposalWhereInputSchema().nullish())
  })
}

export function ProposalUpsertWithoutNotesInputSchema(): z.ZodObject<Properties<ProposalUpsertWithoutNotesInput>> {
  return z.object({
    create: z.lazy(() => ProposalCreateWithoutNotesInputSchema()),
    update: z.lazy(() => ProposalUpdateWithoutNotesInputSchema()),
    where: z.lazy(() => ProposalWhereInputSchema().nullish())
  })
}

export function ProposalUpsertWithoutUserProposalAccessInputSchema(): z.ZodObject<Properties<ProposalUpsertWithoutUserProposalAccessInput>> {
  return z.object({
    create: z.lazy(() => ProposalCreateWithoutUserProposalAccessInputSchema()),
    update: z.lazy(() => ProposalUpdateWithoutUserProposalAccessInputSchema()),
    where: z.lazy(() => ProposalWhereInputSchema().nullish())
  })
}

export function ProposalUpsertWithoutVersionsInputSchema(): z.ZodObject<Properties<ProposalUpsertWithoutVersionsInput>> {
  return z.object({
    create: z.lazy(() => ProposalCreateWithoutVersionsInputSchema()),
    update: z.lazy(() => ProposalUpdateWithoutVersionsInputSchema()),
    where: z.lazy(() => ProposalWhereInputSchema().nullish())
  })
}

export function ProposalVersionSchema(): z.ZodObject<Properties<ProposalVersion>> {
  return z.object({
    __typename: z.literal('ProposalVersion').optional(),
    _count: z.lazy(() => ProposalVersionCountSchema().nullish()),
    cells: z.array(z.lazy(() => ProposalCellSchema())),
    comment: z.string().trim().nullish(),
    createdAt: z.number(),
    createdBy: z.string().trim(),
    data: z.record(z.string(), z.unknown()).nullish(),
    dataSchemaVersion: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    dataSourceUsedAt: z.number().nullish(),
    dataSourceVersions: z.array(z.lazy(() => ProposalVersionDataSourceSchema())),
    extractedPages: z.record(z.string(), z.unknown()),
    fields: z.array(z.lazy(() => ProposalFieldSchema())),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    initialJsonHash: z.string().trim(),
    initialJsonSizeBytes: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    isSharedWithClient: z.boolean(),
    jsonSizeBytes: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    metrics: z.array(z.lazy(() => ProposalMetricSchema())),
    pageRowIndex: z.array(z.lazy(() => ProposalPageRowIndexSchema())),
    proposal: z.lazy(() => ProposalSchema()),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    sequentialNumber: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    templateVersion: z.lazy(() => ProposalTemplateVersionSchema()),
    templateVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function ProposalVersionCellsArgsSchema(): z.ZodObject<Properties<ProposalVersionCellsArgs>> {
  return z.object({
    cursor: z.lazy(() => ProposalCellWhereUniqueInputSchema().nullish()),
    distinct: z.array(ProposalCellScalarFieldEnumSchema).nullish(),
    orderBy: z.array(z.lazy(() => ProposalCellOrderByWithRelationInputSchema())).nullish(),
    skip: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    take: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    where: z.lazy(() => ProposalCellWhereInputSchema().nullish())
  })
}

export function ProposalVersionDataSourceVersionsArgsSchema(): z.ZodObject<Properties<ProposalVersionDataSourceVersionsArgs>> {
  return z.object({
    cursor: z.lazy(() => ProposalVersionDataSourceWhereUniqueInputSchema().nullish()),
    distinct: z.array(ProposalVersionDataSourceScalarFieldEnumSchema).nullish(),
    orderBy: z.array(z.lazy(() => ProposalVersionDataSourceOrderByWithRelationInputSchema())).nullish(),
    skip: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    take: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    where: z.lazy(() => ProposalVersionDataSourceWhereInputSchema().nullish())
  })
}

export function ProposalVersionFieldsArgsSchema(): z.ZodObject<Properties<ProposalVersionFieldsArgs>> {
  return z.object({
    cursor: z.lazy(() => ProposalFieldWhereUniqueInputSchema().nullish()),
    distinct: z.array(ProposalFieldScalarFieldEnumSchema).nullish(),
    orderBy: z.array(z.lazy(() => ProposalFieldOrderByWithRelationInputSchema())).nullish(),
    skip: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    take: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    where: z.lazy(() => ProposalFieldWhereInputSchema().nullish())
  })
}

export function ProposalVersionMetricsArgsSchema(): z.ZodObject<Properties<ProposalVersionMetricsArgs>> {
  return z.object({
    cursor: z.lazy(() => ProposalMetricWhereUniqueInputSchema().nullish()),
    distinct: z.array(ProposalMetricScalarFieldEnumSchema).nullish(),
    orderBy: z.array(z.lazy(() => ProposalMetricOrderByWithRelationInputSchema())).nullish(),
    skip: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    take: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    where: z.lazy(() => ProposalMetricWhereInputSchema().nullish())
  })
}

export function ProposalVersionPageRowIndexArgsSchema(): z.ZodObject<Properties<ProposalVersionPageRowIndexArgs>> {
  return z.object({
    cursor: z.lazy(() => ProposalPageRowIndexWhereUniqueInputSchema().nullish()),
    distinct: z.array(ProposalPageRowIndexScalarFieldEnumSchema).nullish(),
    orderBy: z.array(z.lazy(() => ProposalPageRowIndexOrderByWithRelationInputSchema())).nullish(),
    skip: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    take: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    where: z.lazy(() => ProposalPageRowIndexWhereInputSchema().nullish())
  })
}

export function ProposalVersionCountSchema(): z.ZodObject<Properties<ProposalVersionCount>> {
  return z.object({
    __typename: z.literal('ProposalVersionCount').optional(),
    cells: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    dataSourceVersions: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    fields: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    metrics: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    pageRowIndex: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function ProposalVersionCountCellsArgsSchema(): z.ZodObject<Properties<ProposalVersionCountCellsArgs>> {
  return z.object({
    where: z.lazy(() => ProposalCellWhereInputSchema().nullish())
  })
}

export function ProposalVersionCountDataSourceVersionsArgsSchema(): z.ZodObject<Properties<ProposalVersionCountDataSourceVersionsArgs>> {
  return z.object({
    where: z.lazy(() => ProposalVersionDataSourceWhereInputSchema().nullish())
  })
}

export function ProposalVersionCountFieldsArgsSchema(): z.ZodObject<Properties<ProposalVersionCountFieldsArgs>> {
  return z.object({
    where: z.lazy(() => ProposalFieldWhereInputSchema().nullish())
  })
}

export function ProposalVersionCountMetricsArgsSchema(): z.ZodObject<Properties<ProposalVersionCountMetricsArgs>> {
  return z.object({
    where: z.lazy(() => ProposalMetricWhereInputSchema().nullish())
  })
}

export function ProposalVersionCountPageRowIndexArgsSchema(): z.ZodObject<Properties<ProposalVersionCountPageRowIndexArgs>> {
  return z.object({
    where: z.lazy(() => ProposalPageRowIndexWhereInputSchema().nullish())
  })
}

export function ProposalVersionCreateInputSchema(): z.ZodObject<Properties<ProposalVersionCreateInput>> {
  return z.object({
    comment: z.string().trim().nullish(),
    data: z.record(z.string(), z.unknown()),
    dataSourceUsedAt: z.number().nullish(),
    dataSourceVersionIds: z.array(z.number()).nullish(),
    fields: z.lazy(() => ProposalFieldCreateNestedManyWithoutProposalVersionInputSchema().nullish()),
    isSharedWithClient: z.boolean().nullish(),
    metrics: z.lazy(() => ProposalMetricCreateNestedManyWithoutProposalVersionInputSchema().nullish()),
    templateVersionId: z.number()
  })
}

export function ProposalVersionCreateManyProposalInputSchema(): z.ZodObject<Properties<ProposalVersionCreateManyProposalInput>> {
  return z.object({
    comment: z.string().trim().nullish(),
    createdAt: z.number().nullish(),
    createdBy: z.string().trim(),
    dataSchemaVersion: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    dataSourceUsedAt: z.number().nullish(),
    extractedPages: z.record(z.string(), z.unknown()).nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    initialJsonHash: z.string().trim().nullish(),
    initialJsonSizeBytes: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    isSharedWithClient: z.boolean().nullish(),
    jsonSizeBytes: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    sequentialNumber: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    templateVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function ProposalVersionCreateManyProposalInputEnvelopeSchema(): z.ZodObject<Properties<ProposalVersionCreateManyProposalInputEnvelope>> {
  return z.object({
    data: z.array(z.lazy(() => ProposalVersionCreateManyProposalInputSchema())),
    skipDuplicates: z.boolean().nullish()
  })
}

export function ProposalVersionCreateManyTemplateVersionInputSchema(): z.ZodObject<Properties<ProposalVersionCreateManyTemplateVersionInput>> {
  return z.object({
    comment: z.string().trim().nullish(),
    createdAt: z.number().nullish(),
    createdBy: z.string().trim(),
    dataSchemaVersion: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    dataSourceUsedAt: z.number().nullish(),
    extractedPages: z.record(z.string(), z.unknown()).nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    initialJsonHash: z.string().trim().nullish(),
    initialJsonSizeBytes: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    isSharedWithClient: z.boolean().nullish(),
    jsonSizeBytes: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    sequentialNumber: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function ProposalVersionCreateManyTemplateVersionInputEnvelopeSchema(): z.ZodObject<Properties<ProposalVersionCreateManyTemplateVersionInputEnvelope>> {
  return z.object({
    data: z.array(z.lazy(() => ProposalVersionCreateManyTemplateVersionInputSchema())),
    skipDuplicates: z.boolean().nullish()
  })
}

export function ProposalVersionCreateNestedManyWithoutProposalInputSchema(): z.ZodObject<Properties<ProposalVersionCreateNestedManyWithoutProposalInput>> {
  return z.object({
    connect: z.array(z.lazy(() => ProposalVersionWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => ProposalVersionCreateOrConnectWithoutProposalInputSchema())).nullish(),
    create: z.array(z.lazy(() => ProposalVersionCreateWithoutProposalInputSchema())).nullish(),
    createMany: z.lazy(() => ProposalVersionCreateManyProposalInputEnvelopeSchema().nullish())
  })
}

export function ProposalVersionCreateNestedManyWithoutTemplateVersionInputSchema(): z.ZodObject<Properties<ProposalVersionCreateNestedManyWithoutTemplateVersionInput>> {
  return z.object({
    connect: z.array(z.lazy(() => ProposalVersionWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => ProposalVersionCreateOrConnectWithoutTemplateVersionInputSchema())).nullish(),
    create: z.array(z.lazy(() => ProposalVersionCreateWithoutTemplateVersionInputSchema())).nullish(),
    createMany: z.lazy(() => ProposalVersionCreateManyTemplateVersionInputEnvelopeSchema().nullish())
  })
}

export function ProposalVersionCreateOrConnectWithoutProposalInputSchema(): z.ZodObject<Properties<ProposalVersionCreateOrConnectWithoutProposalInput>> {
  return z.object({
    create: z.lazy(() => ProposalVersionCreateWithoutProposalInputSchema()),
    where: z.lazy(() => ProposalVersionWhereUniqueInputSchema())
  })
}

export function ProposalVersionCreateOrConnectWithoutTemplateVersionInputSchema(): z.ZodObject<Properties<ProposalVersionCreateOrConnectWithoutTemplateVersionInput>> {
  return z.object({
    create: z.lazy(() => ProposalVersionCreateWithoutTemplateVersionInputSchema()),
    where: z.lazy(() => ProposalVersionWhereUniqueInputSchema())
  })
}

export function ProposalVersionCreateWithoutProposalInputSchema(): z.ZodObject<Properties<ProposalVersionCreateWithoutProposalInput>> {
  return z.object({
    cells: z.lazy(() => ProposalCellCreateNestedManyWithoutLastVersionInputSchema().nullish()),
    comment: z.string().trim().nullish(),
    createdAt: z.number().nullish(),
    createdBy: z.string().trim(),
    data: z.lazy(() => ProposalVersionDataCreateNestedOneWithoutProposalVersionInputSchema().nullish()),
    dataSchemaVersion: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    dataSourceUsedAt: z.number().nullish(),
    extractedPages: z.record(z.string(), z.unknown()).nullish(),
    fields: z.lazy(() => ProposalFieldCreateNestedManyWithoutProposalVersionInputSchema().nullish()),
    initialJsonHash: z.string().trim().nullish(),
    initialJsonSizeBytes: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    isSharedWithClient: z.boolean().nullish(),
    jsonSizeBytes: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    metrics: z.lazy(() => ProposalMetricCreateNestedManyWithoutProposalVersionInputSchema().nullish()),
    pageRowIndex: z.lazy(() => ProposalPageRowIndexCreateNestedManyWithoutVersionInputSchema().nullish()),
    sequentialNumber: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    templateVersion: z.lazy(() => ProposalTemplateVersionCreateNestedOneWithoutProposalVersionInputSchema())
  })
}

export function ProposalVersionCreateWithoutTemplateVersionInputSchema(): z.ZodObject<Properties<ProposalVersionCreateWithoutTemplateVersionInput>> {
  return z.object({
    cells: z.lazy(() => ProposalCellCreateNestedManyWithoutLastVersionInputSchema().nullish()),
    comment: z.string().trim().nullish(),
    createdAt: z.number().nullish(),
    createdBy: z.string().trim(),
    data: z.lazy(() => ProposalVersionDataCreateNestedOneWithoutProposalVersionInputSchema().nullish()),
    dataSchemaVersion: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    dataSourceUsedAt: z.number().nullish(),
    extractedPages: z.record(z.string(), z.unknown()).nullish(),
    fields: z.lazy(() => ProposalFieldCreateNestedManyWithoutProposalVersionInputSchema().nullish()),
    initialJsonHash: z.string().trim().nullish(),
    initialJsonSizeBytes: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    isSharedWithClient: z.boolean().nullish(),
    jsonSizeBytes: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    metrics: z.lazy(() => ProposalMetricCreateNestedManyWithoutProposalVersionInputSchema().nullish()),
    pageRowIndex: z.lazy(() => ProposalPageRowIndexCreateNestedManyWithoutVersionInputSchema().nullish()),
    proposal: z.lazy(() => ProposalCreateNestedOneWithoutVersionsInputSchema()),
    sequentialNumber: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function ProposalVersionDataCreateNestedOneWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalVersionDataCreateNestedOneWithoutProposalVersionInput>> {
  return z.object({
    connect: z.lazy(() => ProposalVersionDataWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => ProposalVersionDataCreateOrConnectWithoutProposalVersionInputSchema().nullish()),
    create: z.lazy(() => ProposalVersionDataCreateWithoutProposalVersionInputSchema().nullish())
  })
}

export function ProposalVersionDataCreateOrConnectWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalVersionDataCreateOrConnectWithoutProposalVersionInput>> {
  return z.object({
    create: z.lazy(() => ProposalVersionDataCreateWithoutProposalVersionInputSchema()),
    where: z.lazy(() => ProposalVersionDataWhereUniqueInputSchema())
  })
}

export function ProposalVersionDataCreateWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalVersionDataCreateWithoutProposalVersionInput>> {
  return z.object({
    data: z.record(z.string(), z.unknown())
  })
}

export function ProposalVersionDataNullableScalarRelationFilterSchema(): z.ZodObject<Properties<ProposalVersionDataNullableScalarRelationFilter>> {
  return z.object({
    is: z.lazy(() => ProposalVersionDataWhereInputSchema().nullish()),
    isNot: z.lazy(() => ProposalVersionDataWhereInputSchema().nullish())
  })
}

export function ProposalVersionDataOrderByWithRelationInputSchema(): z.ZodObject<Properties<ProposalVersionDataOrderByWithRelationInput>> {
  return z.object({
    data: SortOrderSchema.nullish(),
    proposalVersion: z.lazy(() => ProposalVersionOrderByWithRelationInputSchema().nullish()),
    proposalVersionId: SortOrderSchema.nullish()
  })
}

export function ProposalVersionDataSourceSchema(): z.ZodObject<Properties<ProposalVersionDataSource>> {
  return z.object({
    __typename: z.literal('ProposalVersionDataSource').optional(),
    createdAt: z.number(),
    dataSourceVersion: z.lazy(() => DataSourceVersionSchema()),
    dataSourceVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    proposalVersion: z.lazy(() => ProposalVersionSchema()),
    proposalVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function ProposalVersionDataSourceOrderByWithRelationInputSchema(): z.ZodObject<Properties<ProposalVersionDataSourceOrderByWithRelationInput>> {
  return z.object({
    createdAt: SortOrderSchema.nullish(),
    dataSourceVersion: z.lazy(() => DataSourceVersionOrderByWithRelationInputSchema().nullish()),
    dataSourceVersionId: SortOrderSchema.nullish(),
    proposalVersion: z.lazy(() => ProposalVersionOrderByWithRelationInputSchema().nullish()),
    proposalVersionId: SortOrderSchema.nullish()
  })
}

export function ProposalVersionDataSourceProposalVersionIdDataSourceVersionIdCompoundUniqueInputSchema(): z.ZodObject<Properties<ProposalVersionDataSourceProposalVersionIdDataSourceVersionIdCompoundUniqueInput>> {
  return z.object({
    dataSourceVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    proposalVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function ProposalVersionDataSourceWhereInputSchema(): z.ZodObject<Properties<ProposalVersionDataSourceWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalVersionDataSourceWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalVersionDataSourceWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalVersionDataSourceWhereInputSchema())).nullish(),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    dataSourceVersion: z.lazy(() => DataSourceVersionScalarRelationFilterSchema().nullish()),
    dataSourceVersionId: z.lazy(() => IntFilterSchema().nullish()),
    proposalVersion: z.lazy(() => ProposalVersionScalarRelationFilterSchema().nullish()),
    proposalVersionId: z.lazy(() => IntFilterSchema().nullish())
  })
}

export function ProposalVersionDataSourceWhereUniqueInputSchema(): z.ZodObject<Properties<ProposalVersionDataSourceWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalVersionDataSourceWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalVersionDataSourceWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalVersionDataSourceWhereInputSchema())).nullish(),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    dataSourceVersion: z.lazy(() => DataSourceVersionScalarRelationFilterSchema().nullish()),
    dataSourceVersionId: z.lazy(() => IntFilterSchema().nullish()),
    proposalVersion: z.lazy(() => ProposalVersionScalarRelationFilterSchema().nullish()),
    proposalVersionId: z.lazy(() => IntFilterSchema().nullish()),
    proposalVersionId_dataSourceVersionId: z.lazy(() => ProposalVersionDataSourceProposalVersionIdDataSourceVersionIdCompoundUniqueInputSchema().nullish())
  })
}

export function ProposalVersionDataUpdateOneWithoutProposalVersionNestedInputSchema(): z.ZodObject<Properties<ProposalVersionDataUpdateOneWithoutProposalVersionNestedInput>> {
  return z.object({
    connect: z.lazy(() => ProposalVersionDataWhereUniqueInputSchema().nullish()),
    connectOrCreate: z.lazy(() => ProposalVersionDataCreateOrConnectWithoutProposalVersionInputSchema().nullish()),
    create: z.lazy(() => ProposalVersionDataCreateWithoutProposalVersionInputSchema().nullish()),
    delete: z.lazy(() => ProposalVersionDataWhereInputSchema().nullish()),
    disconnect: z.lazy(() => ProposalVersionDataWhereInputSchema().nullish()),
    update: z.lazy(() => ProposalVersionDataUpdateToOneWithWhereWithoutProposalVersionInputSchema().nullish()),
    upsert: z.lazy(() => ProposalVersionDataUpsertWithoutProposalVersionInputSchema().nullish())
  })
}

export function ProposalVersionDataUpdateToOneWithWhereWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalVersionDataUpdateToOneWithWhereWithoutProposalVersionInput>> {
  return z.object({
    data: z.lazy(() => ProposalVersionDataUpdateWithoutProposalVersionInputSchema()),
    where: z.lazy(() => ProposalVersionDataWhereInputSchema().nullish())
  })
}

export function ProposalVersionDataUpdateWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalVersionDataUpdateWithoutProposalVersionInput>> {
  return z.object({
    data: z.record(z.string(), z.unknown()).nullish()
  })
}

export function ProposalVersionDataUpsertWithoutProposalVersionInputSchema(): z.ZodObject<Properties<ProposalVersionDataUpsertWithoutProposalVersionInput>> {
  return z.object({
    create: z.lazy(() => ProposalVersionDataCreateWithoutProposalVersionInputSchema()),
    update: z.lazy(() => ProposalVersionDataUpdateWithoutProposalVersionInputSchema()),
    where: z.lazy(() => ProposalVersionDataWhereInputSchema().nullish())
  })
}

export function ProposalVersionDataWhereInputSchema(): z.ZodObject<Properties<ProposalVersionDataWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalVersionDataWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalVersionDataWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalVersionDataWhereInputSchema())).nullish(),
    data: z.lazy(() => JsonFilterSchema().nullish()),
    proposalVersion: z.lazy(() => ProposalVersionScalarRelationFilterSchema().nullish()),
    proposalVersionId: z.lazy(() => IntFilterSchema().nullish())
  })
}

export function ProposalVersionDataWhereUniqueInputSchema(): z.ZodObject<Properties<ProposalVersionDataWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalVersionDataWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalVersionDataWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalVersionDataWhereInputSchema())).nullish(),
    data: z.lazy(() => JsonFilterSchema().nullish()),
    proposalVersion: z.lazy(() => ProposalVersionScalarRelationFilterSchema().nullish()),
    proposalVersionId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function ProposalVersionListRelationFilterSchema(): z.ZodObject<Properties<ProposalVersionListRelationFilter>> {
  return z.object({
    every: z.lazy(() => ProposalVersionWhereInputSchema().nullish()),
    none: z.lazy(() => ProposalVersionWhereInputSchema().nullish()),
    some: z.lazy(() => ProposalVersionWhereInputSchema().nullish())
  })
}

export function ProposalVersionNullableScalarRelationFilterSchema(): z.ZodObject<Properties<ProposalVersionNullableScalarRelationFilter>> {
  return z.object({
    is: z.lazy(() => ProposalVersionWhereInputSchema().nullish()),
    isNot: z.lazy(() => ProposalVersionWhereInputSchema().nullish())
  })
}

export function ProposalVersionOrderByRelationAggregateInputSchema(): z.ZodObject<Properties<ProposalVersionOrderByRelationAggregateInput>> {
  return z.object({
    _count: SortOrderSchema.nullish()
  })
}

export function ProposalVersionOrderByRelevanceInputSchema(): z.ZodObject<Properties<ProposalVersionOrderByRelevanceInput>> {
  return z.object({
    fields: z.array(ProposalVersionOrderByRelevanceFieldEnumSchema),
    search: z.string().trim(),
    sort: SortOrderSchema
  })
}

export function ProposalVersionOrderByWithRelationInputSchema(): z.ZodObject<Properties<ProposalVersionOrderByWithRelationInput>> {
  return z.object({
    _relevance: z.lazy(() => ProposalVersionOrderByRelevanceInputSchema().nullish()),
    cells: z.lazy(() => ProposalCellOrderByRelationAggregateInputSchema().nullish()),
    comment: z.lazy(() => SortOrderInputSchema().nullish()),
    createdAt: SortOrderSchema.nullish(),
    createdBy: SortOrderSchema.nullish(),
    data: z.lazy(() => ProposalVersionDataOrderByWithRelationInputSchema().nullish()),
    dataSchemaVersion: SortOrderSchema.nullish(),
    dataSourceUsedAt: z.lazy(() => SortOrderInputSchema().nullish()),
    extractedPages: SortOrderSchema.nullish(),
    fields: z.lazy(() => ProposalFieldOrderByRelationAggregateInputSchema().nullish()),
    id: SortOrderSchema.nullish(),
    initialJsonHash: SortOrderSchema.nullish(),
    initialJsonSizeBytes: z.lazy(() => SortOrderInputSchema().nullish()),
    isSharedWithClient: SortOrderSchema.nullish(),
    jsonSizeBytes: z.lazy(() => SortOrderInputSchema().nullish()),
    metrics: z.lazy(() => ProposalMetricOrderByRelationAggregateInputSchema().nullish()),
    pageRowIndex: z.lazy(() => ProposalPageRowIndexOrderByRelationAggregateInputSchema().nullish()),
    proposal: z.lazy(() => ProposalOrderByWithRelationInputSchema().nullish()),
    proposalId: SortOrderSchema.nullish(),
    sequentialNumber: SortOrderSchema.nullish(),
    templateVersion: z.lazy(() => ProposalTemplateVersionOrderByWithRelationInputSchema().nullish()),
    templateVersionId: SortOrderSchema.nullish()
  })
}

export function ProposalVersionScalarRelationFilterSchema(): z.ZodObject<Properties<ProposalVersionScalarRelationFilter>> {
  return z.object({
    is: z.lazy(() => ProposalVersionWhereInputSchema().nullish()),
    isNot: z.lazy(() => ProposalVersionWhereInputSchema().nullish())
  })
}

export function ProposalVersionScalarWhereInputSchema(): z.ZodObject<Properties<ProposalVersionScalarWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalVersionScalarWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalVersionScalarWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalVersionScalarWhereInputSchema())).nullish(),
    comment: z.lazy(() => StringNullableFilterSchema().nullish()),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    createdBy: z.lazy(() => StringFilterSchema().nullish()),
    dataSchemaVersion: z.lazy(() => IntFilterSchema().nullish()),
    dataSourceUsedAt: z.lazy(() => DateTimeNullableFilterSchema().nullish()),
    extractedPages: z.lazy(() => JsonFilterSchema().nullish()),
    id: z.lazy(() => IntFilterSchema().nullish()),
    initialJsonHash: z.lazy(() => StringFilterSchema().nullish()),
    initialJsonSizeBytes: z.lazy(() => IntNullableFilterSchema().nullish()),
    isSharedWithClient: z.lazy(() => BoolFilterSchema().nullish()),
    jsonSizeBytes: z.lazy(() => IntNullableFilterSchema().nullish()),
    proposalId: z.lazy(() => IntFilterSchema().nullish()),
    sequentialNumber: z.lazy(() => IntFilterSchema().nullish()),
    templateVersionId: z.lazy(() => IntFilterSchema().nullish())
  })
}

export function ProposalVersionUpdateManyMutationInputSchema(): z.ZodObject<Properties<ProposalVersionUpdateManyMutationInput>> {
  return z.object({
    comment: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish()),
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    createdBy: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    dataSchemaVersion: z.lazy(() => IntFieldUpdateOperationsInputSchema().nullish()),
    dataSourceUsedAt: z.lazy(() => NullableDateTimeFieldUpdateOperationsInputSchema().nullish()),
    extractedPages: z.record(z.string(), z.unknown()).nullish(),
    initialJsonHash: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    initialJsonSizeBytes: z.lazy(() => NullableIntFieldUpdateOperationsInputSchema().nullish()),
    isSharedWithClient: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    jsonSizeBytes: z.lazy(() => NullableIntFieldUpdateOperationsInputSchema().nullish()),
    sequentialNumber: z.lazy(() => IntFieldUpdateOperationsInputSchema().nullish())
  })
}

export function ProposalVersionUpdateManyWithWhereWithoutProposalInputSchema(): z.ZodObject<Properties<ProposalVersionUpdateManyWithWhereWithoutProposalInput>> {
  return z.object({
    data: z.lazy(() => ProposalVersionUpdateManyMutationInputSchema()),
    where: z.lazy(() => ProposalVersionScalarWhereInputSchema())
  })
}

export function ProposalVersionUpdateManyWithWhereWithoutTemplateVersionInputSchema(): z.ZodObject<Properties<ProposalVersionUpdateManyWithWhereWithoutTemplateVersionInput>> {
  return z.object({
    data: z.lazy(() => ProposalVersionUpdateManyMutationInputSchema()),
    where: z.lazy(() => ProposalVersionScalarWhereInputSchema())
  })
}

export function ProposalVersionUpdateManyWithoutProposalNestedInputSchema(): z.ZodObject<Properties<ProposalVersionUpdateManyWithoutProposalNestedInput>> {
  return z.object({
    connect: z.array(z.lazy(() => ProposalVersionWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => ProposalVersionCreateOrConnectWithoutProposalInputSchema())).nullish(),
    create: z.array(z.lazy(() => ProposalVersionCreateWithoutProposalInputSchema())).nullish(),
    createMany: z.lazy(() => ProposalVersionCreateManyProposalInputEnvelopeSchema().nullish()),
    delete: z.array(z.lazy(() => ProposalVersionWhereUniqueInputSchema())).nullish(),
    deleteMany: z.array(z.lazy(() => ProposalVersionScalarWhereInputSchema())).nullish(),
    disconnect: z.array(z.lazy(() => ProposalVersionWhereUniqueInputSchema())).nullish(),
    set: z.array(z.lazy(() => ProposalVersionWhereUniqueInputSchema())).nullish(),
    update: z.array(z.lazy(() => ProposalVersionUpdateWithWhereUniqueWithoutProposalInputSchema())).nullish(),
    updateMany: z.array(z.lazy(() => ProposalVersionUpdateManyWithWhereWithoutProposalInputSchema())).nullish(),
    upsert: z.array(z.lazy(() => ProposalVersionUpsertWithWhereUniqueWithoutProposalInputSchema())).nullish()
  })
}

export function ProposalVersionUpdateManyWithoutTemplateVersionNestedInputSchema(): z.ZodObject<Properties<ProposalVersionUpdateManyWithoutTemplateVersionNestedInput>> {
  return z.object({
    connect: z.array(z.lazy(() => ProposalVersionWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => ProposalVersionCreateOrConnectWithoutTemplateVersionInputSchema())).nullish(),
    create: z.array(z.lazy(() => ProposalVersionCreateWithoutTemplateVersionInputSchema())).nullish(),
    createMany: z.lazy(() => ProposalVersionCreateManyTemplateVersionInputEnvelopeSchema().nullish()),
    delete: z.array(z.lazy(() => ProposalVersionWhereUniqueInputSchema())).nullish(),
    deleteMany: z.array(z.lazy(() => ProposalVersionScalarWhereInputSchema())).nullish(),
    disconnect: z.array(z.lazy(() => ProposalVersionWhereUniqueInputSchema())).nullish(),
    set: z.array(z.lazy(() => ProposalVersionWhereUniqueInputSchema())).nullish(),
    update: z.array(z.lazy(() => ProposalVersionUpdateWithWhereUniqueWithoutTemplateVersionInputSchema())).nullish(),
    updateMany: z.array(z.lazy(() => ProposalVersionUpdateManyWithWhereWithoutTemplateVersionInputSchema())).nullish(),
    upsert: z.array(z.lazy(() => ProposalVersionUpsertWithWhereUniqueWithoutTemplateVersionInputSchema())).nullish()
  })
}

export function ProposalVersionUpdateWithWhereUniqueWithoutProposalInputSchema(): z.ZodObject<Properties<ProposalVersionUpdateWithWhereUniqueWithoutProposalInput>> {
  return z.object({
    data: z.lazy(() => ProposalVersionUpdateWithoutProposalInputSchema()),
    where: z.lazy(() => ProposalVersionWhereUniqueInputSchema())
  })
}

export function ProposalVersionUpdateWithWhereUniqueWithoutTemplateVersionInputSchema(): z.ZodObject<Properties<ProposalVersionUpdateWithWhereUniqueWithoutTemplateVersionInput>> {
  return z.object({
    data: z.lazy(() => ProposalVersionUpdateWithoutTemplateVersionInputSchema()),
    where: z.lazy(() => ProposalVersionWhereUniqueInputSchema())
  })
}

export function ProposalVersionUpdateWithoutProposalInputSchema(): z.ZodObject<Properties<ProposalVersionUpdateWithoutProposalInput>> {
  return z.object({
    cells: z.lazy(() => ProposalCellUpdateManyWithoutLastVersionNestedInputSchema().nullish()),
    comment: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish()),
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    createdBy: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    data: z.lazy(() => ProposalVersionDataUpdateOneWithoutProposalVersionNestedInputSchema().nullish()),
    dataSchemaVersion: z.lazy(() => IntFieldUpdateOperationsInputSchema().nullish()),
    dataSourceUsedAt: z.lazy(() => NullableDateTimeFieldUpdateOperationsInputSchema().nullish()),
    extractedPages: z.record(z.string(), z.unknown()).nullish(),
    fields: z.lazy(() => ProposalFieldUpdateManyWithoutProposalVersionNestedInputSchema().nullish()),
    initialJsonHash: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    initialJsonSizeBytes: z.lazy(() => NullableIntFieldUpdateOperationsInputSchema().nullish()),
    isSharedWithClient: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    jsonSizeBytes: z.lazy(() => NullableIntFieldUpdateOperationsInputSchema().nullish()),
    metrics: z.lazy(() => ProposalMetricUpdateManyWithoutProposalVersionNestedInputSchema().nullish()),
    pageRowIndex: z.lazy(() => ProposalPageRowIndexUpdateManyWithoutVersionNestedInputSchema().nullish()),
    sequentialNumber: z.lazy(() => IntFieldUpdateOperationsInputSchema().nullish()),
    templateVersion: z.lazy(() => ProposalTemplateVersionUpdateOneRequiredWithoutProposalVersionNestedInputSchema().nullish())
  })
}

export function ProposalVersionUpdateWithoutTemplateVersionInputSchema(): z.ZodObject<Properties<ProposalVersionUpdateWithoutTemplateVersionInput>> {
  return z.object({
    cells: z.lazy(() => ProposalCellUpdateManyWithoutLastVersionNestedInputSchema().nullish()),
    comment: z.lazy(() => NullableStringFieldUpdateOperationsInputSchema().nullish()),
    createdAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    createdBy: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    data: z.lazy(() => ProposalVersionDataUpdateOneWithoutProposalVersionNestedInputSchema().nullish()),
    dataSchemaVersion: z.lazy(() => IntFieldUpdateOperationsInputSchema().nullish()),
    dataSourceUsedAt: z.lazy(() => NullableDateTimeFieldUpdateOperationsInputSchema().nullish()),
    extractedPages: z.record(z.string(), z.unknown()).nullish(),
    fields: z.lazy(() => ProposalFieldUpdateManyWithoutProposalVersionNestedInputSchema().nullish()),
    initialJsonHash: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish()),
    initialJsonSizeBytes: z.lazy(() => NullableIntFieldUpdateOperationsInputSchema().nullish()),
    isSharedWithClient: z.lazy(() => BoolFieldUpdateOperationsInputSchema().nullish()),
    jsonSizeBytes: z.lazy(() => NullableIntFieldUpdateOperationsInputSchema().nullish()),
    metrics: z.lazy(() => ProposalMetricUpdateManyWithoutProposalVersionNestedInputSchema().nullish()),
    pageRowIndex: z.lazy(() => ProposalPageRowIndexUpdateManyWithoutVersionNestedInputSchema().nullish()),
    proposal: z.lazy(() => ProposalUpdateOneRequiredWithoutVersionsNestedInputSchema().nullish()),
    sequentialNumber: z.lazy(() => IntFieldUpdateOperationsInputSchema().nullish())
  })
}

export function ProposalVersionUpsertWithWhereUniqueWithoutProposalInputSchema(): z.ZodObject<Properties<ProposalVersionUpsertWithWhereUniqueWithoutProposalInput>> {
  return z.object({
    create: z.lazy(() => ProposalVersionCreateWithoutProposalInputSchema()),
    update: z.lazy(() => ProposalVersionUpdateWithoutProposalInputSchema()),
    where: z.lazy(() => ProposalVersionWhereUniqueInputSchema())
  })
}

export function ProposalVersionUpsertWithWhereUniqueWithoutTemplateVersionInputSchema(): z.ZodObject<Properties<ProposalVersionUpsertWithWhereUniqueWithoutTemplateVersionInput>> {
  return z.object({
    create: z.lazy(() => ProposalVersionCreateWithoutTemplateVersionInputSchema()),
    update: z.lazy(() => ProposalVersionUpdateWithoutTemplateVersionInputSchema()),
    where: z.lazy(() => ProposalVersionWhereUniqueInputSchema())
  })
}

export function ProposalVersionWhereInputSchema(): z.ZodObject<Properties<ProposalVersionWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalVersionWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalVersionWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalVersionWhereInputSchema())).nullish(),
    cells: z.lazy(() => ProposalCellListRelationFilterSchema().nullish()),
    comment: z.lazy(() => StringNullableFilterSchema().nullish()),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    createdBy: z.lazy(() => StringFilterSchema().nullish()),
    data: z.lazy(() => ProposalVersionDataNullableScalarRelationFilterSchema().nullish()),
    dataSchemaVersion: z.lazy(() => IntFilterSchema().nullish()),
    dataSourceUsedAt: z.lazy(() => DateTimeNullableFilterSchema().nullish()),
    extractedPages: z.lazy(() => JsonFilterSchema().nullish()),
    fields: z.lazy(() => ProposalFieldListRelationFilterSchema().nullish()),
    id: z.lazy(() => IntFilterSchema().nullish()),
    initialJsonHash: z.lazy(() => StringFilterSchema().nullish()),
    initialJsonSizeBytes: z.lazy(() => IntNullableFilterSchema().nullish()),
    isSharedWithClient: z.lazy(() => BoolFilterSchema().nullish()),
    jsonSizeBytes: z.lazy(() => IntNullableFilterSchema().nullish()),
    metrics: z.lazy(() => ProposalMetricListRelationFilterSchema().nullish()),
    pageRowIndex: z.lazy(() => ProposalPageRowIndexListRelationFilterSchema().nullish()),
    proposal: z.lazy(() => ProposalScalarRelationFilterSchema().nullish()),
    proposalId: z.lazy(() => IntFilterSchema().nullish()),
    sequentialNumber: z.lazy(() => IntFilterSchema().nullish()),
    templateVersion: z.lazy(() => ProposalTemplateVersionScalarRelationFilterSchema().nullish()),
    templateVersionId: z.lazy(() => IntFilterSchema().nullish())
  })
}

export function ProposalVersionWhereUniqueInputSchema(): z.ZodObject<Properties<ProposalVersionWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalVersionWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalVersionWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalVersionWhereInputSchema())).nullish(),
    cells: z.lazy(() => ProposalCellListRelationFilterSchema().nullish()),
    comment: z.lazy(() => StringNullableFilterSchema().nullish()),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    createdBy: z.lazy(() => StringFilterSchema().nullish()),
    data: z.lazy(() => ProposalVersionDataNullableScalarRelationFilterSchema().nullish()),
    dataSchemaVersion: z.lazy(() => IntFilterSchema().nullish()),
    dataSourceUsedAt: z.lazy(() => DateTimeNullableFilterSchema().nullish()),
    extractedPages: z.lazy(() => JsonFilterSchema().nullish()),
    fields: z.lazy(() => ProposalFieldListRelationFilterSchema().nullish()),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    initialJsonHash: z.lazy(() => StringFilterSchema().nullish()),
    initialJsonSizeBytes: z.lazy(() => IntNullableFilterSchema().nullish()),
    isSharedWithClient: z.lazy(() => BoolFilterSchema().nullish()),
    jsonSizeBytes: z.lazy(() => IntNullableFilterSchema().nullish()),
    metrics: z.lazy(() => ProposalMetricListRelationFilterSchema().nullish()),
    pageRowIndex: z.lazy(() => ProposalPageRowIndexListRelationFilterSchema().nullish()),
    proposal: z.lazy(() => ProposalScalarRelationFilterSchema().nullish()),
    proposalId: z.lazy(() => IntFilterSchema().nullish()),
    sequentialNumber: z.lazy(() => IntFilterSchema().nullish()),
    templateVersion: z.lazy(() => ProposalTemplateVersionScalarRelationFilterSchema().nullish()),
    templateVersionId: z.lazy(() => IntFilterSchema().nullish())
  })
}

export function ProposalWhereInputSchema(): z.ZodObject<Properties<ProposalWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalWhereInputSchema())).nullish(),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    createdBy: z.lazy(() => StringFilterSchema().nullish()),
    id: z.lazy(() => IntFilterSchema().nullish()),
    isFinalized: z.lazy(() => BoolFilterSchema().nullish()),
    lastEditor: z.lazy(() => ProposalLastEditorNullableScalarRelationFilterSchema().nullish()),
    name: z.lazy(() => StringFilterSchema().nullish()),
    notes: z.lazy(() => NoteListRelationFilterSchema().nullish()),
    templateVersion: z.lazy(() => ProposalTemplateVersionScalarRelationFilterSchema().nullish()),
    templateVersionId: z.lazy(() => IntFilterSchema().nullish()),
    totalCellCount: z.lazy(() => IntNullableFilterSchema().nullish()),
    totalCellDataBytes: z.lazy(() => BigIntNullableFilterSchema().nullish()),
    type: z.lazy(() => EnumProposalTypeFilterSchema().nullish()),
    userProposalAccess: z.lazy(() => UserProposalAccessListRelationFilterSchema().nullish()),
    userProposalPins: z.lazy(() => UserProposalPinListRelationFilterSchema().nullish()),
    versions: z.lazy(() => ProposalVersionListRelationFilterSchema().nullish())
  })
}

export function ProposalWhereUniqueInputSchema(): z.ZodObject<Properties<ProposalWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => ProposalWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => ProposalWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => ProposalWhereInputSchema())).nullish(),
    createdAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    createdBy: z.lazy(() => StringFilterSchema().nullish()),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    isFinalized: z.lazy(() => BoolFilterSchema().nullish()),
    lastEditor: z.lazy(() => ProposalLastEditorNullableScalarRelationFilterSchema().nullish()),
    name: z.lazy(() => StringFilterSchema().nullish()),
    notes: z.lazy(() => NoteListRelationFilterSchema().nullish()),
    templateVersion: z.lazy(() => ProposalTemplateVersionScalarRelationFilterSchema().nullish()),
    templateVersionId: z.lazy(() => IntFilterSchema().nullish()),
    totalCellCount: z.lazy(() => IntNullableFilterSchema().nullish()),
    totalCellDataBytes: z.lazy(() => BigIntNullableFilterSchema().nullish()),
    type: z.lazy(() => EnumProposalTypeFilterSchema().nullish()),
    userProposalAccess: z.lazy(() => UserProposalAccessListRelationFilterSchema().nullish()),
    userProposalPins: z.lazy(() => UserProposalPinListRelationFilterSchema().nullish()),
    versions: z.lazy(() => ProposalVersionListRelationFilterSchema().nullish())
  })
}

export function ProposalWithPageIdsSchema(): z.ZodObject<Properties<ProposalWithPageIds>> {
  return z.object({
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    pageIds: z.array(z.string().trim()),
    version: z.lazy(() => IdIntSchema())
  })
}

export function ProposalsFilterSchema(): z.ZodObject<Properties<ProposalsFilter>> {
  return z.object({
    items: z.array(z.lazy(() => ProposalsFilterItemSchema())),
    logicalOperator: LogicalOperatorSchema
  })
}

export function ProposalsFilterItemSchema(): z.ZodObject<Properties<ProposalsFilterItem>> {
  return z.object({
    field: z.string().trim(),
    operator: z.string().trim(),
    value: z.string().trim(),
    values: z.array(z.string().trim())
  })
}

export function ProposalsPaginatedSchema(): z.ZodObject<Properties<ProposalsPaginated>> {
  return z.object({
    __typename: z.literal('ProposalsPaginated').optional(),
    count: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    items: z.array(z.lazy(() => ProposalListItemSchema()))
  })
}

export function ProposalsSortItemSchema(): z.ZodObject<Properties<ProposalsSortItem>> {
  return z.object({
    field: z.string().trim(),
    sort: SortOrderSchema.nullish()
  })
}

export function PublicConfigSchema(): z.ZodObject<Properties<PublicConfig>> {
  return z.object({
    __typename: z.literal('PublicConfig').optional(),
    cdnHost: z.string().trim(),
    cdnMediaUploadEndpoint: z.string().trim(),
    clickhouseConfigured: z.boolean(),
    features: z.lazy(() => FeaturesSchema())
  })
}

export function RespSchema(): z.ZodObject<Properties<Resp>> {
  return z.object({
    __typename: z.literal('Resp').optional(),
    data: z.record(z.string(), z.unknown())
  })
}

export function SortOrderInputSchema(): z.ZodObject<Properties<SortOrderInput>> {
  return z.object({
    nulls: NullsOrderSchema.nullish(),
    sort: SortOrderSchema
  })
}

export function StringFieldUpdateOperationsInputSchema(): z.ZodObject<Properties<StringFieldUpdateOperationsInput>> {
  return z.object({
    set: z.string().trim().nullish()
  })
}

export function StringFilterSchema(): z.ZodObject<Properties<StringFilter>> {
  return z.object({
    contains: z.string().trim().nullish(),
    endsWith: z.string().trim().nullish(),
    equals: z.string().trim().nullish(),
    gt: z.string().trim().nullish(),
    gte: z.string().trim().nullish(),
    in: z.array(z.string().trim()).nullish(),
    lt: z.string().trim().nullish(),
    lte: z.string().trim().nullish(),
    not: z.lazy(() => NestedStringFilterSchema().nullish()),
    notIn: z.array(z.string().trim()).nullish(),
    search: z.string().trim().nullish(),
    startsWith: z.string().trim().nullish()
  })
}

export function StringNullableFilterSchema(): z.ZodObject<Properties<StringNullableFilter>> {
  return z.object({
    contains: z.string().trim().nullish(),
    endsWith: z.string().trim().nullish(),
    equals: z.string().trim().nullish(),
    gt: z.string().trim().nullish(),
    gte: z.string().trim().nullish(),
    in: z.array(z.string().trim()).nullish(),
    lt: z.string().trim().nullish(),
    lte: z.string().trim().nullish(),
    not: z.lazy(() => NestedStringNullableFilterSchema().nullish()),
    notIn: z.array(z.string().trim()).nullish(),
    search: z.string().trim().nullish(),
    startsWith: z.string().trim().nullish()
  })
}

export function StringNullableWithAggregatesFilterSchema(): z.ZodObject<Properties<StringNullableWithAggregatesFilter>> {
  return z.object({
    _count: z.lazy(() => NestedIntNullableFilterSchema().nullish()),
    _max: z.lazy(() => NestedStringNullableFilterSchema().nullish()),
    _min: z.lazy(() => NestedStringNullableFilterSchema().nullish()),
    contains: z.string().trim().nullish(),
    endsWith: z.string().trim().nullish(),
    equals: z.string().trim().nullish(),
    gt: z.string().trim().nullish(),
    gte: z.string().trim().nullish(),
    in: z.array(z.string().trim()).nullish(),
    lt: z.string().trim().nullish(),
    lte: z.string().trim().nullish(),
    not: z.lazy(() => NestedStringNullableWithAggregatesFilterSchema().nullish()),
    notIn: z.array(z.string().trim()).nullish(),
    search: z.string().trim().nullish(),
    startsWith: z.string().trim().nullish()
  })
}

export function StringWithAggregatesFilterSchema(): z.ZodObject<Properties<StringWithAggregatesFilter>> {
  return z.object({
    _count: z.lazy(() => NestedIntFilterSchema().nullish()),
    _max: z.lazy(() => NestedStringFilterSchema().nullish()),
    _min: z.lazy(() => NestedStringFilterSchema().nullish()),
    contains: z.string().trim().nullish(),
    endsWith: z.string().trim().nullish(),
    equals: z.string().trim().nullish(),
    gt: z.string().trim().nullish(),
    gte: z.string().trim().nullish(),
    in: z.array(z.string().trim()).nullish(),
    lt: z.string().trim().nullish(),
    lte: z.string().trim().nullish(),
    not: z.lazy(() => NestedStringWithAggregatesFilterSchema().nullish()),
    notIn: z.array(z.string().trim()).nullish(),
    search: z.string().trim().nullish(),
    startsWith: z.string().trim().nullish()
  })
}

export function SyncUserActivityInputSchema(): z.ZodObject<Properties<SyncUserActivityInput>> {
  return z.object({
    syncEmail: z.boolean().nullish(),
    syncLogin: z.boolean().nullish()
  })
}

export function TemplateCreateInputSchema(): z.ZodObject<Properties<TemplateCreateInput>> {
  return z.object({
    createdBy: z.string().trim().nullish(),
    isDefault: z.boolean().nullish(),
    metrics: z.record(z.string(), z.unknown()),
    name: z.string().trim().nullish(),
    pages: z.record(z.string(), z.unknown()),
    settings: z.record(z.string(), z.unknown()),
    type: TemplateTypeSchema.nullish()
  })
}

export function TemplateUpdateInputSchema(): z.ZodObject<Properties<TemplateUpdateInput>> {
  return z.object({
    createdBy: z.string().trim().nullish(),
    id: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    isDefault: z.boolean().nullish(),
    metrics: z.record(z.string(), z.unknown()),
    name: z.string().trim().nullish(),
    pages: z.record(z.string(), z.unknown()),
    settings: z.record(z.string(), z.unknown())
  })
}

export function ThemeInfoRepresentationSchema(): z.ZodObject<Properties<ThemeInfoRepresentation>> {
  return z.object({
    __typename: z.literal('ThemeInfoRepresentation').optional(),
    locales: z.array(z.string().trim()).nullish(),
    name: z.string().trim()
  })
}

export function UserActivityRowSchema(): z.ZodObject<Properties<UserActivityRow>> {
  return z.object({
    __typename: z.literal('UserActivityRow').optional(),
    activity_time_seconds: z.number(),
    email: z.string().trim(),
    insight_update: z.number(),
    logins: z.number(),
    proposal_create: z.number(),
    proposal_update: z.number(),
    proposal_update_unique: z.number()
  })
}

export function UserConsentRepresentationSchema(): z.ZodObject<Properties<UserConsentRepresentation>> {
  return z.object({
    __typename: z.literal('UserConsentRepresentation').optional(),
    clientId: z.string().trim().nullish(),
    createDate: z.string().trim().nullish(),
    grantedClientScopes: z.array(z.string().trim()).nullish(),
    lastUpdatedDate: z.number().nullish()
  })
}

export function UserCreateInputSchema(): z.ZodObject<Properties<UserCreateInput>> {
  return z.object({
    email: z.string().trim(),
    firstName: z.string().trim(),
    keycloakGroupId: z.string().trim().nullish(),
    lastName: z.string().trim(),
    role: RoleSchema.nullish()
  })
}

export function UserFacingErrorSchema(): z.ZodObject<Properties<UserFacingError>> {
  return z.object({
    __typename: z.literal('UserFacingError').optional(),
    code: UserFacingErrorCodeSchema
  })
}

export function UserLoginAuditEventInputSchema(): z.ZodObject<Properties<UserLoginAuditEventInput>> {
  return z.object({
    _: z.boolean().nullish()
  })
}

export function UserLogoutAuditEventInputSchema(): z.ZodObject<Properties<UserLogoutAuditEventInput>> {
  return z.object({
    _: z.boolean().nullish()
  })
}

export function UserProposalAccessSchema(): z.ZodObject<Properties<UserProposalAccess>> {
  return z.object({
    __typename: z.literal('UserProposalAccess').optional(),
    proposal: z.lazy(() => ProposalSchema()),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    updatedAt: z.number(),
    userEmail: z.string().trim()
  })
}

export function UserProposalAccessAvgAggregateSchema(): z.ZodObject<Properties<UserProposalAccessAvgAggregate>> {
  return z.object({
    __typename: z.literal('UserProposalAccessAvgAggregate').optional(),
    proposalId: z.number().nullish()
  })
}

export function UserProposalAccessAvgOrderByAggregateInputSchema(): z.ZodObject<Properties<UserProposalAccessAvgOrderByAggregateInput>> {
  return z.object({
    proposalId: SortOrderSchema.nullish()
  })
}

export function UserProposalAccessCountAggregateSchema(): z.ZodObject<Properties<UserProposalAccessCountAggregate>> {
  return z.object({
    __typename: z.literal('UserProposalAccessCountAggregate').optional(),
    _all: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    updatedAt: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    userEmail: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647)
  })
}

export function UserProposalAccessCountOrderByAggregateInputSchema(): z.ZodObject<Properties<UserProposalAccessCountOrderByAggregateInput>> {
  return z.object({
    proposalId: SortOrderSchema.nullish(),
    updatedAt: SortOrderSchema.nullish(),
    userEmail: SortOrderSchema.nullish()
  })
}

export function UserProposalAccessCreateInputSchema(): z.ZodObject<Properties<UserProposalAccessCreateInput>> {
  return z.object({
    proposal: z.lazy(() => ProposalCreateNestedOneWithoutUserProposalAccessInputSchema()),
    updatedAt: z.number().nullish(),
    userEmail: z.string().trim()
  })
}

export function UserProposalAccessCreateManyInputSchema(): z.ZodObject<Properties<UserProposalAccessCreateManyInput>> {
  return z.object({
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    updatedAt: z.number().nullish(),
    userEmail: z.string().trim()
  })
}

export function UserProposalAccessCreateManyProposalInputSchema(): z.ZodObject<Properties<UserProposalAccessCreateManyProposalInput>> {
  return z.object({
    updatedAt: z.number().nullish(),
    userEmail: z.string().trim()
  })
}

export function UserProposalAccessCreateManyProposalInputEnvelopeSchema(): z.ZodObject<Properties<UserProposalAccessCreateManyProposalInputEnvelope>> {
  return z.object({
    data: z.array(z.lazy(() => UserProposalAccessCreateManyProposalInputSchema())),
    skipDuplicates: z.boolean().nullish()
  })
}

export function UserProposalAccessCreateNestedManyWithoutProposalInputSchema(): z.ZodObject<Properties<UserProposalAccessCreateNestedManyWithoutProposalInput>> {
  return z.object({
    connect: z.array(z.lazy(() => UserProposalAccessWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => UserProposalAccessCreateOrConnectWithoutProposalInputSchema())).nullish(),
    create: z.array(z.lazy(() => UserProposalAccessCreateWithoutProposalInputSchema())).nullish(),
    createMany: z.lazy(() => UserProposalAccessCreateManyProposalInputEnvelopeSchema().nullish())
  })
}

export function UserProposalAccessCreateOrConnectWithoutProposalInputSchema(): z.ZodObject<Properties<UserProposalAccessCreateOrConnectWithoutProposalInput>> {
  return z.object({
    create: z.lazy(() => UserProposalAccessCreateWithoutProposalInputSchema()),
    where: z.lazy(() => UserProposalAccessWhereUniqueInputSchema())
  })
}

export function UserProposalAccessCreateWithoutProposalInputSchema(): z.ZodObject<Properties<UserProposalAccessCreateWithoutProposalInput>> {
  return z.object({
    updatedAt: z.number().nullish(),
    userEmail: z.string().trim()
  })
}

export function UserProposalAccessGroupBySchema(): z.ZodObject<Properties<UserProposalAccessGroupBy>> {
  return z.object({
    __typename: z.literal('UserProposalAccessGroupBy').optional(),
    _avg: z.lazy(() => UserProposalAccessAvgAggregateSchema().nullish()),
    _count: z.lazy(() => UserProposalAccessCountAggregateSchema().nullish()),
    _max: z.lazy(() => UserProposalAccessMaxAggregateSchema().nullish()),
    _min: z.lazy(() => UserProposalAccessMinAggregateSchema().nullish()),
    _sum: z.lazy(() => UserProposalAccessSumAggregateSchema().nullish()),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    updatedAt: z.number(),
    userEmail: z.string().trim()
  })
}

export function UserProposalAccessListRelationFilterSchema(): z.ZodObject<Properties<UserProposalAccessListRelationFilter>> {
  return z.object({
    every: z.lazy(() => UserProposalAccessWhereInputSchema().nullish()),
    none: z.lazy(() => UserProposalAccessWhereInputSchema().nullish()),
    some: z.lazy(() => UserProposalAccessWhereInputSchema().nullish())
  })
}

export function UserProposalAccessMaxAggregateSchema(): z.ZodObject<Properties<UserProposalAccessMaxAggregate>> {
  return z.object({
    __typename: z.literal('UserProposalAccessMaxAggregate').optional(),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    updatedAt: z.number().nullish(),
    userEmail: z.string().trim().nullish()
  })
}

export function UserProposalAccessMaxOrderByAggregateInputSchema(): z.ZodObject<Properties<UserProposalAccessMaxOrderByAggregateInput>> {
  return z.object({
    proposalId: SortOrderSchema.nullish(),
    updatedAt: SortOrderSchema.nullish(),
    userEmail: SortOrderSchema.nullish()
  })
}

export function UserProposalAccessMinAggregateSchema(): z.ZodObject<Properties<UserProposalAccessMinAggregate>> {
  return z.object({
    __typename: z.literal('UserProposalAccessMinAggregate').optional(),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish(),
    updatedAt: z.number().nullish(),
    userEmail: z.string().trim().nullish()
  })
}

export function UserProposalAccessMinOrderByAggregateInputSchema(): z.ZodObject<Properties<UserProposalAccessMinOrderByAggregateInput>> {
  return z.object({
    proposalId: SortOrderSchema.nullish(),
    updatedAt: SortOrderSchema.nullish(),
    userEmail: SortOrderSchema.nullish()
  })
}

export function UserProposalAccessOrderByRelationAggregateInputSchema(): z.ZodObject<Properties<UserProposalAccessOrderByRelationAggregateInput>> {
  return z.object({
    _count: SortOrderSchema.nullish()
  })
}

export function UserProposalAccessOrderByRelevanceInputSchema(): z.ZodObject<Properties<UserProposalAccessOrderByRelevanceInput>> {
  return z.object({
    fields: z.array(UserProposalAccessOrderByRelevanceFieldEnumSchema),
    search: z.string().trim(),
    sort: SortOrderSchema
  })
}

export function UserProposalAccessOrderByWithAggregationInputSchema(): z.ZodObject<Properties<UserProposalAccessOrderByWithAggregationInput>> {
  return z.object({
    _avg: z.lazy(() => UserProposalAccessAvgOrderByAggregateInputSchema().nullish()),
    _count: z.lazy(() => UserProposalAccessCountOrderByAggregateInputSchema().nullish()),
    _max: z.lazy(() => UserProposalAccessMaxOrderByAggregateInputSchema().nullish()),
    _min: z.lazy(() => UserProposalAccessMinOrderByAggregateInputSchema().nullish()),
    _sum: z.lazy(() => UserProposalAccessSumOrderByAggregateInputSchema().nullish()),
    proposalId: SortOrderSchema.nullish(),
    updatedAt: SortOrderSchema.nullish(),
    userEmail: SortOrderSchema.nullish()
  })
}

export function UserProposalAccessOrderByWithRelationInputSchema(): z.ZodObject<Properties<UserProposalAccessOrderByWithRelationInput>> {
  return z.object({
    _relevance: z.lazy(() => UserProposalAccessOrderByRelevanceInputSchema().nullish()),
    proposal: z.lazy(() => ProposalOrderByWithRelationInputSchema().nullish()),
    proposalId: SortOrderSchema.nullish(),
    updatedAt: SortOrderSchema.nullish(),
    userEmail: SortOrderSchema.nullish()
  })
}

export function UserProposalAccessScalarWhereInputSchema(): z.ZodObject<Properties<UserProposalAccessScalarWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => UserProposalAccessScalarWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => UserProposalAccessScalarWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => UserProposalAccessScalarWhereInputSchema())).nullish(),
    proposalId: z.lazy(() => IntFilterSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    userEmail: z.lazy(() => StringFilterSchema().nullish())
  })
}

export function UserProposalAccessScalarWhereWithAggregatesInputSchema(): z.ZodObject<Properties<UserProposalAccessScalarWhereWithAggregatesInput>> {
  return z.object({
    AND: z.array(z.lazy(() => UserProposalAccessScalarWhereWithAggregatesInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => UserProposalAccessScalarWhereWithAggregatesInputSchema())).nullish(),
    OR: z.array(z.lazy(() => UserProposalAccessScalarWhereWithAggregatesInputSchema())).nullish(),
    proposalId: z.lazy(() => IntWithAggregatesFilterSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeWithAggregatesFilterSchema().nullish()),
    userEmail: z.lazy(() => StringWithAggregatesFilterSchema().nullish())
  })
}

export function UserProposalAccessSumAggregateSchema(): z.ZodObject<Properties<UserProposalAccessSumAggregate>> {
  return z.object({
    __typename: z.literal('UserProposalAccessSumAggregate').optional(),
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647).nullish()
  })
}

export function UserProposalAccessSumOrderByAggregateInputSchema(): z.ZodObject<Properties<UserProposalAccessSumOrderByAggregateInput>> {
  return z.object({
    proposalId: SortOrderSchema.nullish()
  })
}

export function UserProposalAccessUpdateInputSchema(): z.ZodObject<Properties<UserProposalAccessUpdateInput>> {
  return z.object({
    proposal: z.lazy(() => ProposalUpdateOneRequiredWithoutUserProposalAccessNestedInputSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    userEmail: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish())
  })
}

export function UserProposalAccessUpdateManyMutationInputSchema(): z.ZodObject<Properties<UserProposalAccessUpdateManyMutationInput>> {
  return z.object({
    updatedAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    userEmail: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish())
  })
}

export function UserProposalAccessUpdateManyWithWhereWithoutProposalInputSchema(): z.ZodObject<Properties<UserProposalAccessUpdateManyWithWhereWithoutProposalInput>> {
  return z.object({
    data: z.lazy(() => UserProposalAccessUpdateManyMutationInputSchema()),
    where: z.lazy(() => UserProposalAccessScalarWhereInputSchema())
  })
}

export function UserProposalAccessUpdateManyWithoutProposalNestedInputSchema(): z.ZodObject<Properties<UserProposalAccessUpdateManyWithoutProposalNestedInput>> {
  return z.object({
    connect: z.array(z.lazy(() => UserProposalAccessWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => UserProposalAccessCreateOrConnectWithoutProposalInputSchema())).nullish(),
    create: z.array(z.lazy(() => UserProposalAccessCreateWithoutProposalInputSchema())).nullish(),
    createMany: z.lazy(() => UserProposalAccessCreateManyProposalInputEnvelopeSchema().nullish()),
    delete: z.array(z.lazy(() => UserProposalAccessWhereUniqueInputSchema())).nullish(),
    deleteMany: z.array(z.lazy(() => UserProposalAccessScalarWhereInputSchema())).nullish(),
    disconnect: z.array(z.lazy(() => UserProposalAccessWhereUniqueInputSchema())).nullish(),
    set: z.array(z.lazy(() => UserProposalAccessWhereUniqueInputSchema())).nullish(),
    update: z.array(z.lazy(() => UserProposalAccessUpdateWithWhereUniqueWithoutProposalInputSchema())).nullish(),
    updateMany: z.array(z.lazy(() => UserProposalAccessUpdateManyWithWhereWithoutProposalInputSchema())).nullish(),
    upsert: z.array(z.lazy(() => UserProposalAccessUpsertWithWhereUniqueWithoutProposalInputSchema())).nullish()
  })
}

export function UserProposalAccessUpdateWithWhereUniqueWithoutProposalInputSchema(): z.ZodObject<Properties<UserProposalAccessUpdateWithWhereUniqueWithoutProposalInput>> {
  return z.object({
    data: z.lazy(() => UserProposalAccessUpdateWithoutProposalInputSchema()),
    where: z.lazy(() => UserProposalAccessWhereUniqueInputSchema())
  })
}

export function UserProposalAccessUpdateWithoutProposalInputSchema(): z.ZodObject<Properties<UserProposalAccessUpdateWithoutProposalInput>> {
  return z.object({
    updatedAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    userEmail: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish())
  })
}

export function UserProposalAccessUpsertWithWhereUniqueWithoutProposalInputSchema(): z.ZodObject<Properties<UserProposalAccessUpsertWithWhereUniqueWithoutProposalInput>> {
  return z.object({
    create: z.lazy(() => UserProposalAccessCreateWithoutProposalInputSchema()),
    update: z.lazy(() => UserProposalAccessUpdateWithoutProposalInputSchema()),
    where: z.lazy(() => UserProposalAccessWhereUniqueInputSchema())
  })
}

export function UserProposalAccessUserEmailProposalIdCompoundUniqueInputSchema(): z.ZodObject<Properties<UserProposalAccessUserEmailProposalIdCompoundUniqueInput>> {
  return z.object({
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    userEmail: z.string().trim()
  })
}

export function UserProposalAccessWhereInputSchema(): z.ZodObject<Properties<UserProposalAccessWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => UserProposalAccessWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => UserProposalAccessWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => UserProposalAccessWhereInputSchema())).nullish(),
    proposal: z.lazy(() => ProposalScalarRelationFilterSchema().nullish()),
    proposalId: z.lazy(() => IntFilterSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    userEmail: z.lazy(() => StringFilterSchema().nullish())
  })
}

export function UserProposalAccessWhereUniqueInputSchema(): z.ZodObject<Properties<UserProposalAccessWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => UserProposalAccessWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => UserProposalAccessWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => UserProposalAccessWhereInputSchema())).nullish(),
    proposal: z.lazy(() => ProposalScalarRelationFilterSchema().nullish()),
    proposalId: z.lazy(() => IntFilterSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    userEmail: z.lazy(() => StringFilterSchema().nullish()),
    userEmail_proposalId: z.lazy(() => UserProposalAccessUserEmailProposalIdCompoundUniqueInputSchema().nullish())
  })
}

export function UserProposalPinCreateManyProposalInputSchema(): z.ZodObject<Properties<UserProposalPinCreateManyProposalInput>> {
  return z.object({
    pinnedAt: z.number().nullish(),
    userEmail: z.string().trim()
  })
}

export function UserProposalPinCreateManyProposalInputEnvelopeSchema(): z.ZodObject<Properties<UserProposalPinCreateManyProposalInputEnvelope>> {
  return z.object({
    data: z.array(z.lazy(() => UserProposalPinCreateManyProposalInputSchema())),
    skipDuplicates: z.boolean().nullish()
  })
}

export function UserProposalPinCreateNestedManyWithoutProposalInputSchema(): z.ZodObject<Properties<UserProposalPinCreateNestedManyWithoutProposalInput>> {
  return z.object({
    connect: z.array(z.lazy(() => UserProposalPinWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => UserProposalPinCreateOrConnectWithoutProposalInputSchema())).nullish(),
    create: z.array(z.lazy(() => UserProposalPinCreateWithoutProposalInputSchema())).nullish(),
    createMany: z.lazy(() => UserProposalPinCreateManyProposalInputEnvelopeSchema().nullish())
  })
}

export function UserProposalPinCreateOrConnectWithoutProposalInputSchema(): z.ZodObject<Properties<UserProposalPinCreateOrConnectWithoutProposalInput>> {
  return z.object({
    create: z.lazy(() => UserProposalPinCreateWithoutProposalInputSchema()),
    where: z.lazy(() => UserProposalPinWhereUniqueInputSchema())
  })
}

export function UserProposalPinCreateWithoutProposalInputSchema(): z.ZodObject<Properties<UserProposalPinCreateWithoutProposalInput>> {
  return z.object({
    pinnedAt: z.number().nullish(),
    userEmail: z.string().trim()
  })
}

export function UserProposalPinListRelationFilterSchema(): z.ZodObject<Properties<UserProposalPinListRelationFilter>> {
  return z.object({
    every: z.lazy(() => UserProposalPinWhereInputSchema().nullish()),
    none: z.lazy(() => UserProposalPinWhereInputSchema().nullish()),
    some: z.lazy(() => UserProposalPinWhereInputSchema().nullish())
  })
}

export function UserProposalPinOrderByRelationAggregateInputSchema(): z.ZodObject<Properties<UserProposalPinOrderByRelationAggregateInput>> {
  return z.object({
    _count: SortOrderSchema.nullish()
  })
}

export function UserProposalPinScalarWhereInputSchema(): z.ZodObject<Properties<UserProposalPinScalarWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => UserProposalPinScalarWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => UserProposalPinScalarWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => UserProposalPinScalarWhereInputSchema())).nullish(),
    pinnedAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    proposalId: z.lazy(() => IntFilterSchema().nullish()),
    userEmail: z.lazy(() => StringFilterSchema().nullish())
  })
}

export function UserProposalPinUpdateManyMutationInputSchema(): z.ZodObject<Properties<UserProposalPinUpdateManyMutationInput>> {
  return z.object({
    pinnedAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    userEmail: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish())
  })
}

export function UserProposalPinUpdateManyWithWhereWithoutProposalInputSchema(): z.ZodObject<Properties<UserProposalPinUpdateManyWithWhereWithoutProposalInput>> {
  return z.object({
    data: z.lazy(() => UserProposalPinUpdateManyMutationInputSchema()),
    where: z.lazy(() => UserProposalPinScalarWhereInputSchema())
  })
}

export function UserProposalPinUpdateManyWithoutProposalNestedInputSchema(): z.ZodObject<Properties<UserProposalPinUpdateManyWithoutProposalNestedInput>> {
  return z.object({
    connect: z.array(z.lazy(() => UserProposalPinWhereUniqueInputSchema())).nullish(),
    connectOrCreate: z.array(z.lazy(() => UserProposalPinCreateOrConnectWithoutProposalInputSchema())).nullish(),
    create: z.array(z.lazy(() => UserProposalPinCreateWithoutProposalInputSchema())).nullish(),
    createMany: z.lazy(() => UserProposalPinCreateManyProposalInputEnvelopeSchema().nullish()),
    delete: z.array(z.lazy(() => UserProposalPinWhereUniqueInputSchema())).nullish(),
    deleteMany: z.array(z.lazy(() => UserProposalPinScalarWhereInputSchema())).nullish(),
    disconnect: z.array(z.lazy(() => UserProposalPinWhereUniqueInputSchema())).nullish(),
    set: z.array(z.lazy(() => UserProposalPinWhereUniqueInputSchema())).nullish(),
    update: z.array(z.lazy(() => UserProposalPinUpdateWithWhereUniqueWithoutProposalInputSchema())).nullish(),
    updateMany: z.array(z.lazy(() => UserProposalPinUpdateManyWithWhereWithoutProposalInputSchema())).nullish(),
    upsert: z.array(z.lazy(() => UserProposalPinUpsertWithWhereUniqueWithoutProposalInputSchema())).nullish()
  })
}

export function UserProposalPinUpdateWithWhereUniqueWithoutProposalInputSchema(): z.ZodObject<Properties<UserProposalPinUpdateWithWhereUniqueWithoutProposalInput>> {
  return z.object({
    data: z.lazy(() => UserProposalPinUpdateWithoutProposalInputSchema()),
    where: z.lazy(() => UserProposalPinWhereUniqueInputSchema())
  })
}

export function UserProposalPinUpdateWithoutProposalInputSchema(): z.ZodObject<Properties<UserProposalPinUpdateWithoutProposalInput>> {
  return z.object({
    pinnedAt: z.lazy(() => DateTimeFieldUpdateOperationsInputSchema().nullish()),
    userEmail: z.lazy(() => StringFieldUpdateOperationsInputSchema().nullish())
  })
}

export function UserProposalPinUpsertWithWhereUniqueWithoutProposalInputSchema(): z.ZodObject<Properties<UserProposalPinUpsertWithWhereUniqueWithoutProposalInput>> {
  return z.object({
    create: z.lazy(() => UserProposalPinCreateWithoutProposalInputSchema()),
    update: z.lazy(() => UserProposalPinUpdateWithoutProposalInputSchema()),
    where: z.lazy(() => UserProposalPinWhereUniqueInputSchema())
  })
}

export function UserProposalPinUserEmailProposalIdCompoundUniqueInputSchema(): z.ZodObject<Properties<UserProposalPinUserEmailProposalIdCompoundUniqueInput>> {
  return z.object({
    proposalId: z.number({ error: () => 'Expected a valid number' }).int().nonnegative().min(0).max(2147483647),
    userEmail: z.string().trim()
  })
}

export function UserProposalPinWhereInputSchema(): z.ZodObject<Properties<UserProposalPinWhereInput>> {
  return z.object({
    AND: z.array(z.lazy(() => UserProposalPinWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => UserProposalPinWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => UserProposalPinWhereInputSchema())).nullish(),
    pinnedAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    proposal: z.lazy(() => ProposalScalarRelationFilterSchema().nullish()),
    proposalId: z.lazy(() => IntFilterSchema().nullish()),
    userEmail: z.lazy(() => StringFilterSchema().nullish())
  })
}

export function UserProposalPinWhereUniqueInputSchema(): z.ZodObject<Properties<UserProposalPinWhereUniqueInput>> {
  return z.object({
    AND: z.array(z.lazy(() => UserProposalPinWhereInputSchema())).nullish(),
    NOT: z.array(z.lazy(() => UserProposalPinWhereInputSchema())).nullish(),
    OR: z.array(z.lazy(() => UserProposalPinWhereInputSchema())).nullish(),
    pinnedAt: z.lazy(() => DateTimeFilterSchema().nullish()),
    proposal: z.lazy(() => ProposalScalarRelationFilterSchema().nullish()),
    proposalId: z.lazy(() => IntFilterSchema().nullish()),
    userEmail: z.lazy(() => StringFilterSchema().nullish()),
    userEmail_proposalId: z.lazy(() => UserProposalPinUserEmailProposalIdCompoundUniqueInputSchema().nullish())
  })
}
